// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn higharc gen doc-schema directly.

/* eslint-disable @typescript-eslint/naming-convention */
import type {
  Annotation,
  AssetCatalogReference,
  DeprecatedPlanDim,
  InlineImageAsset,
  LinearDimension,
  Linework,
  Note,
  QRCode,
} from "building-types/annotation/annotationTypes";
import type {
  AnnotationFillType,
  AnnotationLineType,
  PaperSize,
  PathEndStyle,
  PositioningMethod,
  TextBackground,
} from "building-types/annotation/annotationTypesEnum";
import type { DXFUnit } from "building-types/assets/dxf";
import type {
  DocDatumSpanAssociation,
  DocFacadeSpanStratumAssociation,
  DocFacadeSweepStratumAssociation,
} from "building-types/associations/associationTypes";
import type { Block } from "building-types/blocks/blockTypes";
import type { GarageHandingDirection } from "building-types/building/garageHanding";
import type { HomeAttributes } from "building-types/building/homeAttributes";
import type { StreetOrientationMode } from "building-types/building/streetOrientationMode";
import type { FilterEntitySourceId } from "building-types/buildingGraphFilter/entitySource";
import type {
  BaseCabinetDescriptor,
  CabinetShape,
  CabinetShapeAngled,
  CabinetShapeLShaped,
  CabinetShapeNone,
  CaseworkDescriptor,
  ClosetShelfDescriptor,
  FillerPanelDescriptor,
  TallCabinetDescriptor,
  UpperCabinetDescriptor,
} from "building-types/casework/caseworkDescriptor";
import type {
  BlindPanelSide,
  PlanNoteOrientation,
  UpperCabinetSubType,
} from "building-types/casework/caseworkTypesEnum";
import type {
  CaseworkLineStyle,
  WallCasework,
  WallCaseworkDynamicDeprecated,
  WallCaseworkFixed,
  WallCaseworkFixedDeprecated,
  WallCaseworkPlanNote,
} from "building-types/casework/wallCaseworkTypes";
import type { FinishClipping } from "building-types/casing/casingTypes";
import type {
  Ceiling,
  CeilingBoundaryType,
  CeilingRidgeOrientation,
  Flat,
  HeightType,
  None,
  TrayFreeform,
  TraySimpleOffset,
  Vaulted,
} from "building-types/ceilings/ceiling";
import type { VerticalDatumData } from "building-types/columns/columnDatumTypes";
import type {
  ArrayColumnPlacementV1,
  ColumnPlacementV1,
  ColumnV1,
  DivisionColumnPlacementV1,
  MaxDistanceColumnPlacementV1,
  ParamColumnPlacementV1,
} from "building-types/columns/columnDeprecatedTypes";
import type {
  ArchitecturalColumnDescriptor,
  ColumnDescriptor,
  StructuralWoodPostDescriptor,
} from "building-types/columns/columnDescriptorTypes";
import type {
  ArrayColumnPlacementV2,
  Column,
  ColumnPlacementV2,
  ColumnSection,
  ColumnV2,
  DivisionColumnPlacementV2,
  MaxDistanceColumnPlacementV2,
  ParamColumnPlacementV2,
} from "building-types/columns/columnTypes";
import type { ColumnHorizontalAlignment, ColumnLateralAlignment } from "building-types/columns/columnTypesEnum";
import type { ColumnPosition, PorchColumnPattern } from "building-types/columns/porchColumnPattern";
import type { ComponentOptionSetAssociation } from "building-types/components/componentAssociationTypes";
import type {
  ComponentInstance,
  ComponentVerticalPlacement,
  ComponentVerticalPlacementRemapping,
  ComponentVerticalPlacementReplication,
} from "building-types/components/componentInstanceTypes";
import type { Component } from "building-types/components/componentTypes";
import type {
  Condition,
  ConditionOperator,
  ConditionTypeDefId,
  ConnectiveOperator,
} from "building-types/conditions/conditionTypes";
import type { CustomDataSequence, DataSequence, SystemDataSequence } from "building-types/dataSequences/dataSequence";
import type { AggregationMethod } from "building-types/dataSequences/measures";
import type { DataTable, DataTableColumnConfig, DataTableFindAndReplaceRow } from "building-types/dataTables/dataTable";
import type {
  AbsoluteVerticalDatumEntity,
  DatumEntity,
  LegacyFoundationLateralDatumEntity,
  LegacyFoundationVerticalDatumEntity,
  LegacyLevelDatumEntity,
  LegacyWallHorizontalDatumEntity,
  LegacyWallPlaneHorizontalDatumEntity,
  LegacyWallVerticalDatumEntity,
  StackedLevelDatumEntity,
} from "building-types/datums/datumEntityTypes";
import type { DatumScope } from "building-types/datums/datumScopeTypes";
import type { WallLateralDatumAnchorAll } from "building-types/datums/datumsTypes";
import type {
  CaseworkHorizontalAlignment,
  CaseworkLateralAlignment,
  CaseworkVerticalAlignment,
  CaseworkVerticalDatumAnchor,
  FoundationDatumVerticalAnchor,
  HorizontalJustification,
  LateralDatumJustification,
  LevelDatumAnchor,
  PropInstanceHorizontalAlignment,
  PropInstanceLateralAlignment,
  PropInstanceVerticalAlignment,
  PropInstanceVerticalDatumAnchor,
  VerticalJustification,
  WallHorizontalDatum,
  WallLateralDatumAnchor,
  WallVerticalDatumAnchor,
} from "building-types/datums/datumsTypesEnum";
import type { DatumUsageBase } from "building-types/datums/datumUsageTypes";
import type { DimensionRowLevel } from "building-types/dimensions/dimensionTypesEnum";
import type { Doc } from "building-types/doc";
import type { ForeignKeyPathOf } from "building-types/doc/foreignKeyPath";
import type { OptionSetForeignKeyString, ParameterForeignKeyString } from "building-types/doc/foreignKeyString";
import type { DocRef } from "building-types/docRef";
import type { DoorOperationType } from "building-types/doors/doorOperationTypes";
import type { DoorDescriptorCustom, DoorPropIdPrefix, SwingSide } from "building-types/doors/doorTypes";
import type { Drawing } from "building-types/drawings/drawingTypes";
import type { DrawingScale, DrawingScaleMode, DrawingType } from "building-types/drawings/drawingTypesEnum";
import type {
  DimensionEdgeBehavior,
  EdgeBehavior,
  ElevationNoteEdgeBehavior,
  FoundationAssemblyEdgeBehavior,
  FoundationPatternEdgeBehavior,
  LabelEdgeBehavior,
  PorchColumnEdgeBehavior,
  TrimEdgeBehavior,
  WallAssemblyEdgeBehavior,
} from "building-types/edgeBehavior/edgeBehavior";
import type { CandidateTypeConstraints } from "building-types/electrical/CandidateTypeConstraints";
import type {
  ControllerPosition,
  ControllerSelectionConfig,
  CSByControllerTag,
  CSDoorByRoomIds,
  CSDoorByRoomType,
  CSDoorByRoomTypeOutside,
  CSExplicitPoint,
  CSNearestCandidate,
  CSNearestCandidateOutside,
  CSNearestDoorOutside,
  CSNearestExplicitWall,
  CSNone,
  CSPrimaryEntrance,
  CSPrimaryEntranceOutside,
  PlacementPoint,
  QueryPoint,
  QueryPointUnion,
} from "building-types/electrical/controllerSelectionTypes";
import type { DoorCandidateTypeConstraints } from "building-types/electrical/DoorCandidateTypeConstraints";
import type {
  ElectricalControllerNonSwitch,
  ElectricalControllerSwitch,
  ElectricalDevice,
  ElectricalLoad,
  ExplicitIndexLoadConnection,
  LoadConnection,
  NearestArrayTerminusLoadConnection,
  NearestLoadConnection,
} from "building-types/electrical/electricalDeviceTypes";
import type { InPlaceElectricalLayout } from "building-types/electrical/electricalInPlaceLayoutTypes";
import type {
  AtBackOfProp,
  AtDoorByType,
  ElectricalLayout,
  FourLightsWithOptionalFan,
  GarageLights,
  LinearArray,
  RectangularArray,
  SingleLight,
  StandardOutlet,
} from "building-types/electrical/electricalLayoutTypes";
import type { RoomBoundaryType, SpacingType } from "building-types/electrical/electricalLayoutTypesEnum";
import type { LegacyOffsetFromPropBack } from "building-types/electrical/electricalLegacyRoomLayoutTypes";
import type {
  ControllerTypeSlot,
  ControllerTypeSlots,
  ElectricalSlots,
  LoadTypeSlot,
  LoadTypeSlots,
} from "building-types/electrical/electricalSlots";
import type { LoadDescriptor } from "building-types/electrical/electricalTypes";
import type {
  ControllerSwitchType,
  ControllerType,
  ElectricalBoxType,
  LoadSymbol,
  LoadType,
} from "building-types/electrical/electricalTypesEnum";
import type {
  Asset,
  DxfAsset,
  FbxAsset,
  ImageAsset,
  ImageAssetLegacy,
  PropThumbnails,
} from "building-types/entities/asset";
import type {
  BuildingGraphPlanarTopologyHandle,
  BuildingWallPlaneSubdomainHandle,
} from "building-types/entities/buildingEntityHandle";
import type { HorizontalEdgeParamNoExpr } from "building-types/entities/edgePlacementTypes";
import type {
  AnnotationHostWall,
  EntityHostedAnnotationPoint,
  WallHostedAnnotationSide,
} from "building-types/entities/entityHostedAnnotationTypes";
import type { EntityRef } from "building-types/entities/entityRefTypes";
import type { Label } from "building-types/entities/labelTypes";
import type { PlanAreaMeasurement, PlanAreaMeasurementShape, Sign } from "building-types/entities/measurementTypes";
import type {
  BoardProfileEntity,
  CustomProfileEntity,
  ProfileEntity,
} from "building-types/entities/profileEntityTypes";
import type { ReferenceGeom } from "building-types/entities/referenceGeom";
import type { ReportableUnitDesignation } from "building-types/entities/reportableUnitDesignationTypes";
import type { AssetReferenceUnderlay, InlineImageUnderlay, Underlay } from "building-types/entities/underlay";
import type {
  EntitySettings,
  EntityTypesEligibleForEntitySettings,
} from "building-types/entitySettings/entitySettingsTypes";
import type { Facade, FacadeSpanStratum, FacadeSweepStratum } from "building-types/facades/facadeTypes";
import type { FacadeWallSweep } from "building-types/facades/wallSweep";
import type { CipConcrete } from "building-types/floors/cipComponentTypes";
import type {
  FloorAssemblyOverride,
  FloorAssemblyOverrideBase,
  FloorEdgeOverride,
  HorizontalFloorAssemblyFreeForm,
  HorizontalFloorAssemblyLegacy,
  HorizontalFloorAssemblyRoomDerived,
  HorizontalFloorAssemblyType,
  SolidFramingFloorAssembly,
  SolidSlabFloorAssembly,
} from "building-types/floors/floorAssemblyTypes";
import type { SpanDirection, StructuralFloorType } from "building-types/floors/floorComponentsTypes";
import type {
  FloorAssemblyDynamicFinishLayerOperator,
  FloorAssemblyExteriorFinishLayerOperator,
  FloorAssemblyFinishLayerOverride,
  FloorAssemblyInteriorFinishLayerOperator,
  FloorAssemblyOperationType,
} from "building-types/floors/floorFinishTypes";
import type {
  BayFramingEdgeOverride,
  FloorBay,
  FloorSplitData,
  SplitLine,
} from "building-types/floors/floorSplitDataTypes";
import type { FloorSystemOpeningFramingConfig } from "building-types/floors/floorSystemOpeningFramingTypes";
import type { FloorSystemExternal } from "building-types/floors/floorSystemTypes";
import type { FrameFloorAssemblyEntity } from "building-types/floors/frameFloorAssemblyTypes";
import type {
  Concrete,
  MasonryComponentEntity,
  OtherMasonryComponent,
} from "building-types/floors/masonryComponentTypes";
import type {
  Drywall,
  Osb,
  Other,
  Plywood,
  SheathingComponentEntity,
} from "building-types/floors/sheathingComponentTypes";
import type { ConcreteSlab, SlabComponentEntity, WoodSlab } from "building-types/floors/slabComponentTypes";
import type { SlabFloorAssemblyEntity } from "building-types/floors/slabFloorAssemblyTypes";
import type { FoundationAssemblyEntityDatums } from "building-types/foundations/foundationAssemblyEntityDatumsTypes";
import type { FoundationAssemblyEntity } from "building-types/foundations/foundationAssemblyEntityTypes";
import type {
  CIPStemWallEntity,
  CircularCIPPierEntity,
  CircularCMUPierEntity,
  CircularIsolatedFootingEntity,
  CMUBrickLedgeType,
  CMUStemWallEntity,
  CustomPierEntity,
  FixedWidthCurbEntity,
  FoundationComponentEntity,
  RectangularCIPPierEntity,
  RectangularCMUPierEntity,
  RectangularIsolatedFootingEntity,
  StripFootingEntity,
  TurndownBrickLedgeType,
  TurndownFootingEntity,
} from "building-types/foundations/foundationComponentEntityTypes";
import type {
  BrickLedgeBehavior,
  BrickLedgeType,
  FoundationSubSystemType,
} from "building-types/foundations/foundationEnums";
import type {
  FoundationPattern,
  PierPosition,
  RoomIsolatedFoundationPattern,
  StairIsolatedFoundationPattern,
} from "building-types/foundations/foundationPatternTypes";
import type {
  Foundation,
  FoundationAssemblySelection,
  FoundationOverride,
  FoundationSystem,
} from "building-types/foundations/foundationSystemTypes";
import type {
  CompositeLumberComponent,
  CustomFramingComponent,
  DimensionalLumberComponent,
  FramingComponentEntity,
  IJoistComponent,
  TrussComponent,
} from "building-types/framing/framingComponentTypes";
import type { FramingConfig } from "building-types/framing/framingMetaDataTypes";
import type { HeaderAssemblyEntity } from "building-types/framing/headerAssemblyTypes";
import type { IJoistProfileType } from "building-types/framing/iJoistTypes";
import type { LumberProfileType, OSBProfile, PlywoodProfile, SpanRating } from "building-types/framing/lumberTypes";
import type {
  HipFramingMethod,
  RoofFramingSpacingMethod,
  RoofFramingType,
} from "building-types/framing/roofFramingTypes";
import type { RoofTrussType } from "building-types/framing/roofTrussTypes";
import type { Group } from "building-types/groups/group";
import type {
  AnnotationHandle,
  AssetHandle,
  AutoDimensionFloorPlanExteriorByOrientationHandle,
  AutoDimensionFloorPlanExteriorByOrientationProvenance,
  AutoDimensionFloorPlanExteriorByRoomMultipleHandle,
  AutoDimensionFloorPlanExteriorByRoomMultipleProvenance,
  AutoDimensionFloorPlanExteriorByRoomSingleHandle,
  AutoDimensionFloorPlanExteriorByRoomSingleProvenance,
  AutoDimensionFloorPlanInteriorByOrthogonalRoomEdge,
  AutoDimensionFloorPlanInteriorByOrthogonalRoomEdgeHandle,
  AutoDimensionFloorPlanInteriorByRoomEdgePair,
  AutoDimensionFloorPlanInteriorByRoomEdgePairHandle,
  AutoDimensionFoundationExteriorByOrientationHandle,
  AutoDimensionFoundationExteriorByOrientationProvenance,
  AutoDimensionFoundationExteriorByRoomMultipleHandle,
  AutoDimensionFoundationExteriorByRoomMultipleProvenance,
  AutoDimensionFoundationExteriorByRoomSingleHandle,
  AutoDimensionFoundationExteriorByRoomSingleProvenance,
  AutoDimensionFoundationInteriorByOrientationHandle,
  AutoDimensionFoundationInteriorByOrientationProvenance,
  AutoDimensionFoundationInteriorByRoomMultipleHandle,
  AutoDimensionFoundationInteriorByRoomMultipleProvenance,
  AutoDimensionFoundationInteriorByRoomSingleHandle,
  AutoDimensionFoundationInteriorByRoomSingleProvenance,
  AutoDimensionPersistedHandle,
  BlockHandle,
  CaseworkHandle,
  CatalogItemHandle,
  CeilingHandle,
  CipComponentHandle,
  ColumnHandle,
  ComponentHandle,
  ComponentInstanceHandle,
  CompositeLevelHandle,
  ContentReplicatorHandle,
  ContentTemplateHandle,
  ContentTemplateInstanceHandle,
  DataSequenceHandle,
  DataTableHandle,
  DatumHandle,
  DocEntityHandle,
  DocRefHandle,
  DormerHandle,
  DrawingRefHandle,
  EdgeBehaviorHandle,
  EdgeHandle,
  EdgeModifierHandle,
  EdgeOrientation,
  EditModeHandle,
  EffectHandle,
  ElectricalDeviceHandle,
  ElectricalLayoutHandle,
  ElectricalRuleHandle,
  ElevationHandle,
  ElevationViewHandle,
  EntitySettingsHandle,
  FacadeHandle,
  FacadeSpanStratumHandle,
  FacadeSweepStratumHandle,
  FloorBayEdgeHandle,
  FloorBayHandle,
  FloorFinishHandle,
  FloorHandle,
  FloorPerimeterOpeningHandle,
  FloorSplitLineEdgeHandle,
  FloorSplitLineHandle,
  FloorSystemHandle,
  FoundationAssemblyHandle,
  FoundationComponentEntityHandle,
  FoundationHandle,
  FoundationSystemHandle,
  FrameFloorAssemblyHandle,
  FramingComponentHandle,
  FreeformWallEdgeHandle,
  FreeformWallHandle,
  GlobalParameterHandle,
  GroupHandle,
  HeaderAssemblyHandle,
  HidableEntityHandle,
  IndeterminateHandle,
  InstanceOptionSetHandle,
  LabelHandle,
  LevelHandle,
  LevelRoomEdge,
  LocalParameterHandle,
  LockableEntityHandle,
  MasonryComponentHandle,
  MeasurementHandle,
  ModifierHandle,
  OpeningHandle,
  OptionEffectHandle,
  OptionHandle,
  OptionLockHandle,
  OptionRuleHandle,
  OptionSetHandle,
  OptionSetOverridesHandle,
  OptionTemplateHandle,
  PaletteHandle,
  PlanSetTemplateConfigHandle,
  PlanSetTemplateHandle,
  PlanViewHandle,
  PresetHandle,
  ProfileHandle,
  PropAttributesHandle,
  PropInstanceHandle,
  RailingHandle,
  RailingPostHandle,
  RailingSettingHandle,
  ReferenceGeomHandle,
  ReportableUnitDesignationHandle,
  RoofHandle,
  RoofOpeningHandle,
  RoofSideHandle,
  RoofSystemHandle,
  RoofVolumeHandle,
  RoomEdge,
  RoomEdgeHandle,
  RoomHandle,
  RoomLayoutHandle,
  RoomLayoutInstanceHandle,
  RuleBasedSelectorHandle,
  RuleBasedSelectorInstanceHandle,
  SectionViewHandle,
  SelectorHandle,
  SettingsHandle,
  SettingsSetHandle,
  ShapeBasedEntityHandle,
  ShapeHandle,
  SheathingComponentHandle,
  SheetHandle,
  SiteHandle,
  SiteShapeHandle,
  SkylightHandle,
  SlabComponentHandle,
  SlabFloorAssemblyHandle,
  StairBlockHandle,
  StairSettingHandle,
  StairSystemHandle,
  SystemParameterHandle,
  UnderlayHandle,
  VertexHandle,
  View3DHandle,
  ViewOverrideHandle,
  ViewportHandle,
  ViewSelectorHandle,
  ViewTemplateHandle,
  ViewTemplateOverrideHandle,
  WallPlaneAssemblyHandle,
  WallPlaneFilterHandle,
  WallPlaneRuleHandle,
  WallPlaneTrimHandle,
} from "building-types/handles/docEntityHandleTypes";
import type { GeneratedEntityHandle, GeneratedPageViewHandle } from "building-types/handles/generatedEntityHandleTypes";
import type {
  ContentTemplateInstanceViewHandle,
  ContentTemplateViewHandle,
  DataSequenceViewHandle,
  WallPlaneViewHandle,
} from "building-types/handles/viewHandleTypes";
import type {
  AlignmentEnum,
  HorizontalAlignment,
  LateralAlignment,
  VerticalAlignment,
} from "building-types/hosting/hostingTypes";
import type { CompositeLevel, CompositeLevelMember } from "building-types/levels/CompositeLevel";
import type { LevelDef } from "building-types/levels/LevelDef";
import type { DatumLevelPlacement, LevelPlacement, StackedLevelPlacement } from "building-types/levels/levelTypes";
import type { CMUProfile } from "building-types/masonry/masonryTypes";
import type { ExteriorMaterial } from "building-types/materials/exteriorMaterialTypes";
import type { ExteriorPalette } from "building-types/materials/exteriorPaletteTypes";
import type {
  InteriorPalette,
  RoomMaterials,
  RoomSetMaterials,
  RoomTypeSet,
} from "building-types/materials/interiorPaletteTypes";
import type { Palette } from "building-types/materials/palette";
import type { PaletteMaterialSlot } from "building-types/materials/paletteMaterialSlotTypes";
import type { PaletteType } from "building-types/materials/paletteType";
import type { EdgeModifier } from "building-types/modifiers/edgeModifierTypes";
import type { Modifier } from "building-types/modifiers/modifierTypes";
import type { Awning } from "building-types/openings/awning";
import type {
  DoorPlacementDeprecated,
  DoorPlacementMatchExpr,
  Opening,
  OpeningHorizontalAlignment,
  SolidOpeningPlacement,
  WindowPlacementDeprecated,
  WindowPlacementMatchExpr,
} from "building-types/openings/opening";
import type {
  WindowLateralAlignment,
  WindowVerticalAlignment,
  WindowVerticalDatum,
} from "building-types/openings/openingTypesEnum";
import type { OpeningWrappingMode } from "building-types/openings/openingWrappingModes";
import type { DocOptionRule } from "building-types/options/docOptionRule";
import type { ElevationImages } from "building-types/options/elevationTypes";
import type { Formula } from "building-types/options/formula";
import type { FormulaDisabled } from "building-types/options/formulaDisabled";
import type {
  CodeFormatting,
  GenerateSettings,
  IntersectionConditions,
  IntersectionEffect,
  IntersectionScope,
  ManualCodeFormatting,
  ModifySettings,
  OptionCodeFormatting,
} from "building-types/options/intersectionBaseTypes";
import type { OptionChoices } from "building-types/options/optionChoices";
import type {
  DocOptionEffect,
  EnableOptionEffect,
  LockOptionEffect,
  SetPriceOptionEffect,
} from "building-types/options/optionEffect";
import type {
  DocOption,
  DocOptionLock,
  DocOptionSet,
  ElevationOptionSet,
  InstanceOptionSet,
  IntersectingOptionSet,
  OptionSetMasterPlanSetBehavior,
  SalesImage,
  SystemOptionSet,
  UserOptionSet,
} from "building-types/options/optionSet";
import type { DocOptionSetOverrides, DocOptionTemplate } from "building-types/options/optionTemplateTypes";
import type {
  BooleanParameter,
  ContentTemplateValue,
  DataSequenceParameter,
  DataSequenceValue,
  DrawingScaleParameter,
  DrawingTemplateParameter,
  ElevationViewParameter,
  ElevationViewValue,
  FootInchParameter,
  GlobalParameter,
  LevelParameter,
  LevelValue,
  LocalParameter,
  NumberParameter,
  OptionChoiceParameter,
  OptionPresetParameter,
  OptionPresetValue,
  OptionValue,
  ParameterRef,
  ParameterValue,
  ParameterValueHandle,
  PrimitiveValue,
  SectionViewParameter,
  SectionViewValue,
  SystemParameter,
  TextParameter,
  UnitParameter,
  UnitValue,
  UrlParameter,
  View3DParameter,
  ViewTemplateParameter,
  ViewTemplateValue,
} from "building-types/options/parameter";
import type { ParameterFormula } from "building-types/options/parameterFormula";
import type { Preset, PresetType } from "building-types/options/preset";
import type {
  BoardDescriptor,
  CustomDescriptor,
  ProfileExtrusionDescriptor,
  ProfileId,
} from "building-types/profiles/profileTypes";
import type { BuiltInExteriorPropId } from "building-types/props/builtInExteriorPropId";
import type { PropCategory } from "building-types/props/propCategoryTypes";
import type { PropInstance, PropInstanceV1, PropInstanceV2 } from "building-types/props/propInstanceTypes";
import type { FullMaterialSlot, PropAttributes, PropAttributesCustom } from "building-types/props/propTypes";
import type { PlacementStyleVersion, PropBoundOrientation } from "building-types/props/propTypesEnum";
import type { SettingsCriterion } from "building-types/provenance/provenanceTypes";
import type {
  GableLabel,
  Roof,
  RoofBlockInstanceRef,
  RoofBlocks,
  RoofDormerPlacement,
  RoofOpeningJustification,
  RoofOpeningPlacement,
  RoofSystem,
  RoofSystemLevelUsage,
  SkylightPlacement,
  VirtualRoofBlock,
} from "building-types/roofs/roofSystemTypes";
import type { RoofWallFramingType } from "building-types/roofs/roofWallFramingTypes";
import type {
  ImportArrangement,
  ImportHalfEdge,
  ImportVertex,
  RoofVolume,
} from "building-types/roofVolumes/roofVolumeTypes";
import type { EntityInstanceType } from "building-types/roomLayouts/roomLayoutEligibleDocEntity";
import type { RoomLayout, RoomLayoutInstance } from "building-types/roomLayouts/roomLayoutTypes";
import type {
  RoomCaseworkPosition,
  RoomPosition,
  RoomPropPosition,
  RoomRefGeomPosition,
  RoomWallPosition,
} from "building-types/rooms/roomPosition";
import type {
  RoomClass,
  RoomEnclosure,
  RoomLabelDimensionType,
  RoomLabelRounding,
  RoomLabelUnits,
  RoomTagDimensionControl,
  RoomType,
} from "building-types/rooms/roomTypesEnum";
import type { SpaceType } from "building-types/rooms/spaceTypesEnum";
import type { StaticRoomAttributes } from "building-types/rooms/staticRoomAttributes";
import type { StaticRoom } from "building-types/rooms/staticRoomTypes";
import type { RuleBasedSelector, RuleBasedSelectorInstance } from "building-types/selectors/ruleBasedSelectorTypes";
import type { AutoDimensionSelector, ViewOverride } from "building-types/selectors/selectorTypes";
import type {
  BuiltInViewSelector,
  DocTableViewSelector,
  ViewSelector,
} from "building-types/selectors/viewSelectorTypes";
import type { ApronCasingSettings } from "building-types/settings/apronCasingSettings";
import type { AreaReportSetting } from "building-types/settings/areaReportSetting";
import type { AreaReportSettings } from "building-types/settings/areaReportSettings";
import type {
  AwningSettings,
  DisabledAwningSettings,
  ShedAwningSettings,
} from "building-types/settings/awningSettings";
import type { BaseSettings } from "building-types/settings/baseSettings";
import type { CaseworkCatalogSettings } from "building-types/settings/caseworkCatalogSettings";
import type { CaseworkSettings } from "building-types/settings/caseworkSettings";
import type { CasingFinishSettings } from "building-types/settings/casingFinishSettings";
import type { CasingOrientationSettings } from "building-types/settings/casingOrientationSettings";
import type {
  CasingHorizontalPlacementSettings,
  CasingLateralPlacementSettings,
} from "building-types/settings/casingPlacementSettings";
import type { ColumnCatalogSettings } from "building-types/settings/columnCatalogSettings";
import type { DoorCatalogSettings } from "building-types/settings/doorCatalogSettings";
import type { DoorSettings } from "building-types/settings/doorSettings";
import type { DoorWallFramingSettings } from "building-types/settings/doorWallFramingSettings";
import type { DoorWallWrappingSettings } from "building-types/settings/doorWallWrappingSettings";
import type { DormerSettings } from "building-types/settings/dormerSettings";
import type { DrawingCatalogSettings } from "building-types/settings/drawingCatalogSettings";
import type { ElectricalItemCatalogSettings } from "building-types/settings/electricalItemCatalogSettings";
import type {
  BaseRangeFilter,
  BaseRoomTypeSpaceTypeFilter,
  ElectricalRule,
  RangeFilter,
  RoomTypeFilter,
  RoomTypeSpaceTypeFilter,
  SpaceTypeFilter,
} from "building-types/settings/electricalRuleTypes";
import type { ElectricalSettings } from "building-types/settings/electricalSettings";
import type { ExteriorDoorCasingSettings } from "building-types/settings/exteriorDoorCasingSettings";
import type { ExteriorDoorCasingViewNotesSettings } from "building-types/settings/exteriorDoorCasingViewNotesSettings";
import type { ExteriorMaterialSettings } from "building-types/settings/exteriorMaterialSettings";
import type { ExteriorPropSettings } from "building-types/settings/exteriorPropSettings";
import type { ExteriorTrimSettings } from "building-types/settings/exteriorTrimSettings";
import type { ExteriorWindowCasingSettings } from "building-types/settings/exteriorWindowCasingSettings";
import type { ExteriorWindowCasingViewNotesSettings } from "building-types/settings/exteriorWindowCasingViewNotesSettings";
import type {
  ExteriorFloorMaterialOverride,
  InteriorFloorMaterialOverride,
} from "building-types/settings/floorMaterialSettings";
import type { FloorSettings } from "building-types/settings/floorSettings";
import type { FoundationSettings } from "building-types/settings/foundationSettings";
import type { GarageSettings } from "building-types/settings/garageSettings";
import type {
  HeadCasingArchedSlice,
  HeadCasingArchedSlices,
  HeadCasingEyebrowTrim,
  HeadCasingFullArch,
  HeadCasingJackArch,
  HeadCasingNone,
  HeadCasingSlice,
  HeadCasingSlices,
  HeadCasingStone,
  HeadCasingTrim,
} from "building-types/settings/headCasingSettings";
import type { HeaderFramingRule, HeaderFramingSettings } from "building-types/settings/headerFramingSettings";
import type { InteriorBaseBoardTrimSettings } from "building-types/settings/interiorBaseBoardTrimSettings";
import type { InteriorCrownMoldingTrimSettings } from "building-types/settings/interiorCrownMoldingTrimSettings";
import type { InteriorDoorCasingSettings } from "building-types/settings/interiorDoorCasingSettings";
import type { InteriorDoorHeadTrimSettings } from "building-types/settings/interiorDoorHeadTrimSettings";
import type { InteriorDoorSideTrimSettings } from "building-types/settings/interiorDoorSideTrimSettings";
import type { InteriorMaterialSettings } from "building-types/settings/interiorMaterialSettings";
import type { InteriorPropSettings } from "building-types/settings/interiorPropSettings";
import type { InteriorTrimSettings } from "building-types/settings/interiorTrimSettings";
import type { InteriorWindowCasingSettings } from "building-types/settings/interiorWindowCasingSettings";
import type { InteriorWindowGeneralCasingSettings } from "building-types/settings/interiorWindowGeneralCasingSettings";
import type { KeyMeasuresSettings } from "building-types/settings/keyMeasuresSettings";
import type { MasterPlanSettings } from "building-types/settings/masterPlanSettings";
import type { SheetCustomScales } from "building-types/settings/pageElevationTypes";
import type { PlanSettings } from "building-types/settings/planSettings";
import type { PorchSettings } from "building-types/settings/porchSettings";
import type { ColonnadeTerminationRule, PorchPlanSettings } from "building-types/settings/porchSettingsTypes";
import type { ProfileCatalogSettings } from "building-types/settings/profileCatalogSettings";
import type { RailingCatalogSettings } from "building-types/settings/railingCatalogSettings";
import type {
  ArrayPostPlacement,
  BalusterDefault,
  DivisionPostPlacement,
  MaxDistancePostPlacement,
  ParamPostPlacement,
  PostDefault,
  PostPlacement,
  RailDefault,
  Railing,
  RailingDefaultSetting,
  RailingInfillStyle,
} from "building-types/settings/railingTypes";
import type { RearPorchSettings } from "building-types/settings/rearPorchSettings";
import type {
  EaveBracketPlacement,
  EaveBracketSide,
  FriezeBoard,
  RoofSlopeOptions,
  RoofTruncationType,
  TruncationSlopeType,
} from "building-types/settings/roofBaseTypes";
import type { RoofFramingSettings } from "building-types/settings/roofFramingSettings";
import type {
  DormerElevationPlanSettings,
  DormerPlanSettings,
  RoofElevationPlanSettings,
  RoofPlanSettings,
} from "building-types/settings/roofPlanSettings";
import type { RoofSettings } from "building-types/settings/roofSettings";
import type { BuildingSide, DormerRoofType, RoofFaces, RoofSide } from "building-types/settings/roofTypes";
import type {
  DoorRoughOpeningSettings,
  RoughOpeningHeadSettings,
  RoughOpeningJambSettings,
  RoughOpeningSillSettings,
  WindowRoughOpeningSettings,
} from "building-types/settings/roughOpeningSettingsTypes";
import type { ScheduleSettings } from "building-types/settings/scheduleSettings";
import type { SettingsFragment } from "building-types/settings/settingsFragment";
import type { SettingsSet } from "building-types/settings/settingsSet";
import type { SettingsSetBehaviorType } from "building-types/settings/settingsSetBehaviorType";
import type { SettingsType } from "building-types/settings/settingsType";
import type {
  ApronCasingType,
  CaseworkDoorStyle,
  ColonnadeTerminationType,
  ColumnDimensionType,
  ConditionedAreaCalculationType,
  CornerBoardTrimAlignment,
  CornerBoardTrimHorizontalDatum,
  DoorPathColumnSpreadMode,
  DormerWallBaseBoardMode,
  EaveCutType,
  EaveFasciaHeightDatum,
  EaveFriezeBoardMode,
  EaveType,
  ElevationNotePlacementType,
  ExteriorDimensionType,
  ExteriorWallOffsetMode,
  GableRoofType,
  InteriorDimensionType,
  PlanLineStyle,
  PlanOrientation,
  PorchHeaderTrimAlignment,
  PropCatalogType,
  RakeFriezeBoardMode,
  RoofBoundaryType,
  RoofPeakDirection,
  RoofStructureType,
  RoofWallMode,
  RoofWeldMode,
  ShutterConfigurationType,
  ShutterShapeType,
  ShutterVerticalAlignment,
  SideCasingType,
  StoolCasingType,
  TrimJustification,
  UtilityDimensionType,
  WainscotingCapType,
  WallIntersectionType,
  WallRoofBaseBoardFilter,
  WallRoofBaseBoardMode,
  WindowMullionType,
  WrapFriezeBoardMode,
} from "building-types/settings/settingsTypesEnum";
import type { BackgroundType, BackgroundVisibility, PlanSeries } from "building-types/settings/sheetsTypesEnum";
import type { SideCasingSettings } from "building-types/settings/sideCasingSettings";
import type { StairCatalogSettings } from "building-types/settings/stairCatalogSettings";
import type { StoolCasingSettings } from "building-types/settings/stoolCasingSettings";
import type { StructureSettings } from "building-types/settings/structureSettings";
import type { ViewNoteSettings } from "building-types/settings/viewNoteSettings";
import type { WainscotingSettings } from "building-types/settings/wainscotingSettings";
import type { WallCatalogSettings } from "building-types/settings/wallCatalogSettings";
import type { WallFramingOpeningSettings } from "building-types/settings/wallFramingOpeningSettings";
import type { WallFramingSettings } from "building-types/settings/wallFramingSettings";
import type { WallOpeningWrappingSettings } from "building-types/settings/wallOpeningWrappingSettings";
import type { WallSettings } from "building-types/settings/wallSettings";
import type { WindowCatalogSettings } from "building-types/settings/windowCatalogSettings";
import type { WindowGridLayout } from "building-types/settings/windowGridLayout";
import type { WindowGridPosition } from "building-types/settings/windowGridPosition";
import type { WindowMaterialSettings } from "building-types/settings/windowMaterialSettings";
import type {
  DisabledWindowMullionSettings,
  GridWindowMullionSettings,
  WindowMullionSettings,
} from "building-types/settings/windowMullionSettings";
import type { WindowSettings } from "building-types/settings/windowSettings";
import type {
  DisabledShutterSettings,
  GenericShutterSettings,
  PanelShutterSettings,
  SimpleSlatShutterSettings,
  VentedShutterSettings,
  WindowShutterSettings,
  ZShutterSettings,
} from "building-types/settings/windowShutterSettings";
import type {
  ArchTopBoolean,
  GlazingColor,
  GlazingType,
  PolygonWindowMode,
  WindowOperationType,
  WindowPanelType,
  WindowShapeTypes,
  WindowVertDivisions,
} from "building-types/settings/windowTypesEnum";
import type { WindowWallFramingSettings } from "building-types/settings/windowWallFramingSettings";
import type { WindowWallWrappingSettings } from "building-types/settings/windowWallWrappingSettings";
import type { ContextHomeProp } from "building-types/site/ContextHomeProp";
import type { BuiltInSiteType, Site, SiteFittingMode, SiteResolutionLevel } from "building-types/site/site";
import type {
  ContourSiteShape,
  DrivewaySiteShape,
  LandscapeSiteShape,
  LandscapeType,
  RetainingWallSiteShape,
  RoadSiteShape,
  SidewalkSiteShape,
  SiteFillSiteShape,
  SiteOverrideSiteShape,
  SiteShape,
  SiteSubtractSiteShape,
  WalkSiteShape,
} from "building-types/site/siteShape";
import type {
  AssembledStair,
  GenericStair,
  MonolithicStair,
  StairBottomShape,
  StairConstruction,
  Stringer,
  StringerLayout,
  StringerPositioning,
  TreadJustification,
} from "building-types/stairs/stairConstruction";
import type {
  StairBlock,
  StairBlockDatumHosting,
  StairBlockEdgeHosting,
  StairBlockHosting,
  StairBlockLanding,
  StairBlockRun,
  StairConfig,
  StairSetting,
  StairSystem,
} from "building-types/stairs/stairTypes";
import type { StairBlockType, StairVerticalAlignment } from "building-types/stairs/stairTypesEnum";
import type { BuiltinPlanViewType } from "building-types/views/BuiltinPlanViewType";
import type { EditorViewState } from "building-types/views/editorViewState";
import type {
  Effect,
  RelaxationObstacleEffect,
  ScalingEffect,
  StylingEffect,
  VisibilityEffect,
} from "building-types/views/effectTypes";
import type { ElevationReferenceFrame } from "building-types/views/elevationReferenceFrame";
import type { Elevation } from "building-types/views/elevationTypes";
import type { GradeLineSource } from "building-types/views/GradeLineSource";
import type { OptionPresetBase } from "building-types/views/optionPresetTypes";
import type {
  AnnotationDrawingTemplate,
  ContentReplicator,
  ContentTemplate,
  ContentTemplateInstance,
  DrawingTemplateInstance,
  DrawingViewport,
  DrawingViewTemplate,
  ElevationViewport,
  ElevationViewTemplate,
  GenericDrawingTemplate,
  ParameterRefNumberField,
  ParameterRefStringField,
  PerspectiveViewport,
  PerspectiveViewTemplate,
  PlanSetTemplate,
  PlanSetTemplateConfig,
  PlanViewport,
  PlanViewTemplate,
  RoomTagCapitalization,
  SectionViewport,
  SectionViewTemplate,
  SheetTemplate,
  SheetTemplateInstance,
  TagTemplate,
  Viewport,
  ViewportBase,
  ViewportHorizontalAlignment,
  ViewportPositioningMethod,
  ViewportScalingMethod,
  ViewportTitleDrawingTemplate,
  ViewportVerticalAlignment,
  ViewportViewType,
  ViewTemplate,
  ViewTemplateOverride,
} from "building-types/views/planSets";
import type { LineStyle, TextStyle } from "building-types/views/Primitive2DOutput";
import type { SelectionMethod } from "building-types/views/SerializableSheetGeometrySelector";
import type { SheetGeometryCategory } from "building-types/views/sheetGeometryCategory";
import type { BackgroundPlanSheet, DrawingRef, DrawingsPlanSheet, Sheet } from "building-types/views/sheetsTypes";
import type { SnapEntity } from "building-types/views/snapEntity";
import type { SnapKind } from "building-types/views/snapKind";
import type {
  CompositeLevelPlanView,
  ElevationView,
  LevelPlanView,
  PlanView,
  PlanViewCompositeLevelMember,
  PlanViewLevelMember,
  SectionView,
  View3D,
} from "building-types/views/View3D";
import type { ViewFilter } from "building-types/views/viewFilterTypes";
import type { ViewStyle } from "building-types/views/ViewStyle";
import type { DimensionPrecision } from "building-types/views/viewTypes";
import type { FreeformWallEntity } from "building-types/walls2/freeformWallTypes";
import type { WallPlaneOperationBoundary } from "building-types/walls2/wallPlane";
import type {
  WallPlaneAssemblyEntity,
  WallPlaneAssemblyLayer,
  WallPlaneCastInPlaceLayer,
  WallPlaneFramingLayer,
  WallPlaneMasonryLayer,
  WallPlaneMaterialFinish,
  WallPlaneSheathingLayer,
} from "building-types/walls2/wallPlaneAssemblyTypes";
import type {
  DocBuildingGraphAndFilterNode,
  DocBuildingGraphFilterGraph,
  DocBuildingGraphFilterNode,
  DocBuildingGraphNotFilterNode,
  DocBuildingGraphOrFilterNode,
  DocBuildingGraphPredicateFilterNode,
  DocBuildingGraphPredicateLiteral,
  DocBuildingGraphSubfilterValueSource,
  DocFaceDirection,
  DocFaceNodeSubFilter,
  DocWallPlaneFilter,
  PredicateOp,
} from "building-types/walls2/wallPlaneFilters";
import type {
  WallPlaneAssemblyOperation,
  WallPlaneCutOperation,
  WallPlaneOperation,
} from "building-types/walls2/wallPlaneOperations";
import type {
  WallFaceRuleEntity,
  WallPlaneAnchoredRuleEntity,
  WallPlaneRuleEntity,
} from "building-types/walls2/wallPlaneRules";
import type { WallPlaneTrimEntity } from "building-types/walls2/wallPlaneTrimTypes";
import type {
  WallAssemblyLayerOperatorAdd,
  WallAssemblyLayerOperatorOverride,
  WallAssemblyLayerOperatorRemove,
  WallAssemblyOffsetOperator,
  WallAssemblyOperator,
  WallFoundationInteractionOperator,
  WallOperatorSetTopDatum,
} from "building-types/walls/wallAssemblyOverrideTypes";
import type {
  WallAssemblyAirGapLayer,
  WallAssemblyExteriorFinishLayer,
  WallAssemblyFinishLayer,
  WallAssemblyFoundationCatalogLayer,
  WallAssemblyInteriorFinishLayer,
  WallAssemblyLayer,
  WallAssemblyLayerConstructorParams,
  WallAssemblyLayerParentHandle,
  WallAssemblyMaterialCatalogLayer,
} from "building-types/walls/wallAssemblyTypes";
import type { StructuralMaterial } from "building-types/walls/wallMaterialTypes";
import type { WallConditionData, WallType } from "building-types/walls/wallType";
import type { ShutterStreetOrientationPreference } from "building-types/windows/shuttersTypes";
import type { WindowDescriptorCustom } from "building-types/windows/windowDescriptorTypes";
import type { BuiltinWindowId } from "building-types/windows/windowId";
import type { FontId } from "common/constants/textFont";
import {
  any,
  arr,
  enu,
  interf,
  lit,
  obj,
  id,
  undef,
  union,
  str,
  num,
  nom,
  bool,
  opt,
  nul,
  inters,
  partial,
  typeParam,
  pick,
  omit,
  mapobj,
  manual,
  tuple,
  ref,
  fk,
  fkStrOf,
  fkPathOf,
  pk,
  pkTable,
  fkTable,
  fkHashTable,
  fkHashJoinTable,
} from "common/data/schema";
import type { MaterialSrc } from "common/materials/materialSrc";
import type { CameraPosition } from "common/types/cameraPosition";
import type {
  DotsPerInch,
  FeetCubed,
  FeetSquared,
  InchesCubed,
  InchesSquared,
  LevelInches,
  NominalNumber,
  OneHundredthMillimeters,
  Percent,
  PixelsPerInch,
  SheetInches,
  SheetPixels,
  SheetPoints,
  Slope,
  UnsignedNumber,
  UntypedNumber,
  WorldFeet,
  WorldInches,
  YardsCubed,
} from "common/types/nominalNumbersTypes";
import type {
  PlacementXAnchor,
  PlacementYAnchor,
  TextAlignment,
  TextVerticalAlignment,
} from "common/utils/textAlignment";
import type { AABB2 } from "geom/aabb2Types";
import type { AABB3 } from "geom/aabb3Types";
import type { HatchMaterialId } from "geom/hatchMaterialId";
import type {
  HatchDesignMaterial,
  HatchMaterial,
  HatchPatternLine,
  HatchPatternMaterial,
  HatchProceduralMaterial,
} from "geom/hatchTypes";
import type { Mat3 } from "geom/mat3";
import type { LineAnchor } from "geom/polyLine2Types";
import type { UVTransformation } from "geom/uv";
import type { Vec3 } from "geom/vec3";

export const AABB2Schema = interf(
  {
    minX: num,
    minY: num,
    maxX: num,
    maxY: num,
  },
  "AABB2",
);
export const AABB3Schema = interf(
  {
    minX: num,
    minY: num,
    minZ: num,
    maxX: num,
    maxY: num,
    maxZ: num,
  },
  "AABB3",
);
export const AbsoluteVerticalDatumEntitySchema = interf(
  {
    datumType: lit("SHAREABLE"),
    datumScope: opt(id("DatumScope")),
    direction: lit("VERTICAL"),
    offsetType: lit("ABSOLUTE"),
    justification: id("VerticalJustification"),
    id: pk("DATUM"),
    offsetNormalized: id("OptionalBoolean"),
    offset: opt(num),
    entityType: lit("DATUM"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "AbsoluteVerticalDatumEntity",
);
export const AggregationMethodSchema = enu(
  {
    [`SUM`]: "SUM",
    [`TAKEFIRST`]: "TAKEFIRST",
  },
  "AggregationMethod",
);
export const AlignmentEnumSchema = union([str, num], "AlignmentEnum");
export const AnnotationSchema = union(
  [
    id("Linework"),
    id("Note"),
    id("LinearDimension"),
    id("InlineImageAsset"),
    id("AssetCatalogReference"),
    id("QRCode"),
    id("DeprecatedPlanDim"),
  ],
  "Annotation",
);
export const AnnotationDrawingTemplateSchema = interf(
  {
    drawingType: lit("ANNOTATION"),
    viewScale: num,
    templateType: lit("DRAWING"),
    id: pk("CONTENT_TEMPLATE"),
    labels: fkTable("LABEL", bool),
    entityType: lit("CONTENT_TEMPLATE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "AnnotationDrawingTemplate",
);
export const AnnotationFillTypeSchema = enu(
  {
    [`SOLID_WHITE`]: "SOLID_WHITE",
    [`SOLID_20PCT_GRAY`]: "SOLID_20PCT_GRAY",
    [`SOLID_40PCT_GRAY`]: "SOLID_40PCT_GRAY",
    [`SOLID_60PCT_GRAY`]: "SOLID_60PCT_GRAY",
    [`CROSSHATCH`]: "CROSSHATCH",
    [`DIAGONAL_DOWN`]: "DIAGONAL_DOWN",
    [`DIAGONAL_UP`]: "DIAGONAL_UP",
    [`GRID`]: "GRID",
    [`NONE`]: "NONE",
  },
  "AnnotationFillType",
);
export const AnnotationHandleSchema = interf(
  {
    type: lit("ANNOTATION"),
    id: str,
  },
  "AnnotationHandle",
);
export const AnnotationHostWallSchema = interf(
  {
    type: lit("WALL"),
    handle: id("RoomHandle"),
    wallSide: id("WallHostedAnnotationSide"),
    horizontalDatum: id("WallHorizontalDatum"),
    edgeIndex: num,
    param: num,
    paramNormalized: bool,
  },
  "AnnotationHostWall",
);
export const AnnotationLineTypeSchema = enu(
  {
    [`CONTINUOUS`]: "CONTINUOUS",
    [`DASHED_LARGE`]: "DASHED_LARGE",
    [`DASHED_SMALL`]: "DASHED_SMALL",
    [`CENTERLINE`]: "CENTERLINE",
    [`DOTTED`]: "DOTTED",
    [`NONE`]: "NONE",
  },
  "AnnotationLineType",
);
export const AnyAtomSchema = any;
export const ApronCasingSettingsSchema = interf(
  {
    apronCasingType: id("ApronCasingType"),
    apronHeight: opt(num),
    apronDepth: opt(num),
    apronCasingMaterial: opt(id("ExteriorMaterial")),
    apronExtension: opt(num),
    apronEndSlope: opt(num),
  },
  "ApronCasingSettings",
);
export const ApronCasingTypeSchema = enu(
  {
    [`DISABLED`]: "DISABLED",
    [`TRIM`]: "TRIM",
  },
  "ApronCasingType",
);
export const ArchitecturalColumnDescriptorSchema = interf(
  {
    sections: arr(id("ColumnSection")),
    name: str,
    entityType: lit("COLUMN"),
    subType: lit("ARCHITECTURAL"),
    viewNotes: opt(
      mapobj(
        lit("COLUMN"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "ColumnViewNoteTable",
      ),
    ),
    elevationNoteEnabled: id("OptionalBoolean"),
    elevationNote: opt(str),
    catalogItemType: lit("COLUMN_DESCRIPTOR"),
  },
  "ArchitecturalColumnDescriptor",
);
export const ArchTopBooleanSchema = enu(
  {
    [`ADD`]: "ADD",
    [`SUBTRACT`]: "SUBTRACT",
  },
  "ArchTopBoolean",
);
export const AreaReportSettingSchema = interf(
  {
    enabled: bool,
    reportedName: str,
    areaCalculationType: id("ConditionedAreaCalculationType"),
    showByLevel: bool,
    showTotals: bool,
    stairAreaFirstFloorOnly: bool,
  },
  "AreaReportSetting",
);
export const AreaReportSettingsSchema = interf(
  {
    CONDITIONED_FLOOR_AREA: id("AreaReportSetting"),
    UNCONDITIONED_FLOOR_AREA: id("AreaReportSetting"),
    TOTAL_GARAGE_AREA: id("AreaReportSetting"),
    FRONT_PORCH_AREA: id("AreaReportSetting"),
    REAR_PORCH_AREA: id("AreaReportSetting"),
    COVERED_PATIO_AREA: id("AreaReportSetting"),
    UNCOVERED_PATIO_AREA: id("AreaReportSetting"),
  },
  "AreaReportSettings",
);
export const ArrayColumnPlacementV1Schema = interf(
  {
    spacing: num,
    shift: num,
    maxCount: opt(num),
    type: lit("ARRAY"),
  },
  "ArrayColumnPlacementV1",
);
export const ArrayColumnPlacementV2Schema = interf(
  {
    spacing: num,
    shift: num,
    maxCount: opt(num),
    type: lit("ARRAY"),
  },
  "ArrayColumnPlacementV2",
);
export const ArrayPostPlacementSchema = interf(
  {
    type: lit("ARRAY"),
    spacing: num,
    shift: num,
    maxCount: opt(num),
    removePostsFromSettings: bool,
    id: pk("RAILING_POST"),
    entityType: lit("RAILING_POST"),
    parentId: union([fk("RAILING", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    edgeIndex: opt(num),
    name: str,
    sortIndex: num,
  },
  "ArrayPostPlacement",
);
export const AssembledStairSchema = interf(
  {
    type: lit("ASSEMBLED"),
    stringerMinDepth: num,
    stringerLayout: id("StringerLayout"),
    stringerThickness: num,
    stringerSideOffset: num,
    stringerMaxSpacing: num,
    stringerMaterial: opt(id("MaterialSrc")),
    stringers: arr(id("Stringer")),
    stairBottomOffset: num,
    stringerTopExtension: num,
    treadThickness: opt(num),
    nosing: opt(num),
    treadMaterial: opt(id("MaterialSrc")),
    hasRisers: id("OptionalBoolean"),
    riserThickness: opt(num),
    riserMaterial: opt(id("MaterialSrc")),
  },
  "AssembledStair",
);
export const AssetSchema = union([id("ImageAsset"), id("DxfAsset"), id("ImageAssetLegacy"), id("FbxAsset")], "Asset");
export const AssetCatalogReferenceSchema = interf(
  {
    detailType: lit("ASSET_REFERENCE"),
    assetId: opt(fk("ASSET")),
    scale: num,
    id: pk("ANNOTATION"),
    handle: union([undef, id("RoomLayoutInstanceHandle"), id("AnnotationHandle"), id("ContentTemplateInstanceHandle")]),
    handleAuxiliary: union([undef, id("AnnotationHandle"), id("ContentTemplateInstanceHandle")]),
    name: str,
    positioningMethod: id("PositioningMethod"),
    edgeId: opt(str),
    parentId: opt(
      union(
        [
          fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }),
          fk("ROOM", { hierarchy: ["PARENT"] }),
          fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] }),
          fk("ELEVATION_VIEW", { hierarchy: ["PARENT"] }),
          fk("SECTION_VIEW", { hierarchy: ["PARENT"] }),
          fk("CONTENT_TEMPLATE_INSTANCE", { hierarchy: ["PARENT"] }),
          fk("LEVEL", { hierarchy: ["PARENT"] }),
        ],
        "DocEntityParentId",
      ),
    ),
    entityType: lit("ANNOTATION"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    entityInstanceType: opt(id("EntityInstanceType")),
    labels: fkTable("LABEL", bool),
    type: lit("DETAIL"),
    x: num,
    y: num,
    rotation: num,
  },
  "AssetCatalogReference",
);
export const AssetHandleSchema = interf(
  {
    type: lit("ASSET"),
    id: str,
  },
  "AssetHandle",
);
export const AssetReferenceUnderlaySchema = interf(
  {
    underlayType: lit("ASSET_REFERENCE"),
    assetId: opt(fk("ASSET")),
    scale: num,
    rotation: opt(num),
    id: pk("UNDERLAY"),
    x: num,
    y: num,
    opacity: opt(nom("Percent")),
    tint: opt(str),
    underlayViewType: union([lit("ELEVATION_VIEW"), lit("PLAN_VIEW")]),
    viewId: opt(fk("ELEVATION_VIEW")),
    levelId: opt(fk("LEVEL")),
    entityType: lit("UNDERLAY"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "AssetReferenceUnderlay",
);
export const AtBackOfPropSchema = interf(
  {
    layoutType: lit("AT_BACK_OF_PROP"),
    controllerPlacementType: opt(arr(id("ControllerSelectionConfig"))),
    connected: id("OptionalBoolean"),
    loadType: fk("LOAD_DESCRIPTOR"),
    loadSlot: opt(id("LoadTypeSlot")),
    placements: arr(id("LegacyOffsetFromPropBack")),
    propType: fk("PROP"),
  },
  "AtBackOfProp",
);
export const AtDoorByTypeSchema = interf(
  {
    layoutType: lit("AT_DOOR_BY_TYPE"),
    loadType: fk("LOAD_DESCRIPTOR"),
    doorType: opt(fk("DOOR_DESCRIPTOR")),
    offset: num,
    controllerPlacementType: opt(arr(id("ControllerSelectionConfig"))),
    connected: id("OptionalBoolean"),
  },
  "AtDoorByType",
);
export const AutoDimensionFloorPlanExteriorByOrientationHandleSchema = interf(
  {
    type: lit("AUTO_DIMENSION"),
    provenance: id("AutoDimensionFloorPlanExteriorByOrientationProvenance"),
  },
  "AutoDimensionFloorPlanExteriorByOrientationHandle",
);
export const AutoDimensionFloorPlanExteriorByOrientationProvenanceSchema = interf(
  {
    type: lit("AUTO_DIMENSION_FLOOR_PLAN_EXTERIOR_BY_ORIENTATION"),
    levelId: fk(["LEVEL", "COMPOSITE_LEVEL"]),
    orientation: id("EdgeOrientation"),
    rowLevel: id("DimensionRowLevel"),
    criteria: arr(id("SettingsCriterion")),
  },
  "AutoDimensionFloorPlanExteriorByOrientationProvenance",
);
export const AutoDimensionFloorPlanExteriorByRoomMultipleHandleSchema = interf(
  {
    type: lit("AUTO_DIMENSION"),
    provenance: id("AutoDimensionFloorPlanExteriorByRoomMultipleProvenance"),
  },
  "AutoDimensionFloorPlanExteriorByRoomMultipleHandle",
);
export const AutoDimensionFloorPlanExteriorByRoomMultipleProvenanceSchema = interf(
  {
    type: lit("AUTO_DIMENSION_FLOOR_PLAN_EXTERIOR_BY_ROOM_MULTIPLE"),
    levelId: fk("LEVEL"),
    rowLevel: id("DimensionRowLevel"),
    isOrthogonal: bool,
    roomEdges: arr(id("RoomEdge")),
    criteria: arr(id("SettingsCriterion")),
  },
  "AutoDimensionFloorPlanExteriorByRoomMultipleProvenance",
);
export const AutoDimensionFloorPlanExteriorByRoomSingleHandleSchema = interf(
  {
    type: lit("AUTO_DIMENSION"),
    provenance: id("AutoDimensionFloorPlanExteriorByRoomSingleProvenance"),
  },
  "AutoDimensionFloorPlanExteriorByRoomSingleHandle",
);
export const AutoDimensionFloorPlanExteriorByRoomSingleProvenanceSchema = interf(
  {
    type: lit("AUTO_DIMENSION_FLOOR_PLAN_EXTERIOR_BY_ROOM_SINGLE"),
    levelId: fk("LEVEL"),
    rowLevel: id("DimensionRowLevel"),
    isOrthogonal: bool,
    roomEdge: id("RoomEdge"),
    criteria: arr(id("SettingsCriterion")),
  },
  "AutoDimensionFloorPlanExteriorByRoomSingleProvenance",
);
export const AutoDimensionFloorPlanInteriorByOrthogonalRoomEdgeSchema = interf(
  {
    type: lit("AUTO_DIMENSION_FLOOR_PLAN_INTERIOR_BY_ORTHOGONAL_ROOM_EDGE"),
    levelId: fk("LEVEL"),
    roomEdges: arr(id("RoomEdge")),
    criteria: arr(id("SettingsCriterion")),
  },
  "AutoDimensionFloorPlanInteriorByOrthogonalRoomEdge",
);
export const AutoDimensionFloorPlanInteriorByOrthogonalRoomEdgeHandleSchema = interf(
  {
    type: lit("AUTO_DIMENSION"),
    provenance: id("AutoDimensionFloorPlanInteriorByOrthogonalRoomEdge"),
  },
  "AutoDimensionFloorPlanInteriorByOrthogonalRoomEdgeHandle",
);
export const AutoDimensionFloorPlanInteriorByRoomEdgePairSchema = interf(
  {
    type: lit("AUTO_DIMENSION_FLOOR_PLAN_INTERIOR_BY_OPPOSITE_ROOM_EDGE_PAIR"),
    levelId: fk("LEVEL"),
    roomEdgePairs: arr(tuple([id("RoomEdge"), id("RoomEdge")])),
    criteria: arr(id("SettingsCriterion")),
  },
  "AutoDimensionFloorPlanInteriorByRoomEdgePair",
);
export const AutoDimensionFloorPlanInteriorByRoomEdgePairHandleSchema = interf(
  {
    type: lit("AUTO_DIMENSION"),
    provenance: id("AutoDimensionFloorPlanInteriorByRoomEdgePair"),
  },
  "AutoDimensionFloorPlanInteriorByRoomEdgePairHandle",
);
export const AutoDimensionFoundationExteriorByOrientationHandleSchema = interf(
  {
    type: lit("AUTO_DIMENSION"),
    provenance: id("AutoDimensionFoundationExteriorByOrientationProvenance"),
  },
  "AutoDimensionFoundationExteriorByOrientationHandle",
);
export const AutoDimensionFoundationExteriorByOrientationProvenanceSchema = interf(
  {
    type: lit("AUTO_DIMENSION_FOUNDATION_EXTERIOR_BY_ORIENTATION"),
    levelId: fk("LEVEL"),
    orientation: id("EdgeOrientation"),
    rowLevel: id("DimensionRowLevel"),
    criteria: arr(id("SettingsCriterion")),
  },
  "AutoDimensionFoundationExteriorByOrientationProvenance",
);
export const AutoDimensionFoundationExteriorByRoomMultipleHandleSchema = interf(
  {
    type: lit("AUTO_DIMENSION"),
    provenance: id("AutoDimensionFoundationExteriorByRoomMultipleProvenance"),
  },
  "AutoDimensionFoundationExteriorByRoomMultipleHandle",
);
export const AutoDimensionFoundationExteriorByRoomMultipleProvenanceSchema = interf(
  {
    type: lit("AUTO_DIMENSION_FOUNDATION_EXTERIOR_BY_ROOM_MULTIPLE"),
    rowLevel: id("DimensionRowLevel"),
    isOrthogonal: bool,
    roomEdges: arr(id("LevelRoomEdge")),
    criteria: arr(id("SettingsCriterion")),
  },
  "AutoDimensionFoundationExteriorByRoomMultipleProvenance",
);
export const AutoDimensionFoundationExteriorByRoomSingleHandleSchema = interf(
  {
    type: lit("AUTO_DIMENSION"),
    provenance: id("AutoDimensionFoundationExteriorByRoomSingleProvenance"),
  },
  "AutoDimensionFoundationExteriorByRoomSingleHandle",
);
export const AutoDimensionFoundationExteriorByRoomSingleProvenanceSchema = interf(
  {
    type: lit("AUTO_DIMENSION_FOUNDATION_EXTERIOR_BY_ROOM_SINGLE"),
    rowLevel: id("DimensionRowLevel"),
    isOrthogonal: bool,
    roomEdge: id("LevelRoomEdge"),
    criteria: arr(id("SettingsCriterion")),
  },
  "AutoDimensionFoundationExteriorByRoomSingleProvenance",
);
export const AutoDimensionFoundationInteriorByOrientationHandleSchema = interf(
  {
    type: lit("AUTO_DIMENSION"),
    provenance: id("AutoDimensionFoundationInteriorByOrientationProvenance"),
  },
  "AutoDimensionFoundationInteriorByOrientationHandle",
);
export const AutoDimensionFoundationInteriorByOrientationProvenanceSchema = interf(
  {
    type: lit("AUTO_DIMENSION_FOUNDATION_INTERIOR_BY_ORIENTATION"),
    levelId: fk("LEVEL"),
    orientation: id("EdgeOrientation"),
    rowLevel: id("DimensionRowLevel"),
    criteria: arr(id("SettingsCriterion")),
  },
  "AutoDimensionFoundationInteriorByOrientationProvenance",
);
export const AutoDimensionFoundationInteriorByRoomMultipleHandleSchema = interf(
  {
    type: lit("AUTO_DIMENSION"),
    provenance: id("AutoDimensionFoundationInteriorByRoomMultipleProvenance"),
  },
  "AutoDimensionFoundationInteriorByRoomMultipleHandle",
);
export const AutoDimensionFoundationInteriorByRoomMultipleProvenanceSchema = interf(
  {
    type: lit("AUTO_DIMENSION_FOUNDATION_INTERIOR_BY_ROOM_MULTIPLE"),
    rowLevel: id("DimensionRowLevel"),
    isOrthogonal: bool,
    roomEdges: arr(id("LevelRoomEdge")),
    criteria: arr(id("SettingsCriterion")),
  },
  "AutoDimensionFoundationInteriorByRoomMultipleProvenance",
);
export const AutoDimensionFoundationInteriorByRoomSingleHandleSchema = interf(
  {
    type: lit("AUTO_DIMENSION"),
    provenance: id("AutoDimensionFoundationInteriorByRoomSingleProvenance"),
  },
  "AutoDimensionFoundationInteriorByRoomSingleHandle",
);
export const AutoDimensionFoundationInteriorByRoomSingleProvenanceSchema = interf(
  {
    type: lit("AUTO_DIMENSION_FOUNDATION_INTERIOR_BY_ROOM_SINGLE"),
    rowLevel: id("DimensionRowLevel"),
    isOrthogonal: bool,
    roomEdge: id("LevelRoomEdge"),
    criteria: arr(id("SettingsCriterion")),
  },
  "AutoDimensionFoundationInteriorByRoomSingleProvenance",
);
export const AutoDimensionPersistedHandleSchema = union(
  [
    id("AutoDimensionFloorPlanExteriorByRoomSingleHandle"),
    id("AutoDimensionFloorPlanExteriorByOrientationHandle"),
    id("AutoDimensionFoundationExteriorByRoomSingleHandle"),
    id("AutoDimensionFoundationExteriorByOrientationHandle"),
    id("AutoDimensionFoundationInteriorByRoomSingleHandle"),
    id("AutoDimensionFoundationInteriorByOrientationHandle"),
    id("AutoDimensionFloorPlanInteriorByRoomEdgePairHandle"),
    id("AutoDimensionFloorPlanInteriorByOrthogonalRoomEdgeHandle"),
  ],
  "AutoDimensionPersistedHandle",
);
export const AutoDimensionSelectorSchema = interf(
  {
    selectorType: lit("AUTO_DIMENSION"),
    overrideId: fk("VIEW_OVERRIDE"),
    parentId: union(
      [
        fk("ROOM", { hierarchy: ["PARENT"] }),
        fk("LEVEL", { hierarchy: ["PARENT"] }),
        fk("COMPOSITE_LEVEL", { hierarchy: ["PARENT"] }),
      ],
      "DocEntityParentId",
    ),
    entityHandle: id("AutoDimensionPersistedHandle"),
    id: pk("SELECTOR"),
    entityType: lit("SELECTOR"),
    name: str,
    sortIndex: num,
  },
  "AutoDimensionSelector",
);
export const AwningSchema = interf(
  {
    startOffset: num,
    endOffset: num,
    offsetsNormalized: bool,
  },
  "Awning",
);
export const AwningSettingsSchema = union([id("ShedAwningSettings"), id("DisabledAwningSettings")], "AwningSettings");
export const BackgroundPlanSheetSchema = interf(
  {
    id: pk("SHEET"),
    type: lit("BACKGROUND"),
    background: id("BackgroundType"),
    backgroundVisibility: id("BackgroundVisibility"),
    removeTitleBlock: bool,
    entityType: lit("SHEET"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    sheetNumberPrefix: str,
    sheetNumber: str,
    labels: fkTable("LABEL", bool),
  },
  "BackgroundPlanSheet",
);
export const BackgroundTypeSchema = enu(
  {
    [`FLOOR_PLAN`]: "FLOOR_PLAN",
    [`ROOF_PLAN`]: "ROOF_PLAN",
  },
  "BackgroundType",
);
export const BackgroundVisibilitySchema = enu(
  {
    [`FULL`]: "FULL",
    [`BACKGROUND`]: "BACKGROUND",
  },
  "BackgroundVisibility",
);
export const BalusterDefaultSchema = interf(
  {
    type: lit("BALUSTER_DEFAULT"),
    width: num,
    spacing: num,
    startHeight: num,
  },
  "BalusterDefault",
);
export const BaseCabinetDescriptorSchema = interf(
  {
    type: lit("BASE_CABINET"),
    width: num,
    shape: opt(id("CabinetShape")),
    superType: lit("CABINET"),
    id: pk("CASEWORK_DESCRIPTOR"),
    name: str,
    floorMaterialOverride: opt(id("InteriorFloorMaterialOverride")),
    tag: opt(str),
    tagOffset: opt(num),
    catalogItemType: lit("CASEWORK_DESCRIPTOR"),
  },
  "BaseCabinetDescriptor",
);
export const BaseRangeFilterSchema = interf(
  {
    minimum: num,
    maximum: num,
    negate: id("OptionalBoolean"),
  },
  "BaseRangeFilter",
);
export const BaseRoomTypeSpaceTypeFilterSchema = interf(
  {
    roomType: arr(id("RoomTypeFilter")),
    spaceType: arr(id("SpaceTypeFilter")),
    area: arr(id("RangeFilter")),
    width: arr(id("RangeFilter")),
    length: arr(id("RangeFilter")),
  },
  "BaseRoomTypeSpaceTypeFilter",
);
export const BaseSettingsSchema = interf(
  {
    type: id("SettingsType"),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "BaseSettings",
);
export const BayFramingEdgeOverrideSchema = interf(
  {
    framingConfig: opt(id("FramingConfig")),
    derivedFromSplitLineEdge: opt(str),
  },
  "BayFramingEdgeOverride",
);
export const BlindPanelSideSchema = enu(
  {
    [`LEFT`]: "LEFT",
    [`RIGHT`]: "RIGHT",
  },
  "BlindPanelSide",
);
export const BlockSchema = interf(
  {
    id: pk("BLOCK"),
    levelId: union([fk("LEVEL", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    isHalfStory: id("OptionalBoolean"),
    suppressWainscoting: id("OptionalBoolean"),
    suppressShutters: id("OptionalBoolean"),
    entityType: lit("BLOCK"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "Block",
);
export const BlockHandleSchema = interf(
  {
    type: lit("BLOCK"),
    id: str,
  },
  "BlockHandle",
);
export const BoardDescriptorSchema = interf(
  {
    profileType: lit("BOARD"),
    width: num,
    height: num,
    nominalWidth: num,
    nominalHeight: num,
    name: str,
    entityType: lit("PROFILE_EXTRUSION"),
    elevationNoteEnabled: id("OptionalBoolean"),
    elevationNote: opt(str),
    catalogItemType: lit("PROFILE_EXTRUSION_DESCRIPTOR"),
  },
  "BoardDescriptor",
);
export const BoardProfileEntitySchema = interf(
  {
    profileType: lit("BOARD"),
    width: num,
    height: num,
    nominalWidth: num,
    nominalHeight: num,
    id: pk("PROFILE"),
    entityType: lit("PROFILE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    elevationNoteEnabled: id("OptionalBoolean"),
    elevationNote: opt(str),
  },
  "BoardProfileEntity",
);
export const BooleanAtomSchema = bool;
export const BooleanParameterSchema = interf(
  {
    defaultValue: id("OptionalBoolean"),
    type: lit("BOOLEAN"),
  },
  "BooleanParameter",
);
export const BrickLedgeBehaviorSchema = enu(
  {
    [`AUTO`]: "AUTO",
    [`FORCE`]: "FORCE",
  },
  "BrickLedgeBehavior",
);
export const BrickLedgeTypeSchema = enu(
  {
    [`NONE`]: "NONE",
    [`ADD`]: "ADD",
    [`INSET`]: "INSET",
  },
  "BrickLedgeType",
);
export const BuildingGraphPlanarTopologyHandleSchema = interf(
  {
    startHorizontalDatumId: opt(fk("DATUM")),
    endHorizontalDatumId: opt(fk("DATUM")),
    startVerticalDatumId: opt(fk("DATUM")),
    endVerticalDatumId: opt(fk("DATUM")),
    relativeUStartInset: opt(num),
    relativeUEndInset: opt(num),
    relativeVBottomInset: opt(num),
    relativeVTopInset: opt(num),
    entityType: lit("BUILDING_GRAPH_PLANAR_TOPOLOGY"),
    id: str,
  },
  "BuildingGraphPlanarTopologyHandle",
);
export const BuildingSideSchema = enu(
  {
    [`FRONT`]: "FRONT",
    [`BACK`]: "BACK",
    [`LEFT`]: "LEFT",
    [`RIGHT`]: "RIGHT",
    [`DIAGONAL`]: "DIAGONAL",
  },
  "BuildingSide",
);
export const BuildingWallPlaneSubdomainHandleSchema = interf(
  {
    parent: ref(
      interf(
        {
          entityType: typeParam("T"),
          id: str,
        },
        "BuildingEntityHandleBase",
        ["T"],
      ),
      { T: lit("WALL_PLANE") },
    ),
    indexU: num,
    indexV: num,
    entityType: lit("WALL_PLANE_SUBDOMAIN"),
    id: str,
  },
  "BuildingWallPlaneSubdomainHandle",
);
export const BuiltInExteriorPropIdSchema = enu(
  {
    [`GARAGEDOORSINGLE`]: "garageDoorSingle",
    [`GARAGEDOORSINGLESECONDARY`]: "garageDoorSingleSecondary",
    [`GARAGEDOORDOUBLE`]: "garageDoorDouble",
    [`GARAGEDOORDOUBLESECONDARY`]: "garageDoorDoubleSecondary",
    [`GARAGEDOORDOUBLETERTIARY`]: "garageDoorDoubleTertiary",
    [`GARAGEDOORDOUBLEQUATERNARY`]: "garageDoorDoubleQuaternary",
    [`DOORGARAGE10080`]: "doorGarage10080",
    [`DOORGARAGE20080`]: "doorGarage20080",
    [`DOORGARAGE18070`]: "doorGarage18070",
    [`DOORGARAGE18070SECONDARY`]: "doorGarage18070Secondary",
    [`DOORGARAGE9070`]: "doorGarage9070",
    [`SEDAN`]: "sedan",
    [`SUV`]: "suv",
    [`TRUCK`]: "truck",
    [`DOORSINGLEGLASS32`]: "doorSingleGlass32",
    [`DOORSINGLEGLASS32HL`]: "doorSingleGlass32HL",
    [`DOORSINGLEGLASS32LOW`]: "doorSingleGlass32Low",
    [`DOORSINGLEGLASS32LOWHL`]: "doorSingleGlass32LowHL",
    [`DOORSINGLEGLASS36HL`]: "doorSingleGlass36HL",
    [`DOORSINGLEGLASS36LOWHL`]: "doorSingleGlass36LowHL",
    [`DOORSINGLEGLASSSECONDARY`]: "doorSingleGlassSecondary",
    [`DOORSINGLEGLASSLOWSECONDARY`]: "doorSingleGlassLowSecondary",
    [`DOORDOUBLEGLASS`]: "doorDoubleGlass",
    [`DOORSLIDINGGLASS4068`]: "doorSlidingGlass4068",
    [`DOORSLIDINGGLASS4080`]: "doorSlidingGlass4080",
    [`DOORSLIDINGGLASS5068`]: "doorSlidingGlass5068",
    [`DOORSLIDINGGLASS5080`]: "doorSlidingGlass5080",
    [`DOORSLIDINGGLASS6068`]: "doorSlidingGlass6068",
    [`DOORSLIDINGGLASS6080`]: "doorSlidingGlass6080",
    [`DOORSLIDINGGLASS7680`]: "doorSlidingGlass7680",
    [`DOORSLIDINGGLASS7880`]: "doorSlidingGlass7880",
    [`DOORSLIDINGGLASS8080`]: "doorSlidingGlass8080",
    [`DOORSLIDINGGLASS9068`]: "doorSlidingGlass9068",
    [`DOORSLIDINGGLASS9080`]: "doorSlidingGlass9080",
    [`DOORSLIDINGGLASS10068`]: "doorSlidingGlass10068",
    [`DOORSLIDINGGLASS10080`]: "doorSlidingGlass10080",
    [`DOORSLIDINGGLASS12080`]: "doorSlidingGlass12080",
    [`DOORSLIDINGGLASS15068`]: "doorSlidingGlass15068",
    [`DOORSLIDINGGLASS15080`]: "doorSlidingGlass15080",
    [`DOORDOUBLEGLASSLOW`]: "doorDoubleGlassLow",
    [`DOORDOUBLEGLASS36LOW`]: "doorDoubleGlass36Low",
    [`DOORDOUBLEGLASS36LOWHINGEDFIXED`]: "doorDoubleGlass36LowHingedFixed",
    [`DOORDOUBLEGLASS36HINGEDFIXED`]: "doorDoubleGlass36HingedFixed",
    [`DOORDOUBLESLIDE`]: "doorDoubleSlide",
    [`DOORDOUBLESLIDELOW`]: "doorDoubleSlideLow",
    [`DOORSINGLEGLASS`]: "doorSingleGlass",
    [`DOORSINGLEGLASS36`]: "doorSingleGlass36",
    [`DOORSINGLEGLASSLOW`]: "doorSingleGlassLow",
    [`DOORSINGLEGLASSLOWTRANSOM`]: "doorSingleGlassLowTransom",
    [`EXTERIORLAMP`]: "exteriorLamp",
    [`DECKSET`]: "deckSet",
    [`DECKCHAIRSINGLE`]: "deckChairSingle",
    [`DECKCHAIR`]: "deckChair",
    [`CHAIRADIRONDACK`]: "chairAdirondack",
    [`DECKBENCH`]: "deckBench",
    [`DECKSIDETABLE`]: "deckSideTable",
    [`DECKCOFFEETABLE`]: "deckCoffeeTable",
    [`DECKDININGTABLE4SEAT`]: "deckDiningTable4Seat",
    [`DECKDININGTABLE6SEAT`]: "deckDiningTable6Seat",
    [`GRILLGAS`]: "grillGas",
    [`GRILLINSERT`]: "grillInsert",
    [`OUTDOORFRIDGE`]: "outdoorFridge",
    [`SINK`]: "sink",
    [`FIREPIT`]: "firepit",
    [`RAKEBRACKET`]: "rakeBracket",
    [`ANGLEBRACKET14X18`]: "angleBracket14x18",
    [`ANGLEBRACKET25X27`]: "angleBracket25x27",
    [`ANGLEBRACKET20X20`]: "angleBracket20x20",
    [`SOFFITCORBEL8X12`]: "soffitCorbel8x12",
    [`AWNINGBRACKET`]: "awningBracket",
    [`BRACKETFRENCHCOUNTRY`]: "bracketFrenchCountry",
    [`BRACKETTALLTAPERED`]: "bracketTallTapered",
    [`CEILINGFAN`]: "ceilingFan",
    [`CRAFTCOLUMN`]: "craftColumn",
    [`CRAFTORNAMENT`]: "craftOrnament",
    [`BEAZERORNAMENT`]: "beazerOrnament",
    [`SHUTTERS3050`]: "shutters3050",
    [`DOORSINGLEARCH36`]: "doorSingleArch36",
    [`EXTERIORLAMPGAS`]: "exteriorLampGas",
    [`ZENCOLUMN`]: "zenColumn",
    [`ZENCOLUMNANGLED`]: "zenColumnAngled",
    [`CRAFTSHUTTER`]: "craftShutter",
    [`ELLIOTTGABLEARCH12`]: "elliottGableArch12",
    [`ELLIOTTGABLEARCH7`]: "elliottGableArch7",
    [`ELLIOTTGABLEARCH8`]: "elliottGableArch8",
    [`ELLIOTTGABLEARCH9`]: "elliottGableArch9",
  },
  "BuiltInExteriorPropId",
);
export const BuiltinPlanViewTypeSchema = enu(
  {
    [`EMPTY`]: "EMPTY",
    [`FLOOR`]: "FLOOR",
    [`FOUNDATION`]: "FOUNDATION",
    [`ELECTRICAL`]: "ELECTRICAL",
    [`ROOF`]: "ROOF",
    [`BROCHURE`]: "BROCHURE",
    [`UTILITY`]: "UTILITY",
    [`STRUCTURAL`]: "STRUCTURAL",
    [`FLOOR_MATERIALS`]: "FLOOR_MATERIALS",
    [`FLOOR_SUMMARY`]: "FLOOR_SUMMARY",
    [`BACKGROUND`]: "BACKGROUND",
  },
  "BuiltinPlanViewType",
);
export const BuiltInSiteTypeSchema = enu(
  {
    [`DYNAMIC`]: "DYNAMIC",
    [`STATIC_CONTOUR`]: "STATIC_CONTOUR",
    [`WHITE_BOX`]: "WHITE_BOX",
  },
  "BuiltInSiteType",
);
export const BuiltInViewSelectorSchema = interf(
  {
    viewSelectorType: lit("BUILT_IN_VIEW"),
    id: pk("VIEW_SELECTOR"),
    overrideId: fk("VIEW_OVERRIDE"),
    entityType: lit("VIEW_SELECTOR"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "BuiltInViewSelector",
);
export const BuiltinWindowIdSchema = enu(
  {
    [`A1840`]: "A1840",
    [`A2040`]: "A2040",
    [`A2060`]: "A2060",
    [`A2640`]: "A2640",
    [`A3030`]: "A3030",
    [`A4040`]: "A4040",
    [`A2046`]: "A2046",
    [`A71046`]: "A71046",
    [`A2050`]: "A2050",
    [`A2030`]: "A2030",
    [`A2080`]: "A2080",
    [`A2650`]: "A2650",
    [`A2550`]: "A2550",
    [`A3040`]: "A3040",
    [`A3040_TEMP`]: "A3040_TEMP",
    [`A3046`]: "A3046",
    [`A3050`]: "A3050",
    [`A3050_TEMP`]: "A3050_TEMP",
    [`A3050_BRICK`]: "A3050_BRICK",
    [`A3850`]: "A3850",
    [`A4050`]: "A4050",
    [`A5050`]: "A5050",
    [`A2860`]: "A2860",
    [`A3060`]: "A3060",
    [`A4060`]: "A4060",
    [`A5060`]: "A5060",
    [`A31080`]: "A31080",
    [`A4080`]: "A4080",
    [`A5080`]: "A5080",
    [`A31090`]: "A31090",
    [`A4090`]: "A4090",
    [`A5090`]: "A5090",
    [`TR13880`]: "TR13880",
    [`TR13890`]: "TR13890",
    [`TW2636`]: "TW2636",
    [`TW2040`]: "TW2040",
    [`TW2640`]: "TW2640",
    [`TW2646`]: "TW2646",
    [`TW2650`]: "TW2650",
    [`TW3020`]: "TW3020",
    [`TW3050`]: "TW3050",
    [`TW3050_TEMP_HALF`]: "TW3050_TEMP_HALF",
    [`TW3060`]: "TW3060",
    [`TW3080`]: "TW3080",
    [`TW4080`]: "TW4080",
    [`TR2020`]: "TR2020",
    [`TR2030`]: "TR2030",
    [`TR2640`]: "TR2640",
    [`TR2650`]: "TR2650",
    [`TR2660`]: "TR2660",
    [`TR2050`]: "TR2050",
    [`TR3050`]: "TR3050",
    [`TR3060`]: "TR3060",
    [`TR3080`]: "TR3080",
    [`K1`]: "K1",
    [`T1`]: "T1",
    [`T2`]: "T2",
    [`T2620`]: "T2620",
    [`T3620`]: "T3620",
    [`T3010`]: "T3010",
    [`T4010`]: "T4010",
    [`T5010`]: "T5010",
    [`T6010`]: "T6010",
    [`T8010`]: "T8010",
    [`T2010`]: "T2010",
    [`T2020`]: "T2020",
    [`T6020`]: "T6020",
    [`T2020_LOW`]: "T2020_LOW",
    [`TW2220`]: "TW2220",
    [`G1620`]: "G1620",
    [`G2020`]: "G2020",
    [`G2030`]: "G2030",
    [`G2436`]: "G2436",
    [`G2040`]: "G2040",
    [`G3040`]: "G3040",
    [`G6630`]: "G6630",
    [`S1`]: "S1",
    [`S2`]: "S2",
    [`SL1`]: "SL1",
    [`D6020`]: "D6020",
    [`V2020`]: "V2020",
    [`V0808`]: "V0808",
    [`V1`]: "V1",
    [`V0912`]: "V0912",
    [`V1220`]: "V1220",
    [`V1020`]: "V1020",
    [`V1620`]: "V1620",
    [`V1824`]: "V1824",
    [`D1`]: "D1",
    [`NO`]: "NO",
    [`FS3050`]: "FS3050",
  },
  "BuiltinWindowId",
);
export const CabinetShapeSchema = union(
  [id("CabinetShapeNone"), id("CabinetShapeLShaped"), id("CabinetShapeAngled")],
  "CabinetShape",
);
export const CabinetShapeAngledSchema = interf(
  {
    type: lit("ANGLED"),
    frontWidths: arr(num),
    reverse: id("OptionalBoolean"),
    rearWidth: opt(num),
  },
  "CabinetShapeAngled",
);
export const CabinetShapeLShapedSchema = interf(
  {
    type: lit("L_SHAPED"),
    frontWidths: arr(num),
    reverse: id("OptionalBoolean"),
  },
  "CabinetShapeLShaped",
);
export const CabinetShapeNoneSchema = interf(
  {
    type: lit("NONE"),
  },
  "CabinetShapeNone",
);
export const CameraPositionSchema = interf(
  {
    x: num,
    y: num,
    z: num,
    targetX: opt(num),
    targetY: opt(num),
    targetZ: opt(num),
    zoom: opt(num),
    maxPolarAngle: opt(num),
    levelId: union([undef, nul, str]),
  },
  "CameraPosition",
);
export const CandidateTypeConstraintsSchema = enu(
  {
    [`BY_DOOR_OR_BEHIND_SWING`]: "BY_DOOR_OR_BEHIND_SWING",
    [`BY_DOOR`]: "BY_DOOR",
    [`BY_DOOR_BEHIND_SWING`]: "BY_DOOR_BEHIND_SWING",
    [`BY_CONVEX_CORNER`]: "BY_CONVEX_CORNER",
  },
  "CandidateTypeConstraints",
);
export const CaseworkCatalogSettingsSchema = interf(
  {
    type: lit("CASEWORK_CATALOG_SETTINGS"),
    caseworkTypes: pkTable("CASEWORK_DESCRIPTOR", id("CaseworkDescriptor")),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "CaseworkCatalogSettings",
);
export const CaseworkDescriptorSchema = union(
  [
    id("BaseCabinetDescriptor"),
    id("UpperCabinetDescriptor"),
    id("TallCabinetDescriptor"),
    id("FillerPanelDescriptor"),
    id("ClosetShelfDescriptor"),
  ],
  "CaseworkDescriptor",
);
export const CaseworkDoorStyleSchema = enu(
  {
    [`SLAB`]: "SLAB",
    [`SHAKER`]: "SHAKER",
  },
  "CaseworkDoorStyle",
);
export const CaseworkHandleSchema = interf(
  {
    type: lit("CASEWORK"),
    id: str,
  },
  "CaseworkHandle",
);
export const CaseworkHorizontalAlignmentSchema = enu(
  {
    [`LEFT`]: "LEFT",
    [`CENTER`]: "CENTER",
    [`RIGHT`]: "RIGHT",
  },
  "CaseworkHorizontalAlignment",
);
export const CaseworkLateralAlignmentSchema = enu(
  {
    [`OUTSIDE_FACE`]: "OUTSIDE_FACE",
    [`CENTERLINE`]: "CENTERLINE",
    [`INSIDE_FACE`]: "INSIDE_FACE",
  },
  "CaseworkLateralAlignment",
);
export const CaseworkLineStyleSchema = enu(
  {
    [`SOLID`]: "SOLID",
    [`DASHED`]: "DASHED",
    [`POCHE`]: "POCHE",
    [`NONE`]: "NONE",
  },
  "CaseworkLineStyle",
);
export const CaseworkSettingsSchema = interf(
  {
    type: lit("CASEWORK_SETTINGS"),
    topOfCountertop: num,
    bottomOfUpperCabinets: num,
    bottomOfMicrowaveUpperCabinets: num,
    bottomOfRefrigeratorUpperCabinets: num,
    topOfUpperShelf: num,
    upperCabinetDepth: num,
    upperMicrowaveCabinetDepth: num,
    upperRefrigeratorCabinetDepth: num,
    baseCabinetDepth: num,
    countertopThickness: num,
    countertopOverhang: num,
    toeKickHeight: num,
    toeKickDepth: num,
    tallCabinetDepth: num,
    doorStyle: id("CaseworkDoorStyle"),
    hardware: bool,
    paletteType: id("PaletteType"),
    baseCabinetMaterial: id("PaletteMaterialSlot"),
    upperCabinetMaterial: id("PaletteMaterialSlot"),
    tallCabinetMaterial: id("PaletteMaterialSlot"),
    countertopMaterial: id("PaletteMaterialSlot"),
    removeFloorMaterialUnderBaseCabinets: bool,
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "CaseworkSettings",
);
export const CaseworkVerticalAlignmentSchema = enu(
  {
    [`TOP`]: "TOP",
    [`CENTER`]: "CENTER",
    [`BOTTOM`]: "BOTTOM",
  },
  "CaseworkVerticalAlignment",
);
export const CaseworkVerticalDatumAnchorSchema = enu(
  {
    [`LEVEL_FLOOR_ELEVATION`]: "LEVEL_FLOOR_ELEVATION",
    [`LEVEL_GRADE`]: "LEVEL_GRADE",
    [`LEVEL_CEILING_HEIGHT`]: "LEVEL_CEILING_HEIGHT",
    [`ROOM_FLOOR_ELEVATION`]: "ROOM_FLOOR_ELEVATION",
  },
  "CaseworkVerticalDatumAnchor",
);
export const CasingFinishSettingsSchema = interf(
  {
    headCasingFinishClipping: opt(id("FinishClipping")),
    apronCasingFinishClipping: opt(id("FinishClipping")),
    sideCasingFinishClipping: opt(id("FinishClipping")),
    stoolCasingFinishClipping: opt(id("FinishClipping")),
  },
  "CasingFinishSettings",
);
export const CasingHorizontalPlacementSettingsSchema = interf(
  {
    casingHorizontalOffset: num,
  },
  "CasingHorizontalPlacementSettings",
);
export const CasingLateralPlacementSettingsSchema = interf(
  {
    casingLateralOffset: num,
  },
  "CasingLateralPlacementSettings",
);
export const CasingOrientationSettingsSchema = interf(
  {
    casingOrientation: opt(id("StreetOrientationMode")),
  },
  "CasingOrientationSettings",
);
export const CatalogItemHandleSchema = interf(
  {
    type: lit("CATALOG_ITEM"),
    itemId: str,
  },
  "CatalogItemHandle",
);
export const CeilingSchema = union(
  [
    inters([
      id("TraySimpleOffset"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("CEILING") },
      ),
      interf({
        id: pk("CEILING"),
        parentId: union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      id("TrayFreeform"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("CEILING") },
      ),
      interf({
        id: pk("CEILING"),
        parentId: union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      id("Vaulted"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("CEILING") },
      ),
      interf({
        id: pk("CEILING"),
        parentId: union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      id("None"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("CEILING") },
      ),
      interf({
        id: pk("CEILING"),
        parentId: union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      id("Flat"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("CEILING") },
      ),
      interf({
        id: pk("CEILING"),
        parentId: union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
  ],
  "Ceiling",
);
export const CeilingBoundaryTypeSchema = enu(
  {
    [`INSIDE_OF_FRAMING`]: "INSIDE_OF_FRAMING",
    [`MAX_RECTANGLE`]: "MAX_RECTANGLE",
  },
  "CeilingBoundaryType",
);
export const CeilingHandleSchema = interf(
  {
    type: lit("CEILING"),
    id: str,
  },
  "CeilingHandle",
);
export const CeilingRidgeOrientationSchema = enu(
  {
    [`AUTO`]: "AUTO",
    [`HORIZONTAL`]: "HORIZONTAL",
    [`VERTICAL`]: "VERTICAL",
    [`PARALLEL_TO_WALL`]: "PARALLEL_TO_WALL",
  },
  "CeilingRidgeOrientation",
);
export const CipComponentHandleSchema = interf(
  {
    type: lit("CIP_COMPONENT"),
    id: str,
  },
  "CipComponentHandle",
);
export const CipConcreteSchema = interf(
  {
    thickness: num,
    id: pk("CIP_COMPONENT"),
    name: str,
    cipType: lit("CONCRETE"),
    entityType: lit("CIP_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "CipConcrete",
);
export const CIPStemWallEntitySchema = interf(
  {
    stemWallWidth: num,
    brickLedgeBehavior: id("BrickLedgeBehavior"),
    brickLedgeType: id("BrickLedgeType"),
    brickLedgeWidth: num,
    stemWallType: lit("CIP"),
    id: pk("FOUNDATION_COMPONENT"),
    name: str,
    componentType: lit("STEMWALL"),
    material: opt(id("ExteriorMaterial")),
    entityType: lit("FOUNDATION_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "CIPStemWallEntity",
);
export const CircularCIPPierEntitySchema = interf(
  {
    pierRadius: num,
    pierDepth: opt(num),
    pierType: lit("CIRCULAR_CIP"),
    id: pk("FOUNDATION_COMPONENT"),
    name: str,
    componentType: lit("PIER"),
    material: opt(id("ExteriorMaterial")),
    entityType: lit("FOUNDATION_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "CircularCIPPierEntity",
);
export const CircularCMUPierEntitySchema = interf(
  {
    pierRadius: num,
    pierDepth: opt(num),
    pierType: lit("CIRCULAR_CMU"),
    id: pk("FOUNDATION_COMPONENT"),
    name: str,
    componentType: lit("PIER"),
    material: opt(id("ExteriorMaterial")),
    entityType: lit("FOUNDATION_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "CircularCMUPierEntity",
);
export const CircularIsolatedFootingEntitySchema = interf(
  {
    footingRadius: num,
    footingDepth: num,
    footingType: lit("CIRCULAR_ISOLATED"),
    id: pk("FOUNDATION_COMPONENT"),
    name: str,
    componentType: lit("FOOTING"),
    material: opt(id("ExteriorMaterial")),
    entityType: lit("FOUNDATION_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "CircularIsolatedFootingEntity",
);
export const ClosetShelfDescriptorSchema = interf(
  {
    shelfDepth: num,
    type: lit("CLOSET_SHELF"),
    width: num,
    superType: lit("SHELVING"),
    id: pk("CASEWORK_DESCRIPTOR"),
    name: str,
    floorMaterialOverride: opt(id("InteriorFloorMaterialOverride")),
    tag: opt(str),
    tagOffset: opt(num),
    catalogItemType: lit("CASEWORK_DESCRIPTOR"),
  },
  "ClosetShelfDescriptor",
);
export const CMUBrickLedgeTypeSchema = union([lit("NONE"), lit("ADD")], "CMUBrickLedgeType");
export const CMUProfileSchema = enu(
  {
    [`CMU_4`]: "CMU_4",
    [`CMU_6`]: "CMU_6",
    [`CMU_8`]: "CMU_8",
    [`CMU_10`]: "CMU_10",
    [`CMU_12`]: "CMU_12",
    [`CMU_8x8x24`]: "CMU_8x8x24",
  },
  "CMUProfile",
);
export const CMUStemWallEntitySchema = interf(
  {
    stemWallBlockWidth: num,
    brickLedgeBehavior: id("BrickLedgeBehavior"),
    brickLedgeType: id("CMUBrickLedgeType"),
    stemWallBrickLedgeBlockWidth: num,
    stemWallType: lit("CMU"),
    id: pk("FOUNDATION_COMPONENT"),
    name: str,
    componentType: lit("STEMWALL"),
    material: opt(id("ExteriorMaterial")),
    entityType: lit("FOUNDATION_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "CMUStemWallEntity",
);
export const CodeFormattingSchema = union([id("ManualCodeFormatting"), id("OptionCodeFormatting")], "CodeFormatting");
export const ColonnadeTerminationRuleSchema = interf(
  {
    endType: id("WallIntersectionType"),
    terminationType: id("ColonnadeTerminationType"),
  },
  "ColonnadeTerminationRule",
);
export const ColonnadeTerminationTypeSchema = enu(
  {
    [`NO_COLUMN`]: "NO_COLUMN",
    [`COLUMN`]: "COLUMN",
  },
  "ColonnadeTerminationType",
);
export const ColumnSchema = union([id("ColumnV1"), id("ColumnV2")], "Column");
export const ColumnCatalogSettingsSchema = interf(
  {
    type: lit("COLUMN_CATALOG_SETTINGS"),
    columnTable: pkTable("COLUMN_DESCRIPTOR", id("ColumnDescriptor")),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "ColumnCatalogSettings",
);
export const ColumnDescriptorSchema = union(
  [id("ArchitecturalColumnDescriptor"), id("StructuralWoodPostDescriptor")],
  "ColumnDescriptor",
);
export const ColumnDimensionTypeSchema = enu(
  {
    [`CENTERLINE`]: "CENTERLINE",
    [`EDGE_OF_FRAMING`]: "EDGE_OF_FRAMING",
    [`HYBRID`]: "HYBRID",
    [`NONE`]: "NONE",
  },
  "ColumnDimensionType",
);
export const ColumnHandleSchema = interf(
  {
    type: lit("COLUMN"),
    id: str,
    parent: union([undef, id("RoomHandle"), id("RoomEdgeHandle")]),
  },
  "ColumnHandle",
);
export const ColumnHorizontalAlignmentSchema = enu(
  {
    [`RIGHT`]: "RIGHT",
    [`CENTER`]: "CENTER",
    [`LEFT`]: "LEFT",
  },
  "ColumnHorizontalAlignment",
);
export const ColumnLateralAlignmentSchema = enu(
  {
    [`CENTER`]: "CENTER",
    [`FRONT`]: "FRONT",
    [`BACK`]: "BACK",
  },
  "ColumnLateralAlignment",
);
export const ColumnPlacementV1Schema = union(
  [
    id("ParamColumnPlacementV1"),
    id("ArrayColumnPlacementV1"),
    id("DivisionColumnPlacementV1"),
    id("MaxDistanceColumnPlacementV1"),
  ],
  "ColumnPlacementV1",
);
export const ColumnPlacementV2Schema = union(
  [
    id("ParamColumnPlacementV2"),
    id("ArrayColumnPlacementV2"),
    id("DivisionColumnPlacementV2"),
    id("MaxDistanceColumnPlacementV2"),
  ],
  "ColumnPlacementV2",
);
export const ColumnPositionSchema = interf(
  {
    rotated: id("OptionalBoolean"),
    param: num,
    paramNormalized: bool,
  },
  "ColumnPosition",
);
export const ColumnSectionSchema = interf(
  {
    height: num,
    width: num,
    depth: num,
    paletteId: id("ExteriorMaterial"),
    materialRotation: opt(num),
    taper: id("OptionalBoolean"),
    bottomElevation: opt(id("NominalNumber")),
  },
  "ColumnSection",
);
export const ColumnV1Schema = interf(
  {
    version: lit("V1"),
    horizontalOffset: num,
    horizontalOffsetNormalized: bool,
    placement: id("ColumnPlacementV1"),
    id: pk("COLUMN"),
    parentId: union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    edgeId: str,
    catalogColumnId: fk("COLUMN_DESCRIPTOR"),
    paletteId: id("ExteriorMaterial"),
    isolatedAssemblyId: fk("FOUNDATION_ASSEMBLY"),
    verticalDatum: id("VerticalDatumData"),
    horizontalDatum: id("WallHorizontalDatum"),
    lateralDatum: id("WallLateralDatumAnchorAll"),
    horizontalAlignment: id("ColumnHorizontalAlignment"),
    lateralAlignment: id("ColumnLateralAlignment"),
    lateralOffset: num,
    lateralOffsetNormalized: bool,
    entityType: lit("COLUMN"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "ColumnV1",
);
export const ColumnV2Schema = interf(
  {
    version: lit("V2"),
    param: num,
    paramNormalized: bool,
    paramAnchor: id("LineAnchor"),
    placement: id("ColumnPlacementV2"),
    id: pk("COLUMN"),
    parentId: union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    edgeId: str,
    catalogColumnId: fk("COLUMN_DESCRIPTOR"),
    paletteId: id("ExteriorMaterial"),
    isolatedAssemblyId: fk("FOUNDATION_ASSEMBLY"),
    verticalDatum: id("VerticalDatumData"),
    horizontalDatum: id("WallHorizontalDatum"),
    lateralDatum: id("WallLateralDatumAnchorAll"),
    horizontalAlignment: id("ColumnHorizontalAlignment"),
    lateralAlignment: id("ColumnLateralAlignment"),
    lateralOffset: num,
    lateralOffsetNormalized: bool,
    entityType: lit("COLUMN"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "ColumnV2",
);
export const ComponentSchema = interf(
  {
    id: pk("COMPONENT"),
    name: str,
    entityType: lit("COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "Component",
);
export const ComponentHandleSchema = interf(
  {
    type: lit("COMPONENT"),
    id: str,
  },
  "ComponentHandle",
);
export const ComponentInstanceSchema = interf(
  {
    id: pk("COMPONENT_INSTANCE"),
    componentId: fk("COMPONENT"),
    verticalPlacement: id("ComponentVerticalPlacement"),
    matrix: id("Mat3"),
    mirrorX: id("OptionalBoolean"),
    mirrorY: id("OptionalBoolean"),
    mirrorCenterX: opt(num),
    mirrorCenterY: opt(num),
    entityType: lit("COMPONENT_INSTANCE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    labels: fkTable("LABEL", bool),
  },
  "ComponentInstance",
);
export const ComponentInstanceHandleSchema = interf(
  {
    type: lit("COMPONENT_INSTANCE"),
    id: str,
  },
  "ComponentInstanceHandle",
);
export const ComponentOptionSetAssociationSchema = interf(
  {
    id: str,
    entityType: lit("OPTION_SET"),
    entityId: fk("OPTION_SET"),
    componentId: fk("COMPONENT"),
    sortIndex: opt(num),
  },
  "ComponentOptionSetAssociation",
);
export const ComponentVerticalPlacementSchema = union(
  [id("ComponentVerticalPlacementRemapping"), id("ComponentVerticalPlacementReplication")],
  "ComponentVerticalPlacement",
);
export const ComponentVerticalPlacementRemappingSchema = interf(
  {
    type: lit("REMAPPING"),
    levelRemapping: opt(obj(fk("LEVEL"), "Table")),
  },
  "ComponentVerticalPlacementRemapping",
);
export const ComponentVerticalPlacementReplicationSchema = interf(
  {
    type: lit("REPLICATION"),
    datumUsage: opt(
      inters(
        [
          id("DatumUsageBase"),
          interf({
            __usage: lit("COMPONENT_PLACEMENT"),
          }),
        ],
        "DatumUsage",
      ),
    ),
  },
  "ComponentVerticalPlacementReplication",
);
export const CompositeLevelSchema = interf(
  {
    id: pk("COMPOSITE_LEVEL"),
    members: arr(id("CompositeLevelMember")),
    entityType: lit("COMPOSITE_LEVEL"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "CompositeLevel",
);
export const CompositeLevelHandleSchema = interf(
  {
    type: lit("COMPOSITE_LEVEL"),
    id: str,
  },
  "CompositeLevelHandle",
);
export const CompositeLevelMemberSchema = interf(
  {
    entityId: fk("LEVEL"),
    componentInstanceChain: opt(id("ForeignKeyPathOf")),
  },
  "CompositeLevelMember",
);
export const CompositeLevelPlanViewSchema = interf(
  {
    id: pk("PLAN_VIEW"),
    levelIds: tuple([id("PlanViewCompositeLevelMember")]),
    referenceType: id("BuiltinPlanViewType"),
    planViewType: lit("COMPOSITE"),
    entityType: lit("PLAN_VIEW"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    viewScale: opt(num),
    viewFilter: opt(partial(id("ViewFilter"))),
    dimensionPrecision: opt(id("DimensionPrecision")),
  },
  "CompositeLevelPlanView",
);
export const CompositeLumberComponentSchema = interf(
  {
    depth: num,
    width: num,
    id: pk("FRAMING_COMPONENT"),
    name: str,
    type: lit("COMPOSITE_LUMBER"),
    entityType: lit("FRAMING_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "CompositeLumberComponent",
);
export const ConcreteSchema = interf(
  {
    profile: id("CMUProfile"),
    id: pk("MASONRY_COMPONENT"),
    name: str,
    masonryType: lit("CONCRETE"),
    entityType: lit("MASONRY_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "Concrete",
);
export const ConcreteSlabSchema = interf(
  {
    id: pk("SLAB_COMPONENT"),
    name: str,
    slabType: lit("CIP"),
    thickness: num,
    entityType: lit("SLAB_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "ConcreteSlab",
);
export const ConditionSchema = interf(
  {
    typeDefId: id("ConditionTypeDefId"),
    operator: id("ConditionOperator"),
    value: union([fk("OPTION"), undef, nul, num, lit(false), lit(true)]),
    connective: opt(id("ConnectiveOperator")),
    groupId: opt(str),
  },
  "Condition",
);
export const ConditionedAreaCalculationTypeSchema = enu(
  {
    [`BY_ROOM_TYPE`]: "BY_ROOM_TYPE",
    [`BY_ROOM_ENCLOSURE`]: "BY_ROOM_ENCLOSURE",
  },
  "ConditionedAreaCalculationType",
);
export const ConditionOperatorSchema = union(
  [lit("=="), lit("!="), lit(">"), lit("<"), lit(">="), lit("<=")],
  "ConditionOperator",
);
export const ConditionTypeDefIdSchema = union(
  [fk("LABEL"), fk("OPTION_SET"), fk("LOCAL_PARAMETER"), fk("GLOBAL_PARAMETER"), fk("SYSTEM_PARAMETER")],
  "ConditionTypeDefId",
);
export const ConnectiveOperatorSchema = union([lit("and"), lit("or")], "ConnectiveOperator");
export const ContentReplicatorSchema = interf(
  {
    id: pk("CONTENT_REPLICATOR"),
    template: id("ContentTemplate"),
    sequenceId: fk("DATA_SEQUENCE"),
    parentId: opt(union([fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
    entityType: lit("CONTENT_REPLICATOR"),
    name: str,
    sortIndex: num,
    disabled: id("ParameterFormulaDisabledField"),
  },
  "ContentReplicator",
);
export const ContentReplicatorHandleSchema = interf(
  {
    type: lit("CONTENT_REPLICATOR"),
    id: str,
  },
  "ContentReplicatorHandle",
);
export const ContentTemplateSchema = union(
  [
    id("SheetTemplate"),
    id("GenericDrawingTemplate"),
    id("AnnotationDrawingTemplate"),
    id("ViewportTitleDrawingTemplate"),
    id("TagTemplate"),
  ],
  "ContentTemplate",
);
export const ContentTemplateHandleSchema = interf(
  {
    type: lit("CONTENT_TEMPLATE"),
    id: str,
  },
  "ContentTemplateHandle",
);
export const ContentTemplateInstanceSchema = union(
  [id("SheetTemplateInstance"), id("DrawingTemplateInstance")],
  "ContentTemplateInstance",
);
export const ContentTemplateInstanceHandleSchema = interf(
  {
    type: lit("CONTENT_TEMPLATE_INSTANCE"),
    id: str,
  },
  "ContentTemplateInstanceHandle",
);
export const ContentTemplateInstanceViewHandleSchema = interf(
  {
    type: lit("CONTENT_TEMPLATE_INSTANCE_VIEW"),
    contentTemplateInstanceId: str,
  },
  "ContentTemplateInstanceViewHandle",
);
export const ContentTemplateValueSchema = interf(
  {
    type: lit("CONTENT_TEMPLATE"),
    value: fk("CONTENT_TEMPLATE"),
  },
  "ContentTemplateValue",
);
export const ContentTemplateViewHandleSchema = interf(
  {
    type: lit("CONTENT_TEMPLATE_VIEW"),
    contentTemplateId: str,
  },
  "ContentTemplateViewHandle",
);
export const ContextHomePropSchema = enu(
  {
    [`NONE`]: "NONE",
    [`DEFAULT`]: "DEFAULT",
    [`SMALL_RANCH`]: "SMALL_RANCH",
    [`MEDIUM_RANCH`]: "MEDIUM_RANCH",
    [`LARGE_RANCH`]: "LARGE_RANCH",
    [`THREE_STORY`]: "THREE_STORY",
    [`TWO_STORY`]: "TWO_STORY",
  },
  "ContextHomeProp",
);
export const ContourSiteShapeSchema = interf(
  {
    type: lit("CONTOUR"),
    zHeight: num,
    height: opt(num),
    material: opt(id("ExteriorMaterial")),
    id: pk("SITE_SHAPE"),
    parentId: union([fk("SITE", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    geom: any,
    entityType: lit("SITE_SHAPE"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "ContourSiteShape",
);
export const ControllerPositionSchema = interf(
  {
    type: lit("CONTROLLER_POSITION"),
    id: str,
    roomId: fk("ROOM"),
    position: id("RoomPosition"),
  },
  "ControllerPosition",
);
export const ControllerSelectionConfigSchema = union(
  [
    id("CSPrimaryEntrance"),
    id("CSPrimaryEntranceOutside"),
    id("CSNearestCandidate"),
    id("CSNearestCandidateOutside"),
    id("CSNearestDoorOutside"),
    id("CSByControllerTag"),
    id("CSDoorByRoomType"),
    id("CSDoorByRoomTypeOutside"),
    id("CSDoorByRoomIds"),
    id("CSNearestExplicitWall"),
    id("CSExplicitPoint"),
    id("CSNone"),
  ],
  "ControllerSelectionConfig",
);
export const ControllerSwitchTypeSchema = enu(
  {
    [`STANDARD`]: "STANDARD",
    [`THREE_WAY`]: "THREE_WAY",
    [`FOUR_WAY`]: "FOUR_WAY",
    [`DIMMER`]: "DIMMER",
  },
  "ControllerSwitchType",
);
export const ControllerTypeSchema = enu(
  {
    [`SWITCH`]: "SWITCH",
    [`SENSOR`]: "SENSOR",
    [`OPENER`]: "OPENER",
  },
  "ControllerType",
);
export const ControllerTypeSlotSchema = enu(
  {
    [`PRIMARY`]: "PRIMARY",
    [`SECONDARY`]: "SECONDARY",
    [`TERTIARY`]: "TERTIARY",
    [`QUATERNARY`]: "QUATERNARY",
  },
  "ControllerTypeSlot",
);
export const ControllerTypeSlotsSchema = interf(
  {
    primary: id("ControllerType"),
    secondary: opt(id("ControllerType")),
    tertiary: opt(id("ControllerType")),
    quaternary: opt(id("ControllerType")),
    sensor: id("ControllerType"),
  },
  "ControllerTypeSlots",
);
export const CornerBoardTrimAlignmentSchema = enu(
  {
    [`TO_FOUNDATION`]: "TO_FOUNDATION",
    [`BO_SOFFIT`]: "BO_SOFFIT",
    [`BO_SOFFIT_LEGACY`]: "BO_SOFFIT_LEGACY",
    [`BO_FRIEZE_BOARD`]: "BO_FRIEZE_BOARD",
  },
  "CornerBoardTrimAlignment",
);
export const CornerBoardTrimHorizontalDatumSchema = enu(
  {
    [`OUTSIDE_WALL_CORNER`]: "OUTSIDE_WALL_CORNER",
    [`INSIDE_WALL_CORNER`]: "INSIDE_WALL_CORNER",
    [`DORMER_WALL_CORNER`]: "DORMER_WALL_CORNER",
  },
  "CornerBoardTrimHorizontalDatum",
);
export const CSByControllerTagSchema = interf(
  {
    type: lit("BY_CONTROLLER_TAG"),
    tagToLookup: opt(str),
    candidateTypeConstraints: opt(id("CandidateTypeConstraints")),
    queryPoint: opt(id("QueryPoint")),
    tag: opt(str),
  },
  "CSByControllerTag",
);
export const CSDoorByRoomIdsSchema = interf(
  {
    type: lit("DOOR_BY_ROOM_IDS"),
    roomId: opt(fk("ROOM")),
    oppositeRoomId: opt(fk("ROOM")),
    doorCandidateTypeConstraints: opt(id("DoorCandidateTypeConstraints")),
    queryPoint: opt(id("QueryPoint")),
    tag: opt(str),
  },
  "CSDoorByRoomIds",
);
export const CSDoorByRoomTypeSchema = interf(
  {
    type: lit("DOOR_BY_ROOM_TYPE"),
    spaceType: opt(id("SpaceType")),
    roomType: opt(id("RoomType")),
    doorCandidateTypeConstraints: opt(id("DoorCandidateTypeConstraints")),
    queryPoint: opt(id("QueryPoint")),
    tag: opt(str),
  },
  "CSDoorByRoomType",
);
export const CSDoorByRoomTypeOutsideSchema = interf(
  {
    type: lit("DOOR_BY_ROOM_TYPE_OUTSIDE_ROOMSET"),
    spaceType: opt(id("SpaceType")),
    roomType: opt(id("RoomType")),
    doorCandidateTypeConstraints: opt(id("DoorCandidateTypeConstraints")),
    queryPoint: opt(id("QueryPoint")),
    tag: opt(str),
  },
  "CSDoorByRoomTypeOutside",
);
export const CSExplicitPointSchema = interf(
  {
    type: lit("EXPLICIT_POINT"),
    tag: opt(str),
    explicitQueryPoint: id("QueryPointUnion"),
  },
  "CSExplicitPoint",
);
export const CSNearestCandidateSchema = interf(
  {
    type: lit("NEAREST"),
    candidateTypeConstraints: opt(id("CandidateTypeConstraints")),
    queryPoint: opt(id("QueryPoint")),
    tag: opt(str),
  },
  "CSNearestCandidate",
);
export const CSNearestCandidateOutsideSchema = interf(
  {
    type: lit("NEAREST_OUTSIDE_ROOMSET"),
    candidateTypeConstraints: opt(id("CandidateTypeConstraints")),
    queryPoint: opt(id("QueryPoint")),
    tag: opt(str),
  },
  "CSNearestCandidateOutside",
);
export const CSNearestDoorOutsideSchema = interf(
  {
    type: lit("NEAREST_DOOR_OUTSIDE_ROOMSET"),
    doorCandidateTypeConstraints: opt(id("DoorCandidateTypeConstraints")),
    queryPoint: opt(id("QueryPoint")),
    tag: opt(str),
  },
  "CSNearestDoorOutside",
);
export const CSNearestExplicitWallSchema = interf(
  {
    type: lit("EXPLICIT POSITION"),
    snapToCandidateMaxSearchDistance: num,
    snapCandidateTypeConstraints: opt(id("CandidateTypeConstraints")),
    tag: opt(str),
    explicitQueryPoint: id("QueryPointUnion"),
  },
  "CSNearestExplicitWall",
);
export const CSNoneSchema = interf(
  {
    type: lit("NONE"),
  },
  "CSNone",
);
export const CSPrimaryEntranceSchema = interf(
  {
    type: lit("PRIMARY_ENTRANCE"),
    queryPoint: opt(id("QueryPoint")),
    tag: opt(str),
  },
  "CSPrimaryEntrance",
);
export const CSPrimaryEntranceOutsideSchema = interf(
  {
    type: lit("PRIMARY_ENTRANCE_OUTSIDE_ROOMSET"),
    queryPoint: opt(id("QueryPoint")),
    tag: opt(str),
  },
  "CSPrimaryEntranceOutside",
);
export const CustomDataSequenceSchema = interf(
  {
    sequenceType: lit("CUSTOM"),
    cols: arr(
      interf({
        id: str,
        name: str,
        type: union([lit("TEXT"), lit("NUMBER"), lit("SYMBOL")]),
      }),
    ),
    rows: arr(obj(union([str, num]))),
    id: pk("DATA_SEQUENCE"),
    entityType: lit("DATA_SEQUENCE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "CustomDataSequence",
);
export const CustomDescriptorSchema = interf(
  {
    profileType: lit("CUSTOM"),
    reflectOverY: id("OptionalBoolean"),
    polyline: arr(num),
    name: str,
    entityType: lit("PROFILE_EXTRUSION"),
    elevationNoteEnabled: id("OptionalBoolean"),
    elevationNote: opt(str),
    catalogItemType: lit("PROFILE_EXTRUSION_DESCRIPTOR"),
  },
  "CustomDescriptor",
);
export const CustomFramingComponentSchema = interf(
  {
    depth: num,
    width: num,
    id: pk("FRAMING_COMPONENT"),
    name: str,
    type: lit("CUSTOM"),
    entityType: lit("FRAMING_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "CustomFramingComponent",
);
export const CustomPierEntitySchema = interf(
  {
    pierPoints: any,
    pierType: lit("CUSTOM"),
    id: pk("FOUNDATION_COMPONENT"),
    name: str,
    componentType: lit("PIER"),
    material: opt(id("ExteriorMaterial")),
    entityType: lit("FOUNDATION_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "CustomPierEntity",
);
export const CustomProfileEntitySchema = interf(
  {
    profileType: lit("CUSTOM"),
    reflectOverY: id("OptionalBoolean"),
    polyline: arr(num),
    id: pk("PROFILE"),
    entityType: lit("PROFILE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    elevationNoteEnabled: id("OptionalBoolean"),
    elevationNote: opt(str),
  },
  "CustomProfileEntity",
);
export const DataSequenceSchema = union([id("CustomDataSequence"), id("SystemDataSequence")], "DataSequence");
export const DataSequenceHandleSchema = interf(
  {
    type: lit("DATA_SEQUENCE"),
    id: str,
  },
  "DataSequenceHandle",
);
export const DataSequenceParameterSchema = interf(
  {
    defaultValue: opt(fk("DATA_SEQUENCE")),
    type: lit("DATA_SEQUENCE"),
  },
  "DataSequenceParameter",
);
export const DataSequenceValueSchema = interf(
  {
    type: lit("DATA_SEQUENCE"),
    value: fk("DATA_SEQUENCE"),
  },
  "DataSequenceValue",
);
export const DataSequenceViewHandleSchema = interf(
  {
    type: lit("DATA_SEQUENCE_VIEW"),
    dataSequenceId: str,
  },
  "DataSequenceViewHandle",
);
export const DataTableSchema = interf(
  {
    id: pk("DATA_TABLE"),
    parentId: opt(
      union(
        [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("CONTENT_TEMPLATE_INSTANCE", { hierarchy: ["PARENT"] })],
        "DocEntityParentId",
      ),
    ),
    dataSequenceId: union([
      lit("ROOF"),
      lit("PROP"),
      lit("CASEWORK"),
      lit("CEILING"),
      id("ParameterRef"),
      fk("DATA_SEQUENCE"),
      lit("DOOR"),
      lit("WINDOW"),
      lit("WALL"),
      lit("ELECTRICAL"),
      lit("SLAB"),
      lit("FOOTING"),
      lit("FRAMING"),
      lit("FLOORING"),
      lit("FLOOR_MATERIALS_SUMMARY"),
      lit("INTERIOR_FINISH"),
      lit("ROOF_AREA"),
      lit("ROOF_ANALYTIC_AREA"),
      lit("ROOF_ANALYTIC_LENGTH"),
      lit("ROOF_RIDGE"),
      lit("ROOF_RIDGE_VENT"),
      lit("ROOF_VALLEY"),
      lit("ROOF_EAVE"),
      lit("ROOF_FLASHING"),
      lit("WALL_AREA"),
      lit("BUILDING_AREA"),
      lit("BUILDING_OPTION"),
      lit("BUILDING_PRESET"),
      lit("MILLWORK"),
      lit("EXTERIOR_TRIM"),
      lit("EXTERIOR_FINISH"),
      lit("OPENING_TRIM"),
      lit("OPENING_CASING"),
      lit("SHEETS"),
    ]),
    levelId: union([undef, id("ParameterRef"), fk("LEVEL")]),
    selectedReportingUnitLabelId: union([fk("LABEL"), undef, id("ParameterRef")]),
    fontSize: opt(nom("SheetInches")),
    x: nom("SheetInches"),
    y: nom("SheetInches"),
    width: nom("SheetInches"),
    height: nom("SheetInches"),
    columnHeadersHidden: id("OptionalBoolean"),
    titleHidden: id("OptionalBoolean"),
    title: opt(str),
    titleFontSize: opt(nom("SheetInches")),
    titleAlignment: opt(id("TextAlignment")),
    columnConfig: obj(id("DataTableColumnConfig"), "Table"),
    findAndReplace: obj(id("DataTableFindAndReplaceRow"), "Table"),
    sortColumnId: opt(str),
    sortColumnIdOrder: opt(str),
    firstRow: opt(num),
    maxRowCount: opt(num),
    presetId: union([id("ParameterRef"), fk("PRESET")]),
    optionSetOverrides: fkTable("OPTION_SET", union([id("ParameterRef"), fk("OPTION")])),
    entityType: lit("DATA_TABLE"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "DataTable",
);
export const DataTableColumnConfigSchema = interf(
  {
    index: opt(num),
    isHidden: id("OptionalBoolean"),
    width: opt(num),
    displayName: opt(str),
    includeFilter: opt(str),
    excludeFilter: opt(str),
    aggregationMethod: opt(id("AggregationMethod")),
  },
  "DataTableColumnConfig",
);
export const DataTableFindAndReplaceRowSchema = interf(
  {
    index: opt(num),
    columnId: str,
    find: str,
    replace: str,
  },
  "DataTableFindAndReplaceRow",
);
export const DataTableHandleSchema = interf(
  {
    type: lit("DATA_TABLE"),
    id: str,
  },
  "DataTableHandle",
);
export const DatumEntitySchema = union(
  [
    id("LegacyFoundationVerticalDatumEntity"),
    id("AbsoluteVerticalDatumEntity"),
    id("LegacyFoundationLateralDatumEntity"),
    id("LegacyWallVerticalDatumEntity"),
    id("LegacyLevelDatumEntity"),
    id("LegacyWallHorizontalDatumEntity"),
    id("StackedLevelDatumEntity"),
    id("LegacyWallPlaneHorizontalDatumEntity"),
  ],
  "DatumEntity",
);
export const DatumHandleSchema = interf(
  {
    type: lit("DATUM"),
    id: str,
  },
  "DatumHandle",
);
export const DatumLevelPlacementSchema = interf(
  {
    datumUsage: opt(
      inters(
        [
          id("DatumUsageBase"),
          interf({
            __usage: lit("LEVEL_PLACEMENT"),
          }),
        ],
        "DatumUsage",
      ),
    ),
    aboveLevelId: opt(fk("LEVEL")),
    belowLevelId: opt(fk("LEVEL")),
    type: lit("DATUM"),
  },
  "DatumLevelPlacement",
);
export const DatumScopeSchema = interf(
  {
    step: str,
    planeHashes: arr(str),
  },
  "DatumScope",
);
export const DatumUsageBaseSchema = interf(
  {
    offset: opt(num),
    entityId: fk("DATUM"),
    componentInstanceChain: opt(id("ForeignKeyPathOf")),
  },
  "DatumUsageBase",
);
export const DeprecatedPlanDimSchema = interf(
  {
    type: lit("PLAN_DIM"),
    polyLine: any,
    id: pk("ANNOTATION"),
    handle: union([undef, id("RoomLayoutInstanceHandle"), id("AnnotationHandle"), id("ContentTemplateInstanceHandle")]),
    handleAuxiliary: union([undef, id("AnnotationHandle"), id("ContentTemplateInstanceHandle")]),
    name: str,
    positioningMethod: id("PositioningMethod"),
    edgeId: opt(str),
    parentId: opt(
      union(
        [
          fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }),
          fk("ROOM", { hierarchy: ["PARENT"] }),
          fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] }),
          fk("ELEVATION_VIEW", { hierarchy: ["PARENT"] }),
          fk("SECTION_VIEW", { hierarchy: ["PARENT"] }),
          fk("CONTENT_TEMPLATE_INSTANCE", { hierarchy: ["PARENT"] }),
          fk("LEVEL", { hierarchy: ["PARENT"] }),
        ],
        "DocEntityParentId",
      ),
    ),
    entityType: lit("ANNOTATION"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    entityInstanceType: opt(id("EntityInstanceType")),
    labels: fkTable("LABEL", bool),
  },
  "DeprecatedPlanDim",
);
export const DimensionalLumberComponentSchema = interf(
  {
    lumberProfileType: id("LumberProfileType"),
    id: pk("FRAMING_COMPONENT"),
    name: str,
    type: lit("DIMENSIONAL_LUMBER"),
    entityType: lit("FRAMING_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "DimensionalLumberComponent",
);
export const DimensionEdgeBehaviorSchema = interf(
  {
    edgeBehaviorType: lit("DIMENSION"),
    disableInteriorAuto: id("OptionalBoolean"),
    disableExteriorAuto: id("OptionalBoolean"),
    disableDiagonalAuto: id("OptionalBoolean"),
    id: pk("EDGE_BEHAVIOR"),
    parentId: union(
      [fk("ROOM", { hierarchy: ["PARENT"] }), fk("STAIR_BLOCK", { hierarchy: ["PARENT"] })],
      "DocEntityParentId",
    ),
    edgeId: str,
    entityType: lit("EDGE_BEHAVIOR"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "DimensionEdgeBehavior",
);
export const DimensionPrecisionSchema = enu(
  {
    [`FOOT`]: "FOOT",
    [`INCH`]: "INCH",
    [`PRECISION_1_2`]: "PRECISION_1_2",
    [`PRECISION_1_4`]: "PRECISION_1_4",
    [`PRECISION_1_8`]: "PRECISION_1_8",
    [`PRECISION_1_16`]: "PRECISION_1_16",
    [`PRECISION_1_32`]: "PRECISION_1_32",
    [`PRECISION_1_64`]: "PRECISION_1_64",
  },
  "DimensionPrecision",
);
export const DimensionRowLevelSchema = enu(
  {
    [`OBSTACLE`]: 0,
    [`BOUNDS`]: 1,
    [`ROW_2`]: 2,
    [`ROW_3`]: 3,
    [`ROW_4`]: 4,
  },
  "DimensionRowLevel",
);
export const DisabledAwningSettingsSchema = interf(
  {
    awningType: lit("DISABLED"),
    type: lit("AWNING_SETTINGS"),
    viewNotes: opt(
      mapobj(
        enu(
          {
            [`AWNING`]: "AWNING",
            [`BRACKET`]: "BRACKET",
          },
          "AwningViewNoteType",
        ),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "AwningViewNoteTable",
      ),
    ),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "DisabledAwningSettings",
);
export const DisabledShutterSettingsSchema = interf(
  {
    type: lit("WINDOW_SHUTTER_SETTINGS"),
    shutterType: lit("DISABLED"),
    viewNotes: opt(
      mapobj(
        lit("SHUTTER"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "ShutterViewNoteTable",
      ),
    ),
    forceShutters: id("OptionalBoolean"),
  },
  "DisabledShutterSettings",
);
export const DisabledWindowMullionSettingsSchema = interf(
  {
    type: lit("WINDOW_MULLION_SETTINGS"),
    mullionType: lit("DISABLED"),
    isLegacyWindowGrid: id("OptionalBoolean"),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "DisabledWindowMullionSettings",
);
export const DivisionColumnPlacementV1Schema = interf(
  {
    segments: num,
    type: lit("DIVISION"),
  },
  "DivisionColumnPlacementV1",
);
export const DivisionColumnPlacementV2Schema = interf(
  {
    segments: num,
    type: lit("DIVISION"),
  },
  "DivisionColumnPlacementV2",
);
export const DivisionPostPlacementSchema = interf(
  {
    type: lit("DIVISION"),
    segments: num,
    removePostsFromSettings: bool,
    includeStartPost: bool,
    id: pk("RAILING_POST"),
    entityType: lit("RAILING_POST"),
    parentId: union([fk("RAILING", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    edgeIndex: opt(num),
    name: str,
    sortIndex: num,
  },
  "DivisionPostPlacement",
);
export const DocSchema = interf(
  {
    isParsed: bool,
    schemaVersion: str,
    name: str,
    locked: fkHashTable(
      [
        "RAILING",
        "ROOM",
        "LEVEL",
        "UNDERLAY",
        "BLOCK",
        "STAIR_BLOCK",
        "GROUP",
        "STAIR_SYSTEM",
        "REFERENCE_GEOM",
        "MEASUREMENT",
        "FLOOR_SYSTEM",
        "ROOF_SYSTEM",
        "FOUNDATION_SYSTEM",
      ],
      id("LockableEntityHandle"),
    ),
    hidden: fkHashTable(
      [
        "ROOM",
        "LEVEL",
        "UNDERLAY",
        "BLOCK",
        "STAIR_BLOCK",
        "GROUP",
        "STAIR_SYSTEM",
        "REFERENCE_GEOM",
        "MEASUREMENT",
        "FLOOR_SYSTEM",
        "ROOF_SYSTEM",
        "FOUNDATION_SYSTEM",
        "ROOF",
        "FOUNDATION",
        "FLOOR",
      ],
      id("HidableEntityHandle"),
    ),
    snapKinds: arr(id("SnapKind")),
    snapEntities: arr(id("SnapEntity")),
    gridSnapDistance: num,
    assets: obj(id("Asset"), "Table"),
    underlays: obj(id("Underlay"), "Table"),
    roofUnderlays: obj(id("Underlay"), "Table"),
    presets: obj(id("Preset"), "Table"),
    levels: obj(id("LevelDef"), "Table"),
    compositeLevels: obj(id("CompositeLevel"), "Table"),
    blocks: obj(id("Block"), "Table"),
    rooms: obj(id("StaticRoom"), "Table"),
    roomLayouts: obj(id("RoomLayout"), "Table"),
    roomLayoutInstances: obj(id("RoomLayoutInstance"), "Table"),
    entityRoomLayouts: fkHashJoinTable(
      ["ANNOTATION", "CONTENT_TEMPLATE_INSTANCE", "CASEWORK", "PROP_INSTANCE", "OPENING"],
      fk("ROOM_LAYOUT"),
    ),
    floors: obj(id("FloorAssemblyOverride"), "Table"),
    floorFinishes: obj(id("FloorAssemblyFinishLayerOverride"), "Table"),
    columns: obj(id("Column"), "Table"),
    openings: obj(id("Opening"), "Table"),
    electricalDevices: obj(id("ElectricalDevice"), "Table"),
    electricalLayouts: obj(id("InPlaceElectricalLayout"), "Table"),
    stairSystems: obj(id("StairSystem"), "Table"),
    stairBlocks: obj(id("StairBlock"), "Table"),
    stairCatalog: obj(id("StairSetting"), "Table"),
    railings: obj(id("Railing"), "Table"),
    railingPosts: obj(id("PostPlacement"), "Table"),
    roofSystems: obj(id("RoofSystem"), "Table"),
    roofs: obj(id("Roof"), "Table"),
    roofVolumes: obj(id("RoofVolume"), "Table"),
    foundationSystems: obj(id("FoundationSystem"), "Table"),
    foundations: obj(id("Foundation"), "Table"),
    edgeBehaviors: obj(id("EdgeBehavior"), "Table"),
    wallPlaneAssemblies: obj(id("WallPlaneAssemblyEntity"), "Table"),
    wallPlaneFilters: obj(id("DocWallPlaneFilter"), "Table"),
    wallPlaneRules: obj(id("WallPlaneRuleEntity"), "Table"),
    wallPlaneTrims: obj(id("WallPlaneTrimEntity"), "Table"),
    freeformWalls: obj(id("FreeformWallEntity"), "Table"),
    elevations: obj(id("Elevation"), "Table"),
    facades: obj(id("Facade"), "Table"),
    facadeSweepStrata: obj(id("FacadeSweepStratum"), "Table"),
    facadeSpanStrata: obj(id("FacadeSpanStratum"), "Table"),
    referenceGeom: obj(id("ReferenceGeom"), "Table"),
    sheets: obj(id("Sheet"), "Table"),
    drawingRefs: obj(id("DrawingRef"), "Table"),
    palettes: obj(id("Palette"), "Table"),
    annotation: obj(id("Annotation"), "Table"),
    casework: obj(id("WallCasework"), "Table"),
    ceilings: obj(id("Ceiling"), "Table"),
    propInstances: obj(id("PropInstance"), "Table"),
    propAttributes: obj(id("PropAttributes"), "Table"),
    profiles: opt(obj(id("ProfileEntity"), "Table")),
    railingCatalog: opt(obj(id("RailingDefaultSetting"), "Table")),
    roofOpenings: obj(id("RoofOpeningPlacement"), "Table"),
    dormers: obj(id("RoofDormerPlacement"), "Table"),
    skylights: obj(id("SkylightPlacement"), "Table"),
    modifiers: obj(id("Modifier"), "Table"),
    edgeModifiers: obj(id("EdgeModifier"), "Table"),
    viewOverrides: obj(id("ViewOverride"), "Table"),
    selectors: obj(id("AutoDimensionSelector"), "Table"),
    viewSelectors: obj(id("ViewSelector"), "Table"),
    measurements: obj(id("PlanAreaMeasurement"), "Table"),
    groups: obj(id("Group"), "Table"),
    entityGroups: fkHashJoinTable(
      [
        "DATUM",
        "ANNOTATION",
        "CONTENT_TEMPLATE",
        "RAILING",
        "CONTENT_TEMPLATE_INSTANCE",
        "PROP",
        "SHEET",
        "SETTINGS_SET",
        "BLOCK",
        "PROFILE",
        "CASEWORK",
        "CEILING",
        "CIP_COMPONENT",
        "FOUNDATION_COMPONENT",
        "COLUMN",
        "FOUNDATION_ASSEMBLY",
        "FRAMING_COMPONENT",
        "MASONRY_COMPONENT",
        "SLAB_COMPONENT",
        "GLOBAL_PARAMETER",
        "SYSTEM_PARAMETER",
        "DATA_SEQUENCE",
        "SITE",
        "STAIR_BLOCK",
        "STAIR_SYSTEM",
        "REFERENCE_GEOM",
        "MEASUREMENT",
        "ROOF_SYSTEM",
        "FREEFORM_WALL",
        "ROOF",
        "WALL_PLANE_ASSEMBLY",
        "PALETTE",
        "PROP_INSTANCE",
        "OPENING",
        "FLOOR",
        "FLOOR_FINISH",
        "FACADE",
        "ELECTRICAL_DEVICE",
        "ELECTRICAL_LAYOUT",
        "MODIFIER",
        "ROOF_VOLUME",
        "HEADER_ASSEMBLY",
        "FRAME_FLOOR_ASSEMBLY",
        "SLAB_FLOOR_ASSEMBLY",
        "SHEATHING_COMPONENT",
      ],
      fk("GROUP"),
    ),
    componentMembers: fkHashJoinTable(
      [
        "RAILING",
        "ROOM",
        "LEVEL",
        "BLOCK",
        "COMPONENT_INSTANCE",
        "STAIR_SYSTEM",
        "FLOOR_SYSTEM",
        "ROOF_SYSTEM",
        "FOUNDATION_SYSTEM",
        "ROOF",
      ],
      fk("COMPONENT"),
    ),
    componentAssociations: obj(id("ComponentOptionSetAssociation"), "Table"),
    components: obj(id("Component"), "Table"),
    componentInstances: obj(id("ComponentInstance"), "Table"),
    docRefs: obj(id("DocRef"), "Table"),
    sites: obj(id("Site"), "Table"),
    siteShapes: obj(id("SiteShape"), "Table"),
    entityRefs: obj(manual("EntityRef"), "Table"),
    settingsSets: obj(id("SettingsSet"), "Table"),
    settings: obj(id("SettingsFragment"), "Table"),
    entitySettings: obj(id("EntitySettings"), "Table"),
    optionTemplates: obj(id("DocOptionTemplate"), "Table"),
    optionSetOverrides: obj(id("DocOptionSetOverrides"), "Table"),
    optionSets: obj(id("DocOptionSet"), "Table"),
    instanceOptionSets: obj(id("InstanceOptionSet"), "Table"),
    optionRules: obj(id("DocOptionRule"), "Table"),
    optionEffects: obj(id("DocOptionEffect"), "Table"),
    optionLocks: obj(id("DocOptionLock"), "Table"),
    optionChoices: id("OptionChoices"),
    attributes: id("HomeAttributes"),
    view3Ds: obj(id("View3D"), "Table"),
    planViews: obj(id("PlanView"), "Table"),
    elevationViews: obj(id("ElevationView"), "Table"),
    sectionViews: obj(id("SectionView"), "Table"),
    datums: obj(id("DatumEntity"), "Table"),
    headerAssemblies: obj(id("HeaderAssemblyEntity"), "Table"),
    framingComponents: obj(id("FramingComponentEntity"), "Table"),
    masonryComponents: obj(id("MasonryComponentEntity"), "Table"),
    cipComponents: obj(id("CipConcrete"), "Table"),
    sheathingComponents: obj(id("SheathingComponentEntity"), "Table"),
    foundationAssemblies: obj(id("FoundationAssemblyEntity"), "Table"),
    foundationComponents: obj(id("FoundationComponentEntity"), "Table"),
    frameFloorAssemblies: obj(id("FrameFloorAssemblyEntity"), "Table"),
    slabFloorAssemblies: obj(id("SlabFloorAssemblyEntity"), "Table"),
    slabComponents: obj(id("SlabComponentEntity"), "Table"),
    planSetTemplates: obj(id("PlanSetTemplate"), "Table"),
    planSetTemplateConfigs: obj(id("PlanSetTemplateConfig"), "Table"),
    contentTemplates: obj(id("ContentTemplate"), "Table"),
    contentTemplateInstances: obj(id("ContentTemplateInstance"), "Table"),
    contentReplicators: obj(id("ContentReplicator"), "Table"),
    viewports: obj(id("Viewport"), "Table"),
    viewTemplates: obj(id("ViewTemplate"), "Table"),
    viewTemplateOverrides: obj(id("ViewTemplateOverride"), "Table"),
    localParameters: obj(id("LocalParameter"), "Table"),
    globalParameters: obj(id("GlobalParameter"), "Table"),
    dataSequences: obj(id("DataSequence"), "Table"),
    dataTables: obj(id("DataTable"), "Table"),
    effects: obj(id("Effect"), "Table"),
    labels: obj(id("Label"), "Table"),
    reportableUnitDesignations: obj(id("ReportableUnitDesignation"), "Table"),
    ruleBasedSelectors: obj(id("RuleBasedSelector"), "Table"),
    ruleBasedSelectorInstances: obj(id("RuleBasedSelectorInstance"), "Table"),
    facadeSpanStratumAssociations: obj(id("DocFacadeSpanStratumAssociation"), "Table"),
    facadeSweepStratumAssociations: obj(id("DocFacadeSweepStratumAssociation"), "Table"),
    datumSpanAssociations: obj(id("DocDatumSpanAssociation"), "Table"),
    floorSystems: obj(id("FloorSystemExternal"), "Table"),
  },
  "Doc",
);
export const DocBuildingGraphAndFilterNodeSchema = interf(
  {
    childrenNodeIds: arr(str),
    filterType: lit("AND"),
    targetType: id("FilterEntitySourceId"),
  },
  "DocBuildingGraphAndFilterNode",
);
export const DocBuildingGraphFilterGraphSchema = interf(
  {
    rootNodeId: str,
    nodes: obj(id("DocBuildingGraphFilterNode"), "Record"),
  },
  "DocBuildingGraphFilterGraph",
);
export const DocBuildingGraphFilterNodeSchema = union(
  [
    id("DocBuildingGraphAndFilterNode"),
    id("DocBuildingGraphOrFilterNode"),
    id("DocBuildingGraphNotFilterNode"),
    id("DocBuildingGraphPredicateFilterNode"),
  ],
  "DocBuildingGraphFilterNode",
);
export const DocBuildingGraphNotFilterNodeSchema = interf(
  {
    childNodeId: str,
    filterType: lit("NOT"),
    targetType: id("FilterEntitySourceId"),
  },
  "DocBuildingGraphNotFilterNode",
);
export const DocBuildingGraphOrFilterNodeSchema = interf(
  {
    childrenNodeIds: arr(str),
    filterType: lit("OR"),
    targetType: id("FilterEntitySourceId"),
  },
  "DocBuildingGraphOrFilterNode",
);
export const DocBuildingGraphPredicateFilterNodeSchema = interf(
  {
    op: id("PredicateOp"),
    path: str,
    values: opt(arr(id("DocBuildingGraphPredicateLiteral"))),
    valueSource: opt(id("DocBuildingGraphSubfilterValueSource")),
    filterType: lit("PREDICATE"),
    targetType: id("FilterEntitySourceId"),
  },
  "DocBuildingGraphPredicateFilterNode",
);
export const DocBuildingGraphPredicateLiteralSchema = union(
  [
    nul,
    str,
    num,
    lit(false),
    lit(true),
    id("LevelHandle"),
    id("RoomHandle"),
    id("FreeformWallHandle"),
    id("RoofHandle"),
    id("FloorHandle"),
    id("RoomEdgeHandle"),
    id("FreeformWallEdgeHandle"),
  ],
  "DocBuildingGraphPredicateLiteral",
);
export const DocBuildingGraphSubfilterValueSourceSchema = interf(
  {
    sourceType: id("FilterEntitySourceId"),
    selectPaths: arr(str),
    filterGraphId: opt(str),
  },
  "DocBuildingGraphSubfilterValueSource",
);
export const DocDatumSpanAssociationSchema = interf(
  {
    disambiguator: union([lit("START"), lit("END"), lit("UPPER"), lit("LOWER")]),
    id: inters(
      [
        str,
        interf({
          __sourceType: lit("DATUM"),
          __targetType: lit("FACADE_SPAN_STRATUM"),
        }),
      ],
      "DocEntityAssociationId",
    ),
    sourceEntityId: fk("DATUM"),
    targetEntityId: fk("FACADE_SPAN_STRATUM"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "DocDatumSpanAssociation",
);
export const DocEntityHandleSchema = union(
  [
    id("GroupHandle"),
    id("ComponentHandle"),
    id("ComponentInstanceHandle"),
    id("DocRefHandle"),
    id("LevelHandle"),
    id("BlockHandle"),
    id("RoomHandle"),
    id("PresetHandle"),
    id("RoomLayoutHandle"),
    id("RoomLayoutInstanceHandle"),
    id("StairSystemHandle"),
    id("StairBlockHandle"),
    id("StairSettingHandle"),
    id("RailingHandle"),
    id("FreeformWallHandle"),
    id("SiteHandle"),
    id("RailingPostHandle"),
    id("RoofSystemHandle"),
    id("RoofHandle"),
    id("EdgeBehaviorHandle"),
    id("WallPlaneFilterHandle"),
    id("WallPlaneRuleHandle"),
    id("WallPlaneTrimHandle"),
    id("WallPlaneAssemblyHandle"),
    id("RoofSideHandle"),
    id("FoundationSystemHandle"),
    id("FoundationHandle"),
    id("AssetHandle"),
    id("UnderlayHandle"),
    id("ReferenceGeomHandle"),
    id("ElevationHandle"),
    id("PaletteHandle"),
    id("SettingsHandle"),
    id("SettingsSetHandle"),
    id("EntitySettingsHandle"),
    id("OptionTemplateHandle"),
    id("OptionSetOverridesHandle"),
    id("SheetHandle"),
    id("DrawingRefHandle"),
    id("OptionSetHandle"),
    id("InstanceOptionSetHandle"),
    id("OptionHandle"),
    id("OptionEffectHandle"),
    id("OptionRuleHandle"),
    id("OptionLockHandle"),
    id("PropInstanceHandle"),
    id("PropAttributesHandle"),
    id("CaseworkHandle"),
    id("CeilingHandle"),
    id("OpeningHandle"),
    id("CatalogItemHandle"),
    id("FloorHandle"),
    id("FloorFinishHandle"),
    id("FloorPerimeterOpeningHandle"),
    id("AnnotationHandle"),
    id("FacadeHandle"),
    id("FacadeSpanStratumHandle"),
    id("FacadeSweepStratumHandle"),
    id("ElectricalDeviceHandle"),
    id("ElectricalLayoutHandle"),
    id("ElectricalRuleHandle"),
    id("RoofOpeningHandle"),
    id("ShapeHandle"),
    id("EdgeHandle"),
    id("VertexHandle"),
    id("SkylightHandle"),
    id("DormerHandle"),
    id("ModifierHandle"),
    id("EdgeModifierHandle"),
    id("ColumnHandle"),
    id("ElevationViewHandle"),
    id("SectionViewHandle"),
    id("View3DHandle"),
    id("PlanViewHandle"),
    id("ProfileHandle"),
    id("RailingSettingHandle"),
    id("EditModeHandle"),
    id("MeasurementHandle"),
    id("GeneratedEntityHandle"),
    id("AutoDimensionFloorPlanExteriorByRoomSingleHandle"),
    id("AutoDimensionFloorPlanExteriorByRoomMultipleHandle"),
    id("AutoDimensionFloorPlanExteriorByOrientationHandle"),
    id("AutoDimensionFoundationExteriorByRoomSingleHandle"),
    id("AutoDimensionFoundationExteriorByRoomMultipleHandle"),
    id("AutoDimensionFoundationExteriorByOrientationHandle"),
    id("AutoDimensionFoundationInteriorByRoomSingleHandle"),
    id("AutoDimensionFoundationInteriorByRoomMultipleHandle"),
    id("AutoDimensionFoundationInteriorByOrientationHandle"),
    id("AutoDimensionFloorPlanInteriorByRoomEdgePairHandle"),
    id("AutoDimensionFloorPlanInteriorByOrthogonalRoomEdgeHandle"),
    id("PlanSetTemplateHandle"),
    id("ContentTemplateHandle"),
    id("ContentTemplateInstanceHandle"),
    id("ContentReplicatorHandle"),
    id("LocalParameterHandle"),
    id("GlobalParameterHandle"),
    id("SystemParameterHandle"),
    id("ViewportHandle"),
    id("DataTableHandle"),
    id("DataSequenceHandle"),
    id("ViewTemplateHandle"),
    id("PlanSetTemplateConfigHandle"),
    id("LabelHandle"),
    id("ViewOverrideHandle"),
    id("SelectorHandle"),
    id("ViewSelectorHandle"),
    id("ViewTemplateOverrideHandle"),
    id("RoofVolumeHandle"),
    id("SiteShapeHandle"),
    id("EffectHandle"),
    id("DatumHandle"),
    id("RuleBasedSelectorHandle"),
    id("RuleBasedSelectorInstanceHandle"),
    id("IndeterminateHandle"),
    id("FramingComponentHandle"),
    id("HeaderAssemblyHandle"),
    id("FoundationAssemblyHandle"),
    id("FoundationComponentEntityHandle"),
    id("FrameFloorAssemblyHandle"),
    id("SlabFloorAssemblyHandle"),
    id("SlabComponentHandle"),
    id("SheathingComponentHandle"),
    id("MasonryComponentHandle"),
    id("CipComponentHandle"),
    id("FloorSystemHandle"),
    id("FloorBayHandle"),
    id("FloorBayEdgeHandle"),
    id("FloorSplitLineHandle"),
    id("FloorSplitLineEdgeHandle"),
    id("CompositeLevelHandle"),
    id("ReportableUnitDesignationHandle"),
  ],
  "DocEntityHandle",
);
export const DocFacadeSpanStratumAssociationSchema = interf(
  {
    id: inters(
      [
        str,
        interf({
          __sourceType: lit("FACADE"),
          __targetType: lit("FACADE_SPAN_STRATUM"),
        }),
      ],
      "DocEntityAssociationId",
    ),
    sourceEntityId: fk("FACADE"),
    targetEntityId: fk("FACADE_SPAN_STRATUM"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "DocFacadeSpanStratumAssociation",
);
export const DocFacadeSweepStratumAssociationSchema = interf(
  {
    id: inters(
      [
        str,
        interf({
          __sourceType: lit("FACADE"),
          __targetType: lit("FACADE_SWEEP_STRATUM"),
        }),
      ],
      "DocEntityAssociationId",
    ),
    sourceEntityId: fk("FACADE"),
    targetEntityId: fk("FACADE_SWEEP_STRATUM"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "DocFacadeSweepStratumAssociation",
);
export const DocFaceDirectionSchema = union([lit("POSITIVE_NORMAL"), lit("NEGATIVE_NORMAL")], "DocFaceDirection");
export const DocFaceNodeSubFilterSchema = union(
  [
    interf({
      kind: lit("UNDEFINED"),
    }),
    interf({
      kind: lit("PERIMETER"),
    }),
    interf({
      kind: lit("OPPOSITE"),
      oppositeFilterGraphId: str,
    }),
  ],
  "DocFaceNodeSubFilter",
);
export const DocOptionSchema = interf(
  {
    id: pk("OPTION", true),
    parentId: union([fk("OPTION_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    name: str,
    sortIndex: num,
    priceTbd: id("OptionalBoolean"),
    price: union([
      undef,
      num,
      ref(
        interf(
          {
            type: lit("MATCH_EXPR"),
            cases: arr(
              ref(
                interf(
                  {
                    condition: id("Formula"),
                    value: typeParam("T"),
                  },
                  "MatchCase",
                  ["T"],
                ),
                { T: typeParam("T") },
              ),
            ),
            defaultValue: typeParam("T"),
          },
          "MatchExpression",
          ["T"],
        ),
        { T: num },
      ),
    ]),
    description: opt(str),
    builderOptionCode: union([undef, nul, str]),
    builderTemplateCode: opt(str),
    salesImages: opt(arr(id("SalesImage"))),
    disabled: id("OptionalBoolean"),
    showroomIntro: id("OptionalBoolean"),
    entityType: lit("OPTION"),
  },
  "DocOption",
);
export const DocOptionEffectSchema = union(
  [id("SetPriceOptionEffect"), id("LockOptionEffect"), id("EnableOptionEffect")],
  "DocOptionEffect",
);
export const DocOptionLockSchema = interf(
  {
    id: pk("OPTION_LOCK"),
    optionSetId: fk("OPTION_SET"),
    disconnectCondition: opt(id("Formula")),
    disconnectConditionOptions: opt(fkTable("OPTION", id("Formula"))),
    entityType: lit("OPTION_LOCK"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "DocOptionLock",
);
export const DocOptionRuleSchema = interf(
  {
    id: pk("OPTION_RULE"),
    predicate: id("Formula"),
    overridable: bool,
    entityType: lit("OPTION_RULE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "DocOptionRule",
);
export const DocOptionSetSchema = union(
  [id("SystemOptionSet"), id("ElevationOptionSet"), id("UserOptionSet"), id("IntersectingOptionSet")],
  "DocOptionSet",
);
export const DocOptionSetOverridesSchema = inters(
  [
    ref(
      interf(
        {
          entityType: typeParam("T"),
          name: str,
          id: str,
          parentId: opt(str),
          sortIndex: num,
        },
        "DocEntityBase",
        ["T"],
      ),
      { T: lit("OPTION_SET_OVERRIDES") },
    ),
    partial(pick(id("DocOptionLock"), union([lit("disconnectCondition"), lit("disconnectConditionOptions")]))),
    partial(omit(id("DocOptionSet"), union([lit("entityType"), lit("tags"), lit("labels")]))),
    interf({
      id: pk("OPTION_SET_OVERRIDES"),
      overrideName: opt(str),
      optionSetId: fk("OPTION_SET"),
      parentId: opt(union([fk("OPTION_TEMPLATE", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
    }),
  ],
  "DocOptionSetOverrides",
);
export const DocOptionTemplateSchema = interf(
  {
    id: pk("OPTION_TEMPLATE"),
    disabled: bool,
    entityType: lit("OPTION_TEMPLATE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "DocOptionTemplate",
);
export const DocRefSchema = interf(
  {
    id: pk("DOC_REF"),
    name: str,
    sortIndex: num,
    docId: str,
    docVersionId: str,
  },
  "DocRef",
);
export const DocRefHandleSchema = interf(
  {
    type: lit("DOC_REF"),
    id: str,
  },
  "DocRefHandle",
);
export const DocTableViewSelectorSchema = interf(
  {
    viewSelectorType: lit("DOC_VIEW"),
    viewId: fk(["ELEVATION_VIEW", "SECTION_VIEW", "PLAN_VIEW", "VIEW_3D"]),
    id: pk("VIEW_SELECTOR"),
    overrideId: fk("VIEW_OVERRIDE"),
    entityType: lit("VIEW_SELECTOR"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "DocTableViewSelector",
);
export const DocWallPlaneFilterSchema = interf(
  {
    id: pk("WALL_PLANE_FILTER"),
    filterGraphId: str,
    filterGraphs: obj(id("DocBuildingGraphFilterGraph"), "Record"),
    subFilter: id("DocFaceNodeSubFilter"),
    entityType: lit("WALL_PLANE_FILTER"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "DocWallPlaneFilter",
);
export const DoorCandidateTypeConstraintsSchema = union(
  [lit("BY_DOOR"), lit("BY_DOOR_BEHIND_SWING")],
  "DoorCandidateTypeConstraints",
);
export const DoorCatalogSettingsSchema = interf(
  {
    type: lit("DOOR_CATALOG_SETTINGS"),
    displayBuiltInCatalog: id("OptionalBoolean"),
    doorTypes: pkTable("DOOR_DESCRIPTOR", id("DoorDescriptorCustom")),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "DoorCatalogSettings",
);
export const DoorDescriptorCustomSchema = interf(
  {
    id: pk("DOOR_DESCRIPTOR"),
    name: opt(str),
    reportedName: str,
    tagDetails: opt(str),
    propIdPrefix: opt(id("DoorPropIdPrefix")),
    propId: opt(fk("PROP")),
    requiresDoorSwing: bool,
    swingSide: opt(id("SwingSide")),
    isExterior: bool,
    isPrimaryDoor: bool,
    doorLeafCount: num,
    includeTrim: bool,
    operationType: id("DoorOperationType"),
    segmentedArc: id("OptionalBoolean"),
    arcFactor: opt(num),
    arcDepth: num,
    roughOpeningAdjustment: opt(num),
    zOffset: num,
    requiresHeightComputation: bool,
    panelThickness: opt(num),
    panelOffsetDepth: opt(num),
    exteriorCasing: opt(id("ExteriorDoorCasingSettings")),
    interiorCasing: opt(id("InteriorDoorCasingSettings")),
    viewNotes: opt(
      mapobj(
        lit("DOOR"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "DoorViewNoteTable",
      ),
    ),
    staticHeight: opt(num),
    includeDriveway: id("OptionalBoolean"),
    roughOpeningSettings: opt(id("DoorRoughOpeningSettings")),
    isLegacyGarageDoorType: id("OptionalBoolean"),
    framing: opt(id("DoorWallFramingSettings")),
    wrapping: opt(id("DoorWallWrappingSettings")),
    width: nom("LevelInches"),
    height: nom("LevelInches"),
    catalogItemType: lit("DOOR_DESCRIPTOR"),
  },
  "DoorDescriptorCustom",
);
export const DoorOperationTypeSchema = enu(
  {
    [`BYPASS`]: "BYPASS",
    [`BI_FOLD`]: "BI_FOLD",
    [`DOUBLE_BI_FOLD`]: "DOUBLE_BI_FOLD",
    [`DOUBLE`]: "DOUBLE",
    [`DOUBLE_FIXED_PANEL`]: "DOUBLE_FIXED_PANEL",
    [`CLOSET`]: "CLOSET",
    [`ATTIC`]: "ATTIC",
    [`OPEN`]: "OPEN",
    [`ARC`]: "ARC",
    [`PORTICO`]: "PORTICO",
    [`WALL_MOUNTED`]: "WALL_MOUNTED",
    [`GARAGE_SINGLE`]: "GARAGE_SINGLE",
    [`GARAGE_DOUBLE`]: "GARAGE_DOUBLE",
    [`FIREPLACE`]: "FIREPLACE",
    [`POCKET`]: "POCKET",
  },
  "DoorOperationType",
);
export const DoorPathColumnSpreadModeSchema = enu(
  {
    [`FROM_CENTER_LINE`]: "FROM_CENTER_LINE",
    [`FROM_DOOR_EDGES`]: "FROM_DOOR_EDGES",
  },
  "DoorPathColumnSpreadMode",
);
export const DoorPlacementDeprecatedSchema = interf(
  {
    type: lit("DOOR"),
    useStripLimits: id("OptionalBoolean"),
    doorType: union([fk("DOOR_DESCRIPTOR")]),
    reverse: id("OptionalBoolean"),
    swingSide: union([undef, lit("NONE"), lit("LEFT"), lit("RIGHT"), lit("AGAINST_SOLID_WALL")]),
    ignoreOppositeWallCollision: id("OptionalBoolean"),
    exteriorCasing: opt(
      union(
        [
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("HeadCasingNone"),
              id("ExteriorDoorCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("HeadCasingTrim"),
              id("ExteriorDoorCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("HeadCasingSlices"),
              id("ExteriorDoorCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("HeadCasingStone"),
              id("ExteriorDoorCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("HeadCasingJackArch"),
              id("ExteriorDoorCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("HeadCasingFullArch"),
              id("ExteriorDoorCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("HeadCasingArchedSlices"),
              id("ExteriorDoorCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("HeadCasingEyebrowTrim"),
              id("ExteriorDoorCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
        ],
        "Partial",
      ),
    ),
    interiorCasing: opt(partial(id("InteriorDoorCasingSettings"))),
    awningSettings: opt(union([partial(id("ShedAwningSettings")), partial(id("DisabledAwningSettings"))], "Partial")),
    viewNotes: opt(
      mapobj(
        lit("DOOR"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "DoorViewNoteTable",
      ),
    ),
    disableAutoDimensions: id("OptionalBoolean"),
    reportedName: opt(str),
    includeDriveway: id("OptionalBoolean"),
    awning: opt(id("Awning")),
    framing: opt(partial(id("DoorWallFramingSettings"))),
    wrapping: opt(partial(id("DoorWallWrappingSettings"))),
    verticalOffset: opt(num),
    lateralOffset: opt(num),
    roughOpeningSettings: opt(partial(id("DoorRoughOpeningSettings"))),
    tagOffset: opt(num),
    tagDetails: opt(str),
    param: num,
    paramNormalized: bool,
    paramAnchor: id("LineAnchor"),
    wallStripDomain: bool,
    id: pk("OPENING"),
    name: str,
    parentId: union(
      [fk("ROOM", { hierarchy: ["PARENT"] }), fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] })],
      "DocEntityParentId",
    ),
    edgeId: str,
    handle: union([undef, id("RoomLayoutInstanceHandle"), id("OpeningHandle")]),
    handleAuxiliary: opt(id("OpeningHandle")),
    entityInstanceType: opt(id("EntityInstanceType")),
    entityType: lit("OPENING"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "DoorPlacementDeprecated",
);
export const DoorPlacementMatchExprSchema = interf(
  {
    type: lit("DOOR_V2"),
    lateralOffset: opt(num),
    doorType: union([fk("DOOR_DESCRIPTOR")]),
    reverse: id("OptionalBoolean"),
    swingSide: union([undef, lit("NONE"), lit("LEFT"), lit("RIGHT"), lit("AGAINST_SOLID_WALL")]),
    ignoreOppositeWallCollision: id("OptionalBoolean"),
    exteriorCasing: union([
      undef,
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingNone"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingTrim"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingSlices"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingStone"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingJackArch"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingFullArch"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingArchedSlices"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingEyebrowTrim"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
    ]),
    interiorCasing: opt(partial(id("InteriorDoorCasingSettings"))),
    awningSettings: union([undef, partial(id("ShedAwningSettings")), partial(id("DisabledAwningSettings"))]),
    viewNotes: opt(
      mapobj(
        lit("DOOR"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "DoorViewNoteTable",
      ),
    ),
    disableAutoDimensions: id("OptionalBoolean"),
    reportedName: opt(str),
    includeDriveway: id("OptionalBoolean"),
    awning: opt(id("Awning")),
    framing: opt(partial(id("DoorWallFramingSettings"))),
    wrapping: opt(partial(id("DoorWallWrappingSettings"))),
    roughOpeningSettings: opt(partial(id("DoorRoughOpeningSettings"))),
    tagOffset: opt(num),
    tagDetails: opt(str),
    horizontalAlignment: id("OpeningHorizontalAlignment"),
    id: pk("OPENING"),
    name: str,
    parentId: union(
      [fk("ROOM", { hierarchy: ["PARENT"] }), fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] })],
      "DocEntityParentId",
    ),
    edgeId: str,
    handle: union([undef, id("RoomLayoutInstanceHandle"), id("OpeningHandle")]),
    handleAuxiliary: opt(id("OpeningHandle")),
    entityInstanceType: opt(id("EntityInstanceType")),
    entityType: lit("OPENING"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    paramAnchor: id("LineAnchor"),
    horizontalDatum: opt(id("WallHorizontalDatum")),
    param: union([
      num,
      ref(
        interf(
          {
            type: lit("MATCH_EXPR"),
            cases: arr(
              ref(
                interf(
                  {
                    condition: id("Formula"),
                    value: typeParam("T"),
                  },
                  "MatchCase",
                  ["T"],
                ),
                { T: typeParam("T") },
              ),
            ),
            defaultValue: typeParam("T"),
          },
          "MatchExpression",
          ["T"],
        ),
        { T: num },
      ),
    ]),
    paramNormalized: union([
      lit(false),
      lit(true),
      ref(
        interf(
          {
            type: lit("MATCH_EXPR"),
            cases: arr(
              ref(
                interf(
                  {
                    condition: id("Formula"),
                    value: typeParam("T"),
                  },
                  "MatchCase",
                  ["T"],
                ),
                { T: typeParam("T") },
              ),
            ),
            defaultValue: typeParam("T"),
          },
          "MatchExpression",
          ["T"],
        ),
        { T: bool },
      ),
    ]),
    verticalOffset: union([
      num,
      ref(
        interf(
          {
            type: lit("MATCH_EXPR"),
            cases: arr(
              ref(
                interf(
                  {
                    condition: id("Formula"),
                    value: typeParam("T"),
                  },
                  "MatchCase",
                  ["T"],
                ),
                { T: typeParam("T") },
              ),
            ),
            defaultValue: typeParam("T"),
          },
          "MatchExpression",
          ["T"],
        ),
        { T: num },
      ),
    ]),
    verticalDatum: union([str, num]),
  },
  "DoorPlacementMatchExpr",
);
export const DoorPropIdPrefixSchema = enu(
  {
    [`DoorInterior`]: "doorInterior",
    [`DoorInteriorCloset`]: "doorInteriorCloset",
    [`DoorInteriorLouvred`]: "doorInteriorLouvred",
    [`DoorInteriorPocket`]: "doorInteriorPocket",
    [`DoorInteriorBiFold`]: "doorInteriorBiFold",
    [`DoorInteriorDouble`]: "doorInteriorDouble",
    [`DoorInteriorDoubleCloset`]: "doorInteriorDoubleCloset",
    [`DoorDoubleFrench`]: "doorDoubleFrench",
    [`DoorDoubleFrench15Lite`]: "doorDoubleFrench15Lite",
    [`DoorInteriorDoubleBypass`]: "doorInteriorDoubleBypass",
    [`DoorInteriorBarn`]: "doorInteriorBarn",
    [`DoorSlidingGlass`]: "doorSlidingGlass",
    [`DoorGarage`]: "doorGarage",
  },
  "DoorPropIdPrefix",
);
export const DoorRoughOpeningSettingsSchema = inters(
  [id("RoughOpeningJambSettings"), id("RoughOpeningHeadSettings")],
  "DoorRoughOpeningSettings",
);
export const DoorSettingsSchema = interf(
  {
    type: lit("DOOR_SETTINGS"),
    interiorDoorHeight: num,
    garageDoorRoughOpeningSize: opt(num),
    framingRoughOpeningJambDelta: opt(num),
    foundationRoughOpeningJambDelta: opt(num),
    framingRoughOpeningHeadDelta: opt(num),
    foundationRoughOpeningHeadDelta: opt(num),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "DoorSettings",
);
export const DoorWallFramingSettingsSchema = inters(
  [
    interf({
      type: lit("DOOR_FRAMING_SETTINGS"),
    }),
    id("WallFramingOpeningSettings"),
  ],
  "DoorWallFramingSettings",
);
export const DoorWallWrappingSettingsSchema = inters(
  [
    interf({
      type: lit("DOOR_WRAPPING_SETTINGS"),
    }),
    id("WallOpeningWrappingSettings"),
  ],
  "DoorWallWrappingSettings",
);
export const DormerElevationPlanSettingsSchema = interf(
  {
    showDormerWindowVerticalDimensions: id("OptionalBoolean"),
    showDormerWindowReportedName: id("OptionalBoolean"),
    showDormerWallFramingHeightDimensions: id("OptionalBoolean"),
    showDormerWallFramingWidthDimensions: id("OptionalBoolean"),
    showDormerGableWindowVerticalDims: id("OptionalBoolean"),
    showDormerGableWindowReportedName: id("OptionalBoolean"),
    showDormerRoofWidthDims: id("OptionalBoolean"),
    showDormerHorizontalPlacementDims: id("OptionalBoolean"),
    showDormerRoofSlopeElevationAnnotation: id("OptionalBoolean"),
    showDormerRoofTruncationHeightDims: id("OptionalBoolean"),
  },
  "DormerElevationPlanSettings",
);
export const DormerHandleSchema = interf(
  {
    type: lit("DORMER"),
    id: str,
  },
  "DormerHandle",
);
export const DormerPlanSettingsSchema = interf(
  {
    includeDormerOverhangDimensions: id("OptionalBoolean"),
    includeDormerDashedFraming: id("OptionalBoolean"),
    includeDormerRoofSlopeAnnotation: id("OptionalBoolean"),
  },
  "DormerPlanSettings",
);
export const DormerRoofTypeSchema = enu(
  {
    [`GABLE`]: "GABLE",
    [`SHED`]: "SHED",
  },
  "DormerRoofType",
);
export const DormerSettingsSchema = interf(
  {
    type: lit("DORMER_SETTINGS"),
    roofType: opt(id("DormerRoofType")),
    eaveReturnDistance: opt(num),
    rakeFriezeBoard: opt(id("ProfileId")),
    rakeFriezeBoardMaterial: opt(id("ExteriorMaterial")),
    eaveFriezeBoard: opt(id("ProfileId")),
    eaveFriezeBoardMaterial: opt(id("ExteriorMaterial")),
    wallBaseBoard: opt(id("ProfileId")),
    wallBaseBoardMode: opt(id("DormerWallBaseBoardMode")),
    wrapFriezeBoardMode: opt(id("WrapFriezeBoardMode")),
    gableBellyBandBoard: opt(id("ProfileId")),
    gableBellyBandBoardMaterial: opt(id("ExteriorMaterial")),
    gableBellyBandBoardAnchor: opt(id("WallVerticalDatumAnchor")),
    gableBellyBandBoardJustification: opt(id("VerticalJustification")),
    gableBellyBandBoardOffset: opt(num),
    slope: union([undef, num, id("Formula")]),
    slopes: opt(arr(id("RoofSlopeOptions"))),
    wallMaterial: opt(id("ExteriorMaterial")),
    roofingMaterial: opt(id("ExteriorMaterial")),
    roofingMaterialThickness: opt(num),
    roofingMaterialExtension: opt(num),
    roofRidgeRoofingCapMaterial: opt(id("ExteriorMaterial")),
    roofRidgeRoofingCapWidth: opt(num),
    roofRidgeRoofingCapThickness: opt(num),
    includeRidgeVent: id("OptionalBoolean"),
    suppressRidgeVent: id("OptionalBoolean"),
    eaveType: opt(id("EaveType")),
    eaveCutType: opt(id("EaveCutType")),
    eaveReturnOverhang: opt(num),
    rakeBracketPropId: opt(fk("PROP")),
    friezeBoardOrientation: opt(id("StreetOrientationMode")),
    addRafterTailExtension: id("OptionalBoolean"),
    rafterTailSlope: opt(num),
    rafterTailExtensionEdgeOffset: opt(num),
    rafterTailExtension: opt(num),
    rafterTailDepth: opt(num),
    rafterTailClosed: id("OptionalBoolean"),
    eaveReturnRoofMaterial: opt(id("ExteriorMaterial")),
    lookoutRafters: id("OptionalBoolean"),
    flyRafters: id("OptionalBoolean"),
    overhang: opt(num),
    includeTriangleGableVent: id("OptionalBoolean"),
    triangleGableVentBaseWidth: opt(num),
    cornerBoardProfile: opt(id("ProfileId")),
    cornerBoardMaterial: opt(id("ExteriorMaterial")),
    cornerBoardBottomOffset: opt(num),
    cornerBoardTopOffset: opt(num),
    side: opt(id("BuildingSide")),
    horizontalPositions: opt(arr(num)),
    normalizedPositions: id("OptionalBoolean"),
    verticalPosition: opt(num),
    width: opt(num),
    height: opt(num),
    frontOffset: opt(num),
    start: opt(num),
    end: opt(num),
    spacing: opt(num),
    truncationType: opt(id("RoofTruncationType")),
    truncationHeightFactor: opt(num),
    truncationNormalizedHeight: id("OptionalBoolean"),
    truncationSlopeType: opt(id("TruncationSlopeType")),
    truncationSlope: opt(num),
    eaveBracketPropId: opt(id("BuiltInExteriorPropId")),
    eaveBracketSide: opt(id("EaveBracketSide")),
    eaveBracketParamsNormalized: id("OptionalBoolean"),
    eaveBracketParams: opt(arr(num)),
    eaveBracketPlacement: opt(id("EaveBracketPlacement")),
    rakeBracketParamsNormalized: id("OptionalBoolean"),
    rakeBracketParams: opt(arr(num)),
    rakeBracketAtPeak: id("OptionalBoolean"),
    useLegacyAttachmentSettings: id("OptionalBoolean"),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "DormerSettings",
);
export const DormerWallBaseBoardModeSchema = enu(
  {
    [`NONE`]: "NONE",
    [`FRONT`]: "FRONT",
    [`SIDES`]: "SIDES",
    [`FRONT_AND_SIDES`]: "FRONT_AND_SIDES",
  },
  "DormerWallBaseBoardMode",
);
export const DotsPerInchSchema = nom("DotsPerInch");
export const DrawingSchema = interf(
  {
    id: pk("DRAWING"),
    catalogId: fk("DRAWING_CATALOG_SETTINGS"),
    type: opt(id("DrawingType")),
    name: opt(str),
    url: opt(str),
    assetWidth: opt(num),
    assetHeight: opt(num),
    prettyName: opt(str),
    size: lit("INHERIT"),
    drawingScale: id("DrawingScale"),
    scale: opt(num),
    scaleMode: opt(id("DrawingScaleMode")),
    fillPage: id("OptionalBoolean"),
    builderOptionID: opt(str),
    catalogItemType: lit("DRAWING"),
  },
  "Drawing",
);
export const DrawingCatalogSettingsSchema = interf(
  {
    type: lit("DRAWING_CATALOG_SETTINGS"),
    drawings: pkTable("DRAWING", id("Drawing")),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "DrawingCatalogSettings",
);
export const DrawingRefSchema = interf(
  {
    id: pk("DRAWING_REF"),
    drawingId: fk("DRAWING"),
    parentId: opt(union([fk("SHEET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
    entityType: lit("DRAWING_REF"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    prettyName: opt(str),
    scaleMode: union([undef, lit("UNIFORM"), lit("WIDTH_OVERRIDE"), lit("HEIGHT_OVERRIDE"), lit("SCALE_TO_FIT")]),
    scale: opt(num),
  },
  "DrawingRef",
);
export const DrawingRefHandleSchema = interf(
  {
    type: lit("DRAWING_REF"),
    id: str,
  },
  "DrawingRefHandle",
);
export const DrawingScaleSchema = enu(
  {
    [`NTS`]: "NTS",
    [`THREE_QUARTER_INCH`]: "3/4\" = 1'",
  },
  "DrawingScale",
);
export const DrawingScaleModeSchema = enu(
  {
    [`UNIFORM`]: "UNIFORM",
    [`WIDTH_OVERRIDE`]: "WIDTH_OVERRIDE",
    [`HEIGHT_OVERRIDE`]: "HEIGHT_OVERRIDE",
    [`SCALE_TO_FIT`]: "SCALE_TO_FIT",
  },
  "DrawingScaleMode",
);
export const DrawingScaleParameterSchema = interf(
  {
    defaultValue: opt(num),
    type: lit("DRAWING_SCALE"),
  },
  "DrawingScaleParameter",
);
export const DrawingsPlanSheetSchema = interf(
  {
    id: pk("SHEET"),
    type: lit("DRAWINGS"),
    includeRoomDrawings: id("OptionalBoolean"),
    removeTitleBlock: bool,
    entityType: lit("SHEET"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    sheetNumberPrefix: str,
    sheetNumber: str,
    labels: fkTable("LABEL", bool),
  },
  "DrawingsPlanSheet",
);
export const DrawingTemplateInstanceSchema = interf(
  {
    templateType: lit("DRAWING"),
    x: num,
    y: num,
    rotation: num,
    positioningMethod: id("PositioningMethod"),
    edgeId: opt(str),
    id: pk("CONTENT_TEMPLATE_INSTANCE"),
    contentTemplateId: fk("CONTENT_TEMPLATE"),
    parameterValues: fkTable(
      ["LOCAL_PARAMETER", "GLOBAL_PARAMETER", "SYSTEM_PARAMETER"],
      union([
        id("ParameterRef"),
        id("PrimitiveValue"),
        id("OptionPresetValue"),
        id("OptionValue"),
        id("LevelValue"),
        id("UnitValue"),
        id("DataSequenceValue"),
        id("ViewTemplateValue"),
        id("ContentTemplateValue"),
        id("ElevationViewValue"),
        id("SectionViewValue"),
      ]),
    ),
    parentId: opt(
      union(
        [
          fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }),
          fk("ROOM", { hierarchy: ["PARENT"] }),
          fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] }),
          fk("ELEVATION_VIEW", { hierarchy: ["PARENT"] }),
          fk("SECTION_VIEW", { hierarchy: ["PARENT"] }),
          fk("CONTENT_TEMPLATE_INSTANCE", { hierarchy: ["PARENT"] }),
          fk("LEVEL", { hierarchy: ["PARENT"] }),
          fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] }),
        ],
        "DocEntityParentId",
      ),
    ),
    entityType: lit("CONTENT_TEMPLATE_INSTANCE"),
    name: str,
    sortIndex: num,
    labels: fkTable("LABEL", bool),
    disabled: id("ParameterFormulaDisabledField"),
  },
  "DrawingTemplateInstance",
);
export const DrawingTemplateParameterSchema = interf(
  {
    defaultValue: opt(fk("CONTENT_TEMPLATE")),
    type: lit("DRAWING_TEMPLATE"),
  },
  "DrawingTemplateParameter",
);
export const DrawingTypeSchema = enu(
  {
    [`FOUNDATION`]: "FOUNDATION",
    [`STRUCTURE`]: "STRUCTURE",
    [`OTHER`]: "OTHER",
    [`VOID`]: "VOID",
  },
  "DrawingType",
);
export const DrawingViewportSchema = inters(
  [
    id("ViewportBase"),
    interf({
      viewType: lit("DRAWING"),
      contentSourceId: union([id("ParameterRef"), fk("CONTENT_TEMPLATE")]),
      parameterValues: fkTable(
        ["LOCAL_PARAMETER", "GLOBAL_PARAMETER", "SYSTEM_PARAMETER"],
        union([
          id("ParameterRef"),
          id("PrimitiveValue"),
          id("OptionPresetValue"),
          id("OptionValue"),
          id("LevelValue"),
          id("UnitValue"),
          id("DataSequenceValue"),
          id("ViewTemplateValue"),
          id("ContentTemplateValue"),
          id("ElevationViewValue"),
          id("SectionViewValue"),
        ]),
      ),
      contentRotationDegrees: opt(id("ParameterRefNumberField")),
    }),
  ],
  "DrawingViewport",
);
export const DrawingViewTemplateSchema = interf(
  {
    viewType: lit("DRAWING"),
    id: pk("VIEW_TEMPLATE"),
    categories: arr(id("SheetGeometryCategory")),
    styleOverrides: mapobj(
      id("SheetGeometryCategory"),
      interf(
        {
          line: opt(id("LineStyle")),
          text: opt(id("TextStyle")),
        },
        "SheetGeometryCategoryStyle",
      ),
      true,
      "SheetGeometryStyleTable",
    ),
    viewStyle: opt(id("ViewStyle")),
    viewTemplateOverrideIds: arr(fk("VIEW_TEMPLATE_OVERRIDE")),
    entityType: lit("VIEW_TEMPLATE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "DrawingViewTemplate",
);
export const DrivewaySiteShapeSchema = interf(
  {
    type: lit("DRIVEWAY"),
    isConformal: id("OptionalBoolean"),
    material: opt(id("ExteriorMaterial")),
    id: pk("SITE_SHAPE"),
    parentId: union([fk("SITE", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    geom: any,
    entityType: lit("SITE_SHAPE"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    zHeight: num,
    height: opt(num),
  },
  "DrivewaySiteShape",
);
export const DrywallSchema = interf(
  {
    id: pk("SHEATHING_COMPONENT"),
    name: str,
    sheathingType: lit("DRYWALL"),
    thickness: num,
    entityType: lit("SHEATHING_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "Drywall",
);
export const DxfAssetSchema = interf(
  {
    srcType: lit("DXF"),
    srcName: str,
    srcSize: num,
    geometryLayerVisibility: obj(bool, "Readonly"),
    geometryLayerStyleOverrides: obj(
      interf({
        line: opt(id("LineStyle")),
        text: opt(id("TextStyle")),
      }),
      "Readonly",
    ),
    id: pk("ASSET"),
    srcPath: str,
    entityType: lit("ASSET"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    geometryUnit: id("DXFUnit"),
    geometryAABB2: id("AABB2"),
    geometryLayers: arr(str),
  },
  "DxfAsset",
);
export const DXFUnitSchema = union(
  [
    lit("Unitless"),
    lit("Inches"),
    lit("Feet"),
    lit("Miles"),
    lit("Millimeters"),
    lit("Centimeters"),
    lit("Meters"),
    lit("Kilometers"),
    lit("Microinches"),
    lit("Mils"),
    lit("Yards"),
    lit("Angstroms"),
    lit("Nanometers"),
    lit("Microns"),
    lit("Decimeters"),
    lit("Decameters"),
    lit("Hectometers"),
    lit("Gigameters"),
    lit("Astronomical Units"),
    lit("Light Years"),
    lit("Parsecs"),
  ],
  "DXFUnit",
);
export const EaveBracketPlacementSchema = enu(
  {
    [`START_TO_END`]: "START_TO_END",
    [`END_TO_START`]: "END_TO_START",
  },
  "EaveBracketPlacement",
);
export const EaveBracketSideSchema = enu(
  {
    [`LEFT`]: "LEFT",
    [`RIGHT`]: "RIGHT",
    [`BOTH`]: "BOTH",
    [`ALL`]: "ALL",
  },
  "EaveBracketSide",
);
export const EaveCutTypeSchema = enu(
  {
    [`PLUMB`]: "PLUMB",
    [`SQUARED`]: "SQUARED",
  },
  "EaveCutType",
);
export const EaveFasciaHeightDatumSchema = enu(
  {
    [`DEFAULT`]: "DEFAULT",
    [`HOST_ROOF`]: "HOST_ROOF",
    [`HOST_ROOF_START_TRUNCATION`]: "HOST_ROOF_START_TRUNCATION",
    [`HOST_ROOF_END_TRUNCATION`]: "HOST_ROOF_END_TRUNCATION",
  },
  "EaveFasciaHeightDatum",
);
export const EaveFriezeBoardModeSchema = enu(
  {
    [`EAVE_AND_EAVE_RETURNS`]: "EAVE_AND_EAVE_RETURNS",
    [`EAVE`]: "EAVE",
    [`LEGACY_EAVE`]: "LEGACY_EAVE",
  },
  "EaveFriezeBoardMode",
);
export const EaveTypeSchema = enu(
  {
    [`BOXED_BOX`]: "BOXED_BOX",
    [`BOXED_OPEN`]: "BOXED_OPEN",
    [`BOXED_MINI_HIP`]: "BOXED_MINI_HIP",
    [`BOXED_MINI_SHED`]: "BOXED_MINI_SHED",
    [`BOXED_FULL_RETURN`]: "BOXED_FULL_RETURN",
    [`ANGLED_ENCLOSED_OPEN`]: "ANGLED_ENCLOSED_OPEN",
    [`ANGLED_OPEN_OPEN`]: "ANGLED_OPEN_OPEN",
  },
  "EaveType",
);
export const EdgeBehaviorSchema = union(
  [
    id("DimensionEdgeBehavior"),
    id("ElevationNoteEdgeBehavior"),
    id("FoundationAssemblyEdgeBehavior"),
    id("FoundationPatternEdgeBehavior"),
    id("LabelEdgeBehavior"),
    id("PorchColumnEdgeBehavior"),
    id("TrimEdgeBehavior"),
    id("WallAssemblyEdgeBehavior"),
  ],
  "EdgeBehavior",
);
export const EdgeBehaviorHandleSchema = interf(
  {
    type: lit("EDGE_BEHAVIOR"),
    id: str,
  },
  "EdgeBehaviorHandle",
);
export const EdgeHandleSchema = interf(
  {
    type: lit("EDGE"),
    edgeId: num,
    parent: id("ShapeBasedEntityHandle"),
    shapeId: str,
  },
  "EdgeHandle",
);
export const EdgeModifierSchema = interf(
  {
    id: pk("EDGE_MODIFIER"),
    parentId: union(
      [
        fk("RAILING", { hierarchy: ["PARENT"] }),
        fk("ROOM", { hierarchy: ["PARENT"] }),
        fk("ROOF", { hierarchy: ["PARENT"] }),
        fk("FOUNDATION", { hierarchy: ["PARENT"] }),
        fk("FLOOR", { hierarchy: ["PARENT"] }),
      ],
      "DocEntityParentId",
    ),
    modifierId: fk("MODIFIER"),
    edgeId: str,
    entityType: lit("EDGE_MODIFIER"),
    name: str,
    sortIndex: num,
  },
  "EdgeModifier",
);
export const EdgeModifierHandleSchema = interf(
  {
    type: lit("EDGE_MODIFIER"),
    id: str,
  },
  "EdgeModifierHandle",
);
export const EdgeOrientationSchema = enu(
  {
    [`TOP`]: "TOP",
    [`BOTTOM`]: "BOTTOM",
    [`LEFT`]: "LEFT",
    [`RIGHT`]: "RIGHT",
  },
  "EdgeOrientation",
);
export const EditModeHandleSchema = interf(
  {
    type: lit("EDIT_MODE"),
    editModeType: union([lit("SHAPE"), lit("WALL_PLANE_OVERRIDE")]),
  },
  "EditModeHandle",
);
export const EditorViewStateSchema = interf(
  {
    activeViewHandle: union([
      undef,
      id("ElevationViewHandle"),
      id("SectionViewHandle"),
      id("View3DHandle"),
      id("PlanViewHandle"),
      id("GeneratedPageViewHandle"),
      id("ContentTemplateViewHandle"),
      id("ContentTemplateInstanceViewHandle"),
      id("DataSequenceViewHandle"),
      id("WallPlaneViewHandle"),
    ]),
    viewTabGroups: mapobj(
      enu(
        {
          [`PLAN_VIEW`]: "PLAN_VIEW",
          [`VIEW_3D_ELEVATION_PAGE`]: "VIEW_3D_ELEVATION_PAGE",
        },
        "ViewTabGroupType",
      ),
      interf(
        {
          type: enu(
            {
              [`PLAN_VIEW`]: "PLAN_VIEW",
              [`VIEW_3D_ELEVATION_PAGE`]: "VIEW_3D_ELEVATION_PAGE",
            },
            "ViewTabGroupType",
          ),
          viewTypesAllowed: arr(
            union([
              lit("ELEVATION_VIEW"),
              lit("SECTION_VIEW"),
              lit("PLAN_VIEW"),
              lit("CONTENT_TEMPLATE_INSTANCE_VIEW"),
              lit("CONTENT_TEMPLATE_VIEW"),
              lit("DATA_SEQUENCE_VIEW"),
              lit("VIEW_3D"),
              lit("GENERATED_PAGE_VIEW"),
              lit("WALL_PLANE_VIEW"),
            ]),
          ),
          previewTabHandle: opt(
            union(
              [
                id("ElevationViewHandle"),
                id("SectionViewHandle"),
                id("View3DHandle"),
                id("PlanViewHandle"),
                id("GeneratedPageViewHandle"),
                id("ContentTemplateViewHandle"),
                id("ContentTemplateInstanceViewHandle"),
                id("DataSequenceViewHandle"),
                id("WallPlaneViewHandle"),
              ],
              "ViewHandle",
            ),
          ),
          openViewHandle: opt(
            union(
              [
                id("ElevationViewHandle"),
                id("SectionViewHandle"),
                id("View3DHandle"),
                id("PlanViewHandle"),
                id("GeneratedPageViewHandle"),
                id("ContentTemplateViewHandle"),
                id("ContentTemplateInstanceViewHandle"),
                id("DataSequenceViewHandle"),
                id("WallPlaneViewHandle"),
              ],
              "ViewHandle",
            ),
          ),
          viewHandles: arr(
            union(
              [
                id("ElevationViewHandle"),
                id("SectionViewHandle"),
                id("View3DHandle"),
                id("PlanViewHandle"),
                id("GeneratedPageViewHandle"),
                id("ContentTemplateViewHandle"),
                id("ContentTemplateInstanceViewHandle"),
                id("DataSequenceViewHandle"),
                id("WallPlaneViewHandle"),
              ],
              "ViewHandle",
            ),
          ),
        },
        "ViewTabGroup",
      ),
      true,
      "ViewTabGroups",
    ),
  },
  "EditorViewState",
);
export const EffectSchema = union(
  [id("VisibilityEffect"), id("StylingEffect"), id("ScalingEffect"), id("RelaxationObstacleEffect")],
  "Effect",
);
export const EffectHandleSchema = interf(
  {
    type: lit("EFFECT"),
    id: str,
  },
  "EffectHandle",
);
export const ElectricalBoxTypeSchema = enu(
  {
    [`NONE`]: "NONE",
    [`ONE_GANG`]: "ONE_GANG",
    [`ONE_GANG_WP`]: "ONE_GANG_WP",
    [`TWO_GANG`]: "TWO_GANG",
    [`THREE_GANG`]: "THREE_GANG",
    [`FOUR_GANG`]: "FOUR_GANG",
    [`FIVE_GANG`]: "FIVE_GANG",
    [`ROUND`]: "ROUND",
    [`ROUND_PAN`]: "ROUND_PAN",
    [`FAN_RATED`]: "FAN_RATED",
    [`FLOOR_SINGLE`]: "FLOOR_SINGLE",
    [`FLOOR_DOUBLE`]: "FLOOR_DOUBLE",
    [`JUNCTION_BOX`]: "JUNCTION_BOX",
  },
  "ElectricalBoxType",
);
export const ElectricalControllerNonSwitchSchema = interf(
  {
    deviceType: lit("CONTROLLER"),
    controllerType: union([undef, lit("SENSOR"), lit("OPENER")]),
    parentId: union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    name: str,
    planTag: opt(str),
    selections: arr(id("ControllerSelectionConfig")),
    connection: id("LoadConnection"),
    id: pk("ELECTRICAL_DEVICE"),
    entityType: lit("ELECTRICAL_DEVICE"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    labels: fkTable("LABEL", bool),
  },
  "ElectricalControllerNonSwitch",
);
export const ElectricalControllerSwitchSchema = interf(
  {
    deviceType: lit("CONTROLLER"),
    controllerType: opt(lit("SWITCH")),
    switchType: id("ControllerSwitchType"),
    parentId: union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    name: str,
    planTag: opt(str),
    selections: arr(id("ControllerSelectionConfig")),
    connection: id("LoadConnection"),
    id: pk("ELECTRICAL_DEVICE"),
    entityType: lit("ELECTRICAL_DEVICE"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    labels: fkTable("LABEL", bool),
  },
  "ElectricalControllerSwitch",
);
export const ElectricalDeviceSchema = union(
  [id("ElectricalLoad"), id("ElectricalControllerNonSwitch"), id("ElectricalControllerSwitch")],
  "ElectricalDevice",
);
export const ElectricalDeviceHandleSchema = interf(
  {
    type: lit("ELECTRICAL_DEVICE"),
    id: str,
  },
  "ElectricalDeviceHandle",
);
export const ElectricalItemCatalogSettingsSchema = interf(
  {
    type: lit("ELECTRICAL_ITEM_CATALOG_SETTINGS"),
    loadTypes: pkTable("LOAD_DESCRIPTOR", id("LoadDescriptor")),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "ElectricalItemCatalogSettings",
);
export const ElectricalLayoutSchema = union(
  [
    id("SingleLight"),
    id("GarageLights"),
    id("FourLightsWithOptionalFan"),
    id("StandardOutlet"),
    id("AtDoorByType"),
    id("AtBackOfProp"),
    id("LinearArray"),
    id("RectangularArray"),
  ],
  "ElectricalLayout",
);
export const ElectricalLayoutHandleSchema = interf(
  {
    type: lit("ELECTRICAL_LAYOUT"),
    id: str,
  },
  "ElectricalLayoutHandle",
);
export const ElectricalLoadSchema = interf(
  {
    deviceType: lit("LOAD"),
    parentId: union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    name: str,
    position: id("RoomPosition"),
    loadType: opt(fk("LOAD_DESCRIPTOR")),
    hideConnections: id("OptionalBoolean"),
    fromLegacyHomeGroup: id("OptionalBoolean"),
    id: pk("ELECTRICAL_DEVICE"),
    entityType: lit("ELECTRICAL_DEVICE"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    labels: fkTable("LABEL", bool),
  },
  "ElectricalLoad",
);
export const ElectricalRuleSchema = interf(
  {
    id: pk("ELECTRICAL_RULE"),
    name: opt(str),
    filters: id("RoomTypeSpaceTypeFilter"),
    electricalLayout: id("ElectricalLayout"),
    parentId: union([fk("SETTINGS", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
  },
  "ElectricalRule",
);
export const ElectricalRuleHandleSchema = interf(
  {
    type: lit("ELECTRICAL_RULE"),
    settingsHandle: id("SettingsHandle"),
    id: str,
  },
  "ElectricalRuleHandle",
);
export const ElectricalSettingsSchema = interf(
  {
    type: lit("ELECTRICAL_SETTINGS"),
    mergeRules: id("OptionalBoolean"),
    slots: id("ElectricalSlots"),
    rules: pkTable("ELECTRICAL_RULE", id("ElectricalRule")),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "ElectricalSettings",
);
export const ElectricalSlotsSchema = interf(
  {
    controllers: id("ControllerTypeSlots"),
    loads: id("LoadTypeSlots"),
  },
  "ElectricalSlots",
);
export const ElevationSchema = interf(
  {
    id: pk("ELEVATION"),
    baseSettings: str,
    defaultExteriorCamera: opt(id("CameraPosition")),
    topLeftPerspectiveCamera: opt(id("CameraPosition")),
    topRightPerspectiveCamera: opt(id("CameraPosition")),
    bottomLeftPerspectiveCamera: opt(id("CameraPosition")),
    bottomRightPerspectiveCamera: opt(id("CameraPosition")),
    thumbnailUrl: opt(str),
    rendered3DImageUrl: opt(str),
    price: union([
      undef,
      num,
      ref(
        interf(
          {
            type: lit("MATCH_EXPR"),
            cases: arr(
              ref(
                interf(
                  {
                    condition: id("Formula"),
                    value: typeParam("T"),
                  },
                  "MatchCase",
                  ["T"],
                ),
                { T: typeParam("T") },
              ),
            ),
            defaultValue: typeParam("T"),
          },
          "MatchExpression",
          ["T"],
        ),
        { T: num },
      ),
    ]),
    description: opt(str),
    disabled: id("OptionalBoolean"),
    showroomIntro: id("OptionalBoolean"),
    name: str,
    priceTbd: id("OptionalBoolean"),
    builderOptionCode: union([undef, nul, str]),
    builderTemplateCode: opt(str),
    salesImages: opt(arr(id("SalesImage"))),
    entityType: lit("ELEVATION"),
    parentId: opt(str),
    sortIndex: num,
  },
  "Elevation",
);
export const ElevationHandleSchema = interf(
  {
    type: lit("ELEVATION"),
    id: str,
  },
  "ElevationHandle",
);
export const ElevationImagesSchema = interf(
  {
    thumbnail: opt(str),
    rendered: opt(str),
  },
  "ElevationImages",
);
export const ElevationNoteEdgeBehaviorSchema = interf(
  {
    edgeBehaviorType: lit("ELEVATION_NOTE"),
    edgeId: str,
    offset: num,
    param: num,
    paramNormalized: bool,
    paramAnchor: id("LineAnchor"),
    datumId: opt(fk("DATUM")),
    text: str,
    rotation: num,
    mirrorWithBuilding: bool,
    disabled: id("FormulaDisabledField"),
    id: pk("EDGE_BEHAVIOR"),
    parentId: union(
      [fk("ROOM", { hierarchy: ["PARENT"] }), fk("STAIR_BLOCK", { hierarchy: ["PARENT"] })],
      "DocEntityParentId",
    ),
    entityType: lit("EDGE_BEHAVIOR"),
    name: str,
    sortIndex: num,
  },
  "ElevationNoteEdgeBehavior",
);
export const ElevationNotePlacementTypeSchema = enu(
  {
    [`IN_PLACE`]: "IN_PLACE",
    [`ON_PERIMETER`]: "ON_PERIMETER",
    [`BOUNDING_BOX`]: "BOUNDING_BOX",
  },
  "ElevationNotePlacementType",
);
export const ElevationOptionSetSchema = interf(
  {
    optionSetType: lit("ELEVATION"),
    baseSettings: obj(str, "Table"),
    cameraPositions: obj(
      mapobj(
        union([
          lit("defaultExteriorCamera"),
          lit("topLeftPerspectiveCamera"),
          lit("topRightPerspectiveCamera"),
          lit("bottomLeftPerspectiveCamera"),
          lit("bottomRightPerspectiveCamera"),
        ]),
        id("CameraPosition"),
        true,
        "ElevationCameraPositions",
      ),
      "Table",
    ),
    images: obj(id("ElevationImages"), "Table"),
    id: pk("OPTION_SET"),
    defaultValue: str,
    options: pkTable("OPTION", id("DocOption"), true),
    salesCategory: str,
    builderOptionSetCode: union([undef, nul, str]),
    category: opt(str),
    description: opt(str),
    tags: opt(arr(str)),
    disabled: id("OptionalBoolean"),
    globalSortOrder: opt(num),
    showroomIntro: id("OptionalBoolean"),
    displayType: union([undef, lit("CARDS"), lit("TABLE")]),
    readonly: id("OptionalBoolean"),
    entityType: lit("OPTION_SET"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    labels: fkTable("LABEL", bool),
  },
  "ElevationOptionSet",
);
export const ElevationReferenceFrameSchema = union(
  [lit("FRONT"), lit("BACK"), lit("LEFT"), lit("RIGHT")],
  "ElevationReferenceFrame",
);
export const ElevationViewSchema = interf(
  {
    id: pk("ELEVATION_VIEW"),
    referenceFrame: id("ElevationReferenceFrame"),
    elevationAnnotationParams: opt(
      interf({
        levelAnnotationMethod: opt(
          enu(
            {
              [`FIXED`]: "FIXED",
              [`ELEVATION_RELATIVE`]: "ELEVATION_RELATIVE",
            },
            "LevelAnnotationMethod",
          ),
        ),
        levelAnnotationOffset: opt(nom("SheetInches")),
        levelAnnotationVerticalSpacing: opt(nom("SheetInches")),
        boundingBoxElbowXSpacing: opt(nom("SheetInches")),
        boundingBoxLabelXSpacing: opt(nom("SheetInches")),
        labelTextWidth: opt(nom("SheetInches")),
      }),
    ),
    viewStyle: opt(id("ViewStyle")),
    gradeLineSource: opt(id("GradeLineSource")),
    entityType: lit("ELEVATION_VIEW"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    viewScale: opt(num),
    viewFilter: opt(partial(id("ViewFilter"))),
    dimensionPrecision: opt(id("DimensionPrecision")),
  },
  "ElevationView",
);
export const ElevationViewHandleSchema = interf(
  {
    type: lit("ELEVATION_VIEW"),
    id: str,
  },
  "ElevationViewHandle",
);
export const ElevationViewParameterSchema = interf(
  {
    defaultValue: opt(fk("ELEVATION_VIEW")),
    type: lit("ELEVATION_VIEW"),
  },
  "ElevationViewParameter",
);
export const ElevationViewportSchema = inters(
  [
    id("ViewportBase"),
    id("OptionPresetBase"),
    interf({
      viewType: lit("ELEVATION_VIEW"),
      contentSourceId: union([id("ParameterRef"), fk("ELEVATION_VIEW")]),
      elevationAnnotationParams: opt(
        interf({
          levelAnnotationMethod: opt(
            enu(
              {
                [`FIXED`]: "FIXED",
                [`ELEVATION_RELATIVE`]: "ELEVATION_RELATIVE",
              },
              "LevelAnnotationMethod",
            ),
          ),
          levelAnnotationOffset: opt(nom("SheetInches")),
          levelAnnotationVerticalSpacing: opt(nom("SheetInches")),
          boundingBoxElbowXSpacing: opt(nom("SheetInches")),
          boundingBoxLabelXSpacing: opt(nom("SheetInches")),
          labelTextWidth: opt(nom("SheetInches")),
        }),
      ),
    }),
  ],
  "ElevationViewport",
);
export const ElevationViewTemplateSchema = interf(
  {
    viewType: lit("ELEVATION_VIEW"),
    belowGradeRenderStyle: opt(id("PlanLineStyle")),
    gradeLineSource: opt(id("GradeLineSource")),
    id: pk("VIEW_TEMPLATE"),
    categories: arr(id("SheetGeometryCategory")),
    styleOverrides: mapobj(
      id("SheetGeometryCategory"),
      interf(
        {
          line: opt(id("LineStyle")),
          text: opt(id("TextStyle")),
        },
        "SheetGeometryCategoryStyle",
      ),
      true,
      "SheetGeometryStyleTable",
    ),
    viewStyle: opt(id("ViewStyle")),
    viewTemplateOverrideIds: arr(fk("VIEW_TEMPLATE_OVERRIDE")),
    entityType: lit("VIEW_TEMPLATE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "ElevationViewTemplate",
);
export const ElevationViewValueSchema = interf(
  {
    type: lit("ELEVATION_VIEW"),
    value: fk("ELEVATION_VIEW"),
  },
  "ElevationViewValue",
);
export const EnableOptionEffectSchema = interf(
  {
    effectType: lit("ENABLE"),
    optionId: union([fk("OPTION"), undef, nul]),
    id: pk("OPTION_EFFECT"),
    optionSetId: fk("OPTION_SET"),
    parentId: union([fk("OPTION_RULE", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    entityType: lit("OPTION_EFFECT"),
    name: str,
    sortIndex: num,
  },
  "EnableOptionEffect",
);
export const EntityHostedAnnotationPointSchema = interf(
  {
    hostEntity: opt(id("AnnotationHostWall")),
    enabled: id("OptionalBoolean"),
  },
  "EntityHostedAnnotationPoint",
);
export const EntityInstanceTypeSchema = enu(
  {
    [`ROOM_LAYOUT_SOURCE`]: "ROOM_LAYOUT_SOURCE",
    [`ROOM_LAYOUT_INSTANCE`]: "ROOM_LAYOUT_INSTANCE",
    [`COMPONENT_INSTANCE`]: "COMPONENT_INSTANCE",
  },
  "EntityInstanceType",
);
export const EntityRefSchema = manual("EntityRef");
export const EntitySettingsSchema = interf(
  {
    id: pk("ENTITY_SETTINGS"),
    entityId: fk(["ROOM", "ROOF", "FOUNDATION", "OPENING", "FLOOR", "ROOF_OPENING", "DORMER"]),
    referencedEntityType: id("EntityTypesEligibleForEntitySettings"),
    settingsOrSettingsSetId: fk(["SETTINGS", "SETTINGS_SET"]),
    entityType: lit("ENTITY_SETTINGS"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "EntitySettings",
);
export const EntitySettingsHandleSchema = interf(
  {
    type: lit("ENTITY_SETTINGS"),
    id: str,
  },
  "EntitySettingsHandle",
);
export const EntityTypesEligibleForEntitySettingsSchema = union(
  [lit("ROOM"), lit("ROOF"), lit("FOUNDATION"), lit("OPENING"), lit("FLOOR"), lit("ROOF_OPENING"), lit("DORMER")],
  "EntityTypesEligibleForEntitySettings",
);
export const ExplicitIndexLoadConnectionSchema = interf(
  {
    type: lit("EXPLICIT_LOAD_INDEX"),
    loadIndex: num,
  },
  "ExplicitIndexLoadConnection",
);
export const ExteriorDimensionTypeSchema = enu(
  {
    [`THREE_ROW`]: "THREE_ROW",
    [`FOUR_ROW`]: "FOUR_ROW",
  },
  "ExteriorDimensionType",
);
export const ExteriorDoorCasingSettingsSchema = union(
  [
    inters([
      interf({
        type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("HeadCasingNone"),
      id("ExteriorDoorCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
    inters([
      interf({
        type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("HeadCasingTrim"),
      id("ExteriorDoorCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
    inters([
      interf({
        type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("HeadCasingSlices"),
      id("ExteriorDoorCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
    inters([
      interf({
        type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("HeadCasingStone"),
      id("ExteriorDoorCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
    inters([
      interf({
        type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("HeadCasingJackArch"),
      id("ExteriorDoorCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
    inters([
      interf({
        type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("HeadCasingFullArch"),
      id("ExteriorDoorCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
    inters([
      interf({
        type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("HeadCasingArchedSlices"),
      id("ExteriorDoorCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
    inters([
      interf({
        type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("HeadCasingEyebrowTrim"),
      id("ExteriorDoorCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
  ],
  "ExteriorDoorCasingSettings",
);
export const ExteriorDoorCasingViewNotesSettingsSchema = interf(
  {
    viewNotes: opt(
      mapobj(
        enu(
          {
            [`APRON`]: "APRON",
            [`HEAD`]: "HEAD",
            [`SIDE`]: "SIDE",
          },
          "ExteriorDoorCasingViewNoteType",
        ),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "ExteriorDoorCasingViewNoteTable",
      ),
    ),
  },
  "ExteriorDoorCasingViewNotesSettings",
);
export const ExteriorFloorMaterialOverrideSchema = union(
  [
    lit("foundation0"),
    lit("foundation1"),
    lit("foundation2"),
    lit("driveway0"),
    lit("driveway1"),
    lit("driveway2"),
    lit("walks0"),
    lit("walks1"),
    lit("walks2"),
    lit("deck0"),
    lit("deck1"),
    lit("deck2"),
    lit("NONE"),
  ],
  "ExteriorFloorMaterialOverride",
);
export const ExteriorMaterialSchema = union(
  [
    lit("wallExterior0"),
    lit("wallExterior1"),
    lit("wallExterior2"),
    lit("wallExterior3"),
    lit("wallExterior4"),
    lit("wallExterior5"),
    lit("wallExterior6"),
    lit("wallExterior7"),
    lit("wallExterior8"),
    lit("wallExterior9"),
    lit("trimExterior0"),
    lit("trimExterior1"),
    lit("trimExterior2"),
    lit("trimExterior3"),
    lit("trimExterior4"),
    lit("trimExterior5"),
    lit("trimExterior6"),
    lit("trimExterior7"),
    lit("trimExterior8"),
    lit("trimExterior9"),
    lit("roof0"),
    lit("roof1"),
    lit("roof2"),
    lit("roof3"),
    lit("roofTrim0"),
    lit("roofTrim1"),
    lit("roofTrim2"),
    lit("roofTrim3"),
    lit("gutter0"),
    lit("gutter1"),
    lit("gutter2"),
    lit("foundation0"),
    lit("foundation1"),
    lit("foundation2"),
    lit("driveway0"),
    lit("driveway1"),
    lit("driveway2"),
    lit("walks0"),
    lit("walks1"),
    lit("walks2"),
    lit("porchCeiling0"),
    lit("porchCeiling1"),
    lit("porchCeiling2"),
    lit("deck0"),
    lit("deck1"),
    lit("deck2"),
    lit("deck3"),
    lit("glass0"),
    lit("glass1"),
    lit("glass2"),
    lit("glassTrim0"),
    lit("glassTrim1"),
    lit("glassTrim2"),
    lit("doorExterior0"),
    lit("doorExterior1"),
    lit("doorExterior2"),
    lit("doorExterior3"),
    lit("garageExterior0"),
    lit("garageExterior1"),
    lit("garageExterior2"),
    lit("garageExterior3"),
    lit("hardwareExterior0"),
    lit("hardwareExterior1"),
    lit("hardwareExterior2"),
    lit("propDefault0"),
    lit("propDefault1"),
    lit("propDefault2"),
    lit("masonry0"),
    lit("masonry1"),
    lit("masonry2"),
    lit("masonry3"),
    lit("chimney0"),
    lit("chimney1"),
    lit("chimney2"),
    lit("shutter0"),
    lit("shutter1"),
    lit("shutter2"),
    lit("headCasing0"),
    lit("headCasing1"),
    lit("headCasing2"),
    lit("headCasing3"),
    lit("apronCasing0"),
    lit("apronCasing1"),
    lit("apronCasing2"),
    lit("apronCasing3"),
    lit("sideCasing0"),
    lit("sideCasing1"),
    lit("sideCasing2"),
    lit("sideCasing3"),
    lit("earth0"),
    lit("road0"),
    lit("grass0"),
    lit("sidewalk0"),
    lit("curb0"),
    lit("fence0"),
    lit("retainingWall0"),
    lit("water0"),
    lit("masonryTrim0:Base"),
    lit("masonryTrim0:Header"),
    lit("masonryTrim0:Rowlock"),
    lit("masonryTrim1:Base"),
    lit("masonryTrim1:Header"),
    lit("masonryTrim1:Rowlock"),
    lit("masonryTrim2:Base"),
    lit("masonryTrim2:Header"),
    lit("masonryTrim2:Rowlock"),
    lit("masonryTrim3:Base"),
    lit("masonryTrim3:Header"),
    lit("masonryTrim3:Rowlock"),
  ],
  "ExteriorMaterial",
);
export const ExteriorMaterialSettingsSchema = interf(
  {
    type: lit("EXTERIOR_MATERIAL_SETTINGS"),
    paletteSlotsUserDefinedNames: opt(obj(obj(str, "MaterialSlotTable"), "Table")),
    id: pk("SETTINGS"),
    name: opt(str),
    paramName: opt(str),
    palettes: arr(str),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "ExteriorMaterialSettings",
);
export const ExteriorPaletteSchema = interf(
  {
    id: pk("PALETTE"),
    type: lit("EXTERIOR_PALETTE"),
    name: str,
    wallExterior0: opt(id("MaterialSrc")),
    wallExterior1: opt(id("MaterialSrc")),
    wallExterior2: opt(id("MaterialSrc")),
    wallExterior3: opt(id("MaterialSrc")),
    wallExterior4: opt(id("MaterialSrc")),
    wallExterior5: opt(id("MaterialSrc")),
    wallExterior6: opt(id("MaterialSrc")),
    wallExterior7: opt(id("MaterialSrc")),
    wallExterior8: opt(id("MaterialSrc")),
    wallExterior9: opt(id("MaterialSrc")),
    trimExterior0: opt(id("MaterialSrc")),
    trimExterior1: opt(id("MaterialSrc")),
    trimExterior2: opt(id("MaterialSrc")),
    trimExterior3: opt(id("MaterialSrc")),
    trimExterior4: opt(id("MaterialSrc")),
    trimExterior5: opt(id("MaterialSrc")),
    trimExterior6: opt(id("MaterialSrc")),
    trimExterior7: opt(id("MaterialSrc")),
    trimExterior8: opt(id("MaterialSrc")),
    trimExterior9: opt(id("MaterialSrc")),
    roof0: opt(id("MaterialSrc")),
    roof1: opt(id("MaterialSrc")),
    roof2: opt(id("MaterialSrc")),
    roof3: opt(id("MaterialSrc")),
    roofTrim0: opt(id("MaterialSrc")),
    roofTrim1: opt(id("MaterialSrc")),
    roofTrim2: opt(id("MaterialSrc")),
    roofTrim3: opt(id("MaterialSrc")),
    gutter0: opt(id("MaterialSrc")),
    gutter1: opt(id("MaterialSrc")),
    gutter2: opt(id("MaterialSrc")),
    foundation0: opt(id("MaterialSrc")),
    foundation1: opt(id("MaterialSrc")),
    foundation2: opt(id("MaterialSrc")),
    driveway0: opt(id("MaterialSrc")),
    driveway1: opt(id("MaterialSrc")),
    driveway2: opt(id("MaterialSrc")),
    walks0: opt(id("MaterialSrc")),
    walks1: opt(id("MaterialSrc")),
    walks2: opt(id("MaterialSrc")),
    porchCeiling0: opt(id("MaterialSrc")),
    porchCeiling1: opt(id("MaterialSrc")),
    porchCeiling2: opt(id("MaterialSrc")),
    deck0: opt(id("MaterialSrc")),
    deck1: opt(id("MaterialSrc")),
    deck2: opt(id("MaterialSrc")),
    deck3: opt(id("MaterialSrc")),
    glass0: opt(id("MaterialSrc")),
    glass1: opt(id("MaterialSrc")),
    glass2: opt(id("MaterialSrc")),
    glassTrim0: opt(id("MaterialSrc")),
    glassTrim1: opt(id("MaterialSrc")),
    glassTrim2: opt(id("MaterialSrc")),
    doorExterior0: opt(id("MaterialSrc")),
    doorExterior1: opt(id("MaterialSrc")),
    doorExterior2: opt(id("MaterialSrc")),
    doorExterior3: opt(id("MaterialSrc")),
    garageExterior0: opt(id("MaterialSrc")),
    garageExterior1: opt(id("MaterialSrc")),
    garageExterior2: opt(id("MaterialSrc")),
    garageExterior3: opt(id("MaterialSrc")),
    hardwareExterior0: opt(id("MaterialSrc")),
    hardwareExterior1: opt(id("MaterialSrc")),
    hardwareExterior2: opt(id("MaterialSrc")),
    propDefault0: opt(id("MaterialSrc")),
    propDefault1: opt(id("MaterialSrc")),
    propDefault2: opt(id("MaterialSrc")),
    masonry0: opt(id("MaterialSrc")),
    masonry1: opt(id("MaterialSrc")),
    masonry2: opt(id("MaterialSrc")),
    masonry3: opt(id("MaterialSrc")),
    chimney0: opt(id("MaterialSrc")),
    chimney1: opt(id("MaterialSrc")),
    chimney2: opt(id("MaterialSrc")),
    shutter0: opt(id("MaterialSrc")),
    shutter1: opt(id("MaterialSrc")),
    shutter2: opt(id("MaterialSrc")),
    headCasing0: opt(id("MaterialSrc")),
    headCasing1: opt(id("MaterialSrc")),
    headCasing2: opt(id("MaterialSrc")),
    headCasing3: opt(id("MaterialSrc")),
    apronCasing0: opt(id("MaterialSrc")),
    apronCasing1: opt(id("MaterialSrc")),
    apronCasing2: opt(id("MaterialSrc")),
    apronCasing3: opt(id("MaterialSrc")),
    sideCasing0: opt(id("MaterialSrc")),
    sideCasing1: opt(id("MaterialSrc")),
    sideCasing2: opt(id("MaterialSrc")),
    sideCasing3: opt(id("MaterialSrc")),
    earth0: opt(id("MaterialSrc")),
    road0: opt(id("MaterialSrc")),
    grass0: opt(id("MaterialSrc")),
    sidewalk0: opt(id("MaterialSrc")),
    curb0: opt(id("MaterialSrc")),
    fence0: opt(id("MaterialSrc")),
    retainingWall0: opt(id("MaterialSrc")),
    water0: opt(id("MaterialSrc")),
    masonryTrim0: union([undef, num, id("MaterialSrc")]),
    masonryTrim1: union([undef, num, id("MaterialSrc")]),
    masonryTrim2: union([undef, num, id("MaterialSrc")]),
    masonryTrim3: union([undef, num, id("MaterialSrc")]),
    entityType: lit("PALETTE"),
    parentId: opt(str),
    sortIndex: num,
  },
  "ExteriorPalette",
);
export const ExteriorPropSettingsSchema = interf(
  {
    type: lit("EXTERIOR_PROP_SETTINGS"),
    displayBuiltInCatalog: id("OptionalBoolean"),
    propTypes: pkTable("PROP", id("PropAttributesCustom")),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "ExteriorPropSettings",
);
export const ExteriorTrimSettingsSchema = interf(
  {
    type: lit("EXTERIOR_TRIM_SETTINGS"),
    enableOutsideCornerMoulding: bool,
    enableInsideCornerMoulding: bool,
    outsideCornerBoardProfile: opt(id("ProfileId")),
    insideCornerBoardProfile: opt(id("ProfileId")),
    dormerCornerBoardProfile: opt(id("ProfileId")),
    outsideCornerBoardMaterial: opt(id("ExteriorMaterial")),
    insideCornerBoardMaterial: opt(id("ExteriorMaterial")),
    dormerCornerBoardMaterial: opt(id("ExteriorMaterial")),
    outsideCornerBoardHorizontalDatum: opt(id("CornerBoardTrimHorizontalDatum")),
    insideCornerBoardHorizontalDatum: opt(id("CornerBoardTrimHorizontalDatum")),
    dormerCornerBoardHorizontalDatum: opt(id("CornerBoardTrimHorizontalDatum")),
    outsideCornerBoardBottomAlignment: opt(id("CornerBoardTrimAlignment")),
    insideCornerBoardBottomAlignment: opt(id("CornerBoardTrimAlignment")),
    outsideCornerBoardBottomOffset: opt(num),
    insideCornerBoardBottomOffset: opt(num),
    dormerCornerBoardBottomOffset: opt(num),
    outsideCornerBoardTopAlignment: opt(id("CornerBoardTrimAlignment")),
    insideCornerBoardTopAlignment: opt(id("CornerBoardTrimAlignment")),
    outsideCornerBoardTopOffset: opt(num),
    insideCornerBoardTopOffset: opt(num),
    dormerCornerBoardTopOffset: opt(num),
    wallRoofBaseBoard: id("WallRoofBaseBoardMode"),
    wallRoofBaseBoardFilter: id("WallRoofBaseBoardFilter"),
    wallRoofBaseBoardProfile: opt(id("ProfileId")),
    porchHeaderTrimProfile: opt(id("ProfileId")),
    porchHeaderTrimAlignment: opt(id("PorchHeaderTrimAlignment")),
    porchHeaderTrimJustification: opt(id("TrimJustification")),
    porchHeaderTrimOffset: opt(num),
    porchHeaderTrimDepthOffset: opt(num),
    porchHeaderTrimMaterial: opt(id("ExteriorMaterial")),
    viewNotes: opt(
      mapobj(
        enu(
          {
            [`OUTSIDE_CORNER`]: "OUTSIDE_CORNER",
            [`INSIDE_CORNER`]: "INSIDE_CORNER",
            [`DORMER_CORNER`]: "DORMER_CORNER",
            [`WALL_ROOF_BASEBOARD`]: "WALL_ROOF_BASEBOARD",
            [`PORCH_HEADER_TRIM`]: "PORCH_HEADER_TRIM",
          },
          "ExteriorTrimViewNotes",
        ),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "AllExteriorTrimViewNoteTable",
      ),
    ),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "ExteriorTrimSettings",
);
export const ExteriorWallOffsetModeSchema = enu(
  {
    [`OUTSIDE_THICKENING`]: "OUTSIDE_THICKENING",
    [`INSIDE_THICKENING`]: "INSIDE_THICKENING",
    [`INSIDE_THICKENING_ALL`]: "INSIDE_THICKENING_ALL",
  },
  "ExteriorWallOffsetMode",
);
export const ExteriorWindowCasingSettingsSchema = union(
  [
    inters([
      interf({
        type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
        factoryMulled: id("OptionalBoolean"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("StoolCasingSettings"),
      id("HeadCasingNone"),
      id("ExteriorWindowCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
    inters([
      interf({
        type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
        factoryMulled: id("OptionalBoolean"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("StoolCasingSettings"),
      id("HeadCasingTrim"),
      id("ExteriorWindowCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
    inters([
      interf({
        type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
        factoryMulled: id("OptionalBoolean"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("StoolCasingSettings"),
      id("HeadCasingSlices"),
      id("ExteriorWindowCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
    inters([
      interf({
        type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
        factoryMulled: id("OptionalBoolean"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("StoolCasingSettings"),
      id("HeadCasingStone"),
      id("ExteriorWindowCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
    inters([
      interf({
        type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
        factoryMulled: id("OptionalBoolean"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("StoolCasingSettings"),
      id("HeadCasingJackArch"),
      id("ExteriorWindowCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
    inters([
      interf({
        type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
        factoryMulled: id("OptionalBoolean"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("StoolCasingSettings"),
      id("HeadCasingFullArch"),
      id("ExteriorWindowCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
    inters([
      interf({
        type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
        factoryMulled: id("OptionalBoolean"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("StoolCasingSettings"),
      id("HeadCasingArchedSlices"),
      id("ExteriorWindowCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
    inters([
      interf({
        type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
        factoryMulled: id("OptionalBoolean"),
      }),
      id("BaseSettings"),
      id("CasingOrientationSettings"),
      id("CasingHorizontalPlacementSettings"),
      id("CasingLateralPlacementSettings"),
      id("ApronCasingSettings"),
      id("SideCasingSettings"),
      id("StoolCasingSettings"),
      id("HeadCasingEyebrowTrim"),
      id("ExteriorWindowCasingViewNotesSettings"),
      id("CasingFinishSettings"),
    ]),
  ],
  "ExteriorWindowCasingSettings",
);
export const ExteriorWindowCasingViewNotesSettingsSchema = interf(
  {
    viewNotes: opt(
      mapobj(
        enu(
          {
            [`APRON`]: "APRON",
            [`HEAD`]: "HEAD",
            [`SIDE`]: "SIDE",
            [`STOOL`]: "STOOL",
          },
          "ExteriorWindowCasingViewNoteType",
        ),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "ExteriorWindowCasingViewNoteTable",
      ),
    ),
  },
  "ExteriorWindowCasingViewNotesSettings",
);
export const FacadeSchema = interf(
  {
    id: pk("FACADE"),
    cornerBoardBehavior: union([undef, nul, lit("REMOVE"), lit("ADD")]),
    insideCornerBoardBehavior: union([undef, nul, lit("REMOVE"), lit("ADD")]),
    cornerBoardOffsetZ: opt(num),
    wainscotingBehavior: union([undef, nul, lit("REMOVE"), lit("ADD")]),
    legacyRoofBehavior: id("OptionalBoolean"),
    legacyRoofCornerBoardBehavior: id("OptionalBoolean"),
    outsideCornerBoardTopAlignment: opt(id("CornerBoardTrimAlignment")),
    outsideCornerBoardBottomAlignment: opt(id("CornerBoardTrimAlignment")),
    outsideCornerBoardTopOffset: opt(num),
    outsideCornerBoardBottomOffset: opt(num),
    insideCornerBoardTopAlignment: opt(id("CornerBoardTrimAlignment")),
    insideCornerBoardBottomAlignment: opt(id("CornerBoardTrimAlignment")),
    insideCornerBoardTopOffset: opt(num),
    insideCornerBoardBottomOffset: opt(num),
    entityType: lit("FACADE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "Facade",
);
export const FacadeHandleSchema = interf(
  {
    type: lit("FACADE"),
    id: str,
  },
  "FacadeHandle",
);
export const FacadeSpanStratumSchema = interf(
  {
    id: pk("FACADE_SPAN_STRATUM"),
    parentId: opt(union([fk("FACADE", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
    elevationNoteEnabled: id("OptionalBoolean"),
    elevationNote: opt(str),
    material: id("ExteriorMaterial"),
    materialTransformation: opt(partial(id("UVTransformation"))),
    materialThickness: opt(num),
    entityType: lit("FACADE_SPAN_STRATUM"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    lowerDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_VERTICAL"),
        }),
      ],
      "DatumUsage",
    ),
    upperDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_VERTICAL"),
        }),
      ],
      "DatumUsage",
    ),
    startDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_HORIZONTAL"),
        }),
      ],
      "DatumUsage",
    ),
    endDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_HORIZONTAL"),
        }),
      ],
      "DatumUsage",
    ),
  },
  "FacadeSpanStratum",
);
export const FacadeSpanStratumHandleSchema = interf(
  {
    type: lit("FACADE_SPAN_STRATUM"),
    id: str,
  },
  "FacadeSpanStratumHandle",
);
export const FacadeSweepStratumSchema = interf(
  {
    id: pk("FACADE_SWEEP_STRATUM"),
    parentId: opt(union([fk("FACADE", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
    datumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_VERTICAL"),
        }),
      ],
      "DatumUsage",
    ),
    sweep: id("FacadeWallSweep"),
    material: id("ExteriorMaterial"),
    materialTransformation: opt(partial(id("UVTransformation"))),
    materialThickness: opt(num),
    entityType: lit("FACADE_SWEEP_STRATUM"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "FacadeSweepStratum",
);
export const FacadeSweepStratumHandleSchema = interf(
  {
    type: lit("FACADE_SWEEP_STRATUM"),
    id: str,
  },
  "FacadeSweepStratumHandle",
);
export const FacadeWallSweepSchema = interf(
  {
    profileId: id("ProfileId"),
    elevationNoteEnabled: bool,
    elevationNote: str,
    trimmedByOpenings: bool,
    dropIntervalsLessThan: opt(num),
    includeOpeningFramesInGaps: id("OptionalBoolean"),
    startOffset: opt(num),
    endOffset: opt(num),
    surfaceOffset: opt(num),
    rotation: opt(num),
    centerOfRotation: opt(num),
    centerOfRotationNormalized: id("OptionalBoolean"),
    wallStripDomain: id("OptionalBoolean"),
    useLegacyWallGapBounds: id("OptionalBoolean"),
  },
  "FacadeWallSweep",
);
export const FbxAssetSchema = interf(
  {
    srcType: lit("FBX"),
    srcName: str,
    srcSize: num,
    numTriangles: num,
    numVertices: num,
    degenerateUVPolygons: opt(num),
    id: pk("ASSET"),
    srcPath: str,
    entityType: lit("ASSET"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    boundingBox: id("AABB3"),
    thumbnailsPNG: opt(id("PropThumbnails")),
    gltfUrl: opt(str),
    svgUrl: opt(str),
  },
  "FbxAsset",
);
export const FeetCubedSchema = nom("FeetCubed");
export const FeetSquaredSchema = nom("FeetSquared");
export const FillerPanelDescriptorSchema = interf(
  {
    type: lit("FILLER_PANEL"),
    width: num,
    shape: opt(id("CabinetShape")),
    superType: lit("CABINET"),
    id: pk("CASEWORK_DESCRIPTOR"),
    name: str,
    floorMaterialOverride: opt(id("InteriorFloorMaterialOverride")),
    tag: opt(str),
    tagOffset: opt(num),
    catalogItemType: lit("CASEWORK_DESCRIPTOR"),
  },
  "FillerPanelDescriptor",
);
export const FilterEntitySourceIdSchema = union(
  [
    lit("WALL_PLANE"),
    lit("FACE_NODE"),
    lit("FACE_EDGE"),
    lit("VOLUME_NODE"),
    lit("VOLUME_EDGE"),
    lit("PLANAR_TOPOLOGY_FACE"),
  ],
  "FilterEntitySourceId",
);
export const FinishClippingSchema = enu(
  {
    [`NO_CLIPPING`]: "NO_CLIPPING",
    [`CLIP_FINISH`]: "CLIP_FINISH",
  },
  "FinishClipping",
);
export const FixedWidthCurbEntitySchema = interf(
  {
    curbWidth: num,
    curbType: lit("FIXED"),
    id: pk("FOUNDATION_COMPONENT"),
    name: str,
    componentType: lit("CURB"),
    material: opt(id("ExteriorMaterial")),
    entityType: lit("FOUNDATION_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "FixedWidthCurbEntity",
);
export const FlatSchema = interf(
  {
    type: lit("FLAT"),
    ceilingMaterial: opt(
      union([
        lit("glass0"),
        lit("glass1"),
        lit("glass2"),
        lit("propDefault0"),
        lit("propDefault1"),
        lit("propDefault2"),
        lit("floorInterior0"),
        lit("floorInterior1"),
        lit("floorInterior2"),
        lit("floorInterior3"),
        lit("floorInterior4"),
        lit("floorInterior5"),
        lit("wallInterior0"),
        lit("wallInterior1"),
        lit("wallInterior2"),
        lit("trimInterior0"),
        lit("trimInterior1"),
        lit("trimInterior2"),
        lit("ceiling0"),
        lit("ceiling1"),
        lit("ceiling2"),
        lit("doorInterior0"),
        lit("doorInterior1"),
        lit("doorInterior2"),
        lit("doorFixture0"),
        lit("doorFixture1"),
        lit("doorFixture2"),
      ]),
    ),
    ceilingDatum: opt(
      inters(
        [
          id("DatumUsageBase"),
          interf({
            __usage: lit("CEILING"),
          }),
        ],
        "DatumUsage",
      ),
    ),
    labels: fkTable("LABEL", bool),
    disabled: id("FormulaDisabledField"),
  },
  "Flat",
);
export const FloorAssemblyDynamicFinishLayerOperatorSchema = interf(
  {
    finishType: lit("DYNAMIC"),
    finishPerimeter: any,
    isFloorThreshold: id("OptionalBoolean"),
    operationType: id("FloorAssemblyOperationType"),
  },
  "FloorAssemblyDynamicFinishLayerOperator",
);
export const FloorAssemblyExteriorFinishLayerOperatorSchema = interf(
  {
    finishMaterial: id("ExteriorFloorMaterialOverride"),
    finishType: lit("EXTERIOR"),
    finishPerimeter: any,
    isFloorThreshold: id("OptionalBoolean"),
    operationType: id("FloorAssemblyOperationType"),
  },
  "FloorAssemblyExteriorFinishLayerOperator",
);
export const FloorAssemblyFinishLayerOverrideSchema = union(
  [
    inters([
      id("FloorAssemblyInteriorFinishLayerOperator"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("FLOOR_FINISH") },
      ),
      id("FormulaDisabled"),
      interf({
        id: pk("FLOOR_FINISH"),
        parentId: opt(union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
      }),
    ]),
    inters([
      id("FloorAssemblyExteriorFinishLayerOperator"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("FLOOR_FINISH") },
      ),
      id("FormulaDisabled"),
      interf({
        id: pk("FLOOR_FINISH"),
        parentId: opt(union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
      }),
    ]),
    inters([
      id("FloorAssemblyDynamicFinishLayerOperator"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("FLOOR_FINISH") },
      ),
      id("FormulaDisabled"),
      interf({
        id: pk("FLOOR_FINISH"),
        parentId: opt(union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
      }),
    ]),
  ],
  "FloorAssemblyFinishLayerOverride",
);
export const FloorAssemblyInteriorFinishLayerOperatorSchema = interf(
  {
    finishMaterial: id("InteriorFloorMaterialOverride"),
    finishType: lit("INTERIOR"),
    finishPerimeter: any,
    isFloorThreshold: id("OptionalBoolean"),
    operationType: id("FloorAssemblyOperationType"),
  },
  "FloorAssemblyInteriorFinishLayerOperator",
);
export const FloorAssemblyOperationTypeSchema = union([lit("ADD"), lit("REPLACE_ALL")], "FloorAssemblyOperationType");
export const FloorAssemblyOverrideSchema = union(
  [
    inters([
      partial(id("SolidFramingFloorAssembly")),
      ref(
        interf(
          {
            assemblyType: typeParam("T"),
          },
          "FloorAssemblyBase",
          ["T"],
        ),
        { T: lit("SOLID") },
      ),
      id("FloorAssemblyOverrideBase"),
      id("HorizontalFloorAssemblyFreeForm"),
    ]),
    inters([
      partial(id("SolidFramingFloorAssembly")),
      ref(
        interf(
          {
            assemblyType: typeParam("T"),
          },
          "FloorAssemblyBase",
          ["T"],
        ),
        { T: lit("SOLID") },
      ),
      id("FloorAssemblyOverrideBase"),
      id("HorizontalFloorAssemblyRoomDerived"),
    ]),
    inters([
      partial(id("SolidFramingFloorAssembly")),
      ref(
        interf(
          {
            assemblyType: typeParam("T"),
          },
          "FloorAssemblyBase",
          ["T"],
        ),
        { T: lit("SOLID") },
      ),
      id("FloorAssemblyOverrideBase"),
      id("HorizontalFloorAssemblyLegacy"),
    ]),
    inters([
      partial(id("SolidSlabFloorAssembly")),
      ref(
        interf(
          {
            assemblyType: typeParam("T"),
          },
          "FloorAssemblyBase",
          ["T"],
        ),
        { T: lit("SOLID") },
      ),
      id("FloorAssemblyOverrideBase"),
      id("HorizontalFloorAssemblyFreeForm"),
    ]),
    inters([
      partial(id("SolidSlabFloorAssembly")),
      ref(
        interf(
          {
            assemblyType: typeParam("T"),
          },
          "FloorAssemblyBase",
          ["T"],
        ),
        { T: lit("SOLID") },
      ),
      id("FloorAssemblyOverrideBase"),
      id("HorizontalFloorAssemblyRoomDerived"),
    ]),
    inters([
      partial(id("SolidSlabFloorAssembly")),
      ref(
        interf(
          {
            assemblyType: typeParam("T"),
          },
          "FloorAssemblyBase",
          ["T"],
        ),
        { T: lit("SOLID") },
      ),
      id("FloorAssemblyOverrideBase"),
      id("HorizontalFloorAssemblyLegacy"),
    ]),
    inters([
      partial(
        ref(
          interf(
            {
              assemblyType: typeParam("T"),
            },
            "FloorAssemblyBase",
            ["T"],
          ),
          { T: lit("VOID") },
        ),
      ),
      ref(
        interf(
          {
            assemblyType: typeParam("T"),
          },
          "FloorAssemblyBase",
          ["T"],
        ),
        { T: lit("VOID") },
      ),
      id("FloorAssemblyOverrideBase"),
      id("HorizontalFloorAssemblyFreeForm"),
    ]),
    inters([
      partial(
        ref(
          interf(
            {
              assemblyType: typeParam("T"),
            },
            "FloorAssemblyBase",
            ["T"],
          ),
          { T: lit("VOID") },
        ),
      ),
      ref(
        interf(
          {
            assemblyType: typeParam("T"),
          },
          "FloorAssemblyBase",
          ["T"],
        ),
        { T: lit("VOID") },
      ),
      id("FloorAssemblyOverrideBase"),
      id("HorizontalFloorAssemblyRoomDerived"),
    ]),
    inters([
      partial(
        ref(
          interf(
            {
              assemblyType: typeParam("T"),
            },
            "FloorAssemblyBase",
            ["T"],
          ),
          { T: lit("VOID") },
        ),
      ),
      ref(
        interf(
          {
            assemblyType: typeParam("T"),
          },
          "FloorAssemblyBase",
          ["T"],
        ),
        { T: lit("VOID") },
      ),
      id("FloorAssemblyOverrideBase"),
      id("HorizontalFloorAssemblyLegacy"),
    ]),
  ],
  "FloorAssemblyOverride",
);
export const FloorAssemblyOverrideBaseSchema = interf(
  {
    id: pk("FLOOR"),
    parentId: union(
      [fk("ROOM", { hierarchy: ["PARENT"] }), fk("FLOOR_SYSTEM", { hierarchy: ["PARENT"] })],
      "DocEntityParentId",
    ),
    entityType: lit("FLOOR"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    labels: fkTable("LABEL", bool),
  },
  "FloorAssemblyOverrideBase",
);
export const FloorBaySchema = interf(
  {
    id: str,
    parentBayId: opt(str),
    bayEdgeOverrides: opt(obj(id("BayFramingEdgeOverride"), "BayFramingEdgeOverridesTable")),
    interiorPoint: arr(num),
    assemblyId: opt(fk(["FRAME_FLOOR_ASSEMBLY", "SLAB_FLOOR_ASSEMBLY"])),
    spanDirection: opt(id("SpanDirection")),
    framingAngle: opt(num),
    framingStartPt: opt(arr(num)),
  },
  "FloorBay",
);
export const FloorBayEdgeHandleSchema = interf(
  {
    type: lit("EDGE"),
    parent: id("FloorBayHandle"),
    shapeId: lit("outline"),
    edgeId: num,
    perimeterIndex: num,
    stableEdgeId: str,
  },
  "FloorBayEdgeHandle",
);
export const FloorBayHandleSchema = interf(
  {
    type: lit("FLOOR_BAY"),
    id: str,
  },
  "FloorBayHandle",
);
export const FloorEdgeOverrideSchema = interf(
  {
    offset: opt(num),
    foundationEdgeOverride: opt(id("FoundationOverride")),
    framingConfig: opt(id("FramingConfig")),
  },
  "FloorEdgeOverride",
);
export const FloorFinishHandleSchema = interf(
  {
    type: lit("FLOOR_FINISH"),
    id: str,
  },
  "FloorFinishHandle",
);
export const FloorHandleSchema = interf(
  {
    type: lit("FLOOR"),
    id: str,
  },
  "FloorHandle",
);
export const FloorPerimeterOpeningHandleSchema = interf(
  {
    type: lit("FLOOR_PERIMETER_OPENING"),
    floorId: str,
    openingIndex: num,
  },
  "FloorPerimeterOpeningHandle",
);
export const FloorSettingsSchema = interf(
  {
    type: lit("FLOOR_SETTINGS"),
    floorPlateThickness: num,
    floorAssembly: fk(["FRAME_FLOOR_ASSEMBLY", "SLAB_FLOOR_ASSEMBLY"]),
    parentId: opt(
      union(
        [fk("LEVEL", { hierarchy: ["PARENT"] }), fk("SETTINGS_SET", { hierarchy: ["PARENT"] })],
        "DocEntityParentId",
      ),
    ),
    name: opt(str),
    id: opt(pk("SETTINGS")),
  },
  "FloorSettings",
);
export const FloorSplitDataSchema = interf(
  {
    splitLines: obj(id("SplitLine"), "Table"),
    bays: obj(id("FloorBay"), "Table"),
  },
  "FloorSplitData",
);
export const FloorSplitLineEdgeHandleSchema = interf(
  {
    type: lit("EDGE"),
    parent: id("FloorSplitLineHandle"),
    shapeId: lit("splitLine"),
    edgeId: num,
  },
  "FloorSplitLineEdgeHandle",
);
export const FloorSplitLineHandleSchema = interf(
  {
    type: lit("FLOOR_SPLIT_LINE"),
    id: str,
  },
  "FloorSplitLineHandle",
);
export const FloorSystemExternalSchema = interf(
  {
    id: pk("FLOOR_SYSTEM"),
    horizontalAssemblyType: id("HorizontalFloorAssemblyType"),
    structuralType: id("StructuralFloorType"),
    lateralOffset: opt(num),
    topDatum: opt(fk("DATUM")),
    openingFramingConfig: opt(id("FloorSystemOpeningFramingConfig")),
    entityType: lit("FLOOR_SYSTEM"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    labels: fkTable("LABEL", bool),
    assemblyId: opt(fk(["FRAME_FLOOR_ASSEMBLY", "SLAB_FLOOR_ASSEMBLY"])),
    spanDirection: opt(id("SpanDirection")),
    framingAngle: opt(num),
    framingStartPt: opt(arr(num)),
  },
  "FloorSystemExternal",
);
export const FloorSystemHandleSchema = interf(
  {
    type: lit("FLOOR_SYSTEM"),
    id: str,
  },
  "FloorSystemHandle",
);
export const FloorSystemOpeningFramingConfigSchema = interf(
  {
    headerCount: opt(num),
    headerFramingComponentId: opt(fk("FRAMING_COMPONENT")),
    trimmerCount: opt(num),
    trimmerFramingComponentId: opt(fk("FRAMING_COMPONENT")),
    enableTailJoist: id("OptionalBoolean"),
    tailJoistFramingComponentId: opt(fk("FRAMING_COMPONENT")),
  },
  "FloorSystemOpeningFramingConfig",
);
export const FontIdSchema = enu(
  {
    [`Arial`]: "Arial",
    [`ArialNarrow`]: "ArialNarrow",
    [`ArialNarrow_Bold`]: "ArialNarrow_Bold",
    [`Circular`]: "Circular",
    [`Circular_Bold`]: "Circular_Bold",
    [`Circular_Book`]: "Circular_Book",
    [`Circular_Medium`]: "Circular_Medium",
    [`ComingSoon`]: "ComingSoon",
    [`CourierPrime`]: "CourierPrime",
    [`Helvetica`]: "Helvetica",
    [`OpenSans`]: "OpenSans",
    [`Programme`]: "Programme",
    [`PTSansNarrow`]: "PTSansNarrow",
    [`SourceSerif`]: "SourceSerif",
  },
  "FontId",
);
export const FootInchParameterSchema = interf(
  {
    defaultValue: opt(num),
    type: lit("FOOT_INCH"),
  },
  "FootInchParameter",
);
export const ForeignKeyPathOfSchema = fkPathOf(["COMPONENT_INSTANCE"]);
export const FormulaSchema = interf(
  {
    type: lit("FORMULA"),
    formula: id("OptionSetForeignKeyString"),
  },
  "Formula",
);
export const FormulaDisabledSchema = interf(
  {
    disabled: id("FormulaDisabledField"),
  },
  "FormulaDisabled",
);
export const FormulaDisabledFieldSchema = union([undef, lit(false), lit(true), id("Formula")]);
export const FoundationSchema = interf(
  {
    id: pk("FOUNDATION"),
    foundationAssemblyId: opt(id("FoundationAssemblySelection")),
    parentId: union([fk("FOUNDATION_SYSTEM", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    levelId: opt(fk("LEVEL")),
    foundationEdgeOverrides: opt(interf({})),
    perimeter: any,
    edgeIds: opt(arr(str)),
    lateralDatumId: opt(fk("DATUM")),
    topDatumId: opt(fk("DATUM")),
    bottomDatumId: opt(fk("DATUM")),
    brickledgeTopDatumId: opt(fk("DATUM")),
    entityType: lit("FOUNDATION"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    labels: fkTable("LABEL", bool),
  },
  "Foundation",
);
export const FoundationAssemblyEdgeBehaviorSchema = interf(
  {
    edgeBehaviorType: lit("FOUNDATION_ASSEMBLY"),
    foundationAssemblyOverrides: arr(
      ref(
        interf(
          {
            id: str,
            name: str,
            superSystem: typeParam("S"),
            assemblySystem: typeParam("T"),
            assemblyId: opt(fk("FOUNDATION_ASSEMBLY")),
            drawingNumber: opt(num),
            drawingId: opt(fk("DRAWING")),
            lateralDatumId: opt(fk("DATUM")),
            topDatumId: opt(fk("DATUM")),
            bottomDatumId: opt(fk("DATUM")),
            brickledgeTopDatumId: opt(fk("DATUM")),
            disabled: id("FormulaDisabledField"),
          },
          "FoundationSystemAssemblyOverride",
          ["S", "T"],
        ),
        {
          S: union([lit("SLAB_ON_GRADE"), lit("RAISED_SLAB"), lit("CRAWLSPACE"), lit("BASEMENT")]),
          T: union([lit("MONOLITHIC"), lit("STEM_WALL_CMU"), lit("STEM_WALL_CIP"), lit("ISOLATED")]),
        },
      ),
    ),
    id: pk("EDGE_BEHAVIOR"),
    parentId: union(
      [fk("ROOM", { hierarchy: ["PARENT"] }), fk("STAIR_BLOCK", { hierarchy: ["PARENT"] })],
      "DocEntityParentId",
    ),
    edgeId: str,
    entityType: lit("EDGE_BEHAVIOR"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "FoundationAssemblyEdgeBehavior",
);
export const FoundationAssemblyEntitySchema = interf(
  {
    name: str,
    id: pk("FOUNDATION_ASSEMBLY"),
    assemblySystem: id("FoundationSubSystemType"),
    tag: opt(str),
    footingId: opt(fk("FOUNDATION_COMPONENT")),
    stemWallId: opt(fk("FOUNDATION_COMPONENT")),
    curbId: opt(fk("FOUNDATION_COMPONENT")),
    pierId: opt(fk("FOUNDATION_COMPONENT")),
    lateralDatumId: opt(fk("DATUM")),
    topDatumId: opt(fk("DATUM")),
    bottomDatumId: opt(fk("DATUM")),
    brickledgeTopDatumId: opt(fk("DATUM")),
    entityType: lit("FOUNDATION_ASSEMBLY"),
    parentId: opt(str),
    sortIndex: num,
  },
  "FoundationAssemblyEntity",
);
export const FoundationAssemblyEntityDatumsSchema = interf(
  {
    lateralDatumId: opt(fk("DATUM")),
    topDatumId: opt(fk("DATUM")),
    bottomDatumId: opt(fk("DATUM")),
    brickledgeTopDatumId: opt(fk("DATUM")),
  },
  "FoundationAssemblyEntityDatums",
);
export const FoundationAssemblyHandleSchema = interf(
  {
    type: lit("FOUNDATION_ASSEMBLY"),
    id: str,
  },
  "FoundationAssemblyHandle",
);
export const FoundationAssemblySelectionSchema = union([fk("FOUNDATION_ASSEMBLY")], "FoundationAssemblySelection");
export const FoundationComponentEntitySchema = union(
  [
    id("TurndownFootingEntity"),
    id("StripFootingEntity"),
    id("CircularIsolatedFootingEntity"),
    id("RectangularIsolatedFootingEntity"),
    id("CIPStemWallEntity"),
    id("CMUStemWallEntity"),
    id("FixedWidthCurbEntity"),
    ref(
      interf(
        {
          curbType: typeParam("T"),
          id: pk("FOUNDATION_COMPONENT"),
          name: str,
          componentType: typeParam("T"),
          material: opt(id("ExteriorMaterial")),
          entityType: typeParam("T"),
          parentId: opt(str),
          sortIndex: num,
        },
        "CurbBase",
        ["T"],
      ),
      { T: lit("AUTO") },
    ),
    id("CircularCMUPierEntity"),
    id("RectangularCMUPierEntity"),
    id("CustomPierEntity"),
    id("CircularCIPPierEntity"),
    id("RectangularCIPPierEntity"),
  ],
  "FoundationComponentEntity",
);
export const FoundationComponentEntityHandleSchema = interf(
  {
    type: lit("FOUNDATION_COMPONENT"),
    id: str,
  },
  "FoundationComponentEntityHandle",
);
export const FoundationDatumVerticalAnchorSchema = enu(
  {
    [`LEVEL_FLOOR_ELEVATION`]: "LEVEL_FLOOR_ELEVATION",
    [`LEVEL_TOP_OF_WALL`]: "LEVEL_TOP_OF_WALL",
    [`TOP_OF_SLAB`]: "TOP_OF_SLAB",
    [`BOTTOM_OF_SLAB`]: "BOTTOM_OF_SLAB",
    [`BOTTOM_OF_FLOORPLATE`]: "BOTTOM_OF_FLOORPLATE",
    [`FOUNDATION`]: "FOUNDATION",
  },
  "FoundationDatumVerticalAnchor",
);
export const FoundationHandleSchema = interf(
  {
    type: lit("FOUNDATION"),
    id: str,
  },
  "FoundationHandle",
);
export const FoundationOverrideSchema = interf(
  {
    foundationAssemblyId: opt(id("FoundationAssemblySelection")),
    offset: opt(num),
    lateralDatumId: opt(fk("DATUM")),
    topDatumId: opt(fk("DATUM")),
    bottomDatumId: opt(fk("DATUM")),
    brickledgeTopDatumId: opt(fk("DATUM")),
  },
  "FoundationOverride",
);
export const FoundationPatternSchema = union(
  [
    ref(
      interf(
        {
          patternType: typeParam("T"),
        },
        "FoundationPatternBase",
        ["T"],
      ),
      { T: lit("LINEAR") },
    ),
    ref(
      interf(
        {
          patternType: typeParam("T"),
        },
        "FoundationPatternBase",
        ["T"],
      ),
      { T: lit("VOID") },
    ),
    id("RoomIsolatedFoundationPattern"),
    id("StairIsolatedFoundationPattern"),
  ],
  "FoundationPattern",
);
export const FoundationPatternEdgeBehaviorSchema = interf(
  {
    edgeBehaviorType: lit("FOUNDATION_PATTERN"),
    foundationPattern: id("FoundationPattern"),
    id: pk("EDGE_BEHAVIOR"),
    parentId: union(
      [fk("ROOM", { hierarchy: ["PARENT"] }), fk("STAIR_BLOCK", { hierarchy: ["PARENT"] })],
      "DocEntityParentId",
    ),
    edgeId: str,
    entityType: lit("EDGE_BEHAVIOR"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "FoundationPatternEdgeBehavior",
);
export const FoundationSettingsSchema = inters(
  [
    mapobj(
      str,
      union([
        inters([
          interf(
            {
              foundationSuperSystemType: lit("SLAB_ON_GRADE"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("CIP"),
              interiorSlabDepth: num,
              basementSlabType: lit("NONE"),
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
            },
            "SlabOnGradeFoundationSuperSystemSettings",
          ),
          interf(
            {
              foundationSubSystemType: lit("MONOLITHIC"),
              foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              garageCurbWidth: num,
            },
            "MonolithicFoundationSubSystemSettings",
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
        inters([
          interf(
            {
              foundationSuperSystemType: lit("SLAB_ON_GRADE"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("CIP"),
              interiorSlabDepth: num,
              basementSlabType: lit("NONE"),
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
            },
            "SlabOnGradeFoundationSuperSystemSettings",
          ),
          ref(
            interf(
              {
                foundationSubSystemType: typeParam("T"),
                foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              },
              "FoundationSubSystemSettingsBase",
              ["T"],
            ),
            { T: lit("STEM_WALL_CMU") },
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
        inters([
          interf(
            {
              foundationSuperSystemType: lit("SLAB_ON_GRADE"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("CIP"),
              interiorSlabDepth: num,
              basementSlabType: lit("NONE"),
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
            },
            "SlabOnGradeFoundationSuperSystemSettings",
          ),
          ref(
            interf(
              {
                foundationSubSystemType: typeParam("T"),
                foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              },
              "FoundationSubSystemSettingsBase",
              ["T"],
            ),
            { T: lit("STEM_WALL_CIP") },
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
        inters([
          interf(
            {
              foundationSuperSystemType: lit("SLAB_ON_GRADE"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("CIP"),
              interiorSlabDepth: num,
              basementSlabType: lit("NONE"),
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
            },
            "SlabOnGradeFoundationSuperSystemSettings",
          ),
          ref(
            interf(
              {
                foundationSubSystemType: typeParam("T"),
                foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              },
              "FoundationSubSystemSettingsBase",
              ["T"],
            ),
            { T: lit("ISOLATED") },
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
        inters([
          interf(
            {
              foundationSuperSystemType: lit("RAISED_SLAB"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("CIP"),
              interiorSlabDepth: num,
              basementSlabType: lit("NONE"),
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
            },
            "RaisedSlabFoundationSuperSystemSettings",
          ),
          interf(
            {
              foundationSubSystemType: lit("MONOLITHIC"),
              foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              garageCurbWidth: num,
            },
            "MonolithicFoundationSubSystemSettings",
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
        inters([
          interf(
            {
              foundationSuperSystemType: lit("RAISED_SLAB"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("CIP"),
              interiorSlabDepth: num,
              basementSlabType: lit("NONE"),
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
            },
            "RaisedSlabFoundationSuperSystemSettings",
          ),
          ref(
            interf(
              {
                foundationSubSystemType: typeParam("T"),
                foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              },
              "FoundationSubSystemSettingsBase",
              ["T"],
            ),
            { T: lit("STEM_WALL_CMU") },
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
        inters([
          interf(
            {
              foundationSuperSystemType: lit("RAISED_SLAB"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("CIP"),
              interiorSlabDepth: num,
              basementSlabType: lit("NONE"),
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
            },
            "RaisedSlabFoundationSuperSystemSettings",
          ),
          ref(
            interf(
              {
                foundationSubSystemType: typeParam("T"),
                foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              },
              "FoundationSubSystemSettingsBase",
              ["T"],
            ),
            { T: lit("STEM_WALL_CIP") },
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
        inters([
          interf(
            {
              foundationSuperSystemType: lit("RAISED_SLAB"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("CIP"),
              interiorSlabDepth: num,
              basementSlabType: lit("NONE"),
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
            },
            "RaisedSlabFoundationSuperSystemSettings",
          ),
          ref(
            interf(
              {
                foundationSubSystemType: typeParam("T"),
                foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              },
              "FoundationSubSystemSettingsBase",
              ["T"],
            ),
            { T: lit("ISOLATED") },
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
        inters([
          interf(
            {
              foundationSuperSystemType: lit("CRAWLSPACE"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("NONE"),
              basementSlabType: lit("NONE"),
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
            },
            "CrawlspaceFoundationSuperSystemSettings",
          ),
          interf(
            {
              foundationSubSystemType: lit("MONOLITHIC"),
              foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              garageCurbWidth: num,
            },
            "MonolithicFoundationSubSystemSettings",
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
        inters([
          interf(
            {
              foundationSuperSystemType: lit("CRAWLSPACE"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("NONE"),
              basementSlabType: lit("NONE"),
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
            },
            "CrawlspaceFoundationSuperSystemSettings",
          ),
          ref(
            interf(
              {
                foundationSubSystemType: typeParam("T"),
                foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              },
              "FoundationSubSystemSettingsBase",
              ["T"],
            ),
            { T: lit("STEM_WALL_CMU") },
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
        inters([
          interf(
            {
              foundationSuperSystemType: lit("CRAWLSPACE"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("NONE"),
              basementSlabType: lit("NONE"),
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
            },
            "CrawlspaceFoundationSuperSystemSettings",
          ),
          ref(
            interf(
              {
                foundationSubSystemType: typeParam("T"),
                foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              },
              "FoundationSubSystemSettingsBase",
              ["T"],
            ),
            { T: lit("STEM_WALL_CIP") },
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
        inters([
          interf(
            {
              foundationSuperSystemType: lit("CRAWLSPACE"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("NONE"),
              basementSlabType: lit("NONE"),
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
            },
            "CrawlspaceFoundationSuperSystemSettings",
          ),
          ref(
            interf(
              {
                foundationSubSystemType: typeParam("T"),
                foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              },
              "FoundationSubSystemSettingsBase",
              ["T"],
            ),
            { T: lit("ISOLATED") },
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
        inters([
          interf(
            {
              foundationSuperSystemType: lit("BASEMENT"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("NONE"),
              basementSlabType: lit("CIP"),
              basementSlabDepth: num,
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
              basementFoundationDatum: id("LevelDatumAnchor"),
              basementFoundationDatumOffset: num,
            },
            "BasementFoundationSuperSystemSettings",
          ),
          interf(
            {
              foundationSubSystemType: lit("MONOLITHIC"),
              foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              garageCurbWidth: num,
            },
            "MonolithicFoundationSubSystemSettings",
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
        inters([
          interf(
            {
              foundationSuperSystemType: lit("BASEMENT"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("NONE"),
              basementSlabType: lit("CIP"),
              basementSlabDepth: num,
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
              basementFoundationDatum: id("LevelDatumAnchor"),
              basementFoundationDatumOffset: num,
            },
            "BasementFoundationSuperSystemSettings",
          ),
          ref(
            interf(
              {
                foundationSubSystemType: typeParam("T"),
                foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              },
              "FoundationSubSystemSettingsBase",
              ["T"],
            ),
            { T: lit("STEM_WALL_CMU") },
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
        inters([
          interf(
            {
              foundationSuperSystemType: lit("BASEMENT"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("NONE"),
              basementSlabType: lit("CIP"),
              basementSlabDepth: num,
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
              basementFoundationDatum: id("LevelDatumAnchor"),
              basementFoundationDatumOffset: num,
            },
            "BasementFoundationSuperSystemSettings",
          ),
          ref(
            interf(
              {
                foundationSubSystemType: typeParam("T"),
                foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              },
              "FoundationSubSystemSettingsBase",
              ["T"],
            ),
            { T: lit("STEM_WALL_CIP") },
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
        inters([
          interf(
            {
              foundationSuperSystemType: lit("BASEMENT"),
              interiorDatumOffset: num,
              garageDatum: id("LevelDatumAnchor"),
              garageDatumOffset: num,
              porchDatum: id("LevelDatumAnchor"),
              porchDatumOffset: num,
              deckDatum: id("LevelDatumAnchor"),
              deckDatumOffset: num,
              brickLedgeDatum: id("LevelDatumAnchor"),
              brickLedgeDatumOffset: num,
              foundationDatum: id("LevelDatumAnchor"),
              foundationDatumOffset: num,
              foundationPerimeterDatum: id("WallLateralDatumAnchor"),
              foundationPerimeterDatumOffset: num,
              interiorSlabType: lit("NONE"),
              basementSlabType: lit("CIP"),
              basementSlabDepth: num,
              garageSlabType: lit("CIP"),
              garageSlabDepth: num,
              porchSlabType: lit("CIP"),
              porchSlabDepth: num,
              porchSlabOverhang: num,
              basementFoundationDatum: id("LevelDatumAnchor"),
              basementFoundationDatumOffset: num,
            },
            "BasementFoundationSuperSystemSettings",
          ),
          ref(
            interf(
              {
                foundationSubSystemType: typeParam("T"),
                foundationAssembly: fk("FOUNDATION_ASSEMBLY"),
              },
              "FoundationSubSystemSettingsBase",
              ["T"],
            ),
            { T: lit("ISOLATED") },
          ),
          interf(
            {
              foundationConditions: partial(
                mapobj(
                  enu(
                    {
                      [`HOUSE_HOUSE`]: "HOUSE_HOUSE",
                      [`HOUSE_GARAGE`]: "HOUSE_GARAGE",
                      [`HOUSE_PORCH`]: "HOUSE_PORCH",
                      [`HOUSE_BRICKLEDGE_PORCH`]: "HOUSE_BRICKLEDGE_PORCH",
                      [`HOUSE_DECK`]: "HOUSE_DECK",
                      [`HOUSE_BRICKLEDGE_DECK`]: "HOUSE_BRICKLEDGE_DECK",
                      [`HOUSE_EXTERIOR`]: "HOUSE_EXTERIOR",
                      [`HOUSE_BRICKLEDGE_EXTERIOR`]: "HOUSE_BRICKLEDGE_EXTERIOR",
                      [`HOUSE_DISABLED`]: "HOUSE_DISABLED",
                      [`BASEMENT_BASEMENT`]: "BASEMENT_BASEMENT",
                      [`BASEMENT_EXTERIOR`]: "BASEMENT_EXTERIOR",
                      [`BASEMENT_BRICKLEDGE_EXTERIOR`]: "BASEMENT_BRICKLEDGE_EXTERIOR",
                      [`BASEMENT_DISABLED`]: "BASEMENT_DISABLED",
                      [`GARAGE_GARAGE`]: "GARAGE_GARAGE",
                      [`GARAGE_PORCH`]: "GARAGE_PORCH",
                      [`GARAGE_BRICKLEDGE_PORCH`]: "GARAGE_BRICKLEDGE_PORCH",
                      [`GARAGE_DECK`]: "GARAGE_DECK",
                      [`GARAGE_BRICKLEDGE_DECK`]: "GARGE_BRICKLEDGE_DECK",
                      [`GARAGE_EXTERIOR`]: "GARAGE_EXTERIOR",
                      [`GARAGE_DOOR_EXTERIOR`]: "GARAGE_DOOR_EXTERIOR",
                      [`GARAGE_BRICKLEDGE_EXTERIOR`]: "GARAGE_BRICKLEDGE_EXTERIOR",
                      [`GARAGE_DISABLED`]: "GARAGE_DISABLED",
                      [`PORCH_PORCH`]: "PORCH_PORCH",
                      [`PORCH_DECK`]: "PORCH_DECK",
                      [`PORCH_BRICKLEDGE_DECK`]: "PORCH_BRICKLEDGE_DECK",
                      [`PORCH_EXTERIOR`]: "PORCH_EXTERIOR",
                      [`PORCH_BRICKLEDGE_EXTERIOR`]: "PORCH_BRICKLEDGE_EXTERIOR",
                      [`PORCH_DISABLED`]: "PORCH_DISABLED",
                      [`DECK_DECK`]: "DECK_DECK",
                      [`DECK_EXTERIOR`]: "DECK_EXTERIOR",
                      [`DECK_DISABLED`]: "DECK_DISABLED",
                      [`EXTERIOR_EXTERIOR`]: "EXTERIOR_EXTERIOR",
                    },
                    "FoundationCondition",
                  ),
                  partial(
                    interf(
                      {
                        drawingNumber: num,
                        drawingId: union([fk("DRAWING")]),
                        assemblyId: fk("FOUNDATION_ASSEMBLY"),
                        scaleMode: union([
                          undef,
                          lit("UNIFORM"),
                          lit("WIDTH_OVERRIDE"),
                          lit("HEIGHT_OVERRIDE"),
                          lit("SCALE_TO_FIT"),
                        ]),
                        scale: opt(num),
                      },
                      "FoundationConditionData",
                    ),
                  ),
                  false,
                  "FoundationConditionDataTable",
                ),
              ),
            },
            "FoundationConditionSettings",
          ),
          interf({
            id: str,
          }),
        ]),
      ]),
      true,
      "FoundationSettingsTable",
    ),
    interf({
      foundationHash: union([
        lit("SLAB_ON_GRADE.MONOLITHIC"),
        lit("SLAB_ON_GRADE.STEM_WALL_CMU"),
        lit("SLAB_ON_GRADE.STEM_WALL_CIP"),
        lit("SLAB_ON_GRADE.ISOLATED"),
        lit("RAISED_SLAB.MONOLITHIC"),
        lit("RAISED_SLAB.STEM_WALL_CMU"),
        lit("RAISED_SLAB.STEM_WALL_CIP"),
        lit("RAISED_SLAB.ISOLATED"),
        lit("CRAWLSPACE.MONOLITHIC"),
        lit("CRAWLSPACE.STEM_WALL_CMU"),
        lit("CRAWLSPACE.STEM_WALL_CIP"),
        lit("CRAWLSPACE.ISOLATED"),
        lit("BASEMENT.MONOLITHIC"),
        lit("BASEMENT.STEM_WALL_CMU"),
        lit("BASEMENT.STEM_WALL_CIP"),
        lit("BASEMENT.ISOLATED"),
      ]),
    }),
    interf({
      type: lit("FOUNDATION_SETTINGS"),
    }),
  ],
  "FoundationSettings",
);
export const FoundationSubSystemTypeSchema = enu(
  {
    [`MONOLITHIC`]: "MONOLITHIC",
    [`STEM_WALL_CMU`]: "STEM_WALL_CMU",
    [`STEM_WALL_CIP`]: "STEM_WALL_CIP",
    [`ISOLATED`]: "ISOLATED",
  },
  "FoundationSubSystemType",
);
export const FoundationSystemSchema = interf(
  {
    id: pk("FOUNDATION_SYSTEM"),
    entityType: lit("FOUNDATION_SYSTEM"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "FoundationSystem",
);
export const FoundationSystemHandleSchema = interf(
  {
    type: lit("FOUNDATION_SYSTEM"),
    id: str,
  },
  "FoundationSystemHandle",
);
export const FourLightsWithOptionalFanSchema = interf(
  {
    layoutType: lit("FOUR_LIGHTS"),
    controllerPlacementType: opt(arr(id("ControllerSelectionConfig"))),
    loadType: opt(fk("LOAD_DESCRIPTOR")),
    fourLightsLoadSlot: opt(id("LoadTypeSlot")),
    addFan: id("OptionalBoolean"),
    cornerInset: opt(num),
    roomBoundaryType: opt(id("RoomBoundaryType")),
  },
  "FourLightsWithOptionalFan",
);
export const FrameFloorAssemblyEntitySchema = interf(
  {
    id: pk("FRAME_FLOOR_ASSEMBLY"),
    name: str,
    tag: opt(str),
    joistComponentId: fk("FRAMING_COMPONENT"),
    rimComponentId: fk("FRAMING_COMPONENT"),
    subFloorComponentId: fk("SHEATHING_COMPONENT"),
    joistSpacing: num,
    spanDirection: id("SpanDirection"),
    entityType: lit("FRAME_FLOOR_ASSEMBLY"),
    parentId: opt(str),
    sortIndex: num,
  },
  "FrameFloorAssemblyEntity",
);
export const FrameFloorAssemblyHandleSchema = interf(
  {
    type: lit("FRAME_FLOOR_ASSEMBLY"),
    id: str,
  },
  "FrameFloorAssemblyHandle",
);
export const FramingComponentEntitySchema = union(
  [
    id("DimensionalLumberComponent"),
    id("CompositeLumberComponent"),
    id("IJoistComponent"),
    id("TrussComponent"),
    id("CustomFramingComponent"),
  ],
  "FramingComponentEntity",
);
export const FramingComponentHandleSchema = interf(
  {
    type: lit("FRAMING_COMPONENT"),
    id: str,
  },
  "FramingComponentHandle",
);
export const FramingConfigSchema = interf(
  {
    count: num,
    framingComponentId: opt(fk("FRAMING_COMPONENT")),
    disabled: id("OptionalBoolean"),
  },
  "FramingConfig",
);
export const FreeformWallEdgeHandleSchema = interf(
  {
    parent: id("FreeformWallHandle"),
    shapeId: lit("path"),
    type: lit("EDGE"),
    edgeId: num,
  },
  "FreeformWallEdgeHandle",
);
export const FreeformWallEntitySchema = interf(
  {
    id: pk("FREEFORM_WALL"),
    entityType: lit("FREEFORM_WALL"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    levelId: fk("LEVEL"),
    path: any,
    edgeIds: arr(str),
    disabled: id("FormulaDisabledField"),
    labels: fkTable("LABEL", bool),
  },
  "FreeformWallEntity",
);
export const FreeformWallHandleSchema = interf(
  {
    type: lit("FREEFORM_WALL"),
    id: str,
  },
  "FreeformWallHandle",
);
export const FriezeBoardSchema = interf(
  {
    name: str,
    friezeBoard: id("ProfileId"),
    friezeBoardMaterial: opt(id("ExteriorMaterial")),
    verticalOffset: opt(num),
    lateralOffset: opt(num),
  },
  "FriezeBoard",
);
export const FullMaterialSlotSchema = interf(
  {
    paletteMaterialSlot: id("PaletteMaterialSlot"),
    useExteriorPalette: bool,
  },
  "FullMaterialSlot",
);
export const GableLabelSchema = interf(
  {
    face: id("RoofFaces"),
    facadeId: fk("FACADE"),
  },
  "GableLabel",
);
export const GableRoofTypeSchema = enu(
  {
    [`DEFAULT`]: "DEFAULT",
    [`AUTO_SIDE_SHED_ROOF`]: "AUTO_SHED_ROOF",
    [`LEFT_SIDE_SHED_ROOF`]: "LEFT_SIDE_SHED_ROOF",
    [`RIGHT_SIDE_SHED_ROOF`]: "RIGHT_SIDE_SHED_ROOF",
  },
  "GableRoofType",
);
export const GarageHandingDirectionSchema = union([nul, lit("left"), lit("right")], "GarageHandingDirection");
export const GarageLightsSchema = interf(
  {
    layoutType: lit("GARAGE_LIGHTS"),
    addOpener: bool,
    controllerPlacementType: opt(arr(id("ControllerSelectionConfig"))),
    loadType: opt(fk("LOAD_DESCRIPTOR")),
    loadSlot: opt(id("LoadTypeSlot")),
    groupLightsInRoomSet: id("OptionalBoolean"),
  },
  "GarageLights",
);
export const GarageSettingsSchema = interf(
  {
    type: lit("GARAGE_SETTINGS"),
    drivewayDoorOffset: num,
    sideDrivewayMargin: num,
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "GarageSettings",
);
export const GeneratedEntityHandleSchema = interf(
  {
    type: lit("GENERATED_ENTITY"),
    entity: union([
      id("GeneratedPageViewHandle"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANNOTATION") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("WALL") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("RAILING") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ROOM") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("PROP") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("WALL_PLANE") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("CASEWORK") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("CEILING") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("COLUMN") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("SITE") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("STAIR_SYSTEM") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("FLOOR_SYSTEM") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ROOF_SYSTEM") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("FOUNDATION_SYSTEM") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ROOF") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("SKYLIGHT") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ROOF_VOLUME") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("SLAB_FLOOR_ASSEMBLY") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("DOOR") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("WINDOW") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("WAINSCOTING") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("SLAB") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("FOOTING") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_FOUNDATION") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_COLUMN") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_PORCH") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_FOUNDATION_SUPER_SYSTEM") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_FOUNDATION_HORIZONTAL_ASSEMBLY") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_WALL") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_ROOF") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_CEILING") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_ROOF_SOFFIT") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_DOOR_TRIM") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_WINDOW_TRIM") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_INTERIOR_TRIM") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_RAILING") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_WALL_STRUCTURAL_DOMAIN") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_FLOOR_STRUCTURE") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ANALYTIC_EXTERIOR_FINISH_EDGE") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("CORNER_BOARDS") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("DIMENSION") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("DRIVEWAY") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("FOUNDATION_SYSTEM_HORIZONTAL_ASSEMBLY") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("FOUNDATION_SUPER_SYSTEM") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("FOUNDATION_STRIP") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("FOUNDATION_SECTION") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("LUMBER") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("INTERIOR_TRIM") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("PORCH") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ROOF_VOLUME_LEGACY") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("WALL_STRUCTURAL_DOMAIN") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("WALL_SYSTEM") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("WALL_LAYER") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ROOF_FRAMING") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("ROOF_SOFFIT") },
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            id: str,
          },
          "BuildingEntityHandleBase",
          ["T"],
        ),
        { T: lit("FRAMED_FLOOR_ASSEMBLY") },
      ),
      id("BuildingWallPlaneSubdomainHandle"),
      id("BuildingGraphPlanarTopologyHandle"),
    ]),
  },
  "GeneratedEntityHandle",
);
export const GeneratedPageViewHandleSchema = interf(
  {
    type: lit("GENERATED_PAGE_VIEW"),
    pageHash: str,
    planSetTemplateConfigId: opt(str),
  },
  "GeneratedPageViewHandle",
);
export const GenerateSettingsSchema = interf(
  {
    targetOptionSetId: union([fk("OPTION_SET"), undef, nul]),
  },
  "GenerateSettings",
);
export const GenericDrawingTemplateSchema = interf(
  {
    drawingType: undef,
    viewScale: num,
    templateType: lit("DRAWING"),
    id: pk("CONTENT_TEMPLATE"),
    labels: fkTable("LABEL", bool),
    entityType: lit("CONTENT_TEMPLATE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "GenericDrawingTemplate",
);
export const GenericShutterSettingsSchema = interf(
  {
    shutterType: lit("GENERIC"),
    type: lit("WINDOW_SHUTTER_SETTINGS"),
    forceShutters: id("OptionalBoolean"),
    shutterShapeOverride: opt(id("ShutterShapeType")),
    shutterWidthOverride: opt(num),
    shutterHeightOverride: opt(num),
    shutterArchRadiusOverride: opt(num),
    verticalAlignment: opt(id("ShutterVerticalAlignment")),
    verticalOffset: opt(num),
    horizontalOffset: opt(num),
    lateralDatum: opt(id("WallLateralDatumAnchor")),
    lateralOffset: opt(num),
    shutterConfiguration: opt(id("ShutterConfigurationType")),
    orientation: opt(id("ShutterStreetOrientationPreference")),
    shutterMaterial: opt(id("ExteriorMaterial")),
    viewNotes: opt(
      mapobj(
        lit("SHUTTER"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "ShutterViewNoteTable",
      ),
    ),
    isLegacyWidthOverride: id("OptionalBoolean"),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "GenericShutterSettings",
);
export const GenericStairSchema = interf(
  {
    type: lit("GENERIC"),
    hasTreadMaterial: bool,
    stairBottomOffset: num,
    stringerTopExtension: num,
    treadThickness: opt(num),
    nosing: opt(num),
    treadMaterial: opt(id("MaterialSrc")),
    hasRisers: id("OptionalBoolean"),
    riserThickness: opt(num),
    riserMaterial: opt(id("MaterialSrc")),
  },
  "GenericStair",
);
export const GlazingColorSchema = enu(
  {
    [`CLEAR`]: "CLEAR",
    [`FROSTED`]: "FROSTED",
    [`BACK_PAINTED`]: "BACK_PAINTED",
    [`TEXTURED`]: "TEXTURED",
  },
  "GlazingColor",
);
export const GlazingTypeSchema = enu(
  {
    [`STANDARD`]: "STANDARD",
    [`TEMPERED`]: "TEMPERED",
    [`IMPACT`]: "IMPACT",
  },
  "GlazingType",
);
export const GlobalParameterSchema = union(
  [
    inters([
      id("NumberParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
    inters([
      id("BooleanParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
    inters([
      id("DrawingScaleParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
    inters([
      id("FootInchParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
    inters([
      id("TextParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
    inters([
      id("UrlParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
    inters([
      id("LevelParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
    inters([
      id("UnitParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
    inters([
      id("ElevationViewParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
    inters([
      id("SectionViewParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
    inters([
      id("View3DParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
    inters([
      id("DrawingTemplateParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
    inters([
      id("ViewTemplateParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
    inters([
      id("OptionChoiceParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
    inters([
      id("OptionPresetParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
    inters([
      id("DataSequenceParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("GLOBAL_PARAMETER") },
      ),
      interf({
        id: pk("GLOBAL_PARAMETER"),
        parentId: undef,
      }),
    ]),
  ],
  "GlobalParameter",
);
export const GlobalParameterHandleSchema = interf(
  {
    type: lit("GLOBAL_PARAMETER"),
    id: str,
  },
  "GlobalParameterHandle",
);
export const GradeLineSourceSchema = enu(
  {
    [`DEFAULT`]: "DEFAULT",
    [`MODELED`]: "MODELED",
  },
  "GradeLineSource",
);
export const GridWindowMullionSettingsSchema = interf(
  {
    type: lit("WINDOW_MULLION_SETTINGS"),
    verticalThickness: num,
    horizontalThickness: num,
    paneOneXCount: num,
    paneOneYCount: num,
    paneTwoXCount: num,
    paneTwoYCount: num,
    paneOneXLayout: opt(id("WindowGridLayout")),
    paneOneYLayout: opt(id("WindowGridLayout")),
    paneTwoXLayout: opt(id("WindowGridLayout")),
    paneTwoYLayout: opt(id("WindowGridLayout")),
    paneOneRadialLayout: opt(id("WindowGridLayout")),
    paneOneCircularLayout: opt(id("WindowGridLayout")),
    mullionOrientation: opt(id("StreetOrientationMode")),
    mullionType: id("WindowMullionType"),
    isLegacyWindowGrid: id("OptionalBoolean"),
    operationType: opt(id("WindowOperationType")),
    horizontalSplit: id("OptionalBoolean"),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "GridWindowMullionSettings",
);
export const GroupSchema = interf(
  {
    id: pk("GROUP"),
    exclusive: id("OptionalBoolean"),
    isBuiltIn: id("OptionalBoolean"),
    isContentMutableBuiltIn: id("OptionalBoolean"),
    isDeletable: id("OptionalBoolean"),
    entityType: lit("GROUP"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "Group",
);
export const GroupHandleSchema = interf(
  {
    type: lit("GROUP"),
    id: str,
  },
  "GroupHandle",
);
export const HatchDesignMaterialSchema = interf(
  {
    type: lit("DESIGN"),
    sizeU: num,
    sizeV: num,
    rotation: num,
    lines: arr(any),
  },
  "HatchDesignMaterial",
);
export const HatchMaterialSchema = union(
  [id("HatchProceduralMaterial"), id("HatchPatternMaterial"), id("HatchDesignMaterial")],
  "HatchMaterial",
);
export const HatchMaterialIdSchema = enu(
  {
    [`None`]: "None",
    [`Debug_Ground`]: "Debug_Ground",
    [`Bricks`]: "Bricks",
    [`Bricks_Vertical`]: "Bricks_Vertical",
    [`Bricks_Drunken_Soldier`]: "Bricks_Drunken_Soldier",
    [`Shakes`]: "Shakes",
    [`Scales`]: "Scales",
    [`Stone`]: "Stone",
    [`Stucco`]: "Stucco",
    [`Wood_Floor`]: "Wood_Floor",
    [`Vertical_Lines`]: "Vertical_Lines",
    [`Horizontal_Lines`]: "Horizontal_Lines",
    [`Diagonal_Lines`]: "Diagonal_Lines",
    [`Section_Lines`]: "Section_Lines",
    [`Roof_Asphalt`]: "Roof_Asphalt",
    [`RoofTile_Capistrano`]: "RoofTile_Capistrano",
    [`Gravel`]: "Gravel",
    [`Wood_Wall`]: "Wood_Wall",
    [`Vertical_Wood_Wall`]: "Vertical_Wood_Wall",
    [`Metal_Roof`]: "Metal_Roof",
    [`Glass`]: "Glass",
    [`Metal_Screen`]: "Metal_Screen",
    [`Diagonal_CrossHatch`]: "Diagonal_CrossHatch",
    [`Annotation_Diagonal_Down`]: "Annotation_Diagonal_Down",
    [`Annotation_Diagonal_Up`]: "Annotation_Diagonal_Up",
    [`Annotation_CrossHatch`]: "Annotation_CrossHatch",
    [`Annotation_Grid`]: "Annotation_Grid",
  },
  "HatchMaterialId",
);
export const HatchPatternLineSchema = interf(
  {
    angle: num,
    originX: num,
    originY: num,
    deltaX: num,
    deltaY: num,
    incX: num,
    dash: arr(num),
  },
  "HatchPatternLine",
);
export const HatchPatternMaterialSchema = interf(
  {
    type: lit("PATTERN"),
    patternLines: arr(id("HatchPatternLine")),
  },
  "HatchPatternMaterial",
);
export const HatchProceduralMaterialSchema = interf(
  {
    type: lit("PROCEDURAL"),
    materialId: id("HatchMaterialId"),
  },
  "HatchProceduralMaterial",
);
export const HeadCasingArchedSliceSchema = interf(
  {
    height: num,
    depthOffset: num,
    material: opt(id("ExteriorMaterial")),
  },
  "HeadCasingArchedSlice",
);
export const HeadCasingArchedSlicesSchema = interf(
  {
    headCasingType: lit("ARCHED_SLICES"),
    headCasingArchedSlices: arr(id("HeadCasingArchedSlice")),
    headCasingArcHeight: num,
    headCasingInteriorDepth: num,
    headCasingInteriorMaterial: id("ExteriorMaterial"),
  },
  "HeadCasingArchedSlices",
);
export const HeadCasingEyebrowTrimSchema = interf(
  {
    headCasingType: lit("EYEBROW_TRIM"),
    headCasingHeight: num,
    headCasingDepth: num,
    headCasingExtension: num,
    headCasingArcHeight: num,
    material: id("ExteriorMaterial"),
  },
  "HeadCasingEyebrowTrim",
);
export const HeadCasingFullArchSchema = interf(
  {
    headCasingType: lit("FULL_ARCH"),
    material: id("ExteriorMaterial"),
    invertUV: bool,
    headCasingHeight: num,
    headCasingDepth: num,
    headCasingExtension: opt(num),
  },
  "HeadCasingFullArch",
);
export const HeadCasingJackArchSchema = interf(
  {
    headCasingType: lit("JACK_ARCH"),
    headCasingHeight: num,
    headCasingDepth: num,
    headCasingExtension: opt(num),
    material: opt(id("ExteriorMaterial")),
    includeKeystone: bool,
    keystoneHeight: num,
    keystoneDepth: num,
    keystoneSlope: num,
    keystoneBottomWidth: num,
    keystoneMaterial: opt(id("ExteriorMaterial")),
  },
  "HeadCasingJackArch",
);
export const HeadCasingNoneSchema = interf(
  {
    headCasingType: lit("NONE"),
  },
  "HeadCasingNone",
);
export const HeadCasingSliceSchema = interf(
  {
    height: num,
    depthOffset: num,
    widthOffset: num,
    material: opt(id("ExteriorMaterial")),
  },
  "HeadCasingSlice",
);
export const HeadCasingSlicesSchema = interf(
  {
    headCasingType: lit("SLICES"),
    headCasingSlices: arr(id("HeadCasingSlice")),
    includeKeystone: bool,
    keystoneHeight: num,
    keystoneDepth: num,
    keystoneSlope: num,
    keystoneBottomWidth: num,
    keystoneMaterial: opt(id("ExteriorMaterial")),
  },
  "HeadCasingSlices",
);
export const HeadCasingStoneSchema = interf(
  {
    headCasingType: lit("STONE"),
    headCasingHeight: num,
    headCasingDepth: num,
    headCasingExtension: opt(num),
    material: opt(id("ExteriorMaterial")),
  },
  "HeadCasingStone",
);
export const HeadCasingTrimSchema = interf(
  {
    headCasingType: lit("TRIM"),
    removeCorner: id("OptionalBoolean"),
    headCasingHeight: num,
    headCasingDepth: num,
    headCasingExtension: opt(num),
    material: opt(id("ExteriorMaterial")),
  },
  "HeadCasingTrim",
);
export const HeaderAssemblyEntitySchema = interf(
  {
    name: str,
    id: pk("HEADER_ASSEMBLY"),
    headerCount: num,
    headerComponentId: fk("FRAMING_COMPONENT"),
    headerTag: opt(str),
    entityType: lit("HEADER_ASSEMBLY"),
    parentId: opt(str),
    sortIndex: num,
  },
  "HeaderAssemblyEntity",
);
export const HeaderAssemblyHandleSchema = interf(
  {
    type: lit("HEADER_ASSEMBLY"),
    id: str,
  },
  "HeaderAssemblyHandle",
);
export const HeaderFramingRuleSchema = interf(
  {
    maxSpan: nom("WorldInches"),
    headerAssemblyId: fk("HEADER_ASSEMBLY"),
    jackStudCount: num,
  },
  "HeaderFramingRule",
);
export const HeaderFramingSettingsSchema = interf(
  {
    type: lit("HEADER_FRAMING_SETTINGS"),
    rules: arr(id("HeaderFramingRule")),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "HeaderFramingSettings",
);
export const HeightTypeSchema = enu(
  {
    [`OFFSET_FROM_CEILING`]: "OFFSET_FROM_CEILING",
    [`ABOVE_FINISH_FLOOR`]: "ABOVE_FINISH_FLOOR",
  },
  "HeightType",
);
export const HidableEntityHandleSchema = union(
  [
    id("GroupHandle"),
    id("LevelHandle"),
    id("BlockHandle"),
    id("RoomHandle"),
    id("StairSystemHandle"),
    id("StairBlockHandle"),
    id("RoofSystemHandle"),
    id("RoofHandle"),
    id("FoundationSystemHandle"),
    id("FoundationHandle"),
    id("UnderlayHandle"),
    id("ReferenceGeomHandle"),
    id("FloorHandle"),
    id("MeasurementHandle"),
    id("FloorSystemHandle"),
  ],
  "HidableEntityHandle",
);
export const HipFramingMethodSchema = enu(
  {
    [`JACK_RAFTERS`]: "JACK_RAFTERS",
    [`STEP_DOWN_HIP_FRAMING`]: "STEP_DOWN_HIP_FRAMING",
  },
  "HipFramingMethod",
);
export const HomeAttributesSchema = interf(
  {
    garageHandingDirection: id("GarageHandingDirection"),
    currentSheetNumber: opt(str),
    currentSheetNumberPrefix: opt(str),
    currentSheetName: opt(str),
    masterPlanName: opt(str),
    homePlanName: opt(str),
    homePlanSetId: opt(str),
    homePlanStatus: opt(str),
    homePlanPriceBase: opt(num),
    homePlanPriceOptions: opt(num),
    homePlanPriceDiscount: opt(num),
    homePlanLotPremium: opt(num),
    homePlanPriceTotal: opt(num),
    builderName: opt(str),
    builderAddress: opt(str),
    builderCity: opt(str),
    builderState: opt(str),
    builderZip: opt(str),
    communityGeneralNotes: opt(str),
    communityGovernmentCodeAndStandards: opt(str),
    communityBuildingCodeAnalysisDesignCriteria: opt(str),
    communityPlanName: opt(str),
    currentLocationName: opt(str),
    companyName: opt(str),
    regionName: opt(str),
    divisionName: opt(str),
    communityName: opt(str),
    phaseName: opt(str),
    productLineName: opt(str),
    multiunitName: opt(str),
    customerName: opt(str),
    lotNumber: opt(str),
    lotAddress: opt(str),
    blockName: opt(str),
    viewportName: opt(str),
    viewportNumber: opt(str),
    viewportDescription: opt(str),
    viewportScale: opt(str),
    roomReportedName: opt(str),
    roomTagDetails: opt(str),
    roomCeilingHeight: opt(str),
    roomFloorMaterial: opt(str),
    roomDimensions: opt(str),
    roomArea: opt(str),
    roomType: opt(str),
    roomBedroomCount: opt(str),
    roomBathroomCount: opt(str),
    roomGarageCount: opt(str),
  },
  "HomeAttributes",
);
export const HorizontalAlignmentSchema = interf(
  {
    param: num,
    paramNormalized: bool,
    alignment: opt(id("AlignmentEnum")),
  },
  "HorizontalAlignment",
);
export const HorizontalEdgeParamNoExprSchema = interf(
  {
    param: num,
    paramNormalized: bool,
  },
  "HorizontalEdgeParamNoExpr",
);
export const HorizontalFloorAssemblyFreeFormSchema = interf(
  {
    horizontalAssemblyType: lit("FREE_FORM"),
    levelId: opt(fk("LEVEL")),
    lateralOffset: opt(num),
    disableFoundationAssembly: id("OptionalBoolean"),
    foundationAssemblyId: opt(fk("FOUNDATION_ASSEMBLY")),
    foundationAssemblyEntityDatums: opt(id("FoundationAssemblyEntityDatums")),
    topDatum: opt(fk("DATUM")),
    splitData: opt(id("FloorSplitData")),
    floorEdgeOverrides: opt(obj(id("FloorEdgeOverride"), "FloorEdgeOverridesTable")),
    floorOpeningEdgeOverrides: opt(obj(id("FloorEdgeOverride"), "FloorEdgeOverridesTable")),
    perimeters: opt(arr(any)),
    openings: opt(arr(any)),
    edgeIds: opt(arr(str)),
    perimeterEdgeCounts: opt(arr(num)),
    openingEdgeIds: opt(arr(str)),
    openingEdgeCounts: opt(arr(num)),
  },
  "HorizontalFloorAssemblyFreeForm",
);
export const HorizontalFloorAssemblyLegacySchema = interf(
  {
    horizontalAssemblyType: lit("LEGACY"),
    levelId: opt(fk("LEVEL")),
    lateralOffset: opt(num),
    disableFoundationAssembly: id("OptionalBoolean"),
    foundationAssemblyId: opt(fk("FOUNDATION_ASSEMBLY")),
    foundationAssemblyEntityDatums: opt(id("FoundationAssemblyEntityDatums")),
    topDatum: opt(fk("DATUM")),
    splitData: opt(id("FloorSplitData")),
    floorEdgeOverrides: opt(obj(id("FloorEdgeOverride"), "FloorEdgeOverridesTable")),
    floorOpeningEdgeOverrides: opt(obj(id("FloorEdgeOverride"), "FloorEdgeOverridesTable")),
    perimeters: opt(arr(any)),
    openings: opt(arr(any)),
    edgeIds: opt(arr(str)),
    perimeterEdgeCounts: opt(arr(num)),
    openingEdgeIds: opt(arr(str)),
    openingEdgeCounts: opt(arr(num)),
  },
  "HorizontalFloorAssemblyLegacy",
);
export const HorizontalFloorAssemblyRoomDerivedSchema = interf(
  {
    roomIds: opt(arr(fk("ROOM"))),
    allRoomsOnLevel: id("OptionalBoolean"),
    excludedRoomIds: opt(arr(fk("ROOM"))),
    horizontalAssemblyType: lit("ROOM_DERIVED"),
    levelId: opt(fk("LEVEL")),
    lateralOffset: opt(num),
    disableFoundationAssembly: id("OptionalBoolean"),
    foundationAssemblyId: opt(fk("FOUNDATION_ASSEMBLY")),
    foundationAssemblyEntityDatums: opt(id("FoundationAssemblyEntityDatums")),
    topDatum: opt(fk("DATUM")),
    splitData: opt(id("FloorSplitData")),
    floorEdgeOverrides: opt(obj(id("FloorEdgeOverride"), "FloorEdgeOverridesTable")),
    floorOpeningEdgeOverrides: opt(obj(id("FloorEdgeOverride"), "FloorEdgeOverridesTable")),
  },
  "HorizontalFloorAssemblyRoomDerived",
);
export const HorizontalFloorAssemblyTypeSchema = enu(
  {
    [`LEGACY`]: "LEGACY",
    [`FREE_FORM`]: "FREE_FORM",
    [`ROOM_DERIVED`]: "ROOM_DERIVED",
  },
  "HorizontalFloorAssemblyType",
);
export const HorizontalJustificationSchema = enu(
  {
    [`START_TO_END`]: "START_TO_END",
    [`END_TO_START`]: "END_TO_START",
  },
  "HorizontalJustification",
);
export const IJoistComponentSchema = interf(
  {
    iJoistProfileType: id("IJoistProfileType"),
    id: pk("FRAMING_COMPONENT"),
    name: str,
    type: lit("I_JOIST"),
    entityType: lit("FRAMING_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "IJoistComponent",
);
export const IJoistProfileTypeSchema = enu(
  {
    [`IJ_9_5_2X3`]: "IJ_9_5_2X3",
    [`IJ_11_875_2X3`]: "IJ_11_875_2X3",
    [`IJ_11_875_2X4`]: "IJ_11_875_2X4",
    [`IJ_14_2X3`]: "IJ_14_2X3",
    [`IJ_14_2X4`]: "IJ_14_2X4",
    [`IJ_16_2X3`]: "IJ_16_2X3",
    [`IJ_16_2X4`]: "IJ_16_2X4",
    [`IJ_18_2X4`]: "IJ_18_2X4",
    [`IJ_20_2X4`]: "IJ_20_2X4",
  },
  "IJoistProfileType",
);
export const ImageAssetSchema = interf(
  {
    srcType: lit("IMAGE"),
    srcName: str,
    srcSize: num,
    width: nom("SheetPixels"),
    height: nom("SheetPixels"),
    id: pk("ASSET"),
    srcPath: str,
    entityType: lit("ASSET"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "ImageAsset",
);
export const ImageAssetLegacySchema = interf(
  {
    srcType: lit("IMAGE_LEGACY"),
    id: pk("ASSET"),
    srcPath: str,
    entityType: lit("ASSET"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "ImageAssetLegacy",
);
export const ImportArrangementSchema = interf(
  {
    halfEdges: arr(id("ImportHalfEdge")),
    vertices: arr(id("ImportVertex")),
    vIndices: arr(num),
  },
  "ImportArrangement",
);
export const ImportHalfEdgeSchema = interf(
  {
    origin: num,
    twin: num,
    next: num,
    prev: num,
    convex: bool,
  },
  "ImportHalfEdge",
);
export const ImportVertexSchema = interf(
  {
    position: opt(id("Vec3")),
    dir: opt(id("Vec3")),
    halfEdges: arr(num),
  },
  "ImportVertex",
);
export const InchesCubedSchema = nom("InchesCubed");
export const InchesSquaredSchema = nom("InchesSquared");
export const IndeterminateHandleSchema = interf(
  {
    type: lit("INDETERMINATE_ENTITY_TYPE"),
    entityTypes: arr(
      union([
        lit("DATUM"),
        lit("ANNOTATION"),
        lit("CONTENT_TEMPLATE"),
        lit("LABEL"),
        lit("RAILING_POST"),
        lit("RAILING"),
        lit("ASSET"),
        lit("ROOM"),
        lit("ROOM_LAYOUT"),
        lit("ELEVATION_VIEW"),
        lit("SECTION_VIEW"),
        lit("CONTENT_TEMPLATE_INSTANCE"),
        lit("LEVEL"),
        lit("UNDERLAY"),
        lit("PROP"),
        lit("AUTO_DIMENSION"),
        lit("COMPOSITE_LEVEL"),
        lit("VIEW_OVERRIDE"),
        lit("SELECTOR"),
        lit("SHEET"),
        lit("SETTINGS"),
        lit("SETTINGS_SET"),
        lit("BLOCK"),
        lit("PROFILE"),
        lit("VIEW_SELECTOR"),
        lit("CASEWORK"),
        lit("CATALOG_ITEM"),
        lit("CEILING"),
        lit("CIP_COMPONENT"),
        lit("FOUNDATION_COMPONENT"),
        lit("COLUMN"),
        lit("FOUNDATION_ASSEMBLY"),
        lit("COMPONENT"),
        lit("COMPONENT_INSTANCE"),
        lit("PLAN_VIEW"),
        lit("FRAMING_COMPONENT"),
        lit("MASONRY_COMPONENT"),
        lit("SLAB_COMPONENT"),
        lit("OPTION_SET"),
        lit("LOCAL_PARAMETER"),
        lit("GLOBAL_PARAMETER"),
        lit("SYSTEM_PARAMETER"),
        lit("OPTION"),
        lit("CONTENT_REPLICATOR"),
        lit("DATA_SEQUENCE"),
        lit("SITE_SHAPE"),
        lit("SITE"),
        lit("DATA_TABLE"),
        lit("PRESET"),
        lit("EDGE_BEHAVIOR"),
        lit("STAIR_BLOCK"),
        lit("GROUP"),
        lit("STAIR_SYSTEM"),
        lit("REFERENCE_GEOM"),
        lit("MEASUREMENT"),
        lit("FLOOR_SYSTEM"),
        lit("ROOF_SYSTEM"),
        lit("FOUNDATION_SYSTEM"),
        lit("DOC_REF"),
        lit("ROOM_LAYOUT_INSTANCE"),
        lit("STAIR_SETTING"),
        lit("FREEFORM_WALL"),
        lit("ROOF"),
        lit("WALL_PLANE_FILTER"),
        lit("WALL_PLANE_RULE"),
        lit("WALL_PLANE_TRIM"),
        lit("WALL_PLANE_ASSEMBLY"),
        lit("ROOF_SIDE"),
        lit("FOUNDATION"),
        lit("ELEVATION"),
        lit("PALETTE"),
        lit("ENTITY_SETTINGS"),
        lit("OPTION_TEMPLATE"),
        lit("OPTION_SET_OVERRIDES"),
        lit("DRAWING_REF"),
        lit("INSTANCE_OPTION_SET"),
        lit("OPTION_EFFECT"),
        lit("OPTION_RULE"),
        lit("OPTION_LOCK"),
        lit("PROP_INSTANCE"),
        lit("OPENING"),
        lit("FLOOR"),
        lit("FLOOR_FINISH"),
        lit("FLOOR_PERIMETER_OPENING"),
        lit("FACADE"),
        lit("FACADE_SPAN_STRATUM"),
        lit("FACADE_SWEEP_STRATUM"),
        lit("ELECTRICAL_DEVICE"),
        lit("ELECTRICAL_LAYOUT"),
        lit("ELECTRICAL_RULE"),
        lit("ROOF_OPENING"),
        lit("SHAPE"),
        lit("EDGE"),
        lit("VERTEX"),
        lit("SKYLIGHT"),
        lit("DORMER"),
        lit("MODIFIER"),
        lit("EDGE_MODIFIER"),
        lit("VIEW_3D"),
        lit("RAILING_SETTING"),
        lit("EDIT_MODE"),
        lit("GENERATED_ENTITY"),
        lit("PLAN_SET_TEMPLATE"),
        lit("VIEWPORT"),
        lit("VIEW_TEMPLATE"),
        lit("PLAN_SET_TEMPLATE_CONFIG"),
        lit("VIEW_TEMPLATE_OVERRIDE"),
        lit("ROOF_VOLUME"),
        lit("EFFECT"),
        lit("RULE_BASED_SELECTOR"),
        lit("RULE_BASED_SELECTOR_INSTANCE"),
        lit("INDETERMINATE_ENTITY_TYPE"),
        lit("HEADER_ASSEMBLY"),
        lit("FRAME_FLOOR_ASSEMBLY"),
        lit("SLAB_FLOOR_ASSEMBLY"),
        lit("SHEATHING_COMPONENT"),
        lit("FLOOR_BAY"),
        lit("FLOOR_SPLIT_LINE"),
        lit("REPORTABLE_UNIT_DESIGNATION"),
      ]),
    ),
    id: str,
  },
  "IndeterminateHandle",
);
export const InlineImageAssetSchema = interf(
  {
    detailType: lit("INLINE_IMAGE"),
    width: num,
    height: num,
    url: opt(str),
    assetAspectRatio: num,
    addToFrontElevation: id("OptionalBoolean"),
    id: pk("ANNOTATION"),
    handle: union([undef, id("RoomLayoutInstanceHandle"), id("AnnotationHandle"), id("ContentTemplateInstanceHandle")]),
    handleAuxiliary: union([undef, id("AnnotationHandle"), id("ContentTemplateInstanceHandle")]),
    name: str,
    positioningMethod: id("PositioningMethod"),
    edgeId: opt(str),
    parentId: opt(
      union(
        [
          fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }),
          fk("ROOM", { hierarchy: ["PARENT"] }),
          fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] }),
          fk("ELEVATION_VIEW", { hierarchy: ["PARENT"] }),
          fk("SECTION_VIEW", { hierarchy: ["PARENT"] }),
          fk("CONTENT_TEMPLATE_INSTANCE", { hierarchy: ["PARENT"] }),
          fk("LEVEL", { hierarchy: ["PARENT"] }),
        ],
        "DocEntityParentId",
      ),
    ),
    entityType: lit("ANNOTATION"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    entityInstanceType: opt(id("EntityInstanceType")),
    labels: fkTable("LABEL", bool),
    type: lit("DETAIL"),
    x: num,
    y: num,
    rotation: num,
  },
  "InlineImageAsset",
);
export const InlineImageUnderlaySchema = interf(
  {
    underlayType: lit("INLINE_IMAGE"),
    width: num,
    height: num,
    srcWidth: opt(num),
    srcHeight: opt(num),
    url: str,
    id: pk("UNDERLAY"),
    x: num,
    y: num,
    opacity: opt(nom("Percent")),
    tint: opt(str),
    underlayViewType: union([lit("ELEVATION_VIEW"), lit("PLAN_VIEW")]),
    viewId: opt(fk("ELEVATION_VIEW")),
    levelId: opt(fk("LEVEL")),
    entityType: lit("UNDERLAY"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "InlineImageUnderlay",
);
export const InPlaceElectricalLayoutSchema = interf(
  {
    id: pk("ELECTRICAL_LAYOUT"),
    layout: id("ElectricalLayout"),
    entityType: lit("ELECTRICAL_LAYOUT"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "InPlaceElectricalLayout",
);
export const InstanceOptionSetSchema = interf(
  {
    id: pk("INSTANCE_OPTION_SET"),
    archetypeId: union([fk("OPTION_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    componentInstanceId: fk("COMPONENT_INSTANCE"),
    disabled: id("OptionalBoolean"),
    entityType: lit("INSTANCE_OPTION_SET"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "InstanceOptionSet",
);
export const InstanceOptionSetHandleSchema = interf(
  {
    type: lit("INSTANCE_OPTION_SET"),
    id: str,
  },
  "InstanceOptionSetHandle",
);
export const InteriorBaseBoardTrimSettingsSchema = interf(
  {
    baseBoardType: opt(id("ProfileId")),
    baseBoardMaterial: union([
      lit("glass0"),
      lit("glass1"),
      lit("glass2"),
      lit("propDefault0"),
      lit("propDefault1"),
      lit("propDefault2"),
      lit("floorInterior0"),
      lit("floorInterior1"),
      lit("floorInterior2"),
      lit("floorInterior3"),
      lit("floorInterior4"),
      lit("floorInterior5"),
      lit("wallInterior0"),
      lit("wallInterior1"),
      lit("wallInterior2"),
      lit("trimInterior0"),
      lit("trimInterior1"),
      lit("trimInterior2"),
      lit("ceiling0"),
      lit("ceiling1"),
      lit("ceiling2"),
      lit("doorInterior0"),
      lit("doorInterior1"),
      lit("doorInterior2"),
      lit("doorFixture0"),
      lit("doorFixture1"),
      lit("doorFixture2"),
    ]),
  },
  "InteriorBaseBoardTrimSettings",
);
export const InteriorCrownMoldingTrimSettingsSchema = interf(
  {
    crownMoldingType: opt(id("ProfileId")),
    crownMoldingMaterial: union([
      lit("glass0"),
      lit("glass1"),
      lit("glass2"),
      lit("propDefault0"),
      lit("propDefault1"),
      lit("propDefault2"),
      lit("floorInterior0"),
      lit("floorInterior1"),
      lit("floorInterior2"),
      lit("floorInterior3"),
      lit("floorInterior4"),
      lit("floorInterior5"),
      lit("wallInterior0"),
      lit("wallInterior1"),
      lit("wallInterior2"),
      lit("trimInterior0"),
      lit("trimInterior1"),
      lit("trimInterior2"),
      lit("ceiling0"),
      lit("ceiling1"),
      lit("ceiling2"),
      lit("doorInterior0"),
      lit("doorInterior1"),
      lit("doorInterior2"),
      lit("doorFixture0"),
      lit("doorFixture1"),
      lit("doorFixture2"),
    ]),
  },
  "InteriorCrownMoldingTrimSettings",
);
export const InteriorDimensionTypeSchema = enu(
  {
    [`BY_ROOM_GROUP`]: "BY_ROOM_GROUP",
    [`BY_STRING`]: "BY_STRING",
  },
  "InteriorDimensionType",
);
export const InteriorDoorCasingSettingsSchema = inters(
  [
    interf({
      type: lit("INTERIOR_DOOR_CASING_SETTINGS"),
    }),
    id("BaseSettings"),
    id("InteriorDoorSideTrimSettings"),
    id("InteriorDoorHeadTrimSettings"),
  ],
  "InteriorDoorCasingSettings",
);
export const InteriorDoorHeadTrimSettingsSchema = interf(
  {
    headTrimType: opt(id("ProfileId")),
    headMaterial: union([
      lit("glass0"),
      lit("glass1"),
      lit("glass2"),
      lit("propDefault0"),
      lit("propDefault1"),
      lit("propDefault2"),
      lit("floorInterior0"),
      lit("floorInterior1"),
      lit("floorInterior2"),
      lit("floorInterior3"),
      lit("floorInterior4"),
      lit("floorInterior5"),
      lit("wallInterior0"),
      lit("wallInterior1"),
      lit("wallInterior2"),
      lit("trimInterior0"),
      lit("trimInterior1"),
      lit("trimInterior2"),
      lit("ceiling0"),
      lit("ceiling1"),
      lit("ceiling2"),
      lit("doorInterior0"),
      lit("doorInterior1"),
      lit("doorInterior2"),
      lit("doorFixture0"),
      lit("doorFixture1"),
      lit("doorFixture2"),
    ]),
    headExtension: num,
  },
  "InteriorDoorHeadTrimSettings",
);
export const InteriorDoorSideTrimSettingsSchema = interf(
  {
    sideTrimType: opt(id("ProfileId")),
    sideMaterial: union([
      lit("glass0"),
      lit("glass1"),
      lit("glass2"),
      lit("propDefault0"),
      lit("propDefault1"),
      lit("propDefault2"),
      lit("floorInterior0"),
      lit("floorInterior1"),
      lit("floorInterior2"),
      lit("floorInterior3"),
      lit("floorInterior4"),
      lit("floorInterior5"),
      lit("wallInterior0"),
      lit("wallInterior1"),
      lit("wallInterior2"),
      lit("trimInterior0"),
      lit("trimInterior1"),
      lit("trimInterior2"),
      lit("ceiling0"),
      lit("ceiling1"),
      lit("ceiling2"),
      lit("doorInterior0"),
      lit("doorInterior1"),
      lit("doorInterior2"),
      lit("doorFixture0"),
      lit("doorFixture1"),
      lit("doorFixture2"),
    ]),
  },
  "InteriorDoorSideTrimSettings",
);
export const InteriorFloorMaterialOverrideSchema = union(
  [
    lit("floorInterior0"),
    lit("floorInterior1"),
    lit("floorInterior2"),
    lit("floorInterior3"),
    lit("floorInterior4"),
    lit("floorInterior5"),
    lit("NONE"),
  ],
  "InteriorFloorMaterialOverride",
);
export const InteriorMaterialSettingsSchema = interf(
  {
    type: lit("INTERIOR_MATERIAL_SETTINGS"),
    paletteSlotsUserDefinedNames: opt(obj(obj(obj(str, "MaterialSlotTable"), "Table"), "TableOfMaterialSlotTables")),
    id: pk("SETTINGS"),
    name: opt(str),
    paramName: opt(str),
    palettes: arr(str),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "InteriorMaterialSettings",
);
export const InteriorPaletteSchema = interf(
  {
    id: pk("PALETTE"),
    type: lit("INTERIOR_PALETTE"),
    name: str,
    defaultRoomMaterials: id("RoomMaterials"),
    roomMaterials: arr(id("RoomSetMaterials")),
    thumbnailUrl: opt(str),
    roomTypeLookupCache: opt(interf({})),
    isRoomTypeLookupCacheDirty: id("OptionalBoolean"),
    entityType: lit("PALETTE"),
    parentId: opt(str),
    sortIndex: num,
  },
  "InteriorPalette",
);
export const InteriorPropSettingsSchema = interf(
  {
    type: lit("INTERIOR_PROP_SETTINGS"),
    displayBuiltInCatalog: id("OptionalBoolean"),
    propTypes: pkTable("PROP", id("PropAttributesCustom")),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "InteriorPropSettings",
);
export const InteriorTrimSettingsSchema = inters(
  [
    interf({
      type: lit("INTERIOR_TRIM_SETTINGS"),
    }),
    id("BaseSettings"),
    id("InteriorBaseBoardTrimSettings"),
    id("InteriorCrownMoldingTrimSettings"),
  ],
  "InteriorTrimSettings",
);
export const InteriorWindowCasingSettingsSchema = inters(
  [
    interf({
      type: lit("INTERIOR_WINDOW_CASING_SETTINGS"),
    }),
    id("BaseSettings"),
    id("InteriorWindowGeneralCasingSettings"),
  ],
  "InteriorWindowCasingSettings",
);
export const InteriorWindowGeneralCasingSettingsSchema = interf(
  {
    includeCasing: id("OptionalBoolean"),
  },
  "InteriorWindowGeneralCasingSettings",
);
export const IntersectingOptionSetSchema = interf(
  {
    optionSetType: lit("INTERSECTING"),
    scope: obj(id("IntersectionScope"), "Table"),
    formatting: obj(id("CodeFormatting"), "Table"),
    effect: id("IntersectionEffect"),
    conditions: fkTable("OPTION", id("IntersectionConditions")),
    id: pk("OPTION_SET"),
    defaultValue: str,
    options: pkTable("OPTION", id("DocOption"), true),
    salesCategory: str,
    builderOptionSetCode: union([undef, nul, str]),
    category: opt(str),
    description: opt(str),
    tags: opt(arr(str)),
    disabled: id("OptionalBoolean"),
    globalSortOrder: opt(num),
    showroomIntro: id("OptionalBoolean"),
    displayType: union([undef, lit("CARDS"), lit("TABLE")]),
    readonly: id("OptionalBoolean"),
    entityType: lit("OPTION_SET"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    labels: fkTable("LABEL", bool),
  },
  "IntersectingOptionSet",
);
export const IntersectionConditionsSchema = interf(
  {
    parentId: union([fk("OPTION", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    choices: fkTable("OPTION_SET", arr(fk("OPTION"))),
  },
  "IntersectionConditions",
);
export const IntersectionEffectSchema = interf(
  {
    type: union([lit("MODIFY"), lit("GENERATE")]),
    modifySettings: opt(id("ModifySettings")),
    generateSettings: opt(id("GenerateSettings")),
  },
  "IntersectionEffect",
);
export const IntersectionScopeSchema = interf(
  {
    optionSetId: fk("OPTION_SET"),
    optionIds: arr(fk("OPTION")),
    cartesianProductAtSet: id("OptionalBoolean"),
  },
  "IntersectionScope",
);
export const KeyMeasuresSettingsSchema = interf(
  {
    type: lit("KEY_MEASURES_SETTINGS"),
    includeCasework: bool,
  },
  "KeyMeasuresSettings",
);
export const LabelSchema = interf(
  {
    id: pk("LABEL"),
    entityType: lit("LABEL"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "Label",
);
export const LabelEdgeBehaviorSchema = interf(
  {
    edgeBehaviorType: lit("LABEL"),
    facadeId: fk("FACADE"),
    id: pk("EDGE_BEHAVIOR"),
    parentId: union(
      [fk("ROOM", { hierarchy: ["PARENT"] }), fk("STAIR_BLOCK", { hierarchy: ["PARENT"] })],
      "DocEntityParentId",
    ),
    edgeId: str,
    entityType: lit("EDGE_BEHAVIOR"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "LabelEdgeBehavior",
);
export const LabelHandleSchema = interf(
  {
    type: lit("LABEL"),
    id: str,
  },
  "LabelHandle",
);
export const LandscapeSiteShapeSchema = interf(
  {
    type: lit("LANDSCAPE"),
    landscapeType: id("LandscapeType"),
    id: pk("SITE_SHAPE"),
    parentId: union([fk("SITE", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    geom: any,
    entityType: lit("SITE_SHAPE"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "LandscapeSiteShape",
);
export const LandscapeTypeSchema = enu(
  {
    [`BUSHES`]: "BUSHES",
    [`TREES`]: "TREES",
    [`SINGLE_TREE`]: "SINGLE_TREE",
  },
  "LandscapeType",
);
export const LateralAlignmentSchema = interf(
  {
    alignment: opt(id("AlignmentEnum")),
    offset: num,
  },
  "LateralAlignment",
);
export const LateralDatumJustificationSchema = enu(
  {
    [`INSIDE_TO_OUTSIDE`]: "INSIDE_TO_OUTSIDE",
    [`OUTSIDE_TO_INSIDE`]: "OUTSIDE_TO_INSIDE",
  },
  "LateralDatumJustification",
);
export const LegacyFoundationLateralDatumEntitySchema = interf(
  {
    datumType: lit("FOUNDATION"),
    anchor: id("WallLateralDatumAnchor"),
    direction: lit("LATERAL"),
    offsetType: lit("RELATIVE"),
    justification: id("LateralDatumJustification"),
    id: pk("DATUM"),
    offsetNormalized: id("OptionalBoolean"),
    offset: opt(num),
    entityType: lit("DATUM"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    srcSettingsId: opt(str),
    srcSettingsSetId: opt(str),
    srcSettingsName: opt(str),
    srcSettingsSetName: opt(str),
  },
  "LegacyFoundationLateralDatumEntity",
);
export const LegacyFoundationVerticalDatumEntitySchema = interf(
  {
    datumType: lit("FOUNDATION"),
    anchor: id("FoundationDatumVerticalAnchor"),
    direction: lit("VERTICAL"),
    offsetType: lit("RELATIVE"),
    justification: id("VerticalJustification"),
    id: pk("DATUM"),
    offsetNormalized: id("OptionalBoolean"),
    offset: opt(num),
    entityType: lit("DATUM"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    srcSettingsId: opt(str),
    srcSettingsSetId: opt(str),
    srcSettingsName: opt(str),
    srcSettingsSetName: opt(str),
  },
  "LegacyFoundationVerticalDatumEntity",
);
export const LegacyLevelDatumEntitySchema = interf(
  {
    datumType: lit("LEVEL"),
    anchor: id("LevelDatumAnchor"),
    levelId: opt(fk("LEVEL")),
    direction: lit("VERTICAL"),
    offsetType: lit("RELATIVE"),
    justification: id("VerticalJustification"),
    id: pk("DATUM"),
    offsetNormalized: id("OptionalBoolean"),
    offset: opt(num),
    entityType: lit("DATUM"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "LegacyLevelDatumEntity",
);
export const LegacyOffsetFromPropBackSchema = interf(
  {
    type: lit("OFFSET_FROM_PROP_BACK"),
    adjustmentNormal: num,
    adjustmentTangent: num,
  },
  "LegacyOffsetFromPropBack",
);
export const LegacyWallHorizontalDatumEntitySchema = interf(
  {
    datumType: lit("WALL"),
    anchor: id("WallHorizontalDatum"),
    direction: lit("HORIZONTAL"),
    offsetType: lit("RELATIVE"),
    justification: id("HorizontalJustification"),
    id: pk("DATUM"),
    offsetNormalized: id("OptionalBoolean"),
    offset: opt(num),
    entityType: lit("DATUM"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    srcSettingsId: opt(str),
    srcSettingsSetId: opt(str),
    srcSettingsName: opt(str),
    srcSettingsSetName: opt(str),
  },
  "LegacyWallHorizontalDatumEntity",
);
export const LegacyWallPlaneHorizontalDatumEntitySchema = interf(
  {
    datumType: lit("WALL_PLANE"),
    planeHash: str,
    datumScope: opt(id("DatumScope")),
    direction: lit("HORIZONTAL"),
    offsetType: lit("ABSOLUTE"),
    justification: id("HorizontalJustification"),
    id: pk("DATUM"),
    offsetNormalized: id("OptionalBoolean"),
    offset: opt(num),
    entityType: lit("DATUM"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "LegacyWallPlaneHorizontalDatumEntity",
);
export const LegacyWallVerticalDatumEntitySchema = interf(
  {
    datumType: lit("WALL"),
    anchor: id("WallVerticalDatumAnchor"),
    direction: lit("VERTICAL"),
    offsetType: lit("RELATIVE"),
    justification: id("VerticalJustification"),
    id: pk("DATUM"),
    offsetNormalized: id("OptionalBoolean"),
    offset: opt(num),
    entityType: lit("DATUM"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    srcSettingsId: opt(str),
    srcSettingsSetId: opt(str),
    srcSettingsName: opt(str),
    srcSettingsSetName: opt(str),
  },
  "LegacyWallVerticalDatumEntity",
);
export const LevelDatumAnchorSchema = enu(
  {
    [`LEVEL_BOTTOM_OF_FLOOR_PLATE`]: "LEVEL_BOTTOM_OF_FLOOR_PLATE",
    [`LEVEL_TOP_OF_WALL`]: "LEVEL_TOP_OF_WALL",
    [`LEVEL_WINDOW_HEAD_HEIGHT`]: "LEVEL_WINDOW_HEAD_HEIGHT",
    [`LEVEL_FLOOR_ELEVATION`]: "LEVEL_FLOOR_ELEVATION",
    [`LEVEL_GRADE`]: "LEVEL_GRADE",
  },
  "LevelDatumAnchor",
);
export const LevelDefSchema = interf(
  {
    id: pk("LEVEL"),
    topOfWall: union([
      num,
      ref(
        interf(
          {
            type: lit("MATCH_EXPR"),
            cases: arr(
              ref(
                interf(
                  {
                    condition: id("Formula"),
                    value: typeParam("T"),
                  },
                  "MatchCase",
                  ["T"],
                ),
                { T: typeParam("T") },
              ),
            ),
            defaultValue: typeParam("T"),
          },
          "MatchExpression",
          ["T"],
        ),
        { T: num },
      ),
    ]),
    enableAutoGeneratedFoundation: bool,
    enableAutoGeneratedFloorSystem: bool,
    placement: id("LevelPlacement"),
    sortIndex: num,
    name: str,
    entityType: lit("LEVEL"),
    parentId: opt(str),
    disabled: id("FormulaDisabledField"),
  },
  "LevelDef",
);
export const LevelHandleSchema = interf(
  {
    type: lit("LEVEL"),
    id: str,
  },
  "LevelHandle",
);
export const LevelInchesSchema = nom("LevelInches");
export const LevelParameterSchema = interf(
  {
    defaultValue: opt(union([fk("LEVEL"), fk("COMPOSITE_LEVEL")])),
    type: lit("LEVEL"),
  },
  "LevelParameter",
);
export const LevelPlacementSchema = union([id("DatumLevelPlacement"), id("StackedLevelPlacement")], "LevelPlacement");
export const LevelPlanViewSchema = interf(
  {
    id: pk("PLAN_VIEW"),
    levelIds: arr(id("PlanViewLevelMember")),
    referenceType: id("BuiltinPlanViewType"),
    planViewType: undef,
    hostLevelId: opt(fk("LEVEL")),
    underlayLevelId: opt(fk("LEVEL")),
    referenceWallLevelIds: opt(arr(fk("LEVEL"))),
    entityType: lit("PLAN_VIEW"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    viewScale: opt(num),
    viewFilter: opt(partial(id("ViewFilter"))),
    dimensionPrecision: opt(id("DimensionPrecision")),
  },
  "LevelPlanView",
);
export const LevelRoomEdgeSchema = interf(
  {
    levelId: fk("LEVEL"),
    roomId: fk("ROOM"),
    edgeId: str,
    entityLocation: id("OptionalBoolean"),
  },
  "LevelRoomEdge",
);
export const LevelValueSchema = interf(
  {
    type: lit("LEVEL"),
    value: union([fk("LEVEL"), fk("COMPOSITE_LEVEL")]),
  },
  "LevelValue",
);
export const LineAnchorSchema = union([lit("START"), lit("END"), lit("CENTER")], "LineAnchor");
export const LinearArraySchema = interf(
  {
    layoutType: lit("LINEAR_ARRAY"),
    controllerPlacementType: opt(arr(id("ControllerSelectionConfig"))),
    endControllerPlacementType: opt(arr(id("ControllerSelectionConfig"))),
    loadType: fk("LOAD_DESCRIPTOR"),
    quantity: opt(num),
    spacingType: opt(id("SpacingType")),
    spacing: opt(num),
    shift: opt(num),
    minDistToWall: opt(num),
    trimToRoom: bool,
    roomBoundaryType: opt(id("RoomBoundaryType")),
  },
  "LinearArray",
);
export const LinearDimensionSchema = interf(
  {
    id: pk("ANNOTATION"),
    handle: union([undef, id("RoomLayoutInstanceHandle"), id("AnnotationHandle"), id("ContentTemplateInstanceHandle")]),
    handleAuxiliary: union([undef, id("AnnotationHandle"), id("ContentTemplateInstanceHandle")]),
    name: str,
    positioningMethod: id("PositioningMethod"),
    edgeId: opt(str),
    parentId: opt(
      union(
        [
          fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }),
          fk("ROOM", { hierarchy: ["PARENT"] }),
          fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] }),
          fk("ELEVATION_VIEW", { hierarchy: ["PARENT"] }),
          fk("SECTION_VIEW", { hierarchy: ["PARENT"] }),
          fk("CONTENT_TEMPLATE_INSTANCE", { hierarchy: ["PARENT"] }),
          fk("LEVEL", { hierarchy: ["PARENT"] }),
        ],
        "DocEntityParentId",
      ),
    ),
    entityType: lit("ANNOTATION"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    entityInstanceType: opt(id("EntityInstanceType")),
    labels: fkTable("LABEL", bool),
    type: lit("LINEAR_DIMENSION"),
    orientation: union([lit("HORIZONTAL"), lit("VERTICAL"), lit("ALIGNED")]),
    lineStartX: num,
    lineStartY: num,
    lineEndX: num,
    lineEndY: num,
    startX: num,
    startY: num,
    endX: num,
    endY: num,
    entityHostedStart: opt(id("EntityHostedAnnotationPoint")),
    entityHostedEnd: opt(id("EntityHostedAnnotationPoint")),
    witnessGap: opt(num),
    extension: opt(num),
    tickLength: opt(num),
    fontSize: opt(nom("SheetInches")),
    dimensionValue: opt(str),
    startExt: opt(num),
    endExt: opt(num),
    prefix: opt(str),
    suffix: opt(str),
    top: opt(str),
    bottom: opt(str),
    showEntityHostedLock: id("OptionalBoolean"),
  },
  "LinearDimension",
);
export const LineStyleSchema = interf(
  {
    linewidth: opt(nom("SheetPoints")),
    strokeColor: opt(str),
    strokeOpacity: opt(nom("Percent")),
    dash: id("OptionalBoolean"),
    dashMask: id("OptionalBoolean"),
    dashLength: opt(arr(nom("SheetPoints"))),
    fill: id("OptionalBoolean"),
    fillColor: opt(str),
    fillOpacity: opt(nom("Percent")),
    hatch: id("OptionalBoolean"),
    hatchMaterial: opt(id("HatchMaterial")),
    hatchLineWidth: opt(nom("SheetPoints")),
    hatchStroke: id("OptionalBoolean"),
    hatchStrokeColor: opt(str),
    hatchDirection: opt(arr(num)),
    hatchLineSpacing: opt(nom("SheetInches")),
    hatchCrossHatch: id("OptionalBoolean"),
  },
  "LineStyle",
);
export const LineworkSchema = interf(
  {
    id: pk("ANNOTATION"),
    handle: union([undef, id("RoomLayoutInstanceHandle"), id("AnnotationHandle"), id("ContentTemplateInstanceHandle")]),
    handleAuxiliary: union([undef, id("AnnotationHandle"), id("ContentTemplateInstanceHandle")]),
    name: str,
    positioningMethod: id("PositioningMethod"),
    edgeId: opt(str),
    parentId: opt(
      union(
        [
          fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }),
          fk("ROOM", { hierarchy: ["PARENT"] }),
          fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] }),
          fk("ELEVATION_VIEW", { hierarchy: ["PARENT"] }),
          fk("SECTION_VIEW", { hierarchy: ["PARENT"] }),
          fk("CONTENT_TEMPLATE_INSTANCE", { hierarchy: ["PARENT"] }),
          fk("LEVEL", { hierarchy: ["PARENT"] }),
        ],
        "DocEntityParentId",
      ),
    ),
    entityType: lit("ANNOTATION"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    entityInstanceType: opt(id("EntityInstanceType")),
    labels: fkTable("LABEL", bool),
    type: lit("LINEWORK"),
    path: any,
    lineType: id("AnnotationLineType"),
    fillType: id("AnnotationFillType"),
    lineWeight: num,
    offset: bool,
    offsetDim: num,
    fillThickness: num,
    offsetLineType: id("AnnotationLineType"),
    offsetFillType: id("AnnotationFillType"),
  },
  "Linework",
);
export const LoadConnectionSchema = union(
  [id("ExplicitIndexLoadConnection"), id("NearestLoadConnection"), id("NearestArrayTerminusLoadConnection")],
  "LoadConnection",
);
export const LoadDescriptorSchema = interf(
  {
    id: pk("LOAD_DESCRIPTOR"),
    name: str,
    planLabel: opt(str),
    symbol: id("LoadSymbol"),
    erpCode: opt(str),
    boxType: opt(id("ElectricalBoxType")),
    catalogItemType: lit("LOAD_DESCRIPTOR"),
  },
  "LoadDescriptor",
);
export const LoadSymbolSchema = enu(
  {
    [`NONE`]: "NONE",
    [`CIRCLE_4`]: "CIRCLE_4",
    [`CIRCLE_7`]: "CIRCLE_7",
    [`CIRCLE_8`]: "CIRCLE_8",
    [`FRAMED_CIRCLE`]: "FRAMED_CIRCLE",
    [`CIRCLE_DL_45_15`]: "CIRCLE_DL_45_15",
    [`CIRCLE_DL_60_40`]: "CIRCLE_DL_60_40",
    [`CIRCLE_DL_12`]: "CIRCLE_DL_12",
    [`RECTANGLE_DL_1X4`]: "RECTANGLE_DL_1X4",
    [`RECTANGLE_DL_2X4`]: "RECTANGLE_DL_2X4",
    [`RECTANGLE_DL_24X4`]: "RECTANGLE_DL_24X4",
    [`CEILING_LIGHT`]: "CEILING_LIGHT",
    [`MOUNTED_WALL_LIGHT`]: "MOUNTED_WALL_LIGHT",
    [`FLOOD_LIGHT`]: "FLOOD_LIGHT",
    [`TRACK_CEILING_LIGHT`]: "TRACK_CEILING_LIGHT",
    [`CEILING_FAN`]: "CEILING_FAN",
    [`CEILING_FAN_LIGHT`]: "CEILING_FAN_LIGHT",
    [`FAN_PREWIRE`]: "FAN_PREWIRE",
    [`BATH_FAN`]: "BATH_FAN",
    [`BATH_FAN_LIGHT`]: "BATH_FAN_LIGHT",
    [`COMMS_TV`]: "COMMS_TV",
    [`OUTLET`]: "OUTLET",
    [`OUTLET_SINGLE`]: "OUTLET_SINGLE",
    [`OUTLET_DUPLEX_2`]: "OUTLET_DUPLEX_2",
    [`OUTLET_SWITCHED`]: "OUTLET_SWITCHED",
    [`OUTLET_TRIPLEX`]: "OUTLET_TRIPLEX",
    [`OUTLET_QUAD`]: "OUTLET_QUAD",
    [`OUTLET_SPECIAL`]: "OUTLET_SPECIAL",
    [`HIGH_VOLTAGE_OUTLET`]: "HIGH_VOLTAGE_OUTLET",
    [`SQUARE`]: "SQUARE",
    [`TEXT_ONLY`]: "TEXT_ONLY",
    [`FLOOR_TO_FLOOR_TRANSITION`]: "FLOOR_TO_FLOOR_TRANSITION",
  },
  "LoadSymbol",
);
export const LoadTypeSchema = enu(
  {
    [`MOUNTED_CEILING_LIGHT`]: "MOUNTED_CEILING_LIGHT",
    [`RECESSED_CEILING_LIGHT`]: "RECESSED_CEILING_LIGHT",
    [`RECESSED_CEILING_LIGHT_MINI`]: "RECESSED_CEILING_LIGHT_MINI",
    [`PENDANT_CEILING_LIGHT`]: "PENDANT_CEILING_LIGHT",
    [`KEYLESS_CEILING_LIGHT`]: "KEYLESS_CEILING_LIGHT",
    [`MOUNTED_CEILING_LED_LIGHT`]: "MOUNTED_CEILING_LED_LIGHT",
    [`FLOURESCENT_CEILING_LIGHT`]: "FLOURESCENT_CEILING_LIGHT",
    [`FLOURESCENT_CEILING_LIGHT_1X4`]: "FLOURESCENT_CEILING_LIGHT_1X4",
    [`UNDER_COUNTER_LIGHT`]: "UNDER_COUNTER_LIGHT",
    [`TRACK_CEILING_LIGHT`]: "TRACK_CEILING_LIGHT",
    [`MOUNTED_WALL_LIGHT`]: "MOUNTED_WALL_LIGHT",
    [`FLOOD_LIGHT`]: "FLOOD_LIGHT",
    [`OUTLET`]: "OUTLET",
    [`OUTLET_240V`]: "OUTLET_240V",
    [`OUTLET_220V`]: "OUTLET_220V",
    [`OUTLET_120_240V`]: "OUTLET_120_240V",
    [`OUTLET_GFCI`]: "OUTLET_GFCI",
    [`OUTLET_GFCI_WP`]: "OUTLET_GFCI_WP",
    [`OUTLET_FLOOR`]: "OUTLET_FLOOR",
    [`OUTLET_HDMI`]: "OUTLET_HDMI",
    [`OUTLET_CAT5`]: "OUTLET_CAT5",
    [`CABLE_OUTLET`]: "CABLE_OUTLET",
    [`TELEVISION`]: "TELEVISION",
    [`TELEPHONE`]: "TELEPHONE",
    [`SMOKE_DETECTOR`]: "SMOKE_DETECTOR",
    [`CARBON_MONOXIDE_DETECTOR`]: "CARBON_MONOXIDE_DETECTOR",
    [`THERMOSTAT`]: "THERMOSTAT",
    [`BATH_FAN`]: "BATH_FAN",
    [`BATH_FAN_LIGHT`]: "BATH_FAN_LIGHT",
    [`DISH_DISPOSAL`]: "DISH_DISPOSAL",
    [`DOORBELL_CHIME`]: "DOORBELL_CHIME",
    [`GARAGE_DOOR_OPENER`]: "GARAGE_DOOR_OPENER",
    [`CEILING_FAN`]: "CEILING_FAN",
    [`CEILING_FAN_LIGHT`]: "CEILING_FAN_LIGHT",
    [`FAN_PREWIRE`]: "FAN_PREWIRE",
    [`HOSE_BIB`]: "HOSE_BIB",
    [`FLOOR_TO_FLOOR_TRANSITION`]: "FLOOR_TO_FLOOR_TRANSITION",
    [`VIRTUAL_CEILING_FAN_LIGHT`]: "VIRTUAL_CEILING_FAN_LIGHT",
  },
  "LoadType",
);
export const LoadTypeSlotSchema = enu(
  {
    [`PRIMARY_LIGHT`]: "PRIMARY_LIGHT",
    [`SECONDARY_LIGHT`]: "SECONDARY_LIGHT",
    [`TERTIARY_LIGHT`]: "TERTIARY_LIGHT",
    [`QUATERNARY_LIGHT`]: "QUATERNARY_LIGHT",
    [`OUTLET`]: "OUTLET",
    [`OUTLET_GFCI`]: "OUTLET_GFCI",
    [`OUTLET_GFCI_WP`]: "OUTLET_GFCI_WP",
    [`OUTLET_FLOOR`]: "OUTLET_FLOOR",
    [`OUTLET_240V`]: "OUTLET_240V",
    [`OUTLET_220V`]: "OUTLET_220V",
    [`OUTLET_CAT5`]: "OUTLET_CAT5",
    [`CABLE_OUTLET`]: "CABLE_OUTLET",
    [`OUTLET_HDMI`]: "OUTLET_HDMI",
    [`RECESSED_CEILING_LIGHT`]: "RECESSED_CEILING_LIGHT",
    [`PENDANT_CEILING_LIGHT`]: "PENDANT_CEILING_LIGHT",
    [`KEYLESS_CEILING_LIGHT`]: "KEYLESS_CEILING_LIGHT",
    [`FLOURESCENT_CEILING_LIGHT`]: "FLOURESCENT_CEILING_LIGHT",
    [`TRACK_CEILING_LIGHT`]: "TRACK_CEILING_LIGHT",
    [`MOUNTED_WALL_LIGHT`]: "MOUNTED_WALL_LIGHT",
    [`FLOOD_LIGHT`]: "FLOOD_LIGHT",
    [`SMOKE_DETECTOR`]: "SMOKE_DETECTOR",
    [`CARBON_MONOXIDE_DETECTOR`]: "CARBON_MONOXIDE_DETECTOR",
    [`THERMOSTAT`]: "THERMOSTAT",
    [`DOORBELL_CHIME`]: "DOORBELL_CHIME",
    [`DISH_DISPOSAL`]: "DISH_DISPOSAL",
    [`GARAGE_DOOR_OPENER`]: "GARAGE_DOOR_OPENER",
    [`FAN_CEILING`]: "FAN_CEILING",
    [`BATH_FAN`]: "BATH_FAN",
    [`HOSE_BIB`]: "HOSE_BIB",
  },
  "LoadTypeSlot",
);
export const LoadTypeSlotsSchema = interf(
  {
    primaryLight: id("LoadType"),
    secondaryLight: opt(id("LoadType")),
    tertiaryLight: opt(id("LoadType")),
    quaternaryLight: opt(id("LoadType")),
    outlet: id("LoadType"),
    outletGFCI: id("LoadType"),
    outletGFCIwaterProof: id("LoadType"),
    outletFloor: id("LoadType"),
    cableOutlet: id("LoadType"),
    outlet240V: id("LoadType"),
    outlet220V: id("LoadType"),
    outletHDMI: id("LoadType"),
    outletCAT5: id("LoadType"),
    recessedCeilingLight: id("LoadType"),
    pendantCeilingLight: id("LoadType"),
    keylessCeilingLight: id("LoadType"),
    flourescentCeilingLight: id("LoadType"),
    trackCeilingLight: id("LoadType"),
    mountedWallLight: id("LoadType"),
    floodLight: id("LoadType"),
    fanCeiling: id("LoadType"),
    smokeDetector: id("LoadType"),
    carbonMonoxideDetector: id("LoadType"),
    thermostat: id("LoadType"),
    bathFan: id("LoadType"),
    garageDoorOpener: id("LoadType"),
    dishDisposal: id("LoadType"),
    doorbellChime: id("LoadType"),
    hoseBib: id("LoadType"),
  },
  "LoadTypeSlots",
);
export const LocalParameterSchema = union(
  [
    inters([
      id("NumberParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
    inters([
      id("BooleanParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
    inters([
      id("DrawingScaleParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
    inters([
      id("FootInchParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
    inters([
      id("TextParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
    inters([
      id("UrlParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
    inters([
      id("LevelParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
    inters([
      id("UnitParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
    inters([
      id("ElevationViewParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
    inters([
      id("SectionViewParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
    inters([
      id("View3DParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
    inters([
      id("DrawingTemplateParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
    inters([
      id("ViewTemplateParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
    inters([
      id("OptionChoiceParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
    inters([
      id("OptionPresetParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
    inters([
      id("DataSequenceParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("LOCAL_PARAMETER") },
      ),
      interf({
        id: pk("LOCAL_PARAMETER"),
        parentId: union(
          [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })],
          "DocEntityParentId",
        ),
      }),
    ]),
  ],
  "LocalParameter",
);
export const LocalParameterHandleSchema = interf(
  {
    type: lit("LOCAL_PARAMETER"),
    id: str,
  },
  "LocalParameterHandle",
);
export const LockableEntityHandleSchema = union(
  [
    id("GroupHandle"),
    id("LevelHandle"),
    id("BlockHandle"),
    id("RoomHandle"),
    id("StairSystemHandle"),
    id("StairBlockHandle"),
    id("RailingHandle"),
    id("RoofSystemHandle"),
    id("FoundationSystemHandle"),
    id("UnderlayHandle"),
    id("ReferenceGeomHandle"),
    id("MeasurementHandle"),
    id("FloorSystemHandle"),
  ],
  "LockableEntityHandle",
);
export const LockOptionEffectSchema = interf(
  {
    effectType: lit("LOCK"),
    optionId: fk("OPTION"),
    id: pk("OPTION_EFFECT"),
    optionSetId: fk("OPTION_SET"),
    parentId: union([fk("OPTION_RULE", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    entityType: lit("OPTION_EFFECT"),
    name: str,
    sortIndex: num,
  },
  "LockOptionEffect",
);
export const LumberProfileTypeSchema = enu(
  {
    [`SPF_2X4`]: "SPF_2X4",
    [`SPF_2X6`]: "SPF_2X6",
    [`SPF_2X8`]: "SPF_2X8",
    [`SPF_2X10`]: "SPF_2X10",
    [`SPF_2X12`]: "SPF_2X12",
    [`CUSTOM`]: "CUSTOM",
  },
  "LumberProfileType",
);
export const ManualCodeFormattingSchema = interf(
  {
    name: str,
    builderTemplateCode: str,
    id: str,
    sortIndex: num,
  },
  "ManualCodeFormatting",
);
export const MasonryComponentEntitySchema = union(
  [id("Concrete"), id("OtherMasonryComponent")],
  "MasonryComponentEntity",
);
export const MasonryComponentHandleSchema = interf(
  {
    type: lit("MASONRY_COMPONENT"),
    id: str,
  },
  "MasonryComponentHandle",
);
export const MasterPlanSettingsSchema = interf(
  {
    type: lit("MASTER_PLAN_SETTINGS"),
    includeCoverPage: bool,
    includeSchedules: bool,
    includeFloorPlans: bool,
    includeRoofPlans: bool,
    includeBasementFloorPlan: bool,
    includeFrontBackElevations: bool,
    includeLeftRightElevations: bool,
    includeSections: bool,
    includePerspectiveViews: bool,
    includeElectricPlans: bool,
    includeFoundationPlans: bool,
    includeStructuralPlans: bool,
    includeFoundationDetails: bool,
    includeUtilityPlans: bool,
  },
  "MasterPlanSettings",
);
export const Mat3Schema = interf({}, "Mat3");
export const MaterialSrcSchema = interf(
  {
    templateId: num,
    layerConfigId: opt(num),
    colorId: opt(num),
    keepPreviousLayers: id("OptionalBoolean"),
    userDefinedName: opt(str),
    userDefinedCategory: opt(str),
  },
  "MaterialSrc",
);
export const MaxDistanceColumnPlacementV1Schema = interf(
  {
    maxDistance: num,
    type: lit("MAX_DISTANCE"),
  },
  "MaxDistanceColumnPlacementV1",
);
export const MaxDistanceColumnPlacementV2Schema = interf(
  {
    maxDistance: num,
    type: lit("MAX_DISTANCE"),
  },
  "MaxDistanceColumnPlacementV2",
);
export const MaxDistancePostPlacementSchema = interf(
  {
    type: lit("MAX_DISTANCE"),
    maxDistance: num,
    removePostsFromSettings: bool,
    includeStartPost: bool,
    id: pk("RAILING_POST"),
    entityType: lit("RAILING_POST"),
    parentId: union([fk("RAILING", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    edgeIndex: opt(num),
    name: str,
    sortIndex: num,
  },
  "MaxDistancePostPlacement",
);
export const MeasurementHandleSchema = interf(
  {
    type: lit("MEASUREMENT"),
    id: str,
  },
  "MeasurementHandle",
);
export const ModifierSchema = interf(
  {
    id: pk("MODIFIER"),
    moveX: opt(num),
    moveY: opt(num),
    entityType: lit("MODIFIER"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "Modifier",
);
export const ModifierHandleSchema = interf(
  {
    type: lit("MODIFIER"),
    id: str,
  },
  "ModifierHandle",
);
export const ModifySettingsSchema = interf(
  {
    optionSetId: union([fk("OPTION_SET"), undef, nul]),
    fields: opt(arr(union([lit("price"), lit("description"), lit("builderOptionCode"), lit("salesImages")]))),
  },
  "ModifySettings",
);
export const MonolithicStairSchema = interf(
  {
    type: lit("MONOLITHIC"),
    stairBottomShape: id("StairBottomShape"),
    stringerMinDepth: num,
    stairMaterial: opt(id("MaterialSrc")),
    hasTreadMaterial: bool,
    stairBottomOffset: num,
    stringerTopExtension: num,
    treadThickness: opt(num),
    nosing: opt(num),
    treadMaterial: opt(id("MaterialSrc")),
    hasRisers: id("OptionalBoolean"),
    riserThickness: opt(num),
    riserMaterial: opt(id("MaterialSrc")),
  },
  "MonolithicStair",
);
export const NearestArrayTerminusLoadConnectionSchema = interf(
  {
    type: lit("NEAREST_LOAD_ARRAY_TERMINUS"),
  },
  "NearestArrayTerminusLoadConnection",
);
export const NearestLoadConnectionSchema = interf(
  {
    type: lit("NEAREST_LOAD"),
  },
  "NearestLoadConnection",
);
export const NominalNumberSchema = union(
  [
    nom("SheetPixels"),
    nom("LevelInches"),
    nom("SheetInches"),
    nom("Percent"),
    nom("SheetPoints"),
    nom("WorldInches"),
    nom("WorldFeet"),
    nom("InchesSquared"),
    nom("InchesCubed"),
    nom("YardsCubed"),
    nom("FeetSquared"),
    nom("FeetCubed"),
    nom("DotsPerInch"),
    nom("PixelsPerInch"),
    nom("OneHundredthMillimeters"),
    nom("Slope"),
    nom("UnsignedNumber"),
    nom("UntypedNumber"),
  ],
  "NominalNumber",
);
export const NoneSchema = interf(
  {
    type: lit("NONE"),
    outline: any,
    boundaryType: id("CeilingBoundaryType"),
    offset: num,
    ceilingMaterial: opt(
      union([
        lit("glass0"),
        lit("glass1"),
        lit("glass2"),
        lit("propDefault0"),
        lit("propDefault1"),
        lit("propDefault2"),
        lit("floorInterior0"),
        lit("floorInterior1"),
        lit("floorInterior2"),
        lit("floorInterior3"),
        lit("floorInterior4"),
        lit("floorInterior5"),
        lit("wallInterior0"),
        lit("wallInterior1"),
        lit("wallInterior2"),
        lit("trimInterior0"),
        lit("trimInterior1"),
        lit("trimInterior2"),
        lit("ceiling0"),
        lit("ceiling1"),
        lit("ceiling2"),
        lit("doorInterior0"),
        lit("doorInterior1"),
        lit("doorInterior2"),
        lit("doorFixture0"),
        lit("doorFixture1"),
        lit("doorFixture2"),
      ]),
    ),
    ceilingDatum: opt(
      inters(
        [
          id("DatumUsageBase"),
          interf({
            __usage: lit("CEILING"),
          }),
        ],
        "DatumUsage",
      ),
    ),
    labels: fkTable("LABEL", bool),
    disabled: id("FormulaDisabledField"),
  },
  "None",
);
export const NoteSchema = interf(
  {
    id: pk("ANNOTATION"),
    handle: union([undef, id("RoomLayoutInstanceHandle"), id("AnnotationHandle"), id("ContentTemplateInstanceHandle")]),
    handleAuxiliary: union([undef, id("AnnotationHandle"), id("ContentTemplateInstanceHandle")]),
    name: str,
    positioningMethod: id("PositioningMethod"),
    edgeId: opt(str),
    parentId: opt(
      union(
        [
          fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }),
          fk("ROOM", { hierarchy: ["PARENT"] }),
          fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] }),
          fk("ELEVATION_VIEW", { hierarchy: ["PARENT"] }),
          fk("SECTION_VIEW", { hierarchy: ["PARENT"] }),
          fk("CONTENT_TEMPLATE_INSTANCE", { hierarchy: ["PARENT"] }),
          fk("LEVEL", { hierarchy: ["PARENT"] }),
        ],
        "DocEntityParentId",
      ),
    ),
    entityType: lit("ANNOTATION"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    entityInstanceType: opt(id("EntityInstanceType")),
    labels: fkTable("LABEL", bool),
    type: lit("NOTE"),
    x: num,
    y: num,
    landingLineX: union([undef, nul, num]),
    landingLineY: union([undef, nul, num]),
    leaderLineX: union([undef, nul, num]),
    leaderLineY: union([undef, nul, num]),
    text: id("ParameterForeignKeyString"),
    rotation: num,
    placementXAnchor: id("PlacementXAnchor"),
    placementYAnchor: id("PlacementYAnchor"),
    textAlignment: id("TextAlignment"),
    verticalAlignment: id("TextVerticalAlignment"),
    textBoxWidth: opt(nom("SheetInches")),
    textBoxHeight: opt(nom("SheetInches")),
    leaderLineEndStyle: opt(id("PathEndStyle")),
    fontSize: opt(nom("SheetInches")),
    leaderArrowLength: opt(num),
    leaderArrowWidth: opt(num),
  },
  "Note",
);
export const NullAtomSchema = nul;
export const NumberAtomSchema = num;
export const NumberParameterSchema = interf(
  {
    defaultValue: opt(num),
    type: lit("NUMBER"),
  },
  "NumberParameter",
);
export const OneHundredthMillimetersSchema = nom("OneHundredthMillimeters");
export const OpeningSchema = union(
  [
    id("DoorPlacementDeprecated"),
    id("WindowPlacementDeprecated"),
    id("DoorPlacementMatchExpr"),
    id("WindowPlacementMatchExpr"),
    id("SolidOpeningPlacement"),
  ],
  "Opening",
);
export const OpeningHandleSchema = interf(
  {
    type: lit("OPENING"),
    id: str,
  },
  "OpeningHandle",
);
export const OpeningHorizontalAlignmentSchema = enu(
  {
    [`RIGHT`]: "RIGHT",
    [`CENTER`]: "CENTER",
    [`LEFT`]: "LEFT",
  },
  "OpeningHorizontalAlignment",
);
export const OpeningWrappingModeSchema = union(
  [lit("NONE"), lit("EXTERIOR_CORE_FACE"), lit("CENTER_OF_CORE"), lit("INTERIOR_CORE_FACE")],
  "OpeningWrappingMode",
);
export const OptionalBooleanSchema = union([undef, lit(false), lit(true)]);
export const OptionChoiceParameterSchema = interf(
  {
    optionSetId: fk("OPTION_SET"),
    defaultValue: opt(fk("OPTION")),
    type: lit("OPTION"),
  },
  "OptionChoiceParameter",
);
export const OptionChoicesSchema = fkTable("OPTION_SET", union([fk("OPTION"), nul]));
export const OptionCodeFormattingSchema = interf(
  {
    optionSetId: fk("OPTION_SET"),
    id: str,
    sortIndex: num,
  },
  "OptionCodeFormatting",
);
export const OptionEffectHandleSchema = interf(
  {
    type: lit("OPTION_EFFECT"),
    id: str,
  },
  "OptionEffectHandle",
);
export const OptionHandleSchema = interf(
  {
    type: lit("OPTION"),
    optionSetId: str,
    optionKey: str,
  },
  "OptionHandle",
);
export const OptionLockHandleSchema = interf(
  {
    type: lit("OPTION_LOCK"),
    id: str,
  },
  "OptionLockHandle",
);
export const OptionPresetBaseSchema = interf(
  {
    presetId: union([id("ParameterRef"), fk("PRESET")]),
    optionSetOverrides: fkTable("OPTION_SET", union([id("ParameterRef"), fk("OPTION")])),
  },
  "OptionPresetBase",
);
export const OptionPresetParameterSchema = interf(
  {
    defaultValue: opt(fk("PRESET")),
    type: lit("PRESET"),
  },
  "OptionPresetParameter",
);
export const OptionPresetValueSchema = interf(
  {
    type: lit("PRESET"),
    value: fk("PRESET"),
  },
  "OptionPresetValue",
);
export const OptionRuleHandleSchema = interf(
  {
    type: lit("OPTION_RULE"),
    id: str,
  },
  "OptionRuleHandle",
);
export const OptionSetForeignKeyStringSchema = fkStrOf(["OPTION_SET", "OPTION", "ELEVATION"]);
export const OptionSetHandleSchema = interf(
  {
    type: lit("OPTION_SET"),
    id: str,
  },
  "OptionSetHandle",
);
export const OptionSetMasterPlanSetBehaviorSchema = enu(
  {
    [`DEFAULT`]: "DEFAULT",
    [`ENABLED`]: "ENABLED",
    [`DISABLED`]: "DISABLED",
  },
  "OptionSetMasterPlanSetBehavior",
);
export const OptionSetOverridesHandleSchema = interf(
  {
    type: lit("OPTION_SET_OVERRIDES"),
    id: str,
  },
  "OptionSetOverridesHandle",
);
export const OptionTemplateHandleSchema = interf(
  {
    type: lit("OPTION_TEMPLATE"),
    id: str,
  },
  "OptionTemplateHandle",
);
export const OptionValueSchema = interf(
  {
    type: lit("OPTION"),
    value: fk("OPTION"),
  },
  "OptionValue",
);
export const OsbSchema = interf(
  {
    spanRating: id("SpanRating"),
    profile: id("OSBProfile"),
    id: pk("SHEATHING_COMPONENT"),
    name: str,
    sheathingType: lit("OSB"),
    thickness: num,
    entityType: lit("SHEATHING_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "Osb",
);
export const OSBProfileSchema = enu(
  {
    [`"3/8"`]: "3/8",
    [`"7/16"`]: "7/16",
    [`"15/32"`]: "15/32",
    [`"1/2"`]: "1/2",
    [`"19/32"`]: "19/32",
    [`"23/32"`]: "23/32",
    [`"3/4"`]: "3/4",
  },
  "OSBProfile",
);
export const OtherSchema = interf(
  {
    spanRating: str,
    id: pk("SHEATHING_COMPONENT"),
    name: str,
    sheathingType: lit("OTHER"),
    thickness: num,
    entityType: lit("SHEATHING_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "Other",
);
export const OtherMasonryComponentSchema = interf(
  {
    width: num,
    height: num,
    length: num,
    id: pk("MASONRY_COMPONENT"),
    name: str,
    masonryType: lit("OTHER"),
    entityType: lit("MASONRY_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "OtherMasonryComponent",
);
export const PaletteSchema = union([id("ExteriorPalette"), id("InteriorPalette")], "Palette");
export const PaletteHandleSchema = interf(
  {
    type: lit("PALETTE"),
    id: str,
  },
  "PaletteHandle",
);
export const PaletteMaterialSlotSchema = union(
  [
    lit("wallExterior0"),
    lit("wallExterior1"),
    lit("wallExterior2"),
    lit("wallExterior3"),
    lit("wallExterior4"),
    lit("wallExterior5"),
    lit("wallExterior6"),
    lit("wallExterior7"),
    lit("wallExterior8"),
    lit("wallExterior9"),
    lit("trimExterior0"),
    lit("trimExterior1"),
    lit("trimExterior2"),
    lit("trimExterior3"),
    lit("trimExterior4"),
    lit("trimExterior5"),
    lit("trimExterior6"),
    lit("trimExterior7"),
    lit("trimExterior8"),
    lit("trimExterior9"),
    lit("roof0"),
    lit("roof1"),
    lit("roof2"),
    lit("roof3"),
    lit("roofTrim0"),
    lit("roofTrim1"),
    lit("roofTrim2"),
    lit("roofTrim3"),
    lit("gutter0"),
    lit("gutter1"),
    lit("gutter2"),
    lit("foundation0"),
    lit("foundation1"),
    lit("foundation2"),
    lit("driveway0"),
    lit("driveway1"),
    lit("driveway2"),
    lit("walks0"),
    lit("walks1"),
    lit("walks2"),
    lit("porchCeiling0"),
    lit("porchCeiling1"),
    lit("porchCeiling2"),
    lit("deck0"),
    lit("deck1"),
    lit("deck2"),
    lit("deck3"),
    lit("glass0"),
    lit("glass1"),
    lit("glass2"),
    lit("glassTrim0"),
    lit("glassTrim1"),
    lit("glassTrim2"),
    lit("doorExterior0"),
    lit("doorExterior1"),
    lit("doorExterior2"),
    lit("doorExterior3"),
    lit("garageExterior0"),
    lit("garageExterior1"),
    lit("garageExterior2"),
    lit("garageExterior3"),
    lit("hardwareExterior0"),
    lit("hardwareExterior1"),
    lit("hardwareExterior2"),
    lit("propDefault0"),
    lit("propDefault1"),
    lit("propDefault2"),
    lit("masonry0"),
    lit("masonry1"),
    lit("masonry2"),
    lit("masonry3"),
    lit("chimney0"),
    lit("chimney1"),
    lit("chimney2"),
    lit("shutter0"),
    lit("shutter1"),
    lit("shutter2"),
    lit("headCasing0"),
    lit("headCasing1"),
    lit("headCasing2"),
    lit("headCasing3"),
    lit("apronCasing0"),
    lit("apronCasing1"),
    lit("apronCasing2"),
    lit("apronCasing3"),
    lit("sideCasing0"),
    lit("sideCasing1"),
    lit("sideCasing2"),
    lit("sideCasing3"),
    lit("earth0"),
    lit("road0"),
    lit("grass0"),
    lit("sidewalk0"),
    lit("curb0"),
    lit("fence0"),
    lit("retainingWall0"),
    lit("water0"),
    lit("masonryTrim0:Base"),
    lit("masonryTrim0:Header"),
    lit("masonryTrim0:Rowlock"),
    lit("masonryTrim1:Base"),
    lit("masonryTrim1:Header"),
    lit("masonryTrim1:Rowlock"),
    lit("masonryTrim2:Base"),
    lit("masonryTrim2:Header"),
    lit("masonryTrim2:Rowlock"),
    lit("masonryTrim3:Base"),
    lit("masonryTrim3:Header"),
    lit("masonryTrim3:Rowlock"),
    lit("floorInterior0"),
    lit("floorInterior1"),
    lit("floorInterior2"),
    lit("floorInterior3"),
    lit("floorInterior4"),
    lit("floorInterior5"),
    lit("wallInterior0"),
    lit("wallInterior1"),
    lit("wallInterior2"),
    lit("trimInterior0"),
    lit("trimInterior1"),
    lit("trimInterior2"),
    lit("ceiling0"),
    lit("ceiling1"),
    lit("ceiling2"),
    lit("doorInterior0"),
    lit("doorInterior1"),
    lit("doorInterior2"),
    lit("doorFixture0"),
    lit("doorFixture1"),
    lit("doorFixture2"),
  ],
  "PaletteMaterialSlot",
);
export const PaletteTypeSchema = enu(
  {
    [`EXTERIOR_PALETTE`]: "EXTERIOR_PALETTE",
    [`INTERIOR_PALETTE`]: "INTERIOR_PALETTE",
  },
  "PaletteType",
);
export const PanelShutterSettingsSchema = interf(
  {
    shutterType: lit("PANEL"),
    type: lit("WINDOW_SHUTTER_SETTINGS"),
    forceShutters: id("OptionalBoolean"),
    shutterShapeOverride: opt(id("ShutterShapeType")),
    shutterWidthOverride: opt(num),
    shutterHeightOverride: opt(num),
    shutterArchRadiusOverride: opt(num),
    verticalAlignment: opt(id("ShutterVerticalAlignment")),
    verticalOffset: opt(num),
    horizontalOffset: opt(num),
    lateralDatum: opt(id("WallLateralDatumAnchor")),
    lateralOffset: opt(num),
    shutterConfiguration: opt(id("ShutterConfigurationType")),
    orientation: opt(id("ShutterStreetOrientationPreference")),
    shutterMaterial: opt(id("ExteriorMaterial")),
    viewNotes: opt(
      mapobj(
        lit("SHUTTER"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "ShutterViewNoteTable",
      ),
    ),
    isLegacyWidthOverride: id("OptionalBoolean"),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "PanelShutterSettings",
);
export const PaperSizeSchema = enu(
  {
    [`SHEET_11X17`]: "SHEET_11X17",
    [`SHEET_22X34`]: "SHEET_22X34",
  },
  "PaperSize",
);
export const ParamColumnPlacementV1Schema = interf(
  {
    param: num,
    paramNormalized: bool,
    type: lit("PARAM"),
  },
  "ParamColumnPlacementV1",
);
export const ParamColumnPlacementV2Schema = interf(
  {
    type: lit("PARAM"),
  },
  "ParamColumnPlacementV2",
);
export const ParameterForeignKeyStringSchema = fkStrOf(["GLOBAL_PARAMETER", "SYSTEM_PARAMETER", "LOCAL_PARAMETER"]);
export const ParameterFormulaSchema = interf(
  {
    type: lit("FORMULA"),
    formula: id("ParameterForeignKeyString"),
  },
  "ParameterFormula",
);
export const ParameterFormulaDisabledFieldSchema = union([undef, lit(false), lit(true), id("ParameterFormula")]);
export const ParameterRefSchema = interf(
  {
    type: lit("PARAMETER_REF"),
    id: union([fk("LOCAL_PARAMETER"), fk("GLOBAL_PARAMETER"), fk("SYSTEM_PARAMETER")]),
  },
  "ParameterRef",
);
export const ParameterRefNumberFieldSchema = union([num, id("ParameterRef")], "ParameterRefNumberField");
export const ParameterRefStringFieldSchema = union([str, id("ParameterRef")], "ParameterRefStringField");
export const ParameterValueSchema = union(
  [
    str,
    num,
    lit(false),
    lit(true),
    union([
      fk("LEVEL"),
      fk("PRESET"),
      fk("OPTION"),
      fk("ELEVATION_VIEW"),
      fk("SECTION_VIEW"),
      fk("VIEW_3D"),
      fk("CONTENT_TEMPLATE"),
      fk("DATA_SEQUENCE"),
      fk("VIEW_TEMPLATE"),
      fk("LABEL"),
      fk("COMPOSITE_LEVEL"),
    ]),
  ],
  "ParameterValue",
);
export const ParameterValueHandleSchema = union(
  [
    id("PrimitiveValue"),
    id("OptionPresetValue"),
    id("OptionValue"),
    id("LevelValue"),
    id("UnitValue"),
    id("DataSequenceValue"),
    id("ViewTemplateValue"),
    id("ContentTemplateValue"),
    id("ElevationViewValue"),
    id("SectionViewValue"),
  ],
  "ParameterValueHandle",
);
export const ParamPostPlacementSchema = interf(
  {
    type: lit("PARAM"),
    param: num,
    paramNormalized: bool,
    removePostsFromSettings: bool,
    removeInfillBefore: bool,
    removeInfillAfter: bool,
    id: pk("RAILING_POST"),
    entityType: lit("RAILING_POST"),
    parentId: union([fk("RAILING", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    edgeIndex: opt(num),
    name: str,
    sortIndex: num,
  },
  "ParamPostPlacement",
);
export const PathEndStyleSchema = enu(
  {
    [`NONE`]: "NONE",
    [`ARROW`]: "ARROW",
  },
  "PathEndStyle",
);
export const PercentSchema = nom("Percent");
export const PerspectiveViewportSchema = inters(
  [
    id("ViewportBase"),
    id("OptionPresetBase"),
    interf({
      viewType: lit("VIEW_3D"),
      contentSourceId: union([
        id("ParameterRef"),
        lit("frontLeftAerial"),
        lit("frontRightAerial"),
        lit("backLeftAerial"),
        lit("backRightAerial"),
        lit("frontSidewalk"),
      ]),
    }),
  ],
  "PerspectiveViewport",
);
export const PerspectiveViewTemplateSchema = interf(
  {
    viewType: lit("VIEW_3D"),
    id: pk("VIEW_TEMPLATE"),
    categories: arr(id("SheetGeometryCategory")),
    styleOverrides: mapobj(
      id("SheetGeometryCategory"),
      interf(
        {
          line: opt(id("LineStyle")),
          text: opt(id("TextStyle")),
        },
        "SheetGeometryCategoryStyle",
      ),
      true,
      "SheetGeometryStyleTable",
    ),
    viewStyle: opt(id("ViewStyle")),
    viewTemplateOverrideIds: arr(fk("VIEW_TEMPLATE_OVERRIDE")),
    entityType: lit("VIEW_TEMPLATE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "PerspectiveViewTemplate",
);
export const PierPositionSchema = interf(
  {
    rotated: id("OptionalBoolean"),
    param: num,
    paramNormalized: bool,
  },
  "PierPosition",
);
export const PixelsPerInchSchema = nom("PixelsPerInch");
export const PlacementPointSchema = interf(
  {
    type: lit("LEGACY_PLACEMENT_POINT"),
    offset: num,
    roomId: fk("ROOM"),
    edgeId: str,
    param: num,
    paramNormalized: bool,
    reverse: bool,
  },
  "PlacementPoint",
);
export const PlacementStyleVersionSchema = enu(
  {
    [`DEPRECATED`]: "DEPRECATED",
    [`VERSION_0`]: "VERSION_0",
  },
  "PlacementStyleVersion",
);
export const PlacementXAnchorSchema = enu(
  {
    [`LEFT`]: "LEFT",
    [`CENTER`]: "CENTER",
    [`RIGHT`]: "RIGHT",
  },
  "PlacementXAnchor",
);
export const PlacementYAnchorSchema = enu(
  {
    [`TOP`]: "TOP",
    [`CENTER`]: "CENTER",
    [`BOTTOM`]: "BOTTOM",
  },
  "PlacementYAnchor",
);
export const PlanAreaMeasurementSchema = interf(
  {
    positioningMethod: id("PositioningMethod"),
    parentId: union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    parentEdgeId: str,
    reportCategories: obj(bool, "PlanAreaReportCategories"),
    shapes: pkTable("SHAPE", id("PlanAreaMeasurementShape")),
    id: pk("MEASUREMENT"),
    measurementType: lit("PLANAR_AREA"),
    sign: id("Sign"),
    entityType: lit("MEASUREMENT"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "PlanAreaMeasurement",
);
export const PlanAreaMeasurementShapeSchema = interf(
  {
    path: any,
    name: str,
  },
  "PlanAreaMeasurementShape",
);
export const PlanLineStyleSchema = enu(
  {
    [`NONE`]: "NONE",
    [`DASHED`]: "DASHED",
    [`FULL`]: "FULL",
  },
  "PlanLineStyle",
);
export const PlanNoteOrientationSchema = enu(
  {
    [`HORIZONTAL`]: "HORIZONTAL",
    [`VERTICAL`]: "VERTICAL",
  },
  "PlanNoteOrientation",
);
export const PlanOrientationSchema = enu(
  {
    [`DEFAULT`]: "DEFAULT",
    [`ROTATE_90_DEGREES`]: "ROTATE_90_DEGREES",
  },
  "PlanOrientation",
);
export const PlanSeriesSchema = enu(
  {
    [`A`]: "A",
    [`B`]: "B",
    [`E`]: "E",
    [`P`]: "P",
  },
  "PlanSeries",
);
export const PlanSetTemplateSchema = interf(
  {
    id: pk("PLAN_SET_TEMPLATE"),
    exportPermissions: obj(union([lit("ALLOW"), lit("DENY"), lit("IF_ASSIGNED")]), "PlanSetTemplateExportPermissions"),
    entityType: lit("PLAN_SET_TEMPLATE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "PlanSetTemplate",
);
export const PlanSetTemplateConfigSchema = interf(
  {
    id: pk("PLAN_SET_TEMPLATE_CONFIG"),
    parentId: opt(union([fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
    parameterValues: fkTable(["LOCAL_PARAMETER", "SYSTEM_PARAMETER"], id("ParameterValueHandle")),
    globalParameterValues: fkTable("GLOBAL_PARAMETER", id("ParameterValueHandle")),
    entityType: lit("PLAN_SET_TEMPLATE_CONFIG"),
    name: str,
    sortIndex: num,
  },
  "PlanSetTemplateConfig",
);
export const PlanSetTemplateConfigHandleSchema = interf(
  {
    type: lit("PLAN_SET_TEMPLATE_CONFIG"),
    id: str,
  },
  "PlanSetTemplateConfigHandle",
);
export const PlanSetTemplateHandleSchema = interf(
  {
    type: lit("PLAN_SET_TEMPLATE"),
    id: str,
  },
  "PlanSetTemplateHandle",
);
export const PlanSettingsSchema = interf(
  {
    type: lit("PLAN_SETTINGS"),
    includeDesignCriteria: bool,
    areaReportSettings: id("AreaReportSettings"),
    includeOptionsSchedule: bool,
    includeFloorMaterialsDiagram: bool,
    includeConditionedAreaDiagram: bool,
    includeGarageDoorsInDoorSchedule: bool,
    minWallLength: num,
    minJambLength: num,
    archPlanSeries: id("PlanSeries"),
    paperSize: id("PaperSize"),
    annotationScale: num,
    columnDimensionType: id("ColumnDimensionType"),
    orientation: id("PlanOrientation"),
    elevationNotePlacementType: id("ElevationNotePlacementType"),
    elevationScaleOverride: id("SheetCustomScales"),
    roomLabelUnits: id("RoomLabelUnits"),
    roomLabelRounding: id("RoomLabelRounding"),
    roomLabelDimensionType: id("RoomLabelDimensionType"),
    generateFramingPlan: bool,
    labelFramingElements: bool,
    enableLegacyFontScaling: bool,
    includeSchedules: bool,
    includeFloorPlans: bool,
    includeRoofPlans: bool,
    includeBasementFloorPlan: bool,
    includeFrontBackElevations: bool,
    includeLeftRightElevations: bool,
    includeSections: bool,
    includePerspectiveViews: bool,
    includeElectricPlans: bool,
    includeFoundationPlans: bool,
    includeStructuralPlans: bool,
    includeFoundationDetails: bool,
    includeUtilityPlans: bool,
    enableAutogradeLine: bool,
    overlayFoundationOutlines: bool,
    belowGradeRenderStyle: id("PlanLineStyle"),
    showWindowHeaderDimsOnElevations: bool,
    automatedDatumAnnotations: bool,
    showRoofWidthDims: id("OptionalBoolean"),
    showRoofHorizontalPlacementDims: id("OptionalBoolean"),
    showRoofSlopeElevationAnnotation: id("OptionalBoolean"),
    showRoofGableWindowVerticalDims: id("OptionalBoolean"),
    showRoofGableWindowReportedName: id("OptionalBoolean"),
    showRoofTruncationHeightDims: id("OptionalBoolean"),
    showDormerWindowVerticalDimensions: id("OptionalBoolean"),
    showDormerWindowReportedName: id("OptionalBoolean"),
    showDormerWallFramingHeightDimensions: id("OptionalBoolean"),
    showDormerWallFramingWidthDimensions: id("OptionalBoolean"),
    showDormerGableWindowVerticalDims: id("OptionalBoolean"),
    showDormerGableWindowReportedName: id("OptionalBoolean"),
    showDormerRoofWidthDims: id("OptionalBoolean"),
    showDormerHorizontalPlacementDims: id("OptionalBoolean"),
    showDormerRoofSlopeElevationAnnotation: id("OptionalBoolean"),
    showDormerRoofTruncationHeightDims: id("OptionalBoolean"),
    enableOpenToAboveAnnotation: id("OptionalBoolean"),
    includeSliderOperation: id("OptionalBoolean"),
    includeWindowTagExtensions: bool,
    interiorDimensionType: id("InteriorDimensionType"),
    exteriorOpeningTagOffset: num,
    interiorOpeningTagOffset: num,
    interiorDimensionAreaThreshold: num,
    addCeilingHeightToRoomTag: id("OptionalBoolean"),
    addFloorMaterialToRoomTag: id("OptionalBoolean"),
    exteriorDimensionType: id("ExteriorDimensionType"),
    exteriorDimensionDatum: id("WallLateralDatumAnchor"),
    exteriorDimensionOffsetMultiplier: num,
    dimensionInteriorWallTJunctionsOnExteriorDims: bool,
    includeFootingInfo: bool,
    includeDetailCallouts: bool,
    dimensionPlumbingProps: bool,
    dimensionElectricalFloorProps: bool,
    dimensionBrickLedge: bool,
    dimensionInteriorFootings: bool,
    utilityDimensionType: id("UtilityDimensionType"),
    excludeNonHouseSlabEdges: bool,
    includeExcavationNote: bool,
    includeRoofOverhangDimensions: id("OptionalBoolean"),
    includeRoofSlopeAnnotation: id("OptionalBoolean"),
    includeDormerOverhangDimensions: id("OptionalBoolean"),
    includeDormerDashedFraming: id("OptionalBoolean"),
    includeDormerRoofSlopeAnnotation: id("OptionalBoolean"),
    includePorchColumnStructure: id("OptionalBoolean"),
    includePorchHeaderStructure: id("OptionalBoolean"),
  },
  "PlanSettings",
);
export const PlanViewSchema = union([id("LevelPlanView"), id("CompositeLevelPlanView")], "PlanView");
export const PlanViewCompositeLevelMemberSchema = interf(
  {
    entityId: fk("COMPOSITE_LEVEL"),
    componentInstanceChain: opt(arr(fk("COMPONENT_INSTANCE"))),
  },
  "PlanViewCompositeLevelMember",
);
export const PlanViewHandleSchema = interf(
  {
    type: lit("PLAN_VIEW"),
    id: str,
  },
  "PlanViewHandle",
);
export const PlanViewLevelMemberSchema = interf(
  {
    entityId: fk("LEVEL"),
    componentInstanceChain: opt(arr(fk("COMPONENT_INSTANCE"))),
  },
  "PlanViewLevelMember",
);
export const PlanViewportSchema = interf(
  {
    viewType: lit("PLAN_VIEW"),
    contentSourceId: union([id("ParameterRef"), fk("LEVEL"), fk("COMPOSITE_LEVEL")]),
    contentSourceComponentInstanceChain: opt(id("ForeignKeyPathOf")),
    contentRotationDegrees: opt(id("ParameterRefNumberField")),
    iterationStep: opt(num),
    maxIterationDistance: opt(num),
    id: pk("VIEWPORT"),
    parentId: opt(
      union(
        [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("CONTENT_TEMPLATE_INSTANCE", { hierarchy: ["PARENT"] })],
        "DocEntityParentId",
      ),
    ),
    viewTemplateId: union([id("ParameterRef"), fk("VIEW_TEMPLATE")]),
    contentTextScale: opt(num),
    dimensionPrecision: opt(id("DimensionPrecision")),
    title: opt(id("ParameterRefStringField")),
    number: opt(id("ParameterRefStringField")),
    description: opt(id("ParameterRefStringField")),
    titleDrawingTemplateId: opt(fk("CONTENT_TEMPLATE")),
    selectedReportingUnitLabelId: union([fk("LABEL"), undef, id("ParameterRef")]),
    viewTemplateOverrideIds: arr(fk("VIEW_TEMPLATE_OVERRIDE")),
    worldOriginInPageSpaceX: nom("SheetInches"),
    worldOriginInPageSpaceY: nom("SheetInches"),
    outline: any,
    scale: opt(id("ParameterRefNumberField")),
    positioningMethod: opt(id("ViewportPositioningMethod")),
    scalingMethod: opt(id("ViewportScalingMethod")),
    verticalAlignment: opt(id("ViewportVerticalAlignment")),
    horizontalAlignment: opt(id("ViewportHorizontalAlignment")),
    entityType: lit("VIEWPORT"),
    name: str,
    sortIndex: num,
    disabled: id("ParameterFormulaDisabledField"),
    presetId: union([id("ParameterRef"), fk("PRESET")]),
    optionSetOverrides: fkTable("OPTION_SET", union([id("ParameterRef"), fk("OPTION")])),
  },
  "PlanViewport",
);
export const PlanViewTemplateSchema = interf(
  {
    viewType: lit("PLAN_VIEW"),
    referenceType: opt(id("BuiltinPlanViewType")),
    reduceOverlap: id("OptionalBoolean"),
    roomTagTemplateId: opt(fk("CONTENT_TEMPLATE")),
    roomTagCapitalization: opt(id("RoomTagCapitalization")),
    cutPlaneHeight: opt(nom("LevelInches")),
    stairCutPlaneHeight: opt(nom("LevelInches")),
    wallFinishCutPlaneHeight: opt(nom("LevelInches")),
    id: pk("VIEW_TEMPLATE"),
    categories: arr(id("SheetGeometryCategory")),
    styleOverrides: mapobj(
      id("SheetGeometryCategory"),
      interf(
        {
          line: opt(id("LineStyle")),
          text: opt(id("TextStyle")),
        },
        "SheetGeometryCategoryStyle",
      ),
      true,
      "SheetGeometryStyleTable",
    ),
    viewStyle: opt(id("ViewStyle")),
    viewTemplateOverrideIds: arr(fk("VIEW_TEMPLATE_OVERRIDE")),
    entityType: lit("VIEW_TEMPLATE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "PlanViewTemplate",
);
export const PlywoodSchema = interf(
  {
    spanRating: id("SpanRating"),
    profile: id("PlywoodProfile"),
    id: pk("SHEATHING_COMPONENT"),
    name: str,
    sheathingType: lit("PLYWOOD"),
    thickness: num,
    entityType: lit("SHEATHING_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "Plywood",
);
export const PlywoodProfileSchema = enu(
  {
    [`"5/16-u"`]: "5/16-u",
    [`"3/8-u"`]: "3/8-u",
    [`"15/32-u"`]: "15/32-u",
    [`"1/2-u"`]: "1/2-u",
    [`"19/32-u"`]: "19/32-u",
    [`"5/8-u"`]: "5/8-u",
    [`"3/4-u"`]: "3/4-u",
    [`"1/4-s"`]: "1/4-s",
    [`"11/32-s"`]: "11/32-s",
    [`"3/8-s"`]: "3/8-s",
    [`"15/32-s"`]: "15/32-s",
    [`"1/2-s"`]: "1/2-s",
    [`"19/32-s"`]: "19/32-s",
    [`"3/4-s"`]: "3/4-s",
    [`"5/8-s"`]: "5/8-s",
    [`"23/32-s"`]: "23/32-s",
  },
  "PlywoodProfile",
);
export const PolygonWindowModeSchema = enu(
  {
    [`TRAPEZOIDAL_LEFT`]: "TRAPEZOIDAL_LEFT",
    [`TRAPEZOIDAL_RIGHT`]: "TRAPEZOIDAL_RIGHT",
    [`PENTAGONAL`]: "PENTAGONAL",
  },
  "PolygonWindowMode",
);
export const PorchColumnEdgeBehaviorSchema = interf(
  {
    edgeBehaviorType: lit("PORCH_COLUMN"),
    porchColumnPattern: id("PorchColumnPattern"),
    id: pk("EDGE_BEHAVIOR"),
    parentId: union(
      [fk("ROOM", { hierarchy: ["PARENT"] }), fk("STAIR_BLOCK", { hierarchy: ["PARENT"] })],
      "DocEntityParentId",
    ),
    edgeId: str,
    entityType: lit("EDGE_BEHAVIOR"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "PorchColumnEdgeBehavior",
);
export const PorchColumnPatternSchema = interf(
  {
    positions: arr(id("ColumnPosition")),
  },
  "PorchColumnPattern",
);
export const PorchHeaderTrimAlignmentSchema = enu(
  {
    [`TOP_OF_HEADER`]: "TOP_OF_HEADER",
    [`BOTTOM_OF_HEADER`]: "BOTTOM_OF_HEADER",
  },
  "PorchHeaderTrimAlignment",
);
export const PorchPlanSettingsSchema = interf(
  {
    includePorchColumnStructure: id("OptionalBoolean"),
    includePorchHeaderStructure: id("OptionalBoolean"),
  },
  "PorchPlanSettings",
);
export const PorchSettingsSchema = interf(
  {
    type: lit("PORCH_SETTINGS"),
    parentId: opt(
      union(
        [fk("ROOM", { hierarchy: ["PARENT"] }), fk("SETTINGS_SET", { hierarchy: ["PARENT"] })],
        "DocEntityParentId",
      ),
    ),
    name: opt(str),
    endSegmentJoinTolerance: opt(num),
    minColumnSpacing: opt(num),
    maxColumnSpacing: num,
    doorPathColumnSpread: opt(num),
    doorPathColumnSpreadMode: opt(id("DoorPathColumnSpreadMode")),
    colonnadeTerminationRules: arr(id("ColonnadeTerminationRule")),
    includeRailing: bool,
    upperFloorIncludeRailing: id("OptionalBoolean"),
    columnLateralOffset: opt(num),
    headerLateralOffset: opt(num),
    foundationOffset: opt(num),
    baseColumnOffset: bool,
    multiColumn: id("OptionalBoolean"),
    multiColumnSpread: opt(num),
    multiColumnFrontOnly: id("OptionalBoolean"),
    topOfHeaderHeightOffset: opt(num),
    frontColonnadeColumnOverride: id("OptionalBoolean"),
    colonnadeOverrideValues: opt(arr(num)),
    internalColumnStructureSize: num,
    internalHeaderStructureWidth: num,
    headerDepth: opt(num),
    headerCasingThickness: num,
    headerCasingOffsetFromCenterLine: num,
    headerCasingMaterial: opt(id("ExteriorMaterial")),
    columnCasingOffset: num,
    columnId: opt(fk("COLUMN_DESCRIPTOR")),
    removeHeader: id("OptionalBoolean"),
    removeColumns: id("OptionalBoolean"),
    viewNotes: opt(
      mapobj(
        enu(
          {
            [`COLUMN_BRACKET`]: "COLUMN_BRACKET",
            [`PORCH_RAILING`]: "PORCH_RAILING",
            [`PORCH_HEADER`]: "PORCH_HEADER",
          },
          "PorchViewNoteType",
        ),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "PorchViewNoteTable",
      ),
    ),
    porchHeaderTrimProfile: opt(id("ProfileId")),
    porchHeaderTrimAlignment: opt(id("PorchHeaderTrimAlignment")),
    porchHeaderTrimJustification: opt(id("TrimJustification")),
    porchHeaderTrimOffset: opt(num),
    porchHeaderTrimDepthOffset: opt(num),
    porchHeaderTrimMaterial: opt(id("ExteriorMaterial")),
    columnBracketPropId: opt(id("BuiltInExteriorPropId")),
    porchPlanSettings: opt(id("PorchPlanSettings")),
    excludeFromPorchMerge: id("OptionalBoolean"),
  },
  "PorchSettings",
);
export const PositioningMethodSchema = enu(
  {
    [`EDGE`]: "EDGE",
    [`GLOBAL`]: "GLOBAL",
  },
  "PositioningMethod",
);
export const PostDefaultSchema = interf(
  {
    type: lit("POST_DEFAULT"),
    width: num,
    depth: num,
  },
  "PostDefault",
);
export const PostPlacementSchema = union(
  [id("ParamPostPlacement"), id("ArrayPostPlacement"), id("DivisionPostPlacement"), id("MaxDistancePostPlacement")],
  "PostPlacement",
);
export const PredicateOpSchema = union(
  [lit("EQ"), lit("NEQ"), lit("IN"), lit("CONTAINS"), lit("INTERSECTS"), lit("EXISTS")],
  "PredicateOp",
);
export const PresetSchema = interf(
  {
    id: pk("PRESET"),
    optionChoices: id("OptionChoices"),
    type: id("PresetType"),
    masterPlanOrder: opt(num),
    masterPlanSettings: opt(partial(id("MasterPlanSettings"))),
    sheetNumberPrefix: opt(str),
    includeInTest: id("OptionalBoolean"),
    price: opt(num),
    builderOptionCode: opt(str),
    entityType: lit("PRESET"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "Preset",
);
export const PresetHandleSchema = interf(
  {
    type: lit("PRESET"),
    id: str,
  },
  "PresetHandle",
);
export const PresetTypeSchema = enu(
  {
    [`PRESETS`]: "PRESETS",
    [`PROCURE`]: "PROCURE",
    [`HOME_PLAN`]: "HOME_PLAN",
  },
  "PresetType",
);
export const PrimitiveValueSchema = interf(
  {
    type: lit("PRIMITIVE"),
    value: id("ParameterValue"),
  },
  "PrimitiveValue",
);
export const ProfileCatalogSettingsSchema = interf(
  {
    type: lit("PROFILE_CATALOG_SETTINGS"),
    mergeCatalog: id("OptionalBoolean"),
    profileTable: pkTable("PROFILE_EXTRUSION_DESCRIPTOR", id("ProfileExtrusionDescriptor")),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "ProfileCatalogSettings",
);
export const ProfileEntitySchema = union([id("BoardProfileEntity"), id("CustomProfileEntity")], "ProfileEntity");
export const ProfileExtrusionDescriptorSchema = union(
  [id("BoardDescriptor"), id("CustomDescriptor")],
  "ProfileExtrusionDescriptor",
);
export const ProfileHandleSchema = interf(
  {
    type: lit("PROFILE"),
    id: str,
  },
  "ProfileHandle",
);
export const ProfileIdSchema = union([union([fk("PROFILE"), fk("PROFILE_EXTRUSION_DESCRIPTOR")])], "ProfileId");
export const PropAttributesSchema = interf(
  {
    id: pk("PROP"),
    name: str,
    propAssetId: union([fk("ASSET"), num]),
    category: id("PropCategory"),
    floorPlanTag: opt(str),
    defaultVerticalOffset: opt(num),
    floorMaterialOverride: opt(id("InteriorFloorMaterialOverride")),
    floorPlanTagOffsetX: opt(num),
    floorPlanTagOffsetY: opt(num),
    useExteriorPalette: id("OptionalBoolean"),
    isPlumbingArchitecturalProp: id("OptionalBoolean"),
    excludeFromFoundationPlanDimensions: id("OptionalBoolean"),
    isUtilityArchitecturalProp: id("OptionalBoolean"),
    isElectricalArchitecturalProp: id("OptionalBoolean"),
    hideTagOnElectricalPlan: id("OptionalBoolean"),
    takeoffDescription: opt(str),
    propBoundOrientation: opt(id("PropBoundOrientation")),
    viewNotes: opt(
      mapobj(
        lit("PROP"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "PropViewNoteTable",
      ),
    ),
    materialOverrides: opt(obj(id("FullMaterialSlot"), "PropMaterialOverrides")),
    uniformScale: id("OptionalBoolean"),
    scaleX: opt(num),
    scaleY: opt(num),
    scaleZ: opt(num),
    labels: fkTable("LABEL", bool),
    entityType: lit("PROP"),
    parentId: opt(str),
    sortIndex: num,
    catalogItemType: lit("PROP"),
  },
  "PropAttributes",
);
export const PropAttributesCustomSchema = interf(
  {
    id: pk("PROP"),
    name: str,
    propAssetId: union([fk("ASSET"), num]),
    category: id("PropCategory"),
    floorPlanTag: opt(str),
    defaultVerticalOffset: opt(num),
    floorMaterialOverride: opt(id("InteriorFloorMaterialOverride")),
    floorPlanTagOffsetX: opt(num),
    floorPlanTagOffsetY: opt(num),
    useExteriorPalette: id("OptionalBoolean"),
    isPlumbingArchitecturalProp: id("OptionalBoolean"),
    excludeFromFoundationPlanDimensions: id("OptionalBoolean"),
    isUtilityArchitecturalProp: id("OptionalBoolean"),
    isElectricalArchitecturalProp: id("OptionalBoolean"),
    hideTagOnElectricalPlan: id("OptionalBoolean"),
    takeoffDescription: opt(str),
    propBoundOrientation: opt(id("PropBoundOrientation")),
    viewNotes: opt(
      mapobj(
        lit("PROP"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "PropViewNoteTable",
      ),
    ),
    materialOverrides: opt(obj(id("FullMaterialSlot"), "PropMaterialOverrides")),
    uniformScale: id("OptionalBoolean"),
    scaleX: opt(num),
    scaleY: opt(num),
    scaleZ: opt(num),
    labels: fkTable("LABEL", bool),
    entityType: lit("PROP"),
    parentId: opt(str),
    sortIndex: num,
    catalogItemType: lit("PROP"),
  },
  "PropAttributesCustom",
);
export const PropAttributesHandleSchema = interf(
  {
    type: lit("PROP"),
    settingsHandle: opt(id("SettingsHandle")),
    id: str,
  },
  "PropAttributesHandle",
);
export const PropBoundOrientationSchema = enu(
  {
    [`LONG_PROP`]: "LONG_PROP",
    [`CENTER_PROP`]: "CENTER_PROP",
    [`CENTROID_PROP`]: "CENTROID_PROP",
  },
  "PropBoundOrientation",
);
export const PropCatalogTypeSchema = enu(
  {
    [`INTERIOR_PROP_CATALOG`]: "INTERIOR_PROP_CATALOG",
    [`EXTERIOR_PROP_CATALOG`]: "EXTERIOR_PROP_CATALOG",
    [`PROP_CATALOG`]: "PROP_CATALOG",
  },
  "PropCatalogType",
);
export const PropCategorySchema = enu(
  {
    [`APPLIANCES`]: "APPLIANCES",
    [`FIXTURES`]: "FIXTURES",
    [`FURNITURE`]: "FURNITURE",
    [`FOLIAGE`]: "FOLIAGE",
    [`OTHER`]: "OTHER",
  },
  "PropCategory",
);
export const PropInstanceSchema = union([id("PropInstanceV2"), id("PropInstanceV1")], "PropInstance");
export const PropInstanceHandleSchema = interf(
  {
    type: lit("PROP_INSTANCE"),
    id: str,
  },
  "PropInstanceHandle",
);
export const PropInstanceHorizontalAlignmentSchema = enu(
  {
    [`LEFT`]: "LEFT",
    [`CENTER`]: "CENTER",
    [`RIGHT`]: "RIGHT",
    [`ORIGIN`]: "ORIGIN",
  },
  "PropInstanceHorizontalAlignment",
);
export const PropInstanceLateralAlignmentSchema = enu(
  {
    [`OUTSIDE_FACE`]: "OUTSIDE_FACE",
    [`CENTERLINE`]: "CENTERLINE",
    [`INSIDE_FACE`]: "INSIDE_FACE",
    [`ORIGIN`]: "ORIGIN",
  },
  "PropInstanceLateralAlignment",
);
export const PropInstanceV1Schema = interf(
  {
    type: lit("WALL"),
    id: pk("PROP_INSTANCE"),
    parentId: opt(
      union([fk("ROOM", { hierarchy: ["PARENT"] }), fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    ),
    edgeId: str,
    catalogType: id("PropCatalogType"),
    propType: fk("PROP"),
    horizontalAlignment: id("PropInstanceHorizontalAlignment"),
    verticalDatum: id("PropInstanceVerticalDatumAnchor"),
    verticalAlignment: id("PropInstanceVerticalAlignment"),
    lateralAlignment: id("PropInstanceLateralAlignment"),
    rotation: num,
    mirrorPropX: id("OptionalBoolean"),
    mirrorPropY: id("OptionalBoolean"),
    floorMaterialOverride: opt(id("InteriorFloorMaterialOverride")),
    useExteriorPalette: id("OptionalBoolean"),
    viewNotes: opt(
      mapobj(
        lit("PROP"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "PropViewNoteTable",
      ),
    ),
    materialOverrides: opt(obj(id("FullMaterialSlot"), "PropMaterialOverrides")),
    floorPlanTag: opt(str),
    floorPlanTagOffsetX: opt(num),
    floorPlanTagOffsetY: opt(num),
    isExterior: id("OptionalBoolean"),
    verticalOffset: opt(num),
    lateralOffsetNormalized: id("OptionalBoolean"),
    useWallStripMaxOffset: id("OptionalBoolean"),
    placementStyle: id("PlacementStyleVersion"),
    horizontalDatum: union([undef, lit("ROOM_EDGE"), lit("STRUCTURE"), lit("SUBSTRATE"), lit("OUTSIDE_OF_SURFACE")]),
    param: num,
    paramNormalized: bool,
    lateralDatum: id("WallLateralDatumAnchorAll"),
    lateralOffset: num,
    paramAnchor: id("LineAnchor"),
    labels: fkTable("LABEL", bool),
    entityType: lit("PROP_INSTANCE"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    entityInstanceType: opt(id("EntityInstanceType")),
  },
  "PropInstanceV1",
);
export const PropInstanceV2Schema = interf(
  {
    type: lit("WALL_V2"),
    id: pk("PROP_INSTANCE"),
    parentId: opt(
      union([fk("ROOM", { hierarchy: ["PARENT"] }), fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    ),
    edgeId: str,
    catalogType: id("PropCatalogType"),
    propType: fk("PROP"),
    horizontalAlignment: id("PropInstanceHorizontalAlignment"),
    verticalDatum: id("PropInstanceVerticalDatumAnchor"),
    verticalAlignment: id("PropInstanceVerticalAlignment"),
    lateralAlignment: id("PropInstanceLateralAlignment"),
    rotation: num,
    mirrorPropX: id("OptionalBoolean"),
    mirrorPropY: id("OptionalBoolean"),
    floorMaterialOverride: opt(id("InteriorFloorMaterialOverride")),
    useExteriorPalette: id("OptionalBoolean"),
    viewNotes: opt(
      mapobj(
        lit("PROP"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "PropViewNoteTable",
      ),
    ),
    materialOverrides: opt(obj(id("FullMaterialSlot"), "PropMaterialOverrides")),
    floorPlanTag: opt(str),
    floorPlanTagOffsetX: opt(num),
    floorPlanTagOffsetY: opt(num),
    isExterior: id("OptionalBoolean"),
    verticalOffset: opt(num),
    lateralOffsetNormalized: id("OptionalBoolean"),
    useWallStripMaxOffset: id("OptionalBoolean"),
    placementStyle: id("PlacementStyleVersion"),
    horizontalDatum: union([undef, lit("ROOM_EDGE"), lit("STRUCTURE"), lit("SUBSTRATE"), lit("OUTSIDE_OF_SURFACE")]),
    param: num,
    paramNormalized: bool,
    lateralDatum: id("WallLateralDatumAnchorAll"),
    lateralOffset: num,
    paramAnchor: id("LineAnchor"),
    labels: fkTable("LABEL", bool),
    entityType: lit("PROP_INSTANCE"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    entityInstanceType: opt(id("EntityInstanceType")),
  },
  "PropInstanceV2",
);
export const PropInstanceVerticalAlignmentSchema = enu(
  {
    [`TOP`]: "TOP",
    [`CENTER`]: "CENTER",
    [`BOTTOM`]: "BOTTOM",
    [`ORIGIN`]: "ORIGIN",
  },
  "PropInstanceVerticalAlignment",
);
export const PropInstanceVerticalDatumAnchorSchema = enu(
  {
    [`LEVEL_FLOOR_ELEVATION`]: "LEVEL_FLOOR_ELEVATION",
    [`LEVEL_GRADE`]: "LEVEL_GRADE",
    [`ROOM_FLOOR_ELEVATION`]: "ROOM_FLOOR_ELEVATION",
  },
  "PropInstanceVerticalDatumAnchor",
);
export const PropThumbnailsSchema = interf(
  {
    small: opt(str),
    large: opt(str),
  },
  "PropThumbnails",
);
export const QRCodeSchema = interf(
  {
    detailType: lit("QR_CODE"),
    url: union([str, id("ParameterRef")]),
    size: num,
    id: pk("ANNOTATION"),
    handle: union([undef, id("RoomLayoutInstanceHandle"), id("AnnotationHandle"), id("ContentTemplateInstanceHandle")]),
    handleAuxiliary: union([undef, id("AnnotationHandle"), id("ContentTemplateInstanceHandle")]),
    name: str,
    positioningMethod: id("PositioningMethod"),
    edgeId: opt(str),
    parentId: opt(
      union(
        [
          fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }),
          fk("ROOM", { hierarchy: ["PARENT"] }),
          fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] }),
          fk("ELEVATION_VIEW", { hierarchy: ["PARENT"] }),
          fk("SECTION_VIEW", { hierarchy: ["PARENT"] }),
          fk("CONTENT_TEMPLATE_INSTANCE", { hierarchy: ["PARENT"] }),
          fk("LEVEL", { hierarchy: ["PARENT"] }),
        ],
        "DocEntityParentId",
      ),
    ),
    entityType: lit("ANNOTATION"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    entityInstanceType: opt(id("EntityInstanceType")),
    labels: fkTable("LABEL", bool),
    type: lit("DETAIL"),
    x: num,
    y: num,
    rotation: num,
  },
  "QRCode",
);
export const QueryPointSchema = interf(
  {
    type: lit("LEGACY"),
    roomId: fk("ROOM"),
    edgeId: str,
    param: num,
    paramNormalized: bool,
    reverse: bool,
  },
  "QueryPoint",
);
export const QueryPointUnionSchema = union(
  [id("QueryPoint"), id("ControllerPosition"), id("PlacementPoint")],
  "QueryPointUnion",
);
export const RailDefaultSchema = interf(
  {
    type: lit("RAIL_DEFAULT"),
    width: num,
    thickness: num,
  },
  "RailDefault",
);
export const RailingSchema = interf(
  {
    id: pk("RAILING"),
    entityType: lit("RAILING"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    levelId: fk("LEVEL"),
    ignoreStairsAndRoomsAbove: id("OptionalBoolean"),
    useNewRailingTerminationLogic: id("OptionalBoolean"),
    path: any,
    railingSettingId: fk("RAILING_SETTING"),
    settingsOverride: opt(partial(id("RailingDefaultSetting"))),
    disabled: id("FormulaDisabledField"),
    labels: fkTable("LABEL", bool),
  },
  "Railing",
);
export const RailingCatalogSettingsSchema = interf(
  {
    type: lit("RAILING_CATALOG_SETTINGS"),
    railingSettingsTable: pkTable("RAILING_SETTING", id("RailingDefaultSetting")),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "RailingCatalogSettings",
);
export const RailingDefaultSettingSchema = interf(
  {
    type: lit("RAILING_DEFAULT"),
    id: pk("RAILING_SETTING"),
    name: str,
    sortIndex: num,
    hasTopRail: bool,
    topRailHeight: opt(num),
    topRail: opt(id("RailDefault")),
    topRailMaterial: opt(id("MaterialSrc")),
    hasBottomRail: bool,
    bottomRailHeight: opt(num),
    bottomRail: opt(id("RailDefault")),
    bottomRailMaterial: opt(id("MaterialSrc")),
    includeRailInPlanDrawing: id("OptionalBoolean"),
    includeRailInShowRoomPlan: id("OptionalBoolean"),
    includeRailInBrochurePlan: id("OptionalBoolean"),
    hasPosts: bool,
    removeTransitionPosts: id("OptionalBoolean"),
    removeStartPost: bool,
    removeEndPost: bool,
    postHeight: opt(num),
    post: opt(id("PostDefault")),
    postMaterial: opt(id("MaterialSrc")),
    includePostsInPlanDrawing: id("OptionalBoolean"),
    includePostsInShowRoomPlan: id("OptionalBoolean"),
    includePostsInBrochurePlan: id("OptionalBoolean"),
    infillStyle: id("RailingInfillStyle"),
    infillDepth: opt(num),
    baluster: opt(id("BalusterDefault")),
    infillMaterial: opt(id("MaterialSrc")),
    viewNotes: opt(
      mapobj(
        lit("RAILING"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "RailingViewNoteTable",
      ),
    ),
    catalogItemType: lit("RAILING_SETTING"),
    entityType: lit("RAILING_SETTING"),
    parentId: opt(str),
  },
  "RailingDefaultSetting",
);
export const RailingHandleSchema = interf(
  {
    type: lit("RAILING"),
    id: str,
  },
  "RailingHandle",
);
export const RailingInfillStyleSchema = enu(
  {
    [`BALUSTERS`]: "BALUSTERS",
    [`SOLID`]: "SOLID",
    [`NONE`]: "NONE",
  },
  "RailingInfillStyle",
);
export const RailingPostHandleSchema = interf(
  {
    type: lit("RAILING_POST"),
    id: str,
  },
  "RailingPostHandle",
);
export const RailingSettingHandleSchema = interf(
  {
    type: lit("RAILING_SETTING"),
    id: str,
  },
  "RailingSettingHandle",
);
export const RakeFriezeBoardModeSchema = enu(
  {
    [`WALL_AND_SOFFIT`]: "WALL_AND_SOFFIT",
    [`WALL`]: "WALL",
  },
  "RakeFriezeBoardMode",
);
export const RangeFilterSchema = union(
  [
    inters([partial(id("BaseRangeFilter")), pick(id("BaseRangeFilter"), lit("minimum"))]),
    inters([partial(id("BaseRangeFilter")), pick(id("BaseRangeFilter"), lit("maximum"))]),
    inters([partial(id("BaseRangeFilter")), pick(id("BaseRangeFilter"), lit("negate"))]),
  ],
  "RangeFilter",
);
export const RearPorchSettingsSchema = interf(
  {
    type: lit("REAR_PORCH_SETTINGS"),
    parentId: opt(
      union(
        [fk("ROOM", { hierarchy: ["PARENT"] }), fk("SETTINGS_SET", { hierarchy: ["PARENT"] })],
        "DocEntityParentId",
      ),
    ),
    name: opt(str),
    endSegmentJoinTolerance: opt(num),
    minColumnSpacing: opt(num),
    maxColumnSpacing: num,
    doorPathColumnSpread: opt(num),
    doorPathColumnSpreadMode: opt(id("DoorPathColumnSpreadMode")),
    colonnadeTerminationRules: arr(id("ColonnadeTerminationRule")),
    includeRailing: bool,
    upperFloorIncludeRailing: id("OptionalBoolean"),
    columnLateralOffset: opt(num),
    headerLateralOffset: opt(num),
    foundationOffset: opt(num),
    baseColumnOffset: bool,
    multiColumn: id("OptionalBoolean"),
    multiColumnSpread: opt(num),
    multiColumnFrontOnly: id("OptionalBoolean"),
    topOfHeaderHeightOffset: opt(num),
    frontColonnadeColumnOverride: id("OptionalBoolean"),
    colonnadeOverrideValues: opt(arr(num)),
    internalColumnStructureSize: num,
    internalHeaderStructureWidth: num,
    headerDepth: opt(num),
    headerCasingThickness: num,
    headerCasingOffsetFromCenterLine: num,
    headerCasingMaterial: opt(id("ExteriorMaterial")),
    columnCasingOffset: num,
    columnId: opt(fk("COLUMN_DESCRIPTOR")),
    removeHeader: id("OptionalBoolean"),
    removeColumns: id("OptionalBoolean"),
    viewNotes: opt(
      mapobj(
        enu(
          {
            [`COLUMN_BRACKET`]: "COLUMN_BRACKET",
            [`PORCH_RAILING`]: "PORCH_RAILING",
            [`PORCH_HEADER`]: "PORCH_HEADER",
          },
          "PorchViewNoteType",
        ),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "PorchViewNoteTable",
      ),
    ),
    porchHeaderTrimProfile: opt(id("ProfileId")),
    porchHeaderTrimAlignment: opt(id("PorchHeaderTrimAlignment")),
    porchHeaderTrimJustification: opt(id("TrimJustification")),
    porchHeaderTrimOffset: opt(num),
    porchHeaderTrimDepthOffset: opt(num),
    porchHeaderTrimMaterial: opt(id("ExteriorMaterial")),
    columnBracketPropId: opt(id("BuiltInExteriorPropId")),
    porchPlanSettings: opt(id("PorchPlanSettings")),
    excludeFromPorchMerge: id("OptionalBoolean"),
  },
  "RearPorchSettings",
);
export const RectangularArraySchema = interf(
  {
    layoutType: lit("RECTANGULAR_ARRAY"),
    controllerPlacementType: opt(arr(id("ControllerSelectionConfig"))),
    endControllerPlacementType: opt(arr(id("ControllerSelectionConfig"))),
    loadType: fk("LOAD_DESCRIPTOR"),
    loadDescriptor: id("LoadDescriptor"),
    xQuantity: opt(num),
    xSpacingType: opt(id("SpacingType")),
    xSpacing: opt(num),
    xShift: opt(num),
    yQuantity: opt(num),
    ySpacingType: opt(id("SpacingType")),
    ySpacing: opt(num),
    yShift: opt(num),
    minDistToWall: opt(num),
    trimToRoom: bool,
    roomBoundaryType: opt(id("RoomBoundaryType")),
  },
  "RectangularArray",
);
export const RectangularCIPPierEntitySchema = interf(
  {
    pierLength: num,
    pierWidth: num,
    pierDepth: opt(num),
    pierType: lit("RECTANGULAR_CIP"),
    id: pk("FOUNDATION_COMPONENT"),
    name: str,
    componentType: lit("PIER"),
    material: opt(id("ExteriorMaterial")),
    entityType: lit("FOUNDATION_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "RectangularCIPPierEntity",
);
export const RectangularCMUPierEntitySchema = interf(
  {
    pierLength: num,
    pierWidth: num,
    pierDepth: opt(num),
    pierType: lit("RECTANGULAR_CMU"),
    id: pk("FOUNDATION_COMPONENT"),
    name: str,
    componentType: lit("PIER"),
    material: opt(id("ExteriorMaterial")),
    entityType: lit("FOUNDATION_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "RectangularCMUPierEntity",
);
export const RectangularIsolatedFootingEntitySchema = interf(
  {
    footingLength: num,
    footingWidth: num,
    footingDepth: num,
    footingType: lit("RECTANGULAR_ISOLATED"),
    id: pk("FOUNDATION_COMPONENT"),
    name: str,
    componentType: lit("FOOTING"),
    material: opt(id("ExteriorMaterial")),
    entityType: lit("FOUNDATION_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "RectangularIsolatedFootingEntity",
);
export const ReferenceGeomSchema = interf(
  {
    id: pk("REFERENCE_GEOM"),
    type: lit("POLYLINE2"),
    name: str,
    geom: any,
    edgeIds: arr(str),
    entityType: lit("REFERENCE_GEOM"),
    parentId: opt(str),
    sortIndex: num,
  },
  "ReferenceGeom",
);
export const ReferenceGeomHandleSchema = interf(
  {
    type: lit("REFERENCE_GEOM"),
    id: str,
  },
  "ReferenceGeomHandle",
);
export const RelaxationObstacleEffectSchema = interf(
  {
    type: lit("RELAXATION_OBSTACLE"),
    targetCategory: union([
      nul,
      lit("UNDEFINED"),
      lit("RELAXATION_DEBUG"),
      lit("FOOTING"),
      lit("SLAB"),
      lit("FOUNDATION_OUTLINE"),
      lit("SLAB_ABOVE"),
      lit("SLAB_BELOW"),
      lit("SLAB_PATIO"),
      lit("SLAB_TAG"),
      lit("BRICKLEDGE_CUT"),
      lit("BRICKLEDGE_PROJECTED"),
      lit("FOUNDATION_CURB"),
      lit("STAIR"),
      lit("STAIR_PROJECTED"),
      lit("STAIR_ABOVE"),
      lit("STAIR_BREAK_LINE"),
      lit("STEM_WALL_UNIONED_EDGES"),
      lit("STEM_WALL"),
      lit("STEM_WALL_ABOVE"),
      lit("STEM_WALL_ABOVE_GAPS"),
      lit("STEM_WALL_BELOW"),
      lit("PIER"),
      lit("PIER_HIDDEN"),
      lit("FOUNDATION_DASHED_LINEWORK"),
      lit("FOUNDATION_SOLID_LINEWORK"),
      lit("UTILITY_FOUNDATION_LINEWORK"),
      lit("ANNOT_LINEWORK"),
      lit("ANNOT_NOTE"),
      lit("ANNOT_DETAIL"),
      lit("ANNOT_DIM_GROUP"),
      lit("ANNOT_DIM_LABEL"),
      lit("ANNOT_DIM_LINE"),
      lit("ANNOT_DIM_LINEWORK"),
      lit("ANNOT_DIM_TICK"),
      lit("ANNOT_DIM_WITNESS"),
      lit("ALL_LVL_ANNOT_LINEWORK"),
      lit("ALL_LVL_ANNOT_NOTE"),
      lit("ALL_LVL_ANNOT_DETAIL"),
      lit("ALL_LVL_ANNOT_DIM_GROUP"),
      lit("ALL_LVL_ANNOT_DIM_LABEL"),
      lit("ALL_LVL_ANNOT_DIM_LINE"),
      lit("ALL_LVL_ANNOT_DIM_LINEWORK"),
      lit("ALL_LVL_ANNOT_DIM_TICK"),
      lit("ALL_LVL_ANNOT_DIM_WITNESS"),
      lit("TOP_OF_PLATE_MARKERS"),
      lit("TOP_OF_PLATE_DIMENSIONS"),
      lit("DORMER_WINDOW_VERTICAL_DIMENSIONS"),
      lit("DORMER_WINDOW_TAGS"),
      lit("ROOF_TRUNCATION_HEIGHT_DIMENSIONS"),
      lit("ROOF_HORIZONTAL_PLACEMENT_DIMENSIONS"),
      lit("ROOF_WIDTH_DIMENSIONS"),
      lit("ROOF_GABLE_WINDOW_VERTICAL_DIMENSIONS"),
      lit("ROOF_GABLE_WINDOW_TAGS"),
      lit("ROOF_DIM_ANNOTATION"),
      lit("ROOF_SLOPE_SYMBOL"),
      lit("WINDOW_HEADER_ANNOTATION"),
      lit("ELEVATION_MARKERS"),
      lit("MATERIAL_TAGS"),
      lit("GRADE_LINE"),
      lit("ELECTRICAL_CONTROLLERS"),
      lit("ELECTRICAL_LINKS"),
      lit("ELECTRICAL_LOADS"),
      lit("ELECTRIC_LOAD_LABEL"),
      lit("PROP_FILL"),
      lit("PROP_APPLIANCES"),
      lit("PROP_FIXTURES"),
      lit("PROP_FURNITURE"),
      lit("PROP_OTHER"),
      lit("PROP_FOLIAGE"),
      lit("PROP_TAG"),
      lit("COLUMN"),
      lit("DIM_LABEL"),
      lit("DIM_LINE"),
      lit("DIM_LINEWORK"),
      lit("DIM_TICK"),
      lit("DIM_WITNESS"),
      lit("DIM_GROUP"),
      lit("FOUNDATION_DIM_LABEL"),
      lit("FOUNDATION_DIM_LINE"),
      lit("FOUNDATION_DIM_LINEWORK"),
      lit("FOUNDATION_DIM_TICK"),
      lit("FOUNDATION_DIM_WITNESS"),
      lit("FOUNDATION_DIM_GROUP"),
      lit("UTILITY_DIM_LABEL"),
      lit("UTILITY_DIM_LINEWORK"),
      lit("UTILITY_DIM_TICK"),
      lit("UTILITY_DIM_WITNESS"),
      lit("WALL_INTERIOR_DIM_LABEL"),
      lit("WALL_INTERIOR_DIM_LINE"),
      lit("WALL_INTERIOR_DIM_LINEWORK"),
      lit("WALL_INTERIOR_DIM_TICK"),
      lit("WALL_INTERIOR_DIM_WITNESS"),
      lit("WALL_INTERIOR_DIM_GROUP"),
      lit("WALL_EXTERIOR_DIM_LABEL"),
      lit("WALL_EXTERIOR_DIM_LINE"),
      lit("WALL_EXTERIOR_DIM_LINEWORK"),
      lit("WALL_EXTERIOR_DIM_TICK"),
      lit("WALL_EXTERIOR_DIM_WITNESS"),
      lit("WALL_EXTERIOR_DIM_GROUP"),
      lit("ROOF_OVERHANG_DIM_LABEL"),
      lit("ROOF_OVERHANG_DIM_LINE"),
      lit("ROOF_OVERHANG_DIM_LINEWORK"),
      lit("ROOF_OVERHANG_DIM_TICK"),
      lit("ROOF_OVERHANG_DIM_WITNESS"),
      lit("ROOF_OVERHANG_DIM_GROUP"),
      lit("CONDITION_TAG"),
      lit("CEILING"),
      lit("RAILING"),
      lit("RAILING_PROJECTED"),
      lit("RAILING_ABOVE"),
      lit("RAILING_PROJECTED_STAIR_ONLY"),
      lit("RAILING_ABOVE_STAIR_ONLY"),
      lit("RAILING_POST"),
      lit("RAILING_POST_STAIR_ONLY"),
      lit("PORCH_COLUMNS"),
      lit("PORCH_BEAMS"),
      lit("PORCH"),
      lit("DECK"),
      lit("PERIMS_WALL"),
      lit("FLOOR_HEIGHT_DIFFERENCE"),
      lit("PERIMS_FLOORPLATE"),
      lit("FLOOR_FILL"),
      lit("FLOOR_AREA_CONDITIONED"),
      lit("FLOOR_AREA_UNCONDITIONED"),
      lit("WALLS"),
      lit("WALL_BOUNDARIES"),
      lit("WALL_CORE"),
      lit("WALL_SUBSTRATE"),
      lit("WALL_EXTERIOR_FINISH"),
      lit("WALL_EXTERIOR_FINISH_PROJECTED"),
      lit("STAIR_WALLS"),
      lit("CHASE_ROOMS"),
      lit("CASEWORK"),
      lit("CASEWORK_SOLID_DASH"),
      lit("CASEWORK_POCHE"),
      lit("WAINSCOTING"),
      lit("WAINSCOTING_CUT"),
      lit("WAINSCOTING_PROJECTED"),
      lit("DOORS"),
      lit("DOOR_OPERATION_LINEWORK"),
      lit("DOOR_CASING_CUT"),
      lit("WINDOWS"),
      lit("WINDOW_CASING_CUT"),
      lit("WINDOW_CASING_PROJECTED"),
      lit("ROOM_LABELS"),
      lit("WINDOW_TAGS"),
      lit("DOOR_TAGS"),
      lit("HEADER_FRAMING_TAGS"),
      lit("CASEWORK_TAG"),
      lit("OPENING_TAGS"),
      lit("INTERIOR_LABELS"),
      lit("ROOF"),
      lit("FLOOR_FINISH"),
      lit("FLOOR_FRAMING"),
      lit("FLOOR_FRAMING_LABEL"),
      lit("FLOOR_SYSTEM_TAG"),
      lit("SITE_SHAPE_CONTOURS"),
      lit("SITE_SHAPE_ELEVATION_TAGS"),
      lit("SITE_SHAPE_DRIVEWAYS"),
      lit("SITE_SHAPE_ROADS"),
      lit("ROOF_PERIMS"),
      lit("ROOF_PERIMS_WITH_LEVEL_PERIMS"),
      lit("ROOF_RIDGE_VENT"),
      lit("ROOF_RIDGE_VENT_ANNOS"),
      lit("ROOF_SLOPE_ANNOS"),
      lit("ROOF_SKYLIGHT_ANNOS"),
      lit("ROOF_DORMER_FRAMING"),
      lit("ROOF_FRAMING"),
      lit("FOUNDATION_FOOTING"),
      lit("FOUNDATION_PIER"),
      lit("TRIM"),
      lit("ROOF_FRIEZE_BOARD"),
      lit("ROOF_FASCIA_BOARD"),
      lit("ROOF_SOFFIT"),
      lit("ROOF_FASCIA_TOP_TRIM"),
      lit("ROOF_BELLY_BAND_BOARD"),
      lit("ROOF_WALL_BASE_BOARD"),
      lit("ROOF_EXPOSED_RAFTER"),
      lit("ROOF_GABLE_VENT"),
      lit("CORNER_BOARD"),
      lit("WALL_FRAMING"),
      lit("SUB_FLOORING"),
      lit("DEBUG_ELEVATION_COLLIDERS"),
      lit("DEBUG_ELEVATION_NOTE_ENTITIES"),
      lit("SKYLIGHTS"),
      lit("SECTION_VIEW_CALLOUT"),
    ]),
    id: pk("EFFECT"),
    categories: arr(id("SheetGeometryCategory")),
    parentId: opt(union([fk("VIEW_TEMPLATE_OVERRIDE", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
    entityType: lit("EFFECT"),
    name: str,
    sortIndex: num,
  },
  "RelaxationObstacleEffect",
);
export const ReportableUnitDesignationSchema = interf(
  {
    id: pk("REPORTABLE_UNIT_DESIGNATION"),
    labelId: fk("LABEL"),
    entityType: lit("REPORTABLE_UNIT_DESIGNATION"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "ReportableUnitDesignation",
);
export const ReportableUnitDesignationHandleSchema = interf(
  {
    type: lit("REPORTABLE_UNIT_DESIGNATION"),
    id: str,
  },
  "ReportableUnitDesignationHandle",
);
export const RetainingWallSiteShapeSchema = interf(
  {
    type: lit("RETAINING_WALL"),
    zHeight: num,
    height: opt(num),
    material: opt(id("ExteriorMaterial")),
    id: pk("SITE_SHAPE"),
    parentId: union([fk("SITE", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    geom: any,
    entityType: lit("SITE_SHAPE"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "RetainingWallSiteShape",
);
export const RoadSiteShapeSchema = interf(
  {
    type: lit("ROAD"),
    isConformal: id("OptionalBoolean"),
    material: opt(id("ExteriorMaterial")),
    id: pk("SITE_SHAPE"),
    parentId: union([fk("SITE", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    geom: any,
    entityType: lit("SITE_SHAPE"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    zHeight: num,
    height: opt(num),
  },
  "RoadSiteShape",
);
export const RoofSchema = interf(
  {
    id: pk("ROOF"),
    parentId: union([fk("ROOF_SYSTEM", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    entityType: lit("ROOF"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    roofVersion: num,
    blocks: id("RoofBlocks"),
    lowRailIndexForPeakDirection: opt(num),
    gableEndLabels: opt(arr(id("GableLabel"))),
    wallRoofBaseBoard: opt(id("WallRoofBaseBoardMode")),
    wallRoofBaseBoardFilter: opt(id("WallRoofBaseBoardFilter")),
    wallRoofBaseBoardProfile: opt(id("ProfileId")),
    suppressWallExtension: id("OptionalBoolean"),
    parentNeighbors: opt(arr(str)),
    flattenLeftSideSlopes: id("OptionalBoolean"),
    flattenRightSideSlopes: id("OptionalBoolean"),
    roofSideOverrides: mapobj(
      id("RoofSide"),
      interf(
        {
          overhang: opt(num),
          slope: union([undef, num, id("Formula")]),
          slopeOptions: opt(arr(id("RoofSlopeOptions"))),
          truncationType: opt(id("RoofTruncationType")),
          truncationSlopeType: opt(id("TruncationSlopeType")),
          truncationSlope: union([undef, num, id("Formula")]),
          framingType: opt(id("RoofWallFramingType")),
          includeTriangleGableVent: id("OptionalBoolean"),
          triangleGableVentBaseWidth: union([undef, num, id("Formula")]),
          includeFasciaTopTrim: id("OptionalBoolean"),
          fasciaTopTrimSize: opt(num),
          gableBellyBandBoard: opt(id("ProfileId")),
          gableBellyBandBoardMaterial: opt(id("ExteriorMaterial")),
          gableBellyBandBoardAnchor: opt(id("WallVerticalDatumAnchor")),
          gableBellyBandBoardJustification: opt(id("VerticalJustification")),
          gableBellyBandBoardOffset: opt(num),
          friezeBoard: opt(arr(id("FriezeBoard"))),
          friezeBoardMaterialLegacy: opt(id("ExteriorMaterial")),
          includeFriezeBoardLegacy: union([
            union([fk("PROFILE"), fk("PROFILE_EXTRUSION_DESCRIPTOR")]),
            undef,
            lit(false),
            lit(true),
          ]),
          wrapFriezeBoardMode: opt(id("WrapFriezeBoardMode")),
          includeRakeBrackets: id("OptionalBoolean"),
          rakeBracketPropId: opt(fk("PROP")),
          rakeBracketAtPeak: id("OptionalBoolean"),
          rakeBracketParams: opt(arr(num)),
          rakeBracketParamsNormalized: id("OptionalBoolean"),
          rakeBracketTruncationParams: opt(arr(num)),
          soffitMaterial: opt(id("ExteriorMaterial")),
          fasciaMaterial: opt(id("ExteriorMaterial")),
          fasciaTopTrimMaterial: opt(id("ExteriorMaterial")),
          fasciaSize: opt(num),
          soffitOffset: opt(num),
          includeEaveBrackets: id("OptionalBoolean"),
          eaveBracketPropId: opt(fk("PROP")),
          eaveBracketParams: opt(arr(num)),
          eaveBracketParamsNormalized: id("OptionalBoolean"),
          eaveBracketPlacement: opt(id("EaveBracketPlacement")),
          eaveCutType: opt(id("EaveCutType")),
          heelHeightOffset: union([undef, num, id("Formula")]),
          normalizedHeelHeightOffset: id("OptionalBoolean"),
        },
        "RoofEdgeOverrides",
      ),
      true,
      "RoofSideOverridesTable",
    ),
    roofEdgeOverrides: interf({}),
    flags: opt(
      mapobj(
        enu(
          {
            [`LEGACY_TRUNCATION`]: "LEGACY_TRUNCATION",
            [`LEGACY_HEEL_HEIGHT_OFFSETS`]: "LEGACY_HEEL_HEIGHT_OFFSETS",
            [`LEGACY_SLOPE`]: "LEGACY_SLOPE",
            [`LEGACY_EAVE_RETURNS`]: "LEGACY_EAVE_RETURNS",
          },
          "RoofFlags",
        ),
        bool,
        true,
        "RoofFlagsTable",
      ),
    ),
    roofSettings: opt(partial(id("RoofSettings"))),
    dormerSettings: opt(partial(id("DormerSettings"))),
    roofPlanSettings: opt(partial(id("RoofPlanSettings"))),
    roofElevationPlanSettings: opt(partial(id("RoofElevationPlanSettings"))),
    labels: fkTable("LABEL", bool),
  },
  "Roof",
);
export const RoofBlockInstanceRefSchema = interf(
  {
    entityId: fk("BLOCK"),
    componentInstanceChain: opt(id("ForeignKeyPathOf")),
  },
  "RoofBlockInstanceRef",
);
export const RoofBlocksSchema = union(
  [fk("BLOCK"), arr(fk("BLOCK")), id("RoofBlockInstanceRef"), arr(id("RoofBlockInstanceRef")), id("VirtualRoofBlock")],
  "RoofBlocks",
);
export const RoofBoundaryTypeSchema = enu(
  {
    [`BOUNDING_BOX`]: "BOUNDING_BOX",
    [`CLIP_TO_PERIMETER`]: "CLIP_TO_PERIMETER",
  },
  "RoofBoundaryType",
);
export const RoofDormerPlacementSchema = interf(
  {
    id: pk("DORMER"),
    name: str,
    windowVerticalOffset: opt(num),
    gableOpeningPlacement: opt(id("RoofOpeningPlacement")),
    windowType: opt(fk("WINDOW_DESCRIPTOR")),
    awning: opt(id("Awning")),
    useNewPlacementMethod: id("OptionalBoolean"),
    dormerPlanSettings: opt(partial(id("DormerPlanSettings"))),
    dormerSettings: opt(partial(id("DormerSettings"))),
    dormerElevationPlanSettings: opt(partial(id("DormerElevationPlanSettings"))),
    parentId: opt(union([fk("ROOF", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
    entityType: lit("DORMER"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    reportedName: opt(str),
    operationType: opt(id("WindowOperationType")),
    paneSplitParam: opt(num),
    paneSplitParamNormalized: id("OptionalBoolean"),
    verticalDivisionSpacing: opt(num),
    framing: opt(partial(id("WindowWallFramingSettings"))),
    wrapping: opt(partial(id("WindowWallWrappingSettings"))),
    materials: opt(partial(id("WindowMaterialSettings"))),
    mullions: opt(
      union([partial(id("GridWindowMullionSettings")), partial(id("DisabledWindowMullionSettings"))], "Partial"),
    ),
    shutters: opt(
      union(
        [
          partial(id("DisabledShutterSettings")),
          partial(id("VentedShutterSettings")),
          partial(id("SimpleSlatShutterSettings")),
          partial(id("PanelShutterSettings")),
          partial(id("ZShutterSettings")),
          partial(id("GenericShutterSettings")),
        ],
        "Partial",
      ),
    ),
    exteriorCasing: opt(
      union(
        [
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingNone"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingTrim"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingSlices"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingStone"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingJackArch"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingFullArch"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingArchedSlices"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingEyebrowTrim"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
        ],
        "Partial",
      ),
    ),
    interiorCasing: opt(partial(id("InteriorWindowCasingSettings"))),
    awningSettings: opt(union([partial(id("ShedAwningSettings")), partial(id("DisabledAwningSettings"))], "Partial")),
    bugScreen: id("OptionalBoolean"),
    viewNotes: opt(
      mapobj(
        lit("WINDOW"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "WindowViewNoteTable",
      ),
    ),
    disableAutoDimensions: id("OptionalBoolean"),
    roughOpeningSettings: opt(partial(id("WindowRoughOpeningSettings"))),
    windowHeadHeight: opt(num),
    tagOffset: opt(num),
    tagDetails: opt(str),
  },
  "RoofDormerPlacement",
);
export const RoofElevationPlanSettingsSchema = interf(
  {
    showRoofWidthDims: id("OptionalBoolean"),
    showRoofHorizontalPlacementDims: id("OptionalBoolean"),
    showRoofSlopeElevationAnnotation: id("OptionalBoolean"),
    showRoofGableWindowVerticalDims: id("OptionalBoolean"),
    showRoofGableWindowReportedName: id("OptionalBoolean"),
    showRoofTruncationHeightDims: id("OptionalBoolean"),
    showDormerWindowVerticalDimensions: id("OptionalBoolean"),
    showDormerWindowReportedName: id("OptionalBoolean"),
    showDormerWallFramingHeightDimensions: id("OptionalBoolean"),
    showDormerWallFramingWidthDimensions: id("OptionalBoolean"),
    showDormerGableWindowVerticalDims: id("OptionalBoolean"),
    showDormerGableWindowReportedName: id("OptionalBoolean"),
    showDormerRoofWidthDims: id("OptionalBoolean"),
    showDormerHorizontalPlacementDims: id("OptionalBoolean"),
    showDormerRoofSlopeElevationAnnotation: id("OptionalBoolean"),
    showDormerRoofTruncationHeightDims: id("OptionalBoolean"),
  },
  "RoofElevationPlanSettings",
);
export const RoofFacesSchema = enu(
  {
    [`ALL`]: "ALL",
    [`FRONT_AND_BACK`]: "FRONT_AND_BACK",
    [`LEFT_AND_RIGHT`]: "LEFT_AND_RIGHT",
    [`FRONT`]: "FRONT",
    [`BACK`]: "BACK",
    [`LEFT`]: "LEFT",
    [`RIGHT`]: "RIGHT",
  },
  "RoofFaces",
);
export const RoofFramingSettingsSchema = interf(
  {
    type: lit("ROOF_FRAMING_SETTINGS"),
    startFramingType: opt(id("RoofWallFramingType")),
    endFramingType: opt(id("RoofWallFramingType")),
    eaveFramingType: opt(id("RoofWallFramingType")),
  },
  "RoofFramingSettings",
);
export const RoofFramingSpacingMethodSchema = enu(
  {
    [`EQUAL_SPACING_BEGIN_END`]: "EQUAL_SPACING_BEGIN_END",
    [`EQUAL_SPACING_BEGIN`]: "EQUAL_SPACING_BEGIN",
    [`EQUAL_SPACING_END`]: "EQUAL_SPACING_END",
  },
  "RoofFramingSpacingMethod",
);
export const RoofFramingTypeSchema = enu(
  {
    [`RAFTER`]: "RAFTER",
    [`TRUSS`]: "TRUSS",
  },
  "RoofFramingType",
);
export const RoofHandleSchema = interf(
  {
    type: lit("ROOF"),
    id: str,
  },
  "RoofHandle",
);
export const RoofOpeningHandleSchema = interf(
  {
    type: lit("ROOF_OPENING"),
    id: str,
  },
  "RoofOpeningHandle",
);
export const RoofOpeningJustificationSchema = enu(
  {
    [`BASE_UP`]: "BASE_UP",
    [`PEAK_DOWN`]: "PEAK_DOWN",
  },
  "RoofOpeningJustification",
);
export const RoofOpeningPlacementSchema = interf(
  {
    id: pk("ROOF_OPENING"),
    parentId: opt(union([fk("ROOF", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
    name: str,
    windowType: union([fk("WINDOW_DESCRIPTOR")]),
    justification: opt(id("RoofOpeningJustification")),
    offset: union([undef, num, id("Formula")]),
    horizontalOffset: opt(num),
    awning: opt(id("Awning")),
    useNewPlacementMethod: id("OptionalBoolean"),
    side: opt(id("RoofSide")),
    useLegacyAttachmentSettings: id("OptionalBoolean"),
    entityType: lit("ROOF_OPENING"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    reportedName: opt(str),
    operationType: opt(id("WindowOperationType")),
    paneSplitParam: opt(num),
    paneSplitParamNormalized: id("OptionalBoolean"),
    verticalDivisionSpacing: opt(num),
    framing: opt(partial(id("WindowWallFramingSettings"))),
    wrapping: opt(partial(id("WindowWallWrappingSettings"))),
    materials: opt(partial(id("WindowMaterialSettings"))),
    mullions: opt(
      union([partial(id("GridWindowMullionSettings")), partial(id("DisabledWindowMullionSettings"))], "Partial"),
    ),
    shutters: opt(
      union(
        [
          partial(id("DisabledShutterSettings")),
          partial(id("VentedShutterSettings")),
          partial(id("SimpleSlatShutterSettings")),
          partial(id("PanelShutterSettings")),
          partial(id("ZShutterSettings")),
          partial(id("GenericShutterSettings")),
        ],
        "Partial",
      ),
    ),
    exteriorCasing: opt(
      union(
        [
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingNone"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingTrim"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingSlices"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingStone"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingJackArch"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingFullArch"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingArchedSlices"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingEyebrowTrim"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
        ],
        "Partial",
      ),
    ),
    interiorCasing: opt(partial(id("InteriorWindowCasingSettings"))),
    awningSettings: opt(union([partial(id("ShedAwningSettings")), partial(id("DisabledAwningSettings"))], "Partial")),
    bugScreen: id("OptionalBoolean"),
    viewNotes: opt(
      mapobj(
        lit("WINDOW"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "WindowViewNoteTable",
      ),
    ),
    disableAutoDimensions: id("OptionalBoolean"),
    roughOpeningSettings: opt(partial(id("WindowRoughOpeningSettings"))),
    windowHeadHeight: opt(num),
    tagOffset: opt(num),
    tagDetails: opt(str),
  },
  "RoofOpeningPlacement",
);
export const RoofPeakDirectionSchema = enu(
  {
    [`AUTO`]: "AUTO",
    [`VERTICAL`]: "VERTICAL",
    [`HORIZONTAL`]: "HORIZONTAL",
    [`BY_LOW_RAIL_INDEX`]: "BY_LOW_RAIL_INDEX",
    [`BY_GABLE_END_RAIL_INDEX`]: "BY_GABLE_END_RAIL_INDEX",
  },
  "RoofPeakDirection",
);
export const RoofPlanSettingsSchema = interf(
  {
    includeRoofOverhangDimensions: id("OptionalBoolean"),
    includeRoofSlopeAnnotation: id("OptionalBoolean"),
    includeDormerOverhangDimensions: id("OptionalBoolean"),
    includeDormerDashedFraming: id("OptionalBoolean"),
    includeDormerRoofSlopeAnnotation: id("OptionalBoolean"),
  },
  "RoofPlanSettings",
);
export const RoofSettingsSchema = interf(
  {
    type: lit("ROOF_SETTINGS"),
    weldMode: opt(id("RoofWeldMode")),
    peakDirection: opt(id("RoofPeakDirection")),
    boundaryType: opt(id("RoofBoundaryType")),
    roofType: opt(id("GableRoofType")),
    startTruncationType: opt(id("RoofTruncationType")),
    startTruncationHeightFactor: opt(num),
    startTruncationNormalizedHeight: id("OptionalBoolean"),
    startTruncationSlopeType: opt(id("TruncationSlopeType")),
    startTruncationSlope: opt(num),
    endTruncationType: opt(id("RoofTruncationType")),
    endTruncationHeightFactor: opt(num),
    endTruncationNormalizedHeight: id("OptionalBoolean"),
    endTruncationSlopeType: opt(id("TruncationSlopeType")),
    endTruncationSlope: opt(num),
    structureType: opt(id("RoofStructureType")),
    roofWallMode: opt(id("RoofWallMode")),
    vaultedRoofThickness: opt(num),
    vaultedRoofRightThickness: opt(num),
    slope: union([undef, num, id("Formula")]),
    slopes: opt(arr(id("RoofSlopeOptions"))),
    rightSlope: union([undef, num, id("Formula")]),
    rightSlopes: opt(arr(id("RoofSlopeOptions"))),
    eaveFasciaSize: num,
    rakeFasciaSize: num,
    soffitOffset: opt(num),
    includeFasciaTopTrim: bool,
    includeEaveReturnFasciaTopTrim: id("OptionalBoolean"),
    fasciaTopTrimSize: num,
    eaveOverhang: union([num, id("Formula")]),
    rakeOverhang: union([num, id("Formula")]),
    overhangSideOffset: opt(num),
    overhangRearOffset: opt(num),
    overhangDatum: opt(id("WallLateralDatumAnchor")),
    eaveType: id("EaveType"),
    eaveCutType: opt(id("EaveCutType")),
    addRafterTailExtension: id("OptionalBoolean"),
    rafterTailExtensionEdgeOffset: opt(num),
    rafterTailExtension: opt(num),
    rafterTailDepth: opt(num),
    rafterTailClosed: id("OptionalBoolean"),
    lookoutRafters: id("OptionalBoolean"),
    flyRafters: id("OptionalBoolean"),
    flyRafterSize: opt(num),
    fullReturnOrientation: opt(id("StreetOrientationMode")),
    miniHipOrientation: opt(id("StreetOrientationMode")),
    eaveReturnRoofSlope: opt(num),
    eaveReturnRoofMaterial: opt(id("ExteriorMaterial")),
    eaveReturnDistance: opt(num),
    eaveReturnOverhang: opt(num),
    eaveExtensionAtCoplanarRake: opt(num),
    eaveExtensionAtNonCoplanarRake: opt(num),
    eaveExtensionAtCoplanarWall: opt(num),
    rakeExtensionAtCoplanarWall: opt(num),
    eaveFasciaHeightDatum: opt(id("EaveFasciaHeightDatum")),
    eaveFasciaHeightOffset: opt(num),
    eaveLeftFasciaHeightOffsetOverride: opt(num),
    eaveRightFasciaHeightOffsetOverride: opt(num),
    friezeBoardOrientation: opt(id("StreetOrientationMode")),
    includeFriezeBoardOnPorches: id("OptionalBoolean"),
    rakeFriezeBoard: opt(arr(id("FriezeBoard"))),
    rakeFriezeBoardMaterialLegacy: opt(id("ExteriorMaterial")),
    rakeFriezeBoardExtents: opt(id("RakeFriezeBoardMode")),
    eaveFriezeBoard: opt(arr(id("FriezeBoard"))),
    eaveFriezeBoardExtents: opt(id("EaveFriezeBoardMode")),
    eaveFriezeBoardMaterialLegacy: opt(id("ExteriorMaterial")),
    wrapFriezeBoardMode: opt(id("WrapFriezeBoardMode")),
    roofingMaterial: opt(id("ExteriorMaterial")),
    roofingMaterialThickness: opt(num),
    roofingMaterialExtension: opt(num),
    roofRidgeRoofingCapMaterial: opt(id("ExteriorMaterial")),
    roofRidgeRoofingCapWidth: opt(num),
    roofRidgeRoofingCapThickness: opt(num),
    includeRidgeVent: id("OptionalBoolean"),
    ridgeVentMinimumThreshold: opt(num),
    ridgeVentEndsOffset: opt(num),
    includeTriangleGableVent: id("OptionalBoolean"),
    triangleGableVentBaseWidth: opt(num),
    gableBellyBandBoard: opt(id("ProfileId")),
    gableBellyBandBoardMaterial: opt(id("ExteriorMaterial")),
    gableBellyBandBoardAnchor: opt(id("WallVerticalDatumAnchor")),
    gableBellyBandBoardJustification: opt(id("VerticalJustification")),
    gableBellyBandBoardOffset: opt(num),
    useNewRoofTrimGeneration: id("OptionalBoolean"),
    soffitMaterial: opt(id("ExteriorMaterial")),
    rakeFasciaMaterial: opt(id("ExteriorMaterial")),
    eaveFasciaMaterial: opt(id("ExteriorMaterial")),
    fasciaTopTrimMaterial: opt(id("ExteriorMaterial")),
    rakeBracketPropId: opt(fk("PROP")),
    rakeBracketAtPeak: id("OptionalBoolean"),
    rakeBracketParams: opt(arr(num)),
    rakeBracketParamsNormalized: id("OptionalBoolean"),
    rakeBracketTruncationParams: opt(arr(num)),
    eaveBracketPropId: opt(fk("PROP")),
    eaveBracketSide: opt(id("EaveBracketSide")),
    eaveBracketParamsNormalized: id("OptionalBoolean"),
    eaveBracketParams: opt(arr(num)),
    eaveBracketPlacement: opt(id("EaveBracketPlacement")),
    generateRoofFraming: id("OptionalBoolean"),
    roofFramingSpacing: opt(num),
    roofFramingSpacingMethod: opt(id("RoofFramingSpacingMethod")),
    roofFramingType: opt(id("RoofFramingType")),
    hipFramingMethod: opt(id("HipFramingMethod")),
    jackRafterProfile: opt(id("LumberProfileType")),
    setBackForStepDownTruss: opt(num),
    trussType: opt(id("RoofTrussType")),
    ceilingJoistOffset: opt(num),
    topChordProfile: opt(id("LumberProfileType")),
    bottomChordProfile: opt(id("LumberProfileType")),
    webChordProfile: opt(id("LumberProfileType")),
    ridgeRafterProfile: opt(id("LumberProfileType")),
    includeFlyRafters: id("OptionalBoolean"),
    flyRafterProfile: opt(id("LumberProfileType")),
    includeLookoutRafters: id("OptionalBoolean"),
    lookoutRafterProfile: opt(id("LumberProfileType")),
    lookoutRafterSpacing: opt(num),
    includeStickFramingAtStart: id("OptionalBoolean"),
    webChordSpacingAtStart: opt(num),
    stickFramingTopChordProfileAtStart: opt(id("LumberProfileType")),
    stickFramingBottomChordProfileAtStart: opt(id("LumberProfileType")),
    stickFramingWebChordProfileAtStart: opt(id("LumberProfileType")),
    includeStickFramingAtEnd: id("OptionalBoolean"),
    webChordSpacingAtEnd: opt(num),
    stickFramingTopChordProfileAtEnd: opt(id("LumberProfileType")),
    stickFramingBottomChordProfileAtEnd: opt(id("LumberProfileType")),
    stickFramingWebChordProfileAtEnd: opt(id("LumberProfileType")),
    shedOverhang: num,
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "RoofSettings",
);
export const RoofSideSchema = enu(
  {
    [`LEFT`]: "LEFT",
    [`RIGHT`]: "RIGHT",
    [`START`]: "START",
    [`END`]: "END",
    [`INVALID`]: "INVALID",
  },
  "RoofSide",
);
export const RoofSideHandleSchema = interf(
  {
    type: lit("ROOF_SIDE"),
    parent: id("RoofHandle"),
    side: str,
  },
  "RoofSideHandle",
);
export const RoofSlopeOptionsSchema = interf(
  {
    slope: union([num, id("Formula")]),
    horizontalDist: opt(num),
  },
  "RoofSlopeOptions",
);
export const RoofStructureTypeSchema = enu(
  {
    [`FLAT`]: "FLAT",
    [`VAULTED`]: "VAULTED",
  },
  "RoofStructureType",
);
export const RoofSystemSchema = interf(
  {
    id: pk("ROOF_SYSTEM"),
    entityType: lit("ROOF_SYSTEM"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "RoofSystem",
);
export const RoofSystemHandleSchema = interf(
  {
    type: lit("ROOF_SYSTEM"),
    id: str,
  },
  "RoofSystemHandle",
);
export const RoofSystemLevelUsageSchema = interf(
  {
    entityId: fk("LEVEL"),
    componentInstanceChain: opt(id("ForeignKeyPathOf")),
  },
  "RoofSystemLevelUsage",
);
export const RoofTruncationTypeSchema = enu(
  {
    [`NONE`]: "NONE",
    [`TRUNCATED`]: "TRUNCATED",
    [`HIP`]: "HIP",
  },
  "RoofTruncationType",
);
export const RoofTrussTypeSchema = enu(
  {
    [`FLY_TRUSS`]: "FLY_TRUSS",
    [`CHORD_TRUSS`]: "CHORD_TRUSS",
    [`KING_POST_TRUSS`]: "KING_POST_TRUSS",
    [`QUEEN_POST_TRUSS`]: "QUEEN_POST_TRUSS",
    [`FINK_TRUSS`]: "FINK_TRUSS",
    [`HOWE_TRUSS`]: "HOWE_TRUSS",
    [`SCISSOR_TRUSS`]: "SCISSOR_TRUSS",
    [`STICK_FRAME_TRUSS`]: "STICK_FRAME_TRUSS",
    [`HIP_TRUSS`]: "HIP_TRUSS",
    [`GAMBREL_TRUSS`]: "GAMBREL_TRUSS",
    [`JACK_TRUSS`]: "JACK_TRUSS",
  },
  "RoofTrussType",
);
export const RoofVolumeSchema = interf(
  {
    id: pk("ROOF_VOLUME"),
    arrangement: opt(id("ImportArrangement")),
    entityType: lit("ROOF_VOLUME"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "RoofVolume",
);
export const RoofVolumeHandleSchema = interf(
  {
    type: lit("ROOF_VOLUME"),
    id: str,
  },
  "RoofVolumeHandle",
);
export const RoofWallFramingTypeSchema = enu(
  {
    [`NONE`]: "NONE",
    [`AUTO`]: "AUTO",
    [`STICK_FRAMING`]: "STICK_FRAMING",
  },
  "RoofWallFramingType",
);
export const RoofWallModeSchema = enu(
  {
    [`INTERIOR`]: "INTERIOR",
    [`EXTERIOR`]: "EXTERIOR",
  },
  "RoofWallMode",
);
export const RoofWeldModeSchema = enu(
  {
    [`AUTO`]: "AUTO",
    [`MANUAL`]: "MANUAL",
  },
  "RoofWeldMode",
);
export const RoomBoundaryTypeSchema = enu(
  {
    [`BOUNDING_BOX`]: "BOUNDING_BOX",
    [`MAX_RECTANGLE`]: "MAX_RECTANGLE",
  },
  "RoomBoundaryType",
);
export const RoomCaseworkPositionSchema = interf(
  {
    type: lit("CASEWORK"),
    caseworkName: str,
    entityPlaneXOffset: num,
    entityPlaneXNormalizedToRoomWidth: bool,
    entityPlaneYOffset: num,
    entityPlaneYNormalizedToRoomWidth: bool,
    rotation: opt(num),
  },
  "RoomCaseworkPosition",
);
export const RoomClassSchema = enu(
  {
    [`HOUSE`]: 0,
    [`BASEMENT`]: 1,
    [`GARAGE`]: 2,
    [`PORCH`]: 3,
    [`DECK`]: 4,
    [`PATIO`]: 5,
    [`EXTERIOR`]: 6,
  },
  "RoomClass",
);
export const RoomEdgeSchema = interf(
  {
    roomId: fk("ROOM"),
    edgeId: str,
  },
  "RoomEdge",
);
export const RoomEdgeHandleSchema = interf(
  {
    type: lit("EDGE"),
    parent: id("RoomHandle"),
    shapeId: lit("outline"),
    edgeId: num,
  },
  "RoomEdgeHandle",
);
export const RoomEnclosureSchema = enu(
  {
    [`CONDITIONED`]: "CONDITIONED",
    [`UNCONDITIONED`]: "UNCONDITIONED",
    [`EXTERIOR`]: "EXTERIOR",
    [`OPEN`]: "OPEN",
    [`NONE`]: "NONE",
  },
  "RoomEnclosure",
);
export const RoomHandleSchema = interf(
  {
    type: lit("ROOM"),
    id: str,
  },
  "RoomHandle",
);
export const RoomIsolatedFoundationPatternSchema = interf(
  {
    hostType: lit("ROOM"),
    patternType: lit("ISOLATED"),
    positions: arr(id("PierPosition")),
    assemblyId: fk("FOUNDATION_ASSEMBLY"),
    xOffset: num,
    yOffset: num,
    pierRotation: num,
    foundationLevelId: opt(fk("LEVEL")),
    topDatumId: opt(fk("DATUM")),
    bottomDatumId: opt(fk("DATUM")),
    edgeBehaviorId: opt(fk("EDGE_BEHAVIOR")),
  },
  "RoomIsolatedFoundationPattern",
);
export const RoomLabelDimensionTypeSchema = enu(
  {
    [`ROOM_DECOMPOSITION`]: "ROOM_DECOMPOSITION",
    [`BOUNDING_BOX`]: "BOUNDING_BOX",
    [`NONE`]: "NONE",
    [`OVERRIDE`]: "OVERRIDE",
  },
  "RoomLabelDimensionType",
);
export const RoomLabelRoundingSchema = enu(
  {
    [`LOWEST`]: "LOWEST",
    [`NEAREST`]: "NEAREST",
    [`HIGHEST`]: "HIGHEST",
  },
  "RoomLabelRounding",
);
export const RoomLabelUnitsSchema = enu(
  {
    [`WHOLE_FEET`]: "WHOLE_FEET",
    [`WHOLE_FEET_INCHES`]: "WHOLE_FEET_INCHES",
  },
  "RoomLabelUnits",
);
export const RoomLayoutSchema = interf(
  {
    id: pk("ROOM_LAYOUT"),
    parentId: union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    entityType: lit("ROOM_LAYOUT"),
    name: str,
    sortIndex: num,
  },
  "RoomLayout",
);
export const RoomLayoutHandleSchema = interf(
  {
    type: lit("ROOM_LAYOUT"),
    id: str,
  },
  "RoomLayoutHandle",
);
export const RoomLayoutInstanceSchema = interf(
  {
    id: pk("ROOM_LAYOUT_INSTANCE"),
    parentId: union([fk("ROOM", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    roomLayoutId: fk("ROOM_LAYOUT"),
    edgeIdRemapping: obj(union([nul, str])),
    suppressedEntities: fkTable(
      ["ANNOTATION", "CONTENT_TEMPLATE_INSTANCE", "CASEWORK", "PROP_INSTANCE", "OPENING"],
      bool,
    ),
    entityType: lit("ROOM_LAYOUT_INSTANCE"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "RoomLayoutInstance",
);
export const RoomLayoutInstanceHandleSchema = interf(
  {
    type: lit("ROOM_LAYOUT_INSTANCE"),
    id: str,
  },
  "RoomLayoutInstanceHandle",
);
export const RoomMaterialsSchema = interf(
  {
    floorInterior0: id("MaterialSrc"),
    floorInterior1: opt(id("MaterialSrc")),
    floorInterior2: opt(id("MaterialSrc")),
    floorInterior3: opt(id("MaterialSrc")),
    floorInterior4: opt(id("MaterialSrc")),
    floorInterior5: opt(id("MaterialSrc")),
    wallInterior0: id("MaterialSrc"),
    wallInterior1: opt(id("MaterialSrc")),
    wallInterior2: opt(id("MaterialSrc")),
    trimInterior0: id("MaterialSrc"),
    trimInterior1: opt(id("MaterialSrc")),
    trimInterior2: opt(id("MaterialSrc")),
    ceiling0: id("MaterialSrc"),
    ceiling1: opt(id("MaterialSrc")),
    ceiling2: opt(id("MaterialSrc")),
    glass0: id("MaterialSrc"),
    glass1: opt(id("MaterialSrc")),
    glass2: opt(id("MaterialSrc")),
    doorInterior0: id("MaterialSrc"),
    doorInterior1: opt(id("MaterialSrc")),
    doorInterior2: opt(id("MaterialSrc")),
    doorFixture0: id("MaterialSrc"),
    doorFixture1: opt(id("MaterialSrc")),
    doorFixture2: opt(id("MaterialSrc")),
    propDefault0: id("MaterialSrc"),
    propDefault1: opt(id("MaterialSrc")),
    propDefault2: opt(id("MaterialSrc")),
  },
  "RoomMaterials",
);
export const RoomPositionSchema = union(
  [id("RoomWallPosition"), id("RoomRefGeomPosition"), id("RoomPropPosition"), id("RoomCaseworkPosition")],
  "RoomPosition",
);
export const RoomPropPositionSchema = interf(
  {
    type: lit("PROP"),
    propType: fk("PROP"),
    entityPlaneXOff: num,
    entityPlaneXNormToRoomWidth: bool,
    entityPlaneYOff: num,
    entityPlaneYNormToRoomWidth: bool,
    rotation: opt(num),
  },
  "RoomPropPosition",
);
export const RoomRefGeomPositionSchema = interf(
  {
    type: lit("REF_GEOM"),
    geomId: union([fk("REFERENCE_GEOM"), undef, nul]),
    edgeId: union([nul, num]),
    param: num,
    paramNormalized: bool,
    offset: num,
    offsetNormalizedToRefGeomWidth: bool,
    rotation: opt(num),
  },
  "RoomRefGeomPosition",
);
export const RoomSetMaterialsSchema = inters([partial(id("RoomMaterials")), id("RoomTypeSet")], "RoomSetMaterials");
export const RoomTagCapitalizationSchema = enu(
  {
    [`UPPER_CASE`]: "UPPER_CASE",
    [`TITLE_CASE`]: "TITLE_CASE",
    [`DEFAULT`]: "DEFAULT",
  },
  "RoomTagCapitalization",
);
export const RoomTagDimensionControlSchema = enu(
  {
    [`MAXIMAL_RECTANGLE`]: "MAXIMAL_RECTANGLE",
    [`AXIS_ALIGNED_BOUNDING_BOX`]: "AXIS_ALIGNED_BOUNDING_BOX",
  },
  "RoomTagDimensionControl",
);
export const RoomTypeSchema = enu(
  {
    [`MASTER_BED`]: "MASTER_BED",
    [`MASTER_BATH`]: "MASTER_BATH",
    [`MASTER_CLOSET`]: "MASTER_CLOSET",
    [`MASTER_HALL`]: "MASTER_HALL",
    [`MASTER_PASS`]: "MASTER_PASS",
    [`MASTER_SEAT`]: "MASTER_SEAT",
    [`MASTER_SUITE`]: "MASTER_SUITE",
    [`MASTER_VESTIBULE`]: "MASTER_VESTIBULE",
    [`SHOWER`]: "SHOWER",
    [`WATER_CLOSET`]: "WATER_CLOSET",
    [`BATH_HALL`]: "BATH_HALL",
    [`MASTER_VANITY`]: "MASTER_VANITY",
    [`BEDROOM`]: "BEDROOM",
    [`BED_PASS`]: "BED_PASS",
    [`REACH_CLOSET`]: "REACH_CLOSET",
    [`BED_CLOSET`]: "BED_CLOSET",
    [`DINING`]: "DINING",
    [`GUEST_SUITE`]: "GUEST_SUITE",
    [`WALK_IN_CLOSET`]: "WALK_IN_CLOSET",
    [`POWDER`]: "POWDER",
    [`FORMAL_DINING`]: "FORMAL_DINING",
    [`FORMAL_LIVING`]: "FORMAL_LIVING",
    [`KITCHEN`]: "KITCHEN",
    [`KITCHEN_CABINETS`]: "KITCHEN_CABINETS",
    [`DINING_NOOK`]: "DINING_NOOK",
    [`REFRIGERATOR`]: "REFRIGERATOR",
    [`KITCHEN_HALL`]: "KITCHEN_HALL",
    [`PANTRY`]: "PANTRY",
    [`LIVING`]: "LIVING",
    [`LIBRARY`]: "LIBRARY",
    [`SCREEN`]: "SCREEN",
    [`LIVING_HALL`]: "LIVING_HALL",
    [`OFFICE`]: "OFFICE",
    [`BAY_WINDOW`]: "BAY_WINDOW",
    [`COAT_CLOSET`]: "COAT_CLOSET",
    [`BATHFULL`]: "BATHFULL",
    [`BATHFULL_1_DOOR`]: "BATHFULL_1_DOOR",
    [`BATHHALF`]: "BATHHALF",
    [`JJ_BATH`]: "JJ_BATH",
    [`BED_BATH`]: "BED_BATH",
    [`BATHTUB`]: "BATHTUB",
    [`ENTRY`]: "ENTRY",
    [`FOYER`]: "FOYER",
    [`ENTRY_BUFFER`]: "ENTRY_BUFFER",
    [`OPEN_BELOW`]: "OPEN_BELOW",
    [`GENERAL`]: "GENERAL",
    [`GALLERY`]: "GALLERY",
    [`GENERAL_OPEN`]: "GENERAL_OPEN",
    [`CLOSET`]: "CLOSET",
    [`SOLARIUM`]: "SOLARIUM",
    [`READING_NOOK`]: "READING_NOOK",
    [`FLEX`]: "FLEX",
    [`CABINETS`]: "CABINETS",
    [`HALL`]: "HALL",
    [`HALL_NO_WINDOW`]: "HALL_NO_WINDOW",
    [`HALL_NO_ENTRY`]: "HALL_NO_ENTRY",
    [`STAIRS`]: "STAIRS",
    [`STAIRS_EDITOR`]: "STAIRS_EDITOR",
    [`CORNER_HALL`]: "CORNER_HALL",
    [`HALL_CASED_OPENING`]: "HALL_CASED_OPENING",
    [`GARAGE`]: "GARAGE",
    [`GARAGE_DETACH`]: "GARAGE_DETACH",
    [`UTIL_HALL`]: "UTIL_HALL",
    [`MECH`]: "MECH",
    [`MUDROOM`]: "MUDROOM",
    [`DOG`]: "DOG",
    [`JUMP`]: "JUMP",
    [`LAUNDRY`]: "LAUNDRY",
    [`WORKSHOP`]: "WORKSHOP",
    [`MUD_LAUNDRY`]: "MUD_LAUNDRY",
    [`FRONT_PORCH`]: "FRONT_PORCH",
    [`REAR_PORCH`]: "REAR_PORCH",
    [`PATIO`]: "PATIO",
    [`WALK`]: "WALK",
    [`BREEZEWAY`]: "BREEZEWAY",
    [`FIREPLACE`]: "FIREPLACE",
    [`FREESTANDING_FIREPLACE`]: "FREESTANDING_FIREPLACE",
    [`PORTICO`]: "PORTICO",
    [`LANDSCAPE`]: "LANDSCAPE",
    [`NONE`]: "NONE",
    [`CHASE`]: "CHASE",
  },
  "RoomType",
);
export const RoomTypeFilterSchema = interf(
  {
    roomType: id("RoomType"),
    negate: id("OptionalBoolean"),
  },
  "RoomTypeFilter",
);
export const RoomTypeSetSchema = interf(
  {
    roomTypes: arr(id("RoomType")),
  },
  "RoomTypeSet",
);
export const RoomTypeSpaceTypeFilterSchema = union(
  [
    inters([partial(id("BaseRoomTypeSpaceTypeFilter")), pick(id("BaseRoomTypeSpaceTypeFilter"), lit("width"))]),
    inters([partial(id("BaseRoomTypeSpaceTypeFilter")), pick(id("BaseRoomTypeSpaceTypeFilter"), lit("length"))]),
    inters([partial(id("BaseRoomTypeSpaceTypeFilter")), pick(id("BaseRoomTypeSpaceTypeFilter"), lit("roomType"))]),
    inters([partial(id("BaseRoomTypeSpaceTypeFilter")), pick(id("BaseRoomTypeSpaceTypeFilter"), lit("spaceType"))]),
    inters([partial(id("BaseRoomTypeSpaceTypeFilter")), pick(id("BaseRoomTypeSpaceTypeFilter"), lit("area"))]),
  ],
  "RoomTypeSpaceTypeFilter",
);
export const RoomWallPositionSchema = interf(
  {
    type: lit("WALL"),
    lateralOffset: num,
    lateralDatum: opt(id("WallLateralDatumAnchorAll")),
    lateralOffsetNormalizedToRoomWidth: bool,
    placementStyle: union([undef, lit("DEPRECATED"), lit("VERSION_0")]),
    rotation: opt(num),
    edgeId: str,
    paramAnchor: id("LineAnchor"),
    horizontalDatum: opt(id("WallHorizontalDatum")),
    param: num,
    paramNormalized: bool,
  },
  "RoomWallPosition",
);
export const RoughOpeningHeadSettingsSchema = interf(
  {
    framingRoughOpeningHeadDelta: opt(num),
    foundationRoughOpeningHeadDelta: opt(num),
  },
  "RoughOpeningHeadSettings",
);
export const RoughOpeningJambSettingsSchema = interf(
  {
    framingRoughOpeningJambDelta: opt(num),
    foundationRoughOpeningJambDelta: opt(num),
  },
  "RoughOpeningJambSettings",
);
export const RoughOpeningSillSettingsSchema = interf(
  {
    framingRoughOpeningSillDelta: opt(num),
    foundationRoughOpeningSillDelta: opt(num),
  },
  "RoughOpeningSillSettings",
);
export const RuleBasedSelectorSchema = interf(
  {
    id: pk("RULE_BASED_SELECTOR"),
    rules: arr(id("Condition")),
    entityType: lit("RULE_BASED_SELECTOR"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "RuleBasedSelector",
);
export const RuleBasedSelectorHandleSchema = interf(
  {
    type: lit("RULE_BASED_SELECTOR"),
    id: str,
  },
  "RuleBasedSelectorHandle",
);
export const RuleBasedSelectorInstanceSchema = interf(
  {
    id: pk("RULE_BASED_SELECTOR_INSTANCE"),
    parentId: union([fk("VIEW_TEMPLATE_OVERRIDE", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    selectorId: fk("RULE_BASED_SELECTOR"),
    entityType: lit("RULE_BASED_SELECTOR_INSTANCE"),
    name: str,
    sortIndex: num,
  },
  "RuleBasedSelectorInstance",
);
export const RuleBasedSelectorInstanceHandleSchema = interf(
  {
    type: lit("RULE_BASED_SELECTOR_INSTANCE"),
    id: str,
  },
  "RuleBasedSelectorInstanceHandle",
);
export const SalesImageSchema = interf(
  {
    url: str,
    width: opt(num),
    height: opt(num),
    title: opt(str),
    description: opt(str),
  },
  "SalesImage",
);
export const ScalingEffectSchema = interf(
  {
    type: lit("SCALING"),
    scale: num,
    id: pk("EFFECT"),
    categories: arr(id("SheetGeometryCategory")),
    parentId: opt(union([fk("VIEW_TEMPLATE_OVERRIDE", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
    entityType: lit("EFFECT"),
    name: str,
    sortIndex: num,
  },
  "ScalingEffect",
);
export const ScheduleSettingsSchema = interf(
  {
    type: lit("SCHEDULE_SETTINGS"),
    scheduleSettingsTable: mapobj(
      union([
        lit("WALL"),
        lit("PROP"),
        lit("CASEWORK"),
        lit("CEILING"),
        lit("ROOF"),
        lit("DOOR"),
        lit("WINDOW"),
        lit("ELECTRICAL"),
        lit("SLAB"),
        lit("FOOTING"),
        lit("FRAMING"),
        lit("FLOORING"),
        lit("FLOOR_MATERIALS_SUMMARY"),
        lit("INTERIOR_FINISH"),
        lit("ROOF_AREA"),
        lit("ROOF_ANALYTIC_AREA"),
        lit("ROOF_ANALYTIC_LENGTH"),
        lit("ROOF_RIDGE"),
        lit("ROOF_RIDGE_VENT"),
        lit("ROOF_VALLEY"),
        lit("ROOF_EAVE"),
        lit("ROOF_FLASHING"),
        lit("WALL_AREA"),
        lit("BUILDING_AREA"),
        lit("BUILDING_OPTION"),
        lit("BUILDING_PRESET"),
        lit("MILLWORK"),
        lit("EXTERIOR_TRIM"),
        lit("EXTERIOR_FINISH"),
        lit("OPENING_TRIM"),
        lit("OPENING_CASING"),
      ]),
      arr(
        interf(
          {
            type: union([
              lit("WALL"),
              lit("PROP"),
              lit("CASEWORK"),
              lit("CEILING"),
              lit("ROOF"),
              lit("DOOR"),
              lit("WINDOW"),
              lit("ELECTRICAL"),
              lit("SLAB"),
              lit("FOOTING"),
              lit("FRAMING"),
              lit("FLOORING"),
              lit("FLOOR_MATERIALS_SUMMARY"),
              lit("INTERIOR_FINISH"),
              lit("ROOF_AREA"),
              lit("ROOF_ANALYTIC_AREA"),
              lit("ROOF_ANALYTIC_LENGTH"),
              lit("ROOF_RIDGE"),
              lit("ROOF_RIDGE_VENT"),
              lit("ROOF_VALLEY"),
              lit("ROOF_EAVE"),
              lit("ROOF_FLASHING"),
              lit("WALL_AREA"),
              lit("BUILDING_AREA"),
              lit("BUILDING_OPTION"),
              lit("BUILDING_PRESET"),
              lit("MILLWORK"),
              lit("EXTERIOR_TRIM"),
              lit("EXTERIOR_FINISH"),
              lit("OPENING_TRIM"),
              lit("OPENING_CASING"),
            ]),
            scheduleName: str,
            attributes: mapobj(
              union(
                [
                  lit("perimeter"),
                  lit("type"),
                  lit("width"),
                  lit("height"),
                  lit("id"),
                  lit("tag"),
                  lit("profile"),
                  lit("category"),
                  lit("description"),
                  lit("name"),
                  lit("panelType"),
                  lit("glazingType"),
                  lit("glazingColor"),
                  lit("material"),
                  lit("operationType"),
                  lit("propType"),
                  lit("profileType"),
                  lit("length"),
                  lit("area"),
                  lit("verticalDivisions"),
                  lit("grids"),
                  lit("floor"),
                  lit("entityName"),
                  lit("class"),
                  lit("panels"),
                  lit("swing"),
                  lit("handing"),
                  lit("details"),
                  lit("leafCount"),
                  lit("level"),
                  lit("roomId"),
                  lit("roomName"),
                  lit("trayCeilingCount"),
                  lit("group"),
                  lit("materialHash"),
                  lit("order"),
                  lit("lengthType"),
                  lit("propName"),
                  lit("baseConstraint"),
                  lit("enclosure"),
                ],
                "KeyAttributeTypesKeys",
              ),
              inters(
                [
                  omit(
                    interf({
                      definesEntity: bool,
                      unit: opt(
                        union(
                          [
                            lit("QUANTITY"),
                            lit("INCHES"),
                            lit("FEET"),
                            lit("SQ IN"),
                            lit("SQ FT"),
                            lit("CU IN"),
                            lit("CU FT"),
                          ],
                          "DataSequenceUnit",
                        ),
                      ),
                      isHidden: id("OptionalBoolean"),
                    }),
                    union([lit("definesEntity"), lit("unit")]),
                  ),
                  interf({
                    definesEntity: bool,
                    unit: opt(
                      union(
                        [
                          lit("QUANTITY"),
                          lit("INCHES"),
                          lit("FEET"),
                          lit("SQ IN"),
                          lit("SQ FT"),
                          lit("CU IN"),
                          lit("CU FT"),
                        ],
                        "DataSequenceUnit",
                      ),
                    ),
                  }),
                  interf(
                    {
                      index: num,
                      isHidden: bool,
                      displayName: str,
                      includeFilter: str,
                      excludeFilter: str,
                    },
                    "KeyAttributeVisualizationOptions",
                  ),
                ],
                "KeyAttributeSettingOptions",
              ),
              true,
              "KeyAttributeSettings",
            ),
            measures: mapobj(
              union(
                [
                  lit("perimeter"),
                  lit("width"),
                  lit("height"),
                  lit("length"),
                  lit("area"),
                  lit("trayCeilingCount"),
                  lit("count"),
                  lit("volume"),
                ],
                "KeyMeasureTypesKeys",
              ),
              inters(
                [
                  omit(
                    interf({
                      unit: union(
                        [
                          lit("QUANTITY"),
                          lit("INCHES"),
                          lit("FEET"),
                          lit("SQ IN"),
                          lit("SQ FT"),
                          lit("CU IN"),
                          lit("CU FT"),
                        ],
                        "DataSequenceUnit",
                      ),
                      isAggregated: bool,
                      isHidden: id("OptionalBoolean"),
                      aggregationMethod: id("AggregationMethod"),
                    }),
                    union([lit("unit"), lit("isAggregated")]),
                  ),
                  interf({
                    isAggregated: bool,
                    unit: union(
                      [
                        lit("QUANTITY"),
                        lit("INCHES"),
                        lit("FEET"),
                        lit("SQ IN"),
                        lit("SQ FT"),
                        lit("CU IN"),
                        lit("CU FT"),
                      ],
                      "DataSequenceUnit",
                    ),
                  }),
                  interf(
                    {
                      index: num,
                      isHidden: bool,
                      displayName: str,
                    },
                    "KeyMeasureVisualizationOptions",
                  ),
                ],
                "KeyMeasureSettingOptions",
              ),
              true,
              "KeyMeasureSettings",
            ),
            footnote: str,
            forceColumnNameUppercase: bool,
            isActive: bool,
          },
          "BuiltInDataTableSettings",
        ),
      ),
      true,
      "BuiltInDataSequenceSettingsTable",
    ),
  },
  "ScheduleSettings",
);
export const SectionViewSchema = interf(
  {
    id: pk("SECTION_VIEW"),
    calloutLabels: opt(fkTable("LABEL", bool)),
    gradeLineSource: opt(id("GradeLineSource")),
    entityType: lit("SECTION_VIEW"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    startX: num,
    startY: num,
    startZ: num,
    endX: num,
    endY: num,
    endZ: num,
    depth: opt(num),
    viewScale: opt(num),
    viewFilter: opt(partial(id("ViewFilter"))),
    dimensionPrecision: opt(id("DimensionPrecision")),
  },
  "SectionView",
);
export const SectionViewHandleSchema = interf(
  {
    type: lit("SECTION_VIEW"),
    id: str,
  },
  "SectionViewHandle",
);
export const SectionViewParameterSchema = interf(
  {
    defaultValue: opt(fk("SECTION_VIEW")),
    type: lit("SECTION_VIEW"),
  },
  "SectionViewParameter",
);
export const SectionViewportSchema = inters(
  [
    id("ViewportBase"),
    id("OptionPresetBase"),
    interf({
      viewType: lit("SECTION_VIEW"),
      contentSourceId: union([id("ParameterRef"), fk("SECTION_VIEW")]),
    }),
  ],
  "SectionViewport",
);
export const SectionViewTemplateSchema = interf(
  {
    viewType: lit("SECTION_VIEW"),
    gradeLineSource: opt(id("GradeLineSource")),
    id: pk("VIEW_TEMPLATE"),
    categories: arr(id("SheetGeometryCategory")),
    styleOverrides: mapobj(
      id("SheetGeometryCategory"),
      interf(
        {
          line: opt(id("LineStyle")),
          text: opt(id("TextStyle")),
        },
        "SheetGeometryCategoryStyle",
      ),
      true,
      "SheetGeometryStyleTable",
    ),
    viewStyle: opt(id("ViewStyle")),
    viewTemplateOverrideIds: arr(fk("VIEW_TEMPLATE_OVERRIDE")),
    entityType: lit("VIEW_TEMPLATE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "SectionViewTemplate",
);
export const SectionViewValueSchema = interf(
  {
    type: lit("SECTION_VIEW"),
    value: fk("SECTION_VIEW"),
  },
  "SectionViewValue",
);
export const SelectionMethodSchema = enu(
  {
    [`ALL`]: "ALL",
    [`BY_LABEL`]: "BY_LABEL",
    [`BY_SELECTOR`]: "BY_SELECTOR",
  },
  "SelectionMethod",
);
export const SelectorHandleSchema = interf(
  {
    type: lit("SELECTOR"),
    id: str,
  },
  "SelectorHandle",
);
export const SetPriceOptionEffectSchema = interf(
  {
    effectType: lit("SET_PRICE"),
    optionId: fk("OPTION"),
    price: num,
    id: pk("OPTION_EFFECT"),
    optionSetId: fk("OPTION_SET"),
    parentId: union([fk("OPTION_RULE", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    entityType: lit("OPTION_EFFECT"),
    name: str,
    sortIndex: num,
  },
  "SetPriceOptionEffect",
);
export const SettingsCriterionSchema = interf(
  {
    type: lit("SETTINGS_CRITERION"),
    settingsType: id("SettingsType"),
    path: str,
    value: str,
  },
  "SettingsCriterion",
);
export const SettingsFragmentSchema = union(
  [
    inters(
      [
        pick(id("InteriorMaterialSettings"), lit("type")),
        partial(id("InteriorMaterialSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("ExteriorMaterialSettings"), lit("type")),
        partial(id("ExteriorMaterialSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("ExteriorPropSettings"), lit("type")),
        partial(id("ExteriorPropSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("InteriorPropSettings"), lit("type")),
        partial(id("InteriorPropSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("DoorSettings"), lit("type")),
        partial(id("DoorSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("WindowSettings"), lit("type")),
        partial(id("WindowSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("WindowMaterialSettings"), lit("type")),
        partial(id("WindowMaterialSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("RoofSettings"), lit("type")),
        partial(id("RoofSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("DormerSettings"), lit("type")),
        partial(id("DormerSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("RoofFramingSettings"), lit("type")),
        partial(id("RoofFramingSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("WindowWallFramingSettings"), lit("type")),
        partial(id("WindowWallFramingSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("WindowWallWrappingSettings"), lit("type")),
        partial(id("WindowWallWrappingSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("DoorWallFramingSettings"), lit("type")),
        partial(id("DoorWallFramingSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("DoorWallWrappingSettings"), lit("type")),
        partial(id("DoorWallWrappingSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("PorchSettings"), lit("type")),
        partial(id("PorchSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("RearPorchSettings"), lit("type")),
        partial(id("RearPorchSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("PlanSettings"), lit("type")),
        partial(id("PlanSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("MasterPlanSettings"), lit("type")),
        partial(id("MasterPlanSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("ScheduleSettings"), lit("type")),
        partial(id("ScheduleSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("KeyMeasuresSettings"), lit("type")),
        partial(id("KeyMeasuresSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("WainscotingSettings"), lit("type")),
        partial(id("WainscotingSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("WallFramingSettings"), lit("type")),
        partial(id("WallFramingSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters([
      pick(id("AwningSettings"), lit("type")),
      partial(id("ShedAwningSettings")),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("AwningSettings"), lit("type")),
      partial(id("DisabledAwningSettings")),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters(
      [
        pick(id("FoundationSettings"), lit("type")),
        partial(id("FoundationSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("GarageSettings"), lit("type")),
        partial(id("GarageSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("WallSettings"), lit("type")),
        partial(id("WallSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("WallCatalogSettings"), lit("type")),
        partial(id("WallCatalogSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("ExteriorTrimSettings"), lit("type")),
        partial(id("ExteriorTrimSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("InteriorTrimSettings"), lit("type")),
        partial(id("InteriorTrimSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("StructureSettings"), lit("type")),
        partial(id("StructureSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("ElectricalSettings"), lit("type")),
        partial(id("ElectricalSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters([
      pick(id("WindowShutterSettings"), lit("type")),
      partial(id("DisabledShutterSettings")),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("WindowShutterSettings"), lit("type")),
      partial(id("VentedShutterSettings")),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("WindowShutterSettings"), lit("type")),
      partial(id("SimpleSlatShutterSettings")),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("WindowShutterSettings"), lit("type")),
      partial(id("PanelShutterSettings")),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("WindowShutterSettings"), lit("type")),
      partial(id("ZShutterSettings")),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("WindowShutterSettings"), lit("type")),
      partial(id("GenericShutterSettings")),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("ExteriorDoorCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingNone"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("ExteriorDoorCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingTrim"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("ExteriorDoorCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingSlices"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("ExteriorDoorCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingStone"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("ExteriorDoorCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingJackArch"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("ExteriorDoorCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingFullArch"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("ExteriorDoorCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingArchedSlices"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("ExteriorDoorCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_DOOR_CASING_SETTINGS"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("HeadCasingEyebrowTrim"),
          id("ExteriorDoorCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters(
      [
        pick(id("InteriorDoorCasingSettings"), lit("type")),
        partial(id("InteriorDoorCasingSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters([
      pick(id("ExteriorWindowCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
            factoryMulled: id("OptionalBoolean"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("StoolCasingSettings"),
          id("HeadCasingNone"),
          id("ExteriorWindowCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("ExteriorWindowCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
            factoryMulled: id("OptionalBoolean"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("StoolCasingSettings"),
          id("HeadCasingTrim"),
          id("ExteriorWindowCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("ExteriorWindowCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
            factoryMulled: id("OptionalBoolean"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("StoolCasingSettings"),
          id("HeadCasingSlices"),
          id("ExteriorWindowCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("ExteriorWindowCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
            factoryMulled: id("OptionalBoolean"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("StoolCasingSettings"),
          id("HeadCasingStone"),
          id("ExteriorWindowCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("ExteriorWindowCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
            factoryMulled: id("OptionalBoolean"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("StoolCasingSettings"),
          id("HeadCasingJackArch"),
          id("ExteriorWindowCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("ExteriorWindowCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
            factoryMulled: id("OptionalBoolean"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("StoolCasingSettings"),
          id("HeadCasingFullArch"),
          id("ExteriorWindowCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("ExteriorWindowCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
            factoryMulled: id("OptionalBoolean"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("StoolCasingSettings"),
          id("HeadCasingArchedSlices"),
          id("ExteriorWindowCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("ExteriorWindowCasingSettings"), lit("type")),
      partial(
        inters([
          interf({
            type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
            factoryMulled: id("OptionalBoolean"),
          }),
          id("BaseSettings"),
          id("CasingOrientationSettings"),
          id("CasingHorizontalPlacementSettings"),
          id("CasingLateralPlacementSettings"),
          id("ApronCasingSettings"),
          id("SideCasingSettings"),
          id("StoolCasingSettings"),
          id("HeadCasingEyebrowTrim"),
          id("ExteriorWindowCasingViewNotesSettings"),
          id("CasingFinishSettings"),
        ]),
      ),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("WindowMullionSettings"), lit("type")),
      partial(id("GridWindowMullionSettings")),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters([
      pick(id("WindowMullionSettings"), lit("type")),
      partial(id("DisabledWindowMullionSettings")),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SETTINGS") },
      ),
      interf({
        id: pk("SETTINGS"),
        parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
      }),
    ]),
    inters(
      [
        pick(id("ViewNoteSettings"), lit("type")),
        partial(id("ViewNoteSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("ProfileCatalogSettings"), lit("type")),
        partial(id("ProfileCatalogSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("ColumnCatalogSettings"), lit("type")),
        partial(id("ColumnCatalogSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("DrawingCatalogSettings"), lit("type")),
        partial(id("DrawingCatalogSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("CaseworkCatalogSettings"), lit("type")),
        partial(id("CaseworkCatalogSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("CaseworkSettings"), lit("type")),
        partial(id("CaseworkSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("StairCatalogSettings"), lit("type")),
        partial(id("StairCatalogSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("RailingCatalogSettings"), lit("type")),
        partial(id("RailingCatalogSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("DoorCatalogSettings"), lit("type")),
        partial(id("DoorCatalogSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("WindowCatalogSettings"), lit("type")),
        partial(id("WindowCatalogSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("ElectricalItemCatalogSettings"), lit("type")),
        partial(id("ElectricalItemCatalogSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("FloorSettings"), lit("type")),
        partial(id("FloorSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("InteriorWindowCasingSettings"), lit("type")),
        partial(id("InteriorWindowCasingSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
    inters(
      [
        pick(id("HeaderFramingSettings"), lit("type")),
        partial(id("HeaderFramingSettings")),
        ref(
          interf(
            {
              entityType: typeParam("T"),
              name: str,
              id: str,
              parentId: opt(str),
              sortIndex: num,
            },
            "DocEntityBase",
            ["T"],
          ),
          { T: lit("SETTINGS") },
        ),
        interf({
          id: pk("SETTINGS"),
          parentId: union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
        }),
      ],
      "GenericSettingsFragment",
    ),
  ],
  "SettingsFragment",
);
export const SettingsHandleSchema = interf(
  {
    type: lit("SETTINGS"),
    id: str,
  },
  "SettingsHandle",
);
export const SettingsSetSchema = interf(
  {
    id: pk("SETTINGS_SET"),
    type: id("SettingsSetBehaviorType"),
    entityType: lit("SETTINGS_SET"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "SettingsSet",
);
export const SettingsSetBehaviorTypeSchema = enu(
  {
    [`GLOBAL`]: "GLOBAL",
    [`TARGETED`]: "TARGETED",
  },
  "SettingsSetBehaviorType",
);
export const SettingsSetHandleSchema = interf(
  {
    type: lit("SETTINGS_SET"),
    id: str,
  },
  "SettingsSetHandle",
);
export const SettingsTypeSchema = enu(
  {
    [`INTERIOR_MATERIAL_SETTINGS`]: "INTERIOR_MATERIAL_SETTINGS",
    [`EXTERIOR_MATERIAL_SETTINGS`]: "EXTERIOR_MATERIAL_SETTINGS",
    [`EXTERIOR_PROP_SETTINGS`]: "EXTERIOR_PROP_SETTINGS",
    [`INTERIOR_PROP_SETTINGS`]: "INTERIOR_PROP_SETTINGS",
    [`ROOF_SETTINGS`]: "ROOF_SETTINGS",
    [`DORMER_SETTINGS`]: "DORMER_SETTINGS",
    [`DOOR_SETTINGS`]: "DOOR_SETTINGS",
    [`WINDOW_SETTINGS`]: "WINDOW_SETTINGS",
    [`PORCH_SETTINGS`]: "PORCH_SETTINGS",
    [`REAR_PORCH_SETTINGS`]: "REAR_PORCH_SETTINGS",
    [`PLAN_SETTINGS`]: "PLAN_SETTINGS",
    [`MASTER_PLAN_SETTINGS`]: "MASTER_PLAN_SETTINGS",
    [`SCHEDULE_SETTINGS`]: "SCHEDULE_SETTINGS",
    [`KEY_MEASURES_SETTINGS`]: "KEY_MEASURES_SETTINGS",
    [`FOUNDATION_SETTINGS`]: "FOUNDATION_SETTINGS",
    [`WAINSCOTING_SETTINGS`]: "WAINSCOTING_SETTINGS",
    [`WALL_FRAMING_SETTINGS`]: "WALL_FRAMING_SETTINGS",
    [`ROOF_FRAMING_SETTINGS`]: "ROOF_FRAMING_SETTINGS",
    [`WINDOW_FRAMING_SETTINGS`]: "WINDOW_FRAMING_SETTINGS",
    [`WINDOW_WRAPPING_SETTINGS`]: "WINDOW_WRAPPING_SETTINGS",
    [`DOOR_FRAMING_SETTINGS`]: "DOOR_FRAMING_SETTINGS",
    [`DOOR_WRAPPING_SETTINGS`]: "DOOR_WRAPPING_SETTINGS",
    [`AWNING_SETTINGS`]: "AWNING_SETTINGS",
    [`WALL_SETTINGS`]: "WALL_SETTINGS",
    [`WALL_CATALOG_SETTINGS`]: "WALL_CATALOG_SETTINGS",
    [`EXTERIOR_DOOR_CASING_SETTINGS`]: "EXTERIOR_DOOR_CASING_SETTINGS",
    [`INTERIOR_DOOR_CASING_SETTINGS`]: "INTERIOR_DOOR_CASING_SETTINGS",
    [`GARAGE_SETTINGS`]: "GARAGE_SETTINGS",
    [`EXTERIOR_TRIM_SETTINGS`]: "EXTERIOR_TRIM_SETTINGS",
    [`INTERIOR_TRIM_SETTINGS`]: "INTERIOR_TRIM_SETTINGS",
    [`STRUCTURE_SETTINGS`]: "STRUCTURE_SETTINGS",
    [`ELECTRICAL_SETTINGS`]: "ELECTRICAL_SETTINGS",
    [`WINDOW_MULLION_SETTINGS`]: "WINDOW_MULLION_SETTINGS",
    [`WINDOW_SHUTTER_SETTINGS`]: "WINDOW_SHUTTER_SETTINGS",
    [`EXTERIOR_WINDOW_CASING_SETTINGS`]: "EXTERIOR_WINDOW_CASING_SETTINGS",
    [`VIEW_NOTE_SETTINGS`]: "VIEW_NOTE_SETTINGS",
    [`DRAWING_CATALOG_SETTINGS`]: "DRAWING_CATALOG_SETTINGS",
    [`CASEWORK_CATALOG_SETTINGS`]: "CASEWORK_CATALOG_SETTINGS",
    [`CASEWORK_SETTINGS`]: "CASEWORK_SETTINGS",
    [`DOOR_CATALOG_SETTINGS`]: "DOOR_CATALOG_SETTINGS",
    [`WINDOW_CATALOG_SETTINGS`]: "WINDOW_CATALOG_SETTINGS",
    [`COLUMN_CATALOG_SETTINGS`]: "COLUMN_CATALOG_SETTINGS",
    [`PROFILE_CATALOG_SETTINGS`]: "PROFILE_CATALOG_SETTINGS",
    [`STAIR_CATALOG_SETTINGS`]: "STAIR_CATALOG_SETTINGS",
    [`RAILING_CATALOG_SETTINGS`]: "RAILING_CATALOG_SETTINGS",
    [`ELECTRICAL_ITEM_CATALOG_SETTINGS`]: "ELECTRICAL_ITEM_CATALOG_SETTINGS",
    [`FLOOR_SETTINGS`]: "FLOOR_SETTINGS",
    [`WINDOW_MATERIAL_SETTINGS`]: "WINDOW_MATERIAL_SETTINGS",
    [`INTERIOR_WINDOW_CASING_SETTINGS`]: "INTERIOR_WINDOW_CASING_SETTINGS",
    [`HEADER_FRAMING_SETTINGS`]: "HEADER_FRAMING_SETTINGS",
  },
  "SettingsType",
);
export const ShapeBasedEntityHandleSchema = union(
  [
    id("RoomHandle"),
    id("RoomLayoutInstanceHandle"),
    id("StairBlockHandle"),
    id("RailingHandle"),
    id("FreeformWallHandle"),
    id("RoofHandle"),
    id("FoundationHandle"),
    id("ReferenceGeomHandle"),
    id("CeilingHandle"),
    id("FloorHandle"),
    id("FloorFinishHandle"),
    id("AnnotationHandle"),
    id("EditModeHandle"),
    id("MeasurementHandle"),
    id("ViewportHandle"),
    id("SiteShapeHandle"),
    id("FloorBayHandle"),
    id("FloorSplitLineHandle"),
  ],
  "ShapeBasedEntityHandle",
);
export const ShapeHandleSchema = interf(
  {
    type: lit("SHAPE"),
    parent: id("ShapeBasedEntityHandle"),
    shapeId: str,
  },
  "ShapeHandle",
);
export const SheathingComponentEntitySchema = union(
  [id("Plywood"), id("Osb"), id("Other"), id("Drywall")],
  "SheathingComponentEntity",
);
export const SheathingComponentHandleSchema = interf(
  {
    type: lit("SHEATHING_COMPONENT"),
    id: str,
  },
  "SheathingComponentHandle",
);
export const ShedAwningSettingsSchema = interf(
  {
    awningType: lit("SHED"),
    slope: union([undef, num, id("Formula")]),
    depth: opt(num),
    fasciaHeight: opt(num),
    trimHeight: opt(num),
    trimWidth: opt(num),
    awningBracketPropId: opt(fk("PROP")),
    bracketOffset: opt(num),
    awningHeightOffset: opt(num),
    awningWidthOffset: opt(num),
    awningLateralOffset: opt(num),
    awningLateralDatum: opt(id("WallLateralDatumAnchor")),
    bracketTrimSpacing: opt(num),
    roofMaterial: opt(id("ExteriorMaterial")),
    soffit: id("OptionalBoolean"),
    soffitHeight: opt(num),
    soffitDepthOffset: opt(num),
    soffitWidthOffset: opt(num),
    type: lit("AWNING_SETTINGS"),
    viewNotes: opt(
      mapobj(
        enu(
          {
            [`AWNING`]: "AWNING",
            [`BRACKET`]: "BRACKET",
          },
          "AwningViewNoteType",
        ),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "AwningViewNoteTable",
      ),
    ),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "ShedAwningSettings",
);
export const SheetSchema = union([id("DrawingsPlanSheet"), id("BackgroundPlanSheet")], "Sheet");
export const SheetCustomScalesSchema = enu(
  {
    [`SCALE_AUTO`]: "SCALE_AUTO",
    [`SCALE_1_16`]: "SCALE_1_16",
    [`SCALE_1_8`]: "SCALE_1_8",
    [`SCALE_1_4`]: "SCALE_1_4",
    [`SCALE_1_2`]: "SCALE_1_2",
  },
  "SheetCustomScales",
);
export const SheetGeometryCategorySchema = enu(
  {
    [`UNDEFINED`]: "UNDEFINED",
    [`RELAXATION_DEBUG`]: "RELAXATION_DEBUG",
    [`FOOTING`]: "FOOTING",
    [`SLAB`]: "SLAB",
    [`FOUNDATION_OUTLINE`]: "FOUNDATION_OUTLINE",
    [`SLAB_ABOVE`]: "SLAB_ABOVE",
    [`SLAB_BELOW`]: "SLAB_BELOW",
    [`SLAB_PATIO`]: "SLAB_PATIO",
    [`SLAB_TAG`]: "SLAB_TAG",
    [`BRICKLEDGE_CUT`]: "BRICKLEDGE_CUT",
    [`BRICKLEDGE_PROJECTED`]: "BRICKLEDGE_PROJECTED",
    [`FOUNDATION_CURB`]: "FOUNDATION_CURB",
    [`STAIR`]: "STAIR",
    [`STAIR_PROJECTED`]: "STAIR_PROJECTED",
    [`STAIR_ABOVE`]: "STAIR_ABOVE",
    [`STAIR_BREAK_LINE`]: "STAIR_BREAK_LINE",
    [`STEM_WALL_UNIONED_EDGES`]: "STEM_WALL_UNIONED_EDGES",
    [`STEM_WALL`]: "STEM_WALL",
    [`STEM_WALL_ABOVE`]: "STEM_WALL_ABOVE",
    [`STEM_WALL_ABOVE_GAPS`]: "STEM_WALL_ABOVE_GAPS",
    [`STEM_WALL_BELOW`]: "STEM_WALL_BELOW",
    [`PIER`]: "PIER",
    [`PIER_HIDDEN`]: "PIER_HIDDEN",
    [`FOUNDATION_DASHED_LINEWORK`]: "FOUNDATION_DASHED_LINEWORK",
    [`FOUNDATION_SOLID_LINEWORK`]: "FOUNDATION_SOLID_LINEWORK",
    [`UTILITY_FOUNDATION_LINEWORK`]: "UTILITY_FOUNDATION_LINEWORK",
    [`ANNOT_LINEWORK`]: "ANNOT_LINEWORK",
    [`ANNOT_NOTE`]: "ANNOT_NOTE",
    [`ANNOT_DETAIL`]: "ANNOT_DETAIL",
    [`ANNOT_DIM_GROUP`]: "ANNOT_DIM_GROUP",
    [`ANNOT_DIM_LABEL`]: "ANNOT_DIM_LABEL",
    [`ANNOT_DIM_LINE`]: "ANNOT_DIM_LINE",
    [`ANNOT_DIM_LINEWORK`]: "ANNOT_DIM_LINEWORK",
    [`ANNOT_DIM_TICK`]: "ANNOT_DIM_TICK",
    [`ANNOT_DIM_WITNESS`]: "ANNOT_DIM_WITNESS",
    [`ALL_LVL_ANNOT_LINEWORK`]: "ALL_LVL_ANNOT_LINEWORK",
    [`ALL_LVL_ANNOT_NOTE`]: "ALL_LVL_ANNOT_NOTE",
    [`ALL_LVL_ANNOT_DETAIL`]: "ALL_LVL_ANNOT_DETAIL",
    [`ALL_LVL_ANNOT_DIM_GROUP`]: "ALL_LVL_ANNOT_DIM_GROUP",
    [`ALL_LVL_ANNOT_DIM_LABEL`]: "ALL_LVL_ANNOT_DIM_LABEL",
    [`ALL_LVL_ANNOT_DIM_LINE`]: "ALL_LVL_ANNOT_DIM_LINE",
    [`ALL_LVL_ANNOT_DIM_LINEWORK`]: "ALL_LVL_ANNOT_DIM_LINEWORK",
    [`ALL_LVL_ANNOT_DIM_TICK`]: "ALL_LVL_ANNOT_DIM_TICK",
    [`ALL_LVL_ANNOT_DIM_WITNESS`]: "ALL_LVL_ANNOT_DIM_WITNESS",
    [`TOP_OF_PLATE_MARKERS`]: "TOP_OF_PLATE_MARKERS",
    [`TOP_OF_PLATE_DIMENSIONS`]: "TOP_OF_PLATE_DIMENSIONS",
    [`DORMER_WINDOW_VERTICAL_DIMENSIONS`]: "DORMER_WINDOW_VERTICAL_DIMENSIONS",
    [`DORMER_WINDOW_TAGS`]: "DORMER_WINDOW_TAGS",
    [`ROOF_TRUNCATION_HEIGHT_DIMENSIONS`]: "ROOF_TRUNCATION_HEIGHT_DIMENSIONS",
    [`ROOF_HORIZONTAL_PLACEMENT_DIMENSIONS`]: "ROOF_HORIZONTAL_PLACEMENT_DIMENSIONS",
    [`ROOF_WIDTH_DIMENSIONS`]: "ROOF_WIDTH_DIMENSIONS",
    [`ROOF_GABLE_WINDOW_VERTICAL_DIMENSIONS`]: "ROOF_GABLE_WINDOW_VERTICAL_DIMENSIONS",
    [`ROOF_GABLE_WINDOW_TAGS`]: "ROOF_GABLE_WINDOW_TAGS",
    [`ROOF_DIM_ANNOTATION`]: "ROOF_DIM_ANNOTATION",
    [`ROOF_SLOPE_SYMBOL`]: "ROOF_SLOPE_SYMBOL",
    [`WINDOW_HEADER_ANNOTATION`]: "WINDOW_HEADER_ANNOTATION",
    [`ELEVATION_MARKERS`]: "ELEVATION_MARKERS",
    [`MATERIAL_TAGS`]: "MATERIAL_TAGS",
    [`GRADE_LINE`]: "GRADE_LINE",
    [`ELECTRICAL_CONTROLLERS`]: "ELECTRICAL_CONTROLLERS",
    [`ELECTRICAL_LINKS`]: "ELECTRICAL_LINKS",
    [`ELECTRICAL_LOADS`]: "ELECTRICAL_LOADS",
    [`ELECTRIC_LOAD_LABEL`]: "ELECTRIC_LOAD_LABEL",
    [`PROP_FILL`]: "PROP_FILL",
    [`PROP_APPLIANCES`]: "PROP_APPLIANCES",
    [`PROP_FIXTURES`]: "PROP_FIXTURES",
    [`PROP_FURNITURE`]: "PROP_FURNITURE",
    [`PROP_OTHER`]: "PROP_OTHER",
    [`PROP_FOLIAGE`]: "PROP_FOLIAGE",
    [`PROP_TAG`]: "PROP_TAG",
    [`COLUMN`]: "COLUMN",
    [`DIM_LABEL`]: "DIM_LABEL",
    [`DIM_LINE`]: "DIM_LINE",
    [`DIM_LINEWORK`]: "DIM_LINEWORK",
    [`DIM_TICK`]: "DIM_TICK",
    [`DIM_WITNESS`]: "DIM_WITNESS",
    [`DIM_GROUP`]: "DIM_GROUP",
    [`FOUNDATION_DIM_LABEL`]: "FOUNDATION_DIM_LABEL",
    [`FOUNDATION_DIM_LINE`]: "FOUNDATION_DIM_LINE",
    [`FOUNDATION_DIM_LINEWORK`]: "FOUNDATION_DIM_LINEWORK",
    [`FOUNDATION_DIM_TICK`]: "FOUNDATION_DIM_TICK",
    [`FOUNDATION_DIM_WITNESS`]: "FOUNDATION_DIM_WITNESS",
    [`FOUNDATION_DIM_GROUP`]: "FOUNDATION_DIM_GROUP",
    [`UTILITY_DIM_LABEL`]: "UTILITY_DIM_LABEL",
    [`UTILITY_DIM_LINEWORK`]: "UTILITY_DIM_LINEWORK",
    [`UTILITY_DIM_TICK`]: "UTILITY_DIM_TICK",
    [`UTILITY_DIM_WITNESS`]: "UTILITY_DIM_WITNESS",
    [`WALL_INTERIOR_DIM_LABEL`]: "WALL_INTERIOR_DIM_LABEL",
    [`WALL_INTERIOR_DIM_LINE`]: "WALL_INTERIOR_DIM_LINE",
    [`WALL_INTERIOR_DIM_LINEWORK`]: "WALL_INTERIOR_DIM_LINEWORK",
    [`WALL_INTERIOR_DIM_TICK`]: "WALL_INTERIOR_DIM_TICK",
    [`WALL_INTERIOR_DIM_WITNESS`]: "WALL_INTERIOR_DIM_WITNESS",
    [`WALL_INTERIOR_DIM_GROUP`]: "WALL_INTERIOR_DIM_GROUP",
    [`WALL_EXTERIOR_DIM_LABEL`]: "WALL_EXTERIOR_DIM_LABEL",
    [`WALL_EXTERIOR_DIM_LINE`]: "WALL_EXTERIOR_DIM_LINE",
    [`WALL_EXTERIOR_DIM_LINEWORK`]: "WALL_EXTERIOR_DIM_LINEWORK",
    [`WALL_EXTERIOR_DIM_TICK`]: "WALL_EXTERIOR_DIM_TICK",
    [`WALL_EXTERIOR_DIM_WITNESS`]: "WALL_EXTERIOR_DIM_WITNESS",
    [`WALL_EXTERIOR_DIM_GROUP`]: "WALL_EXTERIOR_DIM_GROUP",
    [`ROOF_OVERHANG_DIM_LABEL`]: "ROOF_OVERHANG_DIM_LABEL",
    [`ROOF_OVERHANG_DIM_LINE`]: "ROOF_OVERHANG_DIM_LINE",
    [`ROOF_OVERHANG_DIM_LINEWORK`]: "ROOF_OVERHANG_DIM_LINEWORK",
    [`ROOF_OVERHANG_DIM_TICK`]: "ROOF_OVERHANG_DIM_TICK",
    [`ROOF_OVERHANG_DIM_WITNESS`]: "ROOF_OVERHANG_DIM_WITNESS",
    [`ROOF_OVERHANG_DIM_GROUP`]: "ROOF_OVERHANG_DIM_GROUP",
    [`CONDITION_TAG`]: "CONDITION_TAG",
    [`CEILING`]: "CEILING",
    [`RAILING`]: "RAILING",
    [`RAILING_PROJECTED`]: "RAILING_PROJECTED",
    [`RAILING_ABOVE`]: "RAILING_ABOVE",
    [`RAILING_PROJECTED_STAIR_ONLY`]: "RAILING_PROJECTED_STAIR_ONLY",
    [`RAILING_ABOVE_STAIR_ONLY`]: "RAILING_ABOVE_STAIR_ONLY",
    [`RAILING_POST`]: "RAILING_POST",
    [`RAILING_POST_STAIR_ONLY`]: "RAILING_POST_STAIR_ONLY",
    [`PORCH_COLUMNS`]: "PORCH_COLUMNS",
    [`PORCH_BEAMS`]: "PORCH_BEAMS",
    [`PORCH`]: "PORCH",
    [`DECK`]: "DECK",
    [`PERIMS_WALL`]: "PERIMS_WALL",
    [`FLOOR_HEIGHT_DIFFERENCE`]: "FLOOR_HEIGHT_DIFFERENCE",
    [`PERIMS_FLOORPLATE`]: "PERIMS_FLOORPLATE",
    [`FLOOR_FILL`]: "FLOOR_FILL",
    [`FLOOR_AREA_CONDITIONED`]: "FLOOR_AREA_CONDITIONED",
    [`FLOOR_AREA_UNCONDITIONED`]: "FLOOR_AREA_UNCONDITIONED",
    [`WALLS`]: "WALLS",
    [`WALL_BOUNDARIES`]: "WALL_BOUNDARIES",
    [`WALL_CORE`]: "WALL_CORE",
    [`WALL_SUBSTRATE`]: "WALL_SUBSTRATE",
    [`WALL_EXTERIOR_FINISH`]: "WALL_EXTERIOR_FINISH",
    [`WALL_EXTERIOR_FINISH_PROJECTED`]: "WALL_EXTERIOR_FINISH_PROJECTED",
    [`STAIR_WALLS`]: "STAIR_WALLS",
    [`CHASE_ROOMS`]: "CHASE_ROOMS",
    [`CASEWORK`]: "CASEWORK",
    [`CASEWORK_SOLID_DASH`]: "CASEWORK_SOLID_DASH",
    [`CASEWORK_POCHE`]: "CASEWORK_POCHE",
    [`WAINSCOTING`]: "WAINSCOTING",
    [`WAINSCOTING_CUT`]: "WAINSCOTING_CUT",
    [`WAINSCOTING_PROJECTED`]: "WAINSCOTING_PROJECTED",
    [`DOORS`]: "DOORS",
    [`DOOR_OPERATION_LINEWORK`]: "DOOR_OPERATION_LINEWORK",
    [`DOOR_CASING_CUT`]: "DOOR_CASING_CUT",
    [`WINDOWS`]: "WINDOWS",
    [`WINDOW_CASING_CUT`]: "WINDOW_CASING_CUT",
    [`WINDOW_CASING_PROJECTED`]: "WINDOW_CASING_PROJECTED",
    [`ROOM_LABELS`]: "ROOM_LABELS",
    [`WINDOW_TAGS`]: "WINDOW_TAGS",
    [`DOOR_TAGS`]: "DOOR_TAGS",
    [`HEADER_FRAMING_TAGS`]: "HEADER_FRAMING_TAGS",
    [`CASEWORK_TAG`]: "CASEWORK_TAG",
    [`OPENING_TAGS`]: "OPENING_TAGS",
    [`INTERIOR_LABELS`]: "INTERIOR_LABELS",
    [`ROOF`]: "ROOF",
    [`FLOOR_FINISH`]: "FLOOR_FINISH",
    [`FLOOR_FRAMING`]: "FLOOR_FRAMING",
    [`FLOOR_FRAMING_LABEL`]: "FLOOR_FRAMING_LABEL",
    [`FLOOR_SYSTEM_TAG`]: "FLOOR_SYSTEM_TAG",
    [`SITE_SHAPE_CONTOURS`]: "SITE_SHAPE_CONTOURS",
    [`SITE_SHAPE_ELEVATION_TAGS`]: "SITE_SHAPE_ELEVATION_TAGS",
    [`SITE_SHAPE_DRIVEWAYS`]: "SITE_SHAPE_DRIVEWAYS",
    [`SITE_SHAPE_ROADS`]: "SITE_SHAPE_ROADS",
    [`ROOF_PERIMS`]: "ROOF_PERIMS",
    [`ROOF_PERIMS_WITH_LEVEL_PERIMS`]: "ROOF_PERIMS_WITH_LEVEL_PERIMS",
    [`ROOF_RIDGE_VENT`]: "ROOF_RIDGE_VENT",
    [`ROOF_RIDGE_VENT_ANNOS`]: "ROOF_RIDGE_VENT_ANNOS",
    [`ROOF_SLOPE_ANNOS`]: "ROOF_SLOPE_ANNOS",
    [`ROOF_SKYLIGHT_ANNOS`]: "ROOF_SKYLIGHT_ANNOS",
    [`ROOF_DORMER_FRAMING`]: "ROOF_DORMER_FRAMING",
    [`ROOF_FRAMING`]: "ROOF_FRAMING",
    [`FOUNDATION_FOOTING`]: "FOUNDATION_FOOTING",
    [`FOUNDATION_PIER`]: "FOUNDATION_PIER",
    [`TRIM`]: "TRIM",
    [`ROOF_FRIEZE_BOARD`]: "ROOF_FRIEZE_BOARD",
    [`ROOF_FASCIA_BOARD`]: "ROOF_FASCIA_BOARD",
    [`ROOF_SOFFIT`]: "ROOF_SOFFIT",
    [`ROOF_FASCIA_TOP_TRIM`]: "ROOF_FASCIA_TOP_TRIM",
    [`ROOF_BELLY_BAND_BOARD`]: "ROOF_BELLY_BAND_BOARD",
    [`ROOF_WALL_BASE_BOARD`]: "ROOF_WALL_BASE_BOARD",
    [`ROOF_EXPOSED_RAFTER`]: "ROOF_EXPOSED_RAFTER",
    [`ROOF_GABLE_VENT`]: "ROOF_GABLE_VENT",
    [`CORNER_BOARD`]: "CORNER_BOARD",
    [`WALL_FRAMING`]: "WALL_FRAMING",
    [`SUB_FLOORING`]: "SUB_FLOORING",
    [`DEBUG_ELEVATION_COLLIDERS`]: "DEBUG_ELEVATION_COLLIDERS",
    [`DEBUG_ELEVATION_NOTE_ENTITIES`]: "DEBUG_ELEVATION_NOTE_ENTITIES",
    [`SKYLIGHTS`]: "SKYLIGHTS",
    [`SECTION_VIEW_CALLOUT`]: "SECTION_VIEW_CALLOUT",
  },
  "SheetGeometryCategory",
);
export const SheetHandleSchema = interf(
  {
    type: lit("SHEET"),
    id: str,
  },
  "SheetHandle",
);
export const SheetInchesSchema = nom("SheetInches");
export const SheetPixelsSchema = nom("SheetPixels");
export const SheetPointsSchema = nom("SheetPoints");
export const SheetTemplateSchema = interf(
  {
    templateType: lit("SHEET"),
    margin: num,
    width: num,
    height: num,
    id: pk("CONTENT_TEMPLATE"),
    labels: fkTable("LABEL", bool),
    entityType: lit("CONTENT_TEMPLATE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "SheetTemplate",
);
export const SheetTemplateInstanceSchema = interf(
  {
    templateType: lit("SHEET"),
    sheetNumberPrefix: str,
    sheetNumber: str,
    id: pk("CONTENT_TEMPLATE_INSTANCE"),
    contentTemplateId: fk("CONTENT_TEMPLATE"),
    parameterValues: fkTable(
      ["LOCAL_PARAMETER", "GLOBAL_PARAMETER", "SYSTEM_PARAMETER"],
      union([
        id("ParameterRef"),
        id("PrimitiveValue"),
        id("OptionPresetValue"),
        id("OptionValue"),
        id("LevelValue"),
        id("UnitValue"),
        id("DataSequenceValue"),
        id("ViewTemplateValue"),
        id("ContentTemplateValue"),
        id("ElevationViewValue"),
        id("SectionViewValue"),
      ]),
    ),
    parentId: opt(
      union(
        [
          fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }),
          fk("ROOM", { hierarchy: ["PARENT"] }),
          fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] }),
          fk("ELEVATION_VIEW", { hierarchy: ["PARENT"] }),
          fk("SECTION_VIEW", { hierarchy: ["PARENT"] }),
          fk("CONTENT_TEMPLATE_INSTANCE", { hierarchy: ["PARENT"] }),
          fk("LEVEL", { hierarchy: ["PARENT"] }),
          fk("PLAN_SET_TEMPLATE", { hierarchy: ["PARENT"] }),
        ],
        "DocEntityParentId",
      ),
    ),
    entityType: lit("CONTENT_TEMPLATE_INSTANCE"),
    name: str,
    sortIndex: num,
    labels: fkTable("LABEL", bool),
    disabled: id("ParameterFormulaDisabledField"),
  },
  "SheetTemplateInstance",
);
export const ShutterConfigurationTypeSchema = enu(
  {
    [`BOTH`]: "BOTH",
    [`LEFT`]: "LEFT",
    [`RIGHT`]: "RIGHT",
  },
  "ShutterConfigurationType",
);
export const ShutterShapeTypeSchema = enu(
  {
    [`RECTANGULAR`]: "RECTANGULAR",
    [`ARCHED`]: "ARCHED",
  },
  "ShutterShapeType",
);
export const ShutterStreetOrientationPreferenceSchema = enu(
  {
    [`FRONT`]: "FRONT",
    [`NOT_BACK`]: "NOT_BACK",
    [`ALL`]: "ALL",
  },
  "ShutterStreetOrientationPreference",
);
export const ShutterVerticalAlignmentSchema = enu(
  {
    [`TOP`]: "TOP",
    [`CENTER`]: "CENTER",
    [`BOTTOM`]: "BOTTOM",
  },
  "ShutterVerticalAlignment",
);
export const SideCasingSettingsSchema = interf(
  {
    sideCasingType: id("SideCasingType"),
    sideCasingWidth: opt(num),
    sideCasingDepth: opt(num),
    sideCasingMaterial: opt(id("ExteriorMaterial")),
    sideCasingTopOffset: opt(num),
    sideCasingBottomOffset: opt(num),
  },
  "SideCasingSettings",
);
export const SideCasingTypeSchema = enu(
  {
    [`DISABLED`]: "DISABLED",
    [`TRIM`]: "TRIM",
  },
  "SideCasingType",
);
export const SidewalkSiteShapeSchema = interf(
  {
    type: lit("SIDEWALK"),
    id: pk("SITE_SHAPE"),
    parentId: union([fk("SITE", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    geom: any,
    entityType: lit("SITE_SHAPE"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "SidewalkSiteShape",
);
export const SignSchema = enu(
  {
    [`ADDITIVE`]: "ADDITIVE",
    [`SUBTRACTIVE`]: "SUBTRACTIVE",
  },
  "Sign",
);
export const SimpleSlatShutterSettingsSchema = interf(
  {
    shutterType: lit("SIMPLE_SLATS"),
    midSlat: id("OptionalBoolean"),
    type: lit("WINDOW_SHUTTER_SETTINGS"),
    forceShutters: id("OptionalBoolean"),
    shutterShapeOverride: opt(id("ShutterShapeType")),
    shutterWidthOverride: opt(num),
    shutterHeightOverride: opt(num),
    shutterArchRadiusOverride: opt(num),
    verticalAlignment: opt(id("ShutterVerticalAlignment")),
    verticalOffset: opt(num),
    horizontalOffset: opt(num),
    lateralDatum: opt(id("WallLateralDatumAnchor")),
    lateralOffset: opt(num),
    shutterConfiguration: opt(id("ShutterConfigurationType")),
    orientation: opt(id("ShutterStreetOrientationPreference")),
    shutterMaterial: opt(id("ExteriorMaterial")),
    viewNotes: opt(
      mapobj(
        lit("SHUTTER"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "ShutterViewNoteTable",
      ),
    ),
    isLegacyWidthOverride: id("OptionalBoolean"),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "SimpleSlatShutterSettings",
);
export const SingleLightSchema = interf(
  {
    layoutType: lit("SINGLE_LIGHT"),
    controllerPlacementType: opt(arr(id("ControllerSelectionConfig"))),
    loadType: opt(fk("LOAD_DESCRIPTOR")),
    loadSlot: opt(id("LoadTypeSlot")),
    controllerSlot: opt(id("ControllerTypeSlot")),
    addCeilingFan: id("OptionalBoolean"),
    addBathFan: id("OptionalBoolean"),
    singleController: id("OptionalBoolean"),
    roomBoundaryType: opt(id("RoomBoundaryType")),
  },
  "SingleLight",
);
export const SiteSchema = interf(
  {
    id: pk("SITE"),
    type: opt(id("BuiltInSiteType")),
    fittingMode: opt(id("SiteFittingMode")),
    surfaceMaterial: opt(id("ExteriorMaterial")),
    siteResolution: opt(id("SiteResolutionLevel")),
    sideSetback: opt(num),
    backSetback: opt(num),
    frontSetback: opt(num),
    roadWidth: opt(num),
    backRoad: id("OptionalBoolean"),
    homeBackVerticalOffset: opt(num),
    homeFrontVerticalOffset: opt(num),
    siteBaseElevation: opt(num),
    sidewalkWidth: opt(num),
    sidewalkRampLength: opt(num),
    grassCurbWidth: opt(num),
    curbHeight: opt(num),
    frontWalk: id("OptionalBoolean"),
    frontWalkConnectedToDriveway: id("OptionalBoolean"),
    frontWalkConnectedSetback: opt(num),
    frontWalkWidth: opt(num),
    driveway: id("OptionalBoolean"),
    drivewayMaterial: opt(id("ExteriorMaterial")),
    sidewalk: id("OptionalBoolean"),
    curb: id("OptionalBoolean"),
    fence: id("OptionalBoolean"),
    contextHomes: opt(id("ContextHomeProp")),
    fenceHeight: opt(num),
    fenceSetback: opt(num),
    roadVerticalOffset: opt(num),
    entityType: lit("SITE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "Site",
);
export const SiteFillSiteShapeSchema = interf(
  {
    type: lit("SITE_FILL"),
    zHeight: num,
    height: opt(num),
    material: opt(id("ExteriorMaterial")),
    id: pk("SITE_SHAPE"),
    parentId: union([fk("SITE", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    geom: any,
    entityType: lit("SITE_SHAPE"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "SiteFillSiteShape",
);
export const SiteFittingModeSchema = enu(
  {
    [`TIGHT`]: "TIGHT",
    [`MEDIUM`]: "MEDIUM",
    [`LOOSE`]: "LOOSE",
  },
  "SiteFittingMode",
);
export const SiteHandleSchema = interf(
  {
    type: lit("SITE"),
    id: str,
  },
  "SiteHandle",
);
export const SiteOverrideSiteShapeSchema = interf(
  {
    type: lit("SITE_OVERRIDE"),
    zHeight: num,
    height: opt(num),
    material: opt(id("ExteriorMaterial")),
    id: pk("SITE_SHAPE"),
    parentId: union([fk("SITE", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    geom: any,
    entityType: lit("SITE_SHAPE"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "SiteOverrideSiteShape",
);
export const SiteResolutionLevelSchema = enu(
  {
    [`COARSE`]: "COARSE",
    [`MEDIUM`]: "MEDIUM",
    [`FINE`]: "FINE",
  },
  "SiteResolutionLevel",
);
export const SiteShapeSchema = union(
  [
    id("ContourSiteShape"),
    id("DrivewaySiteShape"),
    id("SiteOverrideSiteShape"),
    id("RoadSiteShape"),
    id("SiteFillSiteShape"),
    id("SiteSubtractSiteShape"),
    id("RetainingWallSiteShape"),
    id("LandscapeSiteShape"),
    id("SidewalkSiteShape"),
    id("WalkSiteShape"),
  ],
  "SiteShape",
);
export const SiteShapeHandleSchema = interf(
  {
    type: lit("SITE_SHAPE"),
    id: str,
    parent: id("SiteHandle"),
  },
  "SiteShapeHandle",
);
export const SiteSubtractSiteShapeSchema = interf(
  {
    type: lit("SITE_SUBTRACT"),
    zHeight: num,
    height: opt(num),
    material: opt(id("ExteriorMaterial")),
    id: pk("SITE_SHAPE"),
    parentId: union([fk("SITE", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    geom: any,
    entityType: lit("SITE_SHAPE"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "SiteSubtractSiteShape",
);
export const SkylightHandleSchema = interf(
  {
    type: lit("SKYLIGHT"),
    id: str,
  },
  "SkylightHandle",
);
export const SkylightPlacementSchema = interf(
  {
    id: pk("SKYLIGHT"),
    parentId: opt(union([fk("ROOF", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
    name: str,
    side: id("BuildingSide"),
    horizontalPositions: union([undef, nul, arr(num)]),
    normalizedPositions: id("OptionalBoolean"),
    verticalPosition: opt(num),
    width: opt(num),
    height: opt(num),
    useNewPlacementMethod: id("OptionalBoolean"),
    entityType: lit("SKYLIGHT"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "SkylightPlacement",
);
export const SlabComponentEntitySchema = union([id("ConcreteSlab"), id("WoodSlab")], "SlabComponentEntity");
export const SlabComponentHandleSchema = interf(
  {
    type: lit("SLAB_COMPONENT"),
    id: str,
  },
  "SlabComponentHandle",
);
export const SlabFloorAssemblyEntitySchema = interf(
  {
    id: pk("SLAB_FLOOR_ASSEMBLY"),
    name: str,
    tag: opt(str),
    slabComponentId: fk("SLAB_COMPONENT"),
    subFloorComponentId: fk("SHEATHING_COMPONENT"),
    entityType: lit("SLAB_FLOOR_ASSEMBLY"),
    parentId: opt(str),
    sortIndex: num,
  },
  "SlabFloorAssemblyEntity",
);
export const SlabFloorAssemblyHandleSchema = interf(
  {
    type: lit("SLAB_FLOOR_ASSEMBLY"),
    id: str,
  },
  "SlabFloorAssemblyHandle",
);
export const SlopeSchema = nom("Slope");
export const SnapEntitySchema = enu(
  {
    [`ANNOTATION`]: "ANNOTATION",
    [`CASEWORK`]: "CASEWORK",
    [`CEILING`]: "CEILING",
    [`CMD`]: "CMD",
    [`COLUMN`]: "COLUMN",
    [`CONTENT_TEMPLATE_INSTANCE`]: "CONTENT_TEMPLATE_INSTANCE",
    [`DATA_TABLE`]: "DATA_TABLE",
    [`ELECTRICAL`]: "ELECTRICAL",
    [`FLOOR_FINISH`]: "FLOOR_FINISH",
    [`FOUNDATION`]: "FOUNDATION",
    [`FOUNDATION_PIER`]: "FOUNDATION_PIER",
    [`MEASUREMENT`]: "MEASUREMENT",
    [`SITE_SHAPE`]: "SITE_SHAPE",
    [`OPENING`]: "OPENING",
    [`PORCH_COLUMN`]: "PORCH_COLUMN",
    [`PROP_INSTANCE`]: "PROP_INSTANCE",
    [`RAILING`]: "RAILING",
    [`RAILING_POST`]: "RAILING_POST",
    [`REFERENCE_GEOM`]: "REFERENCE_GEOM",
    [`ROOF`]: "ROOF",
    [`ROOM`]: "ROOM",
    [`SHEET`]: "SHEET",
    [`SECTION_CUT`]: "SECTION_CUT",
    [`SECTION_VIEW`]: "SECTION_VIEW",
    [`SHAPE_EDIT_MODE`]: "SHAPE_EDIT_MODE",
    [`STAIR`]: "STAIR",
    [`UNDERLAY`]: "UNDERLAY",
    [`VIEWPORT`]: "VIEWPORT",
    [`WALL`]: "WALL",
    [`WALL_ASSEMBLY`]: "WALL_ASSEMBLY",
  },
  "SnapEntity",
);
export const SnapKindSchema = enu(
  {
    [`GRID`]: "GRID",
    [`VERTICAL`]: "VERTICAL",
    [`HORIZONTAL`]: "HORIZONTAL",
    [`VERTEX`]: "VERTEX",
    [`MID`]: "MID",
    [`NEAR`]: "NEAR",
    [`INTERSECT`]: "INTERSECT",
    [`PROJECT`]: "PROJECT",
  },
  "SnapKind",
);
export const SolidFramingFloorAssemblySchema = interf(
  {
    floorJoist: fk("FRAMING_COMPONENT"),
    rimBoard: fk("FRAMING_COMPONENT"),
    assemblyId: fk(["FRAME_FLOOR_ASSEMBLY", "SLAB_FLOOR_ASSEMBLY"]),
    structuralType: lit("FRAMING"),
    subFloor: fk("SHEATHING_COMPONENT"),
    topDatumOffset: opt(num),
    assemblyType: lit("SOLID"),
    spanDirection: union([undef, lit("SHORTEST_SPAN"), lit("LONGEST_SPAN"), lit("SPECIFY")]),
    framingAngle: opt(num),
    framingStartPt: opt(arr(num)),
  },
  "SolidFramingFloorAssembly",
);
export const SolidOpeningPlacementSchema = interf(
  {
    type: lit("SOLID"),
    wallStripDomain: bool,
    id: pk("OPENING"),
    name: str,
    parentId: union(
      [fk("ROOM", { hierarchy: ["PARENT"] }), fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] })],
      "DocEntityParentId",
    ),
    edgeId: str,
    handle: union([undef, id("RoomLayoutInstanceHandle"), id("OpeningHandle")]),
    handleAuxiliary: opt(id("OpeningHandle")),
    entityInstanceType: opt(id("EntityInstanceType")),
    entityType: lit("OPENING"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "SolidOpeningPlacement",
);
export const SolidSlabFloorAssemblySchema = interf(
  {
    slab: fk("SLAB_COMPONENT"),
    assemblyId: fk(["FRAME_FLOOR_ASSEMBLY", "SLAB_FLOOR_ASSEMBLY"]),
    structuralType: lit("SLAB"),
    subFloor: fk("SHEATHING_COMPONENT"),
    topDatumOffset: opt(num),
    assemblyType: lit("SOLID"),
  },
  "SolidSlabFloorAssembly",
);
export const SpaceTypeSchema = enu(
  {
    [`EXTERIOR`]: "EXTERIOR",
    [`EXTERIOR_COVERED`]: "EXTERIOR_COVERED",
    [`EXTERIOR_BACK`]: "EXTERIOR_BACK",
    [`EXTERIOR_COVERED_BACK`]: "EXTERIOR_COVERED_BACK",
    [`TRANSITION`]: "TRANSITION",
    [`CIRCULATION`]: "CIRCULATION",
    [`GATHERING`]: "GATHERING",
    [`DINING`]: "DINING",
    [`KITCHEN`]: "KITCHEN",
    [`LIVING`]: "LIVING",
    [`CONTEMPLATIVE`]: "CONTEMPLATIVE",
    [`BEDROOM`]: "BEDROOM",
    [`BATHROOM`]: "BATHROOM",
    [`UTILITY`]: "UTILITY",
    [`STORAGE`]: "STORAGE",
    [`GENERAL`]: "GENERAL",
    [`UNCLASSIFIED`]: "UNCLASSIFIED",
  },
  "SpaceType",
);
export const SpaceTypeFilterSchema = interf(
  {
    spaceType: id("SpaceType"),
    negate: id("OptionalBoolean"),
  },
  "SpaceTypeFilter",
);
export const SpacingTypeSchema = enu(
  {
    [`SEGMENT_END_POINTS`]: "SEGMENT_END_POINTS",
    [`SEGMENT_MID_POINT`]: "SEGMENT_MID_POINT",
  },
  "SpacingType",
);
export const SpanDirectionSchema = enu(
  {
    [`SHORTEST_SPAN`]: "SHORTEST_SPAN",
    [`LONGEST_SPAN`]: "LONGEST_SPAN",
    [`SPECIFY`]: "SPECIFY",
  },
  "SpanDirection",
);
export const SpanRatingSchema = enu(
  {
    [`"SR12"`]: "SR12",
    [`"SR16"`]: "SR16",
    [`"SR20"`]: "SR20",
    [`"SR24"`]: "SR24",
    [`"SR32/16"`]: "SR32/16",
    [`"SR40/20"`]: "SR40/20",
    [`"SR48/24"`]: "SR48/24",
  },
  "SpanRating",
);
export const SplitLineSchema = union(
  [
    ref(
      interf(
        {
          id: str,
          splitterType: typeParam("T"),
          polyline: any,
          edgeIds: arr(str),
          edgeOverrides: opt(
            obj(
              interf(
                {
                  thickness: opt(num),
                  framingComponentId: opt(fk("FRAMING_COMPONENT")),
                  framingProfile: opt(id("LumberProfileType")),
                  joistAlignment: opt(
                    enu(
                      {
                        [`FLUSH_TOP`]: "FLUSH_TOP",
                        [`FLUSH_BOTTOM`]: "FLUSH_BOTTOM",
                        [`DROPPED`]: "DROPPED",
                      },
                      "SplitLineJoistAlignment",
                    ),
                  ),
                  supportFramingCondition: opt(
                    enu(
                      {
                        [`RUN_OVER`]: "RUN_OVER",
                        [`LAP_JOINT`]: "LAP_JOINT",
                      },
                      "SplitLineSupportFramingCondition",
                    ),
                  ),
                  spliceLength: opt(num),
                },
                "SplitLineEdgeOverride",
              ),
              "SplitLineEdgeOverridesTable",
            ),
          ),
        },
        "SplitLineBase",
        ["T"],
      ),
      { T: lit("MANUAL_LINE_SPLITTER") },
    ),
    ref(
      interf(
        {
          id: str,
          splitterType: typeParam("T"),
          polyline: any,
          edgeIds: arr(str),
          edgeOverrides: opt(
            obj(
              interf(
                {
                  thickness: opt(num),
                  framingComponentId: opt(fk("FRAMING_COMPONENT")),
                  framingProfile: opt(id("LumberProfileType")),
                  joistAlignment: opt(
                    enu(
                      {
                        [`FLUSH_TOP`]: "FLUSH_TOP",
                        [`FLUSH_BOTTOM`]: "FLUSH_BOTTOM",
                        [`DROPPED`]: "DROPPED",
                      },
                      "SplitLineJoistAlignment",
                    ),
                  ),
                  supportFramingCondition: opt(
                    enu(
                      {
                        [`RUN_OVER`]: "RUN_OVER",
                        [`LAP_JOINT`]: "LAP_JOINT",
                      },
                      "SplitLineSupportFramingCondition",
                    ),
                  ),
                  spliceLength: opt(num),
                },
                "SplitLineEdgeOverride",
              ),
              "SplitLineEdgeOverridesTable",
            ),
          ),
        },
        "SplitLineBase",
        ["T"],
      ),
      { T: lit("WALL_LINE_SPLITTER") },
    ),
    ref(
      interf(
        {
          id: str,
          splitterType: typeParam("T"),
          polyline: any,
          edgeIds: arr(str),
          edgeOverrides: opt(
            obj(
              interf(
                {
                  thickness: opt(num),
                  framingComponentId: opt(fk("FRAMING_COMPONENT")),
                  framingProfile: opt(id("LumberProfileType")),
                  joistAlignment: opt(
                    enu(
                      {
                        [`FLUSH_TOP`]: "FLUSH_TOP",
                        [`FLUSH_BOTTOM`]: "FLUSH_BOTTOM",
                        [`DROPPED`]: "DROPPED",
                      },
                      "SplitLineJoistAlignment",
                    ),
                  ),
                  supportFramingCondition: opt(
                    enu(
                      {
                        [`RUN_OVER`]: "RUN_OVER",
                        [`LAP_JOINT`]: "LAP_JOINT",
                      },
                      "SplitLineSupportFramingCondition",
                    ),
                  ),
                  spliceLength: opt(num),
                },
                "SplitLineEdgeOverride",
              ),
              "SplitLineEdgeOverridesTable",
            ),
          ),
        },
        "SplitLineBase",
        ["T"],
      ),
      { T: lit("BEAM_LINE_SPLITTER") },
    ),
  ],
  "SplitLine",
);
export const StackedLevelDatumEntitySchema = interf(
  {
    datumType: lit("STACKED_LEVEL"),
    direction: lit("VERTICAL"),
    offsetType: lit("RELATIVE"),
    justification: id("VerticalJustification"),
    id: pk("DATUM"),
    offsetNormalized: id("OptionalBoolean"),
    offset: opt(num),
    entityType: lit("DATUM"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "StackedLevelDatumEntity",
);
export const StackedLevelPlacementSchema = interf(
  {
    automaticStacking: bool,
    stackAbove: opt(fk("LEVEL")),
    type: lit("STACKED"),
  },
  "StackedLevelPlacement",
);
export const StairBlockSchema = union([id("StairBlockRun"), id("StairBlockLanding")], "StairBlock");
export const StairBlockDatumHostingSchema = interf(
  {
    type: lit("DATUM"),
    childType: id("StairBlockType"),
    childAlignment: id("StairVerticalAlignment"),
    datum: opt(fk("DATUM")),
    offset: num,
  },
  "StairBlockDatumHosting",
);
export const StairBlockEdgeHostingSchema = interf(
  {
    type: lit("EDGE"),
    childAlignment: id("StairVerticalAlignment"),
    hostId: opt(str),
    hostEdgeId: opt(str),
    childEdgeId: opt(str),
    horizontal: opt(id("HorizontalAlignment")),
    vertical: opt(id("VerticalAlignment")),
    lateral: opt(id("LateralAlignment")),
    childType: id("StairBlockType"),
    datum: opt(fk("DATUM")),
    offset: num,
  },
  "StairBlockEdgeHosting",
);
export const StairBlockHandleSchema = interf(
  {
    type: lit("STAIR_BLOCK"),
    id: str,
  },
  "StairBlockHandle",
);
export const StairBlockHostingSchema = union(
  [id("StairBlockEdgeHosting"), id("StairBlockDatumHosting")],
  "StairBlockHosting",
);
export const StairBlockLandingSchema = interf(
  {
    type: lit("LANDING"),
    stepUpFromPreviousLanding: id("OptionalBoolean"),
    datumVertical: opt(fk(["DATUM", "ROOM", "LEVEL", "STAIR_BLOCK"])),
    id: pk("STAIR_BLOCK"),
    parentId: opt(union([fk("STAIR_SYSTEM", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
    stairSystemId: fk("STAIR_SYSTEM"),
    outline: any,
    edgeIds: arr(str),
    construction: opt(id("StairConstruction")),
    generated: id("OptionalBoolean"),
    hosting: opt(id("StairBlockHosting")),
    entityType: lit("STAIR_BLOCK"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "StairBlockLanding",
);
export const StairBlockRunSchema = interf(
  {
    type: lit("RUN"),
    treadJustification: id("TreadJustification"),
    startEdgeId: str,
    datumVerticalUpper: opt(fk(["DATUM", "ROOM", "LEVEL", "STAIR_BLOCK"])),
    datumVerticalLower: opt(fk(["DATUM", "ROOM", "LEVEL", "STAIR_BLOCK"])),
    hostingUpper: opt(id("StairBlockHosting")),
    hostingLower: opt(id("StairBlockHosting")),
    id: pk("STAIR_BLOCK"),
    parentId: opt(union([fk("STAIR_SYSTEM", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
    stairSystemId: fk("STAIR_SYSTEM"),
    outline: any,
    edgeIds: arr(str),
    construction: opt(id("StairConstruction")),
    generated: id("OptionalBoolean"),
    hosting: opt(id("StairBlockHosting")),
    entityType: lit("STAIR_BLOCK"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "StairBlockRun",
);
export const StairBlockTypeSchema = enu(
  {
    [`RUN`]: "RUN",
    [`LANDING`]: "LANDING",
  },
  "StairBlockType",
);
export const StairBottomShapeSchema = enu(
  {
    [`FLAT`]: "FLAT",
    [`SLOPED`]: "SLOPED",
  },
  "StairBottomShape",
);
export const StairCatalogSettingsSchema = interf(
  {
    type: lit("STAIR_CATALOG_SETTINGS"),
    stairSettingsTable: pkTable("STAIR_SETTING", id("StairSetting")),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "StairCatalogSettings",
);
export const StairConfigSchema = interf(
  {
    minTreadDepth: num,
    maxTreadDepth: num,
    landingDepth: opt(num),
    landingMaterial: opt(id("MaterialSrc")),
    desiredTreadDepth: num,
    desiredRunWidth: opt(num),
    maxRiserHeight: num,
    desiredRiserHeight: num,
    minimumClearWidth: num,
    stringerPerpDepthFromStairNotch: num,
    construction: opt(id("StairConstruction")),
  },
  "StairConfig",
);
export const StairConstructionSchema = union(
  [id("MonolithicStair"), id("AssembledStair"), id("GenericStair")],
  "StairConstruction",
);
export const StairIsolatedFoundationPatternSchema = interf(
  {
    hostType: lit("STAIR_BLOCK"),
    postId: fk("COLUMN_DESCRIPTOR"),
    postMaterial: opt(id("MaterialSrc")),
    verticalDatum: id("VerticalDatumData"),
    patternType: lit("ISOLATED"),
    positions: arr(id("PierPosition")),
    assemblyId: fk("FOUNDATION_ASSEMBLY"),
    xOffset: num,
    yOffset: num,
    pierRotation: num,
    foundationLevelId: opt(fk("LEVEL")),
    topDatumId: opt(fk("DATUM")),
    bottomDatumId: opt(fk("DATUM")),
    edgeBehaviorId: opt(fk("EDGE_BEHAVIOR")),
  },
  "StairIsolatedFoundationPattern",
);
export const StairSettingSchema = interf(
  {
    id: pk("STAIR_SETTING"),
    name: str,
    config: id("StairConfig"),
    catalogItemType: lit("STAIR_SETTING"),
    entityType: lit("STAIR_SETTING"),
    parentId: opt(str),
    sortIndex: num,
  },
  "StairSetting",
);
export const StairSettingHandleSchema = interf(
  {
    type: lit("STAIR_SETTING"),
    id: str,
  },
  "StairSettingHandle",
);
export const StairSystemSchema = interf(
  {
    id: pk("STAIR_SYSTEM"),
    levelId: fk("LEVEL"),
    config: id("StairConfig"),
    contextAware: id("OptionalBoolean"),
    defaultConstruction: opt(id("StairConstruction")),
    stairSettingId: union([fk("STAIR_CATALOG_SETTINGS"), fk("STAIR_SETTING"), undef]),
    entityType: lit("STAIR_SYSTEM"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    labels: fkTable("LABEL", bool),
  },
  "StairSystem",
);
export const StairSystemHandleSchema = interf(
  {
    type: lit("STAIR_SYSTEM"),
    id: str,
  },
  "StairSystemHandle",
);
export const StairVerticalAlignmentSchema = enu(
  {
    [`TOP`]: "TOP",
    [`BOTTOM`]: "BOTTOM",
  },
  "StairVerticalAlignment",
);
export const StandardOutletSchema = interf(
  {
    layoutType: lit("STANDARD_OUTLETS"),
    loadType: opt(fk("LOAD_DESCRIPTOR")),
    loadSlot: opt(id("LoadTypeSlot")),
    outletSpacing: opt(num),
    minWallLength: opt(num),
    singleOutletMax: opt(num),
  },
  "StandardOutlet",
);
export const StaticRoomSchema = interf(
  {
    id: pk("ROOM"),
    type: id("RoomType"),
    parentId: union([fk("BLOCK", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    attributes: opt(id("StaticRoomAttributes")),
    wallMaterial: opt(
      union([
        lit("glass0"),
        lit("glass1"),
        lit("glass2"),
        lit("propDefault0"),
        lit("propDefault1"),
        lit("propDefault2"),
        lit("floorInterior0"),
        lit("floorInterior1"),
        lit("floorInterior2"),
        lit("floorInterior3"),
        lit("floorInterior4"),
        lit("floorInterior5"),
        lit("wallInterior0"),
        lit("wallInterior1"),
        lit("wallInterior2"),
        lit("trimInterior0"),
        lit("trimInterior1"),
        lit("trimInterior2"),
        lit("ceiling0"),
        lit("ceiling1"),
        lit("ceiling2"),
        lit("doorInterior0"),
        lit("doorInterior1"),
        lit("doorInterior2"),
        lit("doorFixture0"),
        lit("doorFixture1"),
        lit("doorFixture2"),
      ]),
    ),
    suppressElectricalFromSettings: id("OptionalBoolean"),
    useBuiltinLayout: bool,
    removeBuiltInOpenings: id("OptionalBoolean"),
    disableInteriorDimensions: id("OptionalBoolean"),
    disableFoundationGeneration: id("OptionalBoolean"),
    entityType: lit("ROOM"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    nameInPlan: opt(str),
    tagDetails: opt(str),
    ceilingHeightTagOverride: opt(str),
    floorMaterialTagOverride: opt(str),
    areaTagOverride: opt(str),
    roomTagTemplateId: opt(fk("CONTENT_TEMPLATE")),
    tagDimensionControl: opt(id("RoomTagDimensionControl")),
    addCeilingHeightToRoomTag: id("OptionalBoolean"),
    addFloorMaterialToRoomTag: id("OptionalBoolean"),
    labels: fkTable("LABEL", bool),
    outline: any,
    edgeIds: arr(str),
  },
  "StaticRoom",
);
export const StaticRoomAttributesSchema = interf(
  {
    roomEnclosure: opt(id("RoomEnclosure")),
    roomClass: opt(id("RoomClass")),
    bedroomCount: opt(num),
    bathroomCount: opt(num),
    garageCount: opt(num),
    singleDoor: id("OptionalBoolean"),
    openToBelow: id("OptionalBoolean"),
    openToAbove: id("OptionalBoolean"),
    openToAdjacent: id("OptionalBoolean"),
    isCirculation: id("OptionalBoolean"),
    exteriorCeilingMaterial: opt(id("ExteriorMaterial")),
    windowType: opt(id("BuiltinWindowId")),
    hasBaseTrimMolding: id("OptionalBoolean"),
    hasInteriorWallFacades: id("OptionalBoolean"),
    hasCurb: id("OptionalBoolean"),
    lightIntensityOverride: opt(num),
    hiddenInEditor: id("OptionalBoolean"),
    roomTagHiddenInPlan: id("OptionalBoolean"),
    roomSalesLabelHiddenInBrochure: id("OptionalBoolean"),
    labelDimensionType: opt(id("RoomLabelDimensionType")),
    labelWidthOverride: opt(str),
    labelHeightOverride: opt(str),
    hasExteriorTrim: id("OptionalBoolean"),
    hasCrownTrimMolding: id("OptionalBoolean"),
    disableInteriorDimensions: id("OptionalBoolean"),
    removeFloorStructure: id("OptionalBoolean"),
  },
  "StaticRoomAttributes",
);
export const StoolCasingSettingsSchema = interf(
  {
    stoolCasingType: id("StoolCasingType"),
    stoolCasingThickness: opt(num),
    stoolCasingDepth: opt(num),
    stoolCasingExtension: opt(num),
    stoolCasingMaterial: id("ExteriorMaterial"),
  },
  "StoolCasingSettings",
);
export const StoolCasingTypeSchema = enu(
  {
    [`DISABLED`]: "DISABLED",
    [`TRIM`]: "TRIM",
  },
  "StoolCasingType",
);
export const StreetOrientationModeSchema = enu(
  {
    [`ALL_FACES`]: "ALL_FACES",
    [`FRONT_FACES`]: "FRONT_FACES",
    [`FRONT_AND_SIDE_FACES`]: "FRONT_AND_SIDE_FACES",
    [`FRONT_AND_BACK_FACES`]: "FRONT_AND_BACK_FACES",
    [`NO_FACES`]: "NO_FACES",
  },
  "StreetOrientationMode",
);
export const StringAtomSchema = str;
export const StringerSchema = interf(
  {
    positioning: id("StringerPositioning"),
    position: num,
    width: num,
    closed: bool,
  },
  "Stringer",
);
export const StringerLayoutSchema = enu(
  {
    [`AUTOMATIC`]: "AUTOMATIC",
    [`MANUAL`]: "MANUAL",
  },
  "StringerLayout",
);
export const StringerPositioningSchema = enu(
  {
    [`PERCENTAGE`]: "PERCENTAGE",
    [`FROM_LEFT`]: "FROM_LEFT",
    [`FROM_RIGHT`]: "FROM_RIGHT",
  },
  "StringerPositioning",
);
export const StripFootingEntitySchema = interf(
  {
    footingWidth: num,
    footingDepth: num,
    footingPadding: num,
    lateralOffset: opt(num),
    footingType: lit("STRIP"),
    id: pk("FOUNDATION_COMPONENT"),
    name: str,
    componentType: lit("FOOTING"),
    material: opt(id("ExteriorMaterial")),
    entityType: lit("FOUNDATION_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "StripFootingEntity",
);
export const StructuralFloorTypeSchema = enu(
  {
    [`FRAMING`]: "FRAMING",
    [`SLAB`]: "SLAB",
  },
  "StructuralFloorType",
);
export const StructuralMaterialSchema = union(
  [
    ref(
      interf(
        {
          type: typeParam("T"),
          name: str,
          thickness: num,
          catalogItemType: typeParam("T"),
        },
        "StructuralMaterialBase",
        ["T"],
      ),
      {
        T: enu(
          {
            [`STRUCTURE`]: "STRUCTURE",
            [`SUBSTRATE_PLYWOOD_SR16`]: "SUBSTRATE_PLYWOOD_SR16",
            [`SUBSTRATE_PLYWOOD_SR24`]: "SUBSTRATE_PLYWOOD_SR24",
            [`SUBSTRATE_PLYWOOD_SR32`]: "SUBSTRATE_PLYWOOD_SR32",
            [`SUBSTRATE_OSB_SR16`]: "SUBSTRATE_OSB_SR16",
            [`SUBSTRATE_OSB_SR32`]: "SUBSTRATE_OSB_SR32",
          },
          "FloorMaterialType",
        ),
      },
    ),
    ref(
      interf(
        {
          type: typeParam("T"),
          name: str,
          thickness: num,
          catalogItemType: typeParam("T"),
        },
        "StructuralMaterialBase",
        ["T"],
      ),
      {
        T: enu(
          {
            [`FOUNDATION`]: "FOUNDATION",
            [`STRUCTURE`]: "STRUCTURE",
            [`SUBSTRATE`]: "SUBSTRATE",
            [`THERMAL`]: "THERMAL",
            [`MEMBRANE`]: "MEMBRANE",
            [`INTERIOR_FINISH`]: "INTERIOR_FINISH",
            [`EXTERIOR_FINISH`]: "EXTERIOR_FINISH",
            [`AIRGAP`]: "AIRGAP",
          },
          "WallMaterialType",
        ),
      },
    ),
  ],
  "StructuralMaterial",
);
export const StructuralWoodPostDescriptorSchema = interf(
  {
    postThickness: num,
    postWidth: num,
    columnMaterial: lit("WOOD"),
    built: lit("POST"),
    paletteId: id("ExteriorMaterial"),
    verticalDatum: id("VerticalDatumData"),
    name: str,
    entityType: lit("COLUMN"),
    subType: lit("STRUCTURAL"),
    viewNotes: opt(
      mapobj(
        lit("COLUMN"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "ColumnViewNoteTable",
      ),
    ),
    elevationNoteEnabled: id("OptionalBoolean"),
    elevationNote: opt(str),
    catalogItemType: lit("COLUMN_DESCRIPTOR"),
  },
  "StructuralWoodPostDescriptor",
);
export const StructureSettingsSchema = interf(
  {
    type: lit("STRUCTURE_SETTINGS"),
    maxUnsupportedCornerSpan: opt(num),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "StructureSettings",
);
export const StylingEffectSchema = interf(
  {
    type: lit("STYLING"),
    lineStyleOverrides: id("LineStyle"),
    textStyleOverrides: id("TextStyle"),
    id: pk("EFFECT"),
    categories: arr(id("SheetGeometryCategory")),
    parentId: opt(union([fk("VIEW_TEMPLATE_OVERRIDE", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
    entityType: lit("EFFECT"),
    name: str,
    sortIndex: num,
  },
  "StylingEffect",
);
export const SwingSideSchema = enu(
  {
    [`NONE`]: "NONE",
    [`LEFT`]: "LEFT",
    [`RIGHT`]: "RIGHT",
  },
  "SwingSide",
);
export const SystemDataSequenceSchema = interf(
  {
    sequenceType: lit("SYSTEM"),
    source: union([
      lit("WALL"),
      lit("PROP"),
      lit("CASEWORK"),
      lit("CEILING"),
      lit("ROOF"),
      lit("DOOR"),
      lit("WINDOW"),
      lit("ELECTRICAL"),
      lit("SLAB"),
      lit("FOOTING"),
      lit("FRAMING"),
      lit("FLOORING"),
      lit("FLOOR_MATERIALS_SUMMARY"),
      lit("INTERIOR_FINISH"),
      lit("ROOF_AREA"),
      lit("ROOF_ANALYTIC_AREA"),
      lit("ROOF_ANALYTIC_LENGTH"),
      lit("ROOF_RIDGE"),
      lit("ROOF_RIDGE_VENT"),
      lit("ROOF_VALLEY"),
      lit("ROOF_EAVE"),
      lit("ROOF_FLASHING"),
      lit("WALL_AREA"),
      lit("BUILDING_AREA"),
      lit("BUILDING_OPTION"),
      lit("BUILDING_PRESET"),
      lit("MILLWORK"),
      lit("EXTERIOR_TRIM"),
      lit("EXTERIOR_FINISH"),
      lit("OPENING_TRIM"),
      lit("OPENING_CASING"),
      lit("SHEETS"),
    ]),
    id: pk("DATA_SEQUENCE"),
    entityType: lit("DATA_SEQUENCE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "SystemDataSequence",
);
export const SystemOptionSetSchema = interf(
  {
    optionSetType: lit("SYSTEM"),
    id: pk("OPTION_SET"),
    defaultValue: str,
    options: pkTable("OPTION", id("DocOption"), true),
    salesCategory: str,
    builderOptionSetCode: union([undef, nul, str]),
    category: opt(str),
    description: opt(str),
    tags: opt(arr(str)),
    disabled: id("OptionalBoolean"),
    globalSortOrder: opt(num),
    showroomIntro: id("OptionalBoolean"),
    displayType: union([undef, lit("CARDS"), lit("TABLE")]),
    readonly: id("OptionalBoolean"),
    entityType: lit("OPTION_SET"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    labels: fkTable("LABEL", bool),
  },
  "SystemOptionSet",
);
export const SystemParameterSchema = union(
  [
    inters([
      id("NumberParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SYSTEM_PARAMETER") },
      ),
      interf({
        parentId: undef,
      }),
    ]),
    inters([
      id("TextParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SYSTEM_PARAMETER") },
      ),
      interf({
        parentId: undef,
      }),
    ]),
    inters([
      id("UrlParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SYSTEM_PARAMETER") },
      ),
      interf({
        parentId: undef,
      }),
    ]),
    inters([
      id("OptionChoiceParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SYSTEM_PARAMETER") },
      ),
      interf({
        parentId: undef,
      }),
    ]),
    inters([
      id("OptionPresetParameter"),
      ref(
        interf(
          {
            entityType: typeParam("T"),
            name: str,
            id: str,
            parentId: opt(str),
            sortIndex: num,
          },
          "DocEntityBase",
          ["T"],
        ),
        { T: lit("SYSTEM_PARAMETER") },
      ),
      interf({
        parentId: undef,
      }),
    ]),
  ],
  "SystemParameter",
);
export const SystemParameterHandleSchema = interf(
  {
    type: lit("SYSTEM_PARAMETER"),
    id: str,
  },
  "SystemParameterHandle",
);
export const TagTemplateSchema = interf(
  {
    drawingType: lit("TAG"),
    targetEntityType: lit("ROOM"),
    templateType: lit("DRAWING"),
    id: pk("CONTENT_TEMPLATE"),
    labels: fkTable("LABEL", bool),
    entityType: lit("CONTENT_TEMPLATE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "TagTemplate",
);
export const TallCabinetDescriptorSchema = interf(
  {
    height: num,
    type: lit("TALL_CABINET"),
    width: num,
    shape: opt(id("CabinetShape")),
    superType: lit("CABINET"),
    id: pk("CASEWORK_DESCRIPTOR"),
    name: str,
    floorMaterialOverride: opt(id("InteriorFloorMaterialOverride")),
    tag: opt(str),
    tagOffset: opt(num),
    catalogItemType: lit("CASEWORK_DESCRIPTOR"),
  },
  "TallCabinetDescriptor",
);
export const TextAlignmentSchema = enu(
  {
    [`LEFT`]: "LEFT",
    [`CENTER`]: "CENTER",
    [`RIGHT`]: "RIGHT",
  },
  "TextAlignment",
);
export const TextBackgroundSchema = enu(
  {
    [`OUTLINE`]: "OUTLINE",
    [`SOLID`]: "SOLID",
  },
  "TextBackground",
);
export const TextParameterSchema = interf(
  {
    defaultValue: opt(str),
    type: lit("TEXT"),
  },
  "TextParameter",
);
export const TextStyleSchema = interf(
  {
    fontColor: opt(str),
    fontSize: opt(nom("SheetInches")),
    font: opt(id("FontId")),
    fontOpacity: opt(nom("Percent")),
    background: opt(id("TextBackground")),
    backgroundColor: opt(str),
    strokeColor: opt(str),
    strokeWidth: opt(nom("SheetPoints")),
    boxVerticalAlignmentPercentageOffset: opt(num),
    alignment: opt(id("TextAlignment")),
    verticalAlignment: opt(id("TextVerticalAlignment")),
  },
  "TextStyle",
);
export const TextVerticalAlignmentSchema = enu(
  {
    [`TOP`]: "TOP",
    [`CENTER`]: "CENTER",
    [`BOTTOM`]: "BOTTOM",
  },
  "TextVerticalAlignment",
);
export const TrayFreeformSchema = interf(
  {
    heightType: id("HeightType"),
    height: num,
    type: lit("TRAY_FREEFORM"),
    outline: any,
    ceilingMaterial: opt(
      union([
        lit("glass0"),
        lit("glass1"),
        lit("glass2"),
        lit("propDefault0"),
        lit("propDefault1"),
        lit("propDefault2"),
        lit("floorInterior0"),
        lit("floorInterior1"),
        lit("floorInterior2"),
        lit("floorInterior3"),
        lit("floorInterior4"),
        lit("floorInterior5"),
        lit("wallInterior0"),
        lit("wallInterior1"),
        lit("wallInterior2"),
        lit("trimInterior0"),
        lit("trimInterior1"),
        lit("trimInterior2"),
        lit("ceiling0"),
        lit("ceiling1"),
        lit("ceiling2"),
        lit("doorInterior0"),
        lit("doorInterior1"),
        lit("doorInterior2"),
        lit("doorFixture0"),
        lit("doorFixture1"),
        lit("doorFixture2"),
      ]),
    ),
    ceilingDatum: opt(
      inters(
        [
          id("DatumUsageBase"),
          interf({
            __usage: lit("CEILING"),
          }),
        ],
        "DatumUsage",
      ),
    ),
    labels: fkTable("LABEL", bool),
    disabled: id("FormulaDisabledField"),
  },
  "TrayFreeform",
);
export const TraySimpleOffsetSchema = interf(
  {
    heightType: id("HeightType"),
    height: num,
    type: lit("TRAY_SIMPLE_OFFSET"),
    boundaryType: id("CeilingBoundaryType"),
    offset: num,
    ceilingMaterial: opt(
      union([
        lit("glass0"),
        lit("glass1"),
        lit("glass2"),
        lit("propDefault0"),
        lit("propDefault1"),
        lit("propDefault2"),
        lit("floorInterior0"),
        lit("floorInterior1"),
        lit("floorInterior2"),
        lit("floorInterior3"),
        lit("floorInterior4"),
        lit("floorInterior5"),
        lit("wallInterior0"),
        lit("wallInterior1"),
        lit("wallInterior2"),
        lit("trimInterior0"),
        lit("trimInterior1"),
        lit("trimInterior2"),
        lit("ceiling0"),
        lit("ceiling1"),
        lit("ceiling2"),
        lit("doorInterior0"),
        lit("doorInterior1"),
        lit("doorInterior2"),
        lit("doorFixture0"),
        lit("doorFixture1"),
        lit("doorFixture2"),
      ]),
    ),
    ceilingDatum: opt(
      inters(
        [
          id("DatumUsageBase"),
          interf({
            __usage: lit("CEILING"),
          }),
        ],
        "DatumUsage",
      ),
    ),
    labels: fkTable("LABEL", bool),
    disabled: id("FormulaDisabledField"),
  },
  "TraySimpleOffset",
);
export const TreadJustificationSchema = enu(
  {
    [`BOTTOM`]: "BOTTOM",
    [`CENTER`]: "CENTER",
    [`TOP`]: "TOP",
  },
  "TreadJustification",
);
export const TrimEdgeBehaviorSchema = interf(
  {
    edgeBehaviorType: lit("TRIM"),
    hasBaseTrimMolding: id("OptionalBoolean"),
    hasCrownTrimMolding: id("OptionalBoolean"),
    id: pk("EDGE_BEHAVIOR"),
    parentId: union(
      [fk("ROOM", { hierarchy: ["PARENT"] }), fk("STAIR_BLOCK", { hierarchy: ["PARENT"] })],
      "DocEntityParentId",
    ),
    edgeId: str,
    entityType: lit("EDGE_BEHAVIOR"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "TrimEdgeBehavior",
);
export const TrimJustificationSchema = enu(
  {
    [`ABOVE`]: "ABOVE",
    [`BELOW`]: "BELOW",
  },
  "TrimJustification",
);
export const TruncationSlopeTypeSchema = enu(
  {
    [`OVERRIDE`]: "OVERRIDE",
    [`SIDE_SLOPES`]: "SIDE_SLOPES",
    [`FROM_HOST`]: "FROM_HOST",
  },
  "TruncationSlopeType",
);
export const TrussComponentSchema = interf(
  {
    depth: num,
    width: num,
    id: pk("FRAMING_COMPONENT"),
    name: str,
    type: lit("TRUSS"),
    entityType: lit("FRAMING_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "TrussComponent",
);
export const TurndownBrickLedgeTypeSchema = union([lit("NONE"), lit("ADD")], "TurndownBrickLedgeType");
export const TurndownFootingEntitySchema = interf(
  {
    footingWidth: num,
    brickLedgeBehavior: id("BrickLedgeBehavior"),
    brickLedgeType: id("TurndownBrickLedgeType"),
    brickLedgeWidth: num,
    footingType: lit("TURNDOWN"),
    id: pk("FOUNDATION_COMPONENT"),
    name: str,
    componentType: lit("FOOTING"),
    material: opt(id("ExteriorMaterial")),
    entityType: lit("FOUNDATION_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "TurndownFootingEntity",
);
export const UndefinedAtomSchema = undef;
export const UnderlaySchema = union([id("InlineImageUnderlay"), id("AssetReferenceUnderlay")], "Underlay");
export const UnderlayHandleSchema = interf(
  {
    type: lit("UNDERLAY"),
    id: str,
  },
  "UnderlayHandle",
);
export const UnitParameterSchema = interf(
  {
    defaultValue: opt(fk("LABEL")),
    type: lit("UNIT"),
  },
  "UnitParameter",
);
export const UnitValueSchema = interf(
  {
    type: lit("UNIT"),
    value: fk("LABEL"),
  },
  "UnitValue",
);
export const UnsignedNumberSchema = nom("UnsignedNumber");
export const UntypedNumberSchema = nom("UntypedNumber");
export const UpperCabinetDescriptorSchema = interf(
  {
    subType: id("UpperCabinetSubType"),
    height: num,
    type: lit("UPPER_CABINET"),
    width: num,
    shape: opt(id("CabinetShape")),
    superType: lit("CABINET"),
    id: pk("CASEWORK_DESCRIPTOR"),
    name: str,
    floorMaterialOverride: opt(id("InteriorFloorMaterialOverride")),
    tag: opt(str),
    tagOffset: opt(num),
    catalogItemType: lit("CASEWORK_DESCRIPTOR"),
  },
  "UpperCabinetDescriptor",
);
export const UpperCabinetSubTypeSchema = enu(
  {
    [`GENERAL`]: "GENERAL",
    [`REFRIGERATOR`]: "REFRIGERATOR",
    [`MICROWAVE`]: "MICROWAVE",
    [`WALL_BLIND_SQUARE_CORNER`]: "WALL_BLIND_SQUARE_CORNER",
  },
  "UpperCabinetSubType",
);
export const UrlParameterSchema = interf(
  {
    defaultValue: opt(str),
    type: lit("URL"),
  },
  "UrlParameter",
);
export const UserOptionSetSchema = interf(
  {
    id: pk("OPTION_SET"),
    optionSetType: lit("USER"),
    ineligibleHotspotEntities: opt(obj(bool, "Table")),
    includeOptionOnMasterPlanSet: opt(obj(id("OptionSetMasterPlanSetBehavior"), "Table")),
    defaultValue: str,
    options: pkTable("OPTION", id("DocOption"), true),
    salesCategory: str,
    builderOptionSetCode: union([undef, nul, str]),
    category: opt(str),
    description: opt(str),
    tags: opt(arr(str)),
    disabled: id("OptionalBoolean"),
    globalSortOrder: opt(num),
    showroomIntro: id("OptionalBoolean"),
    displayType: union([undef, lit("CARDS"), lit("TABLE")]),
    readonly: id("OptionalBoolean"),
    entityType: lit("OPTION_SET"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    labels: fkTable("LABEL", bool),
  },
  "UserOptionSet",
);
export const UtilityDimensionTypeSchema = enu(
  {
    [`OUTSIDE_EDGE_OF_SLAB`]: "OUTSIDE_EDGE_OF_SLAB",
    [`OUTSIDE_EDGE_OF_FOUNDATION`]: "OUTSIDE_EDGE_OF_FOUNDATION",
  },
  "UtilityDimensionType",
);
export const UVTransformationSchema = interf(
  {
    uTranslation: num,
    vTranslation: num,
    rotationDegrees: num,
    isMirrored: id("OptionalBoolean"),
  },
  "UVTransformation",
);
export const VaultedSchema = interf(
  {
    includeEndcaps: id("OptionalBoolean"),
    type: lit("VAULTED"),
    boundaryType: id("CeilingBoundaryType"),
    offset: num,
    slope: opt(num),
    ridge: opt(num),
    ridgeOrientation: opt(id("CeilingRidgeOrientation")),
    ridgeOrientingWall: opt(str),
    ceilingMaterial: opt(
      union([
        lit("glass0"),
        lit("glass1"),
        lit("glass2"),
        lit("propDefault0"),
        lit("propDefault1"),
        lit("propDefault2"),
        lit("floorInterior0"),
        lit("floorInterior1"),
        lit("floorInterior2"),
        lit("floorInterior3"),
        lit("floorInterior4"),
        lit("floorInterior5"),
        lit("wallInterior0"),
        lit("wallInterior1"),
        lit("wallInterior2"),
        lit("trimInterior0"),
        lit("trimInterior1"),
        lit("trimInterior2"),
        lit("ceiling0"),
        lit("ceiling1"),
        lit("ceiling2"),
        lit("doorInterior0"),
        lit("doorInterior1"),
        lit("doorInterior2"),
        lit("doorFixture0"),
        lit("doorFixture1"),
        lit("doorFixture2"),
      ]),
    ),
    ceilingDatum: opt(
      inters(
        [
          id("DatumUsageBase"),
          interf({
            __usage: lit("CEILING"),
          }),
        ],
        "DatumUsage",
      ),
    ),
    labels: fkTable("LABEL", bool),
    disabled: id("FormulaDisabledField"),
  },
  "Vaulted",
);
export const Vec3Schema = tuple([num, num, num], "Vec3");
export const VentedShutterSettingsSchema = interf(
  {
    shutterType: lit("VENTED"),
    type: lit("WINDOW_SHUTTER_SETTINGS"),
    forceShutters: id("OptionalBoolean"),
    shutterShapeOverride: opt(id("ShutterShapeType")),
    shutterWidthOverride: opt(num),
    shutterHeightOverride: opt(num),
    shutterArchRadiusOverride: opt(num),
    verticalAlignment: opt(id("ShutterVerticalAlignment")),
    verticalOffset: opt(num),
    horizontalOffset: opt(num),
    lateralDatum: opt(id("WallLateralDatumAnchor")),
    lateralOffset: opt(num),
    shutterConfiguration: opt(id("ShutterConfigurationType")),
    orientation: opt(id("ShutterStreetOrientationPreference")),
    shutterMaterial: opt(id("ExteriorMaterial")),
    viewNotes: opt(
      mapobj(
        lit("SHUTTER"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "ShutterViewNoteTable",
      ),
    ),
    isLegacyWidthOverride: id("OptionalBoolean"),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "VentedShutterSettings",
);
export const VertexHandleSchema = interf(
  {
    type: lit("VERTEX"),
    vertexId: num,
    parent: id("ShapeBasedEntityHandle"),
    shapeId: str,
  },
  "VertexHandle",
);
export const VerticalAlignmentSchema = interf(
  {
    datum: opt(fk("DATUM")),
    offset: num,
  },
  "VerticalAlignment",
);
export const VerticalDatumDataSchema = union(
  [
    ref(
      interf(
        {
          type: typeParam("T"),
          topDatumId: opt(union([fk("DATUM"), fk("ROOM"), fk("LEVEL"), fk("STAIR_BLOCK")])),
          topOffset: opt(num),
          bottomDatumId: opt(union([fk("DATUM"), fk("ROOM"), fk("LEVEL"), fk("STAIR_BLOCK")])),
          bottomOffset: opt(num),
        },
        "VerticalDatumDataBase",
        ["T"],
      ),
      { T: lit("ABSOLUTE") },
    ),
    ref(
      interf(
        {
          type: typeParam("T"),
          topDatumId: opt(union([fk("DATUM"), fk("ROOM"), fk("LEVEL"), fk("STAIR_BLOCK")])),
          topOffset: opt(num),
          bottomDatumId: opt(union([fk("DATUM"), fk("ROOM"), fk("LEVEL"), fk("STAIR_BLOCK")])),
          bottomOffset: opt(num),
        },
        "VerticalDatumDataBase",
        ["T"],
      ),
      { T: lit("RELATIVE") },
    ),
  ],
  "VerticalDatumData",
);
export const VerticalJustificationSchema = enu(
  {
    [`BOTTOM_UP`]: "BOTTOM_UP",
    [`TOP_DOWN`]: "TOP_DOWN",
  },
  "VerticalJustification",
);
export const View3DSchema = interf(
  {
    id: pk("VIEW_3D"),
    levelId: union([fk("LEVEL"), nul]),
    selectedReportingUnitLabelId: opt(fk("LABEL")),
    hiddenCategoriesOutsideSelectedReportingUnit: opt(obj(bool, "Table")),
    camera: opt(id("CameraPosition")),
    showroomView: id("OptionalBoolean"),
    entityType: lit("VIEW_3D"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    viewScale: opt(num),
    viewFilter: opt(partial(id("ViewFilter"))),
    dimensionPrecision: opt(id("DimensionPrecision")),
  },
  "View3D",
);
export const View3DHandleSchema = interf(
  {
    type: lit("VIEW_3D"),
    id: str,
  },
  "View3DHandle",
);
export const View3DParameterSchema = interf(
  {
    defaultValue: opt(
      union([
        lit("frontLeftAerial"),
        lit("frontRightAerial"),
        lit("backLeftAerial"),
        lit("backRightAerial"),
        lit("frontSidewalk"),
      ]),
    ),
    type: lit("VIEW_3D"),
  },
  "View3DParameter",
);
export const ViewFilterSchema = interf(
  {
    baseTrimMolding: bool,
    casework: bool,
    caseworkTags: bool,
    ceilings: bool,
    columns: bool,
    cornerBoards: bool,
    crownTrimMolding: bool,
    interiorWallPlaneTrimMolding: bool,
    debug: bool,
    debugBuildingOutlineVertices: bool,
    doors: bool,
    doorSwings: bool,
    doorTags: bool,
    doorUnits: bool,
    doorCasing: bool,
    headerFramingTags: bool,
    driveways: bool,
    electrical: bool,
    elevationAnnotation: bool,
    elevationNotes: bool,
    gradeLine: bool,
    exteriorAutoDimensions: bool,
    faceDiff: bool,
    floorAreas: bool,
    floorSystems: bool,
    floorSystemTags: bool,
    flooring: bool,
    floorMaterialAreas: bool,
    foundation: bool,
    foundationSystems: bool,
    slab: bool,
    stemWall: bool,
    foundationCurb: bool,
    foundationFooting: bool,
    foundationPiers: bool,
    foundationAutoDimensions: bool,
    interiorAutoDimensions: bool,
    interiorLights: bool,
    measurements: bool,
    siteShapes: bool,
    overrides: bool,
    perimeter: bool,
    porches: bool,
    porchKeyMeasures: bool,
    railingPosts: bool,
    railings: bool,
    referenceGeom: bool,
    buildingGraph: bool,
    roofing: bool,
    roofs: bool,
    roofRidgeVent: bool,
    roofVolumes: bool,
    rooms: bool,
    roomTags: bool,
    roomSalesLabels: bool,
    site: bool,
    solarPotential: bool,
    stairSystems: bool,
    underlays: bool,
    roofUnderlays: bool,
    wainscoting: bool,
    wallSubstrate: bool,
    wallExteriorFinish: bool,
    walls: bool,
    wallCore: bool,
    wallStructuralDomains: bool,
    windows: bool,
    windowCasing: bool,
    windowShutters: bool,
    windowTags: bool,
    windowUnits: bool,
    datumTag: opt(str),
    procureMeasuresEaves: bool,
    procureMeasuresFlashing: bool,
    procureMeasuresRidges: bool,
    procureMeasuresRidgeVents: bool,
    procureMeasuresRoofAreas: bool,
    procureMeasuresValleys: bool,
    procureMeasuresInteriorDoors: bool,
    procureMeasuresExteriorDoors: bool,
    procureMeasuresInteriorWindows: bool,
    procureMeasuresExteriorWindows: bool,
    procureMeasuresRoofTrim: bool,
    procureMeasuresFacadeTrim: bool,
    procureMeasuresRoomPerimeter: bool,
    analyticColumns: bool,
    analyticFoundationSlabs: bool,
    analyticFoundationFootings: bool,
    analyticStemWalls: bool,
    analyticFloorStructures: bool,
    analyticRailings: bool,
    interiorTrimAnalyticEntities: bool,
    roofAnalyticFaces: bool,
    roofAnalyticEdges: bool,
    analyticRoofSoffits: bool,
    roofAnalyticFlashing: bool,
    doorTrimAnalyticEntities: bool,
    windowTrimAnalyticEntities: bool,
    wallInteriorFinishAnalyticFaces: bool,
    wallInteriorFinishAnalyticFacesLOD2: bool,
    wallExteriorFinishAnalyticFaces: bool,
    wallExteriorFinishAnalyticEdges: bool,
    ceilingAnalyticFaces: bool,
    foundationKeyMeasures: bool,
    floorKeyMeasures: bool,
    roofKeyMeasures: bool,
    floorAreasFrontPorch: bool,
    floorAreasConditioned: bool,
    floorAreasGarage: bool,
    floorAreasCoveredPatio: bool,
    floorAreasUncoveredPatio: bool,
    floorAreasUnconditioned: bool,
    floorAreasRearPorch: bool,
    debugLevelExtrusions: bool,
    roofsDebug: bool,
    camera: bool,
    exteriorLightProbes: bool,
    interiorLightProbes: bool,
    lut: bool,
    sao: bool,
    sceneLights: bool,
    siteLightProbes: bool,
    warmup: bool,
    crossSection: bool,
    propBoundingBoxes: bool,
    wallFraming: bool,
    wallFramingRegions: bool,
    gableEndWallFraming: bool,
    floorFraming: bool,
    floorFramingLabels: bool,
    subFlooring: bool,
    slabFlooring: bool,
    roofFraming: bool,
    siteShapesContour: bool,
    siteShapesDriveway: bool,
    siteShapesHeightOverrides: bool,
    siteShapesRoad: bool,
    siteShapesSiteFill: bool,
    siteShapesSiteSubtract: bool,
    siteShapesRetainingWall: bool,
    siteShapesLandscape: bool,
    siteShapesWalkway: bool,
    propAppliances: bool,
    propFixtures: bool,
    propFurniture: bool,
    propOther: bool,
    propFoliage: bool,
    annotation: bool,
    annotationAllByBackgroundSheet: opt(str),
    grid: bool,
    homeSideIndicator: bool,
    issues: bool,
    misalignedWallWarning: bool,
    roofSideSelection: bool,
    sectionViews: bool,
    sheet: bool,
    labels: fkTable("LABEL", bool),
  },
  "ViewFilter",
);
export const ViewNoteSettingsSchema = inters(
  [
    mapobj(
      enu(
        {
          [`NONE`]: "NONE",
          [`FASCIA`]: "FASCIA",
          [`EAVE_FASCIA`]: "EAVE_FASCIA",
          [`EAVE_SOFFIT`]: "EAVE_SOFFIT",
          [`FASCIA_TRIM`]: "FASCIA_TRIM",
          [`RAFTER_EXTENSION`]: "RAFTER_EXTENSION",
          [`BOX_EAVE`]: "BOX_EAVE",
          [`MINI_HIP_EAVE`]: "MINI_HIP_EAVE",
          [`MINI_HIP_ROOF`]: "MINI_HIP_ROOF",
          [`MINI_SHED_EAVE`]: "MINI_SHED_EAVE",
          [`MINI_SHED_ROOF`]: "MINI_SHED_ROOF",
          [`WINDOW_EXTERIOR_TRIM`]: "WINDOW_EXTERIOR_TRIM",
          [`DOOR_EXTERIOR`]: "DOOR_EXTERIOR",
          [`GABLE_ROOF_VENT`]: "GABLE_ROOF_VENT",
          [`PROFILE_EXTRUSION`]: "PROFILE_EXTRUSION",
          [`COLUMN`]: "COLUMN",
          [`COLUMN_BRACKET`]: "COLUMN_BRACKET",
          [`PORCH_RAILING`]: "PORCH_RAILING",
          [`PORCH_HEADER`]: "PORCH_HEADER",
          [`PORCH_HEADER_TRIM`]: "PORCH_HEADER_TRIM",
          [`RAILING`]: "RAILING",
          [`STAIR_RUN`]: "STAIR_RUN",
          [`AWNING`]: "AWNING",
          [`AWNING_BRACKET`]: "AWNING_BRACKET",
          [`APRON_CASING`]: "APRON_CASING",
          [`HEAD_CASING`]: "HEAD_CASING",
          [`SIDE_CASING`]: "SIDE_CASING",
          [`STOOL_CASING`]: "STOOL_CASING",
          [`SITE_SHAPE`]: "SITE_SHAPE",
          [`WINDOW`]: "WINDOW",
          [`SHUTTER`]: "SHUTTER",
          [`DOOR`]: "DOOR",
          [`WAINSCOTING`]: "WAINSCOTING",
          [`WAINSCOTING_CAP`]: "WAINSCOTING_CAP",
          [`PROP`]: "PROP",
          [`OUTSIDE_CORNER`]: "OUTSIDE_CORNER",
          [`INSIDE_CORNER`]: "INSIDE_CORNER",
          [`DORMER_CORNER`]: "DORMER_CORNER",
          [`WALL_ROOF_BASEBOARD`]: "WALL_ROOF_BASEBOARD",
        },
        "ViewEntityType",
      ),
      interf(
        {
          enabled: bool,
          text: opt(str),
          tagOnlyOne: id("OptionalBoolean"),
        },
        "EntityAnnotationSetting",
      ),
      true,
      "EntityAnnotationSettingsTable",
    ),
    interf({
      typicalSuffix: str,
    }),
    interf({
      type: lit("VIEW_NOTE_SETTINGS"),
    }),
  ],
  "ViewNoteSettings",
);
export const ViewOverrideSchema = interf(
  {
    id: pk("VIEW_OVERRIDE"),
    action: lit("HIDE"),
    entityType: lit("VIEW_OVERRIDE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "ViewOverride",
);
export const ViewOverrideHandleSchema = interf(
  {
    type: lit("VIEW_OVERRIDE"),
    id: str,
  },
  "ViewOverrideHandle",
);
export const ViewportSchema = union(
  [
    id("PlanViewport"),
    id("ElevationViewport"),
    id("SectionViewport"),
    id("PerspectiveViewport"),
    id("DrawingViewport"),
  ],
  "Viewport",
);
export const ViewportBaseSchema = interf(
  {
    id: pk("VIEWPORT"),
    parentId: opt(
      union(
        [fk("CONTENT_TEMPLATE", { hierarchy: ["PARENT"] }), fk("CONTENT_TEMPLATE_INSTANCE", { hierarchy: ["PARENT"] })],
        "DocEntityParentId",
      ),
    ),
    viewTemplateId: union([id("ParameterRef"), fk("VIEW_TEMPLATE")]),
    contentTextScale: opt(num),
    dimensionPrecision: opt(id("DimensionPrecision")),
    title: opt(id("ParameterRefStringField")),
    number: opt(id("ParameterRefStringField")),
    description: opt(id("ParameterRefStringField")),
    titleDrawingTemplateId: opt(fk("CONTENT_TEMPLATE")),
    selectedReportingUnitLabelId: union([fk("LABEL"), undef, id("ParameterRef")]),
    viewType: id("ViewportViewType"),
    viewTemplateOverrideIds: arr(fk("VIEW_TEMPLATE_OVERRIDE")),
    worldOriginInPageSpaceX: nom("SheetInches"),
    worldOriginInPageSpaceY: nom("SheetInches"),
    outline: any,
    scale: opt(id("ParameterRefNumberField")),
    positioningMethod: opt(id("ViewportPositioningMethod")),
    scalingMethod: opt(id("ViewportScalingMethod")),
    verticalAlignment: opt(id("ViewportVerticalAlignment")),
    horizontalAlignment: opt(id("ViewportHorizontalAlignment")),
    entityType: lit("VIEWPORT"),
    name: str,
    sortIndex: num,
    disabled: id("ParameterFormulaDisabledField"),
  },
  "ViewportBase",
);
export const ViewportHandleSchema = interf(
  {
    type: lit("VIEWPORT"),
    id: str,
  },
  "ViewportHandle",
);
export const ViewportHorizontalAlignmentSchema = enu(
  {
    [`LEFT`]: "LEFT",
    [`CENTER`]: "CENTER",
    [`RIGHT`]: "RIGHT",
  },
  "ViewportHorizontalAlignment",
);
export const ViewportPositioningMethodSchema = enu(
  {
    [`ALIGNED`]: "ALIGNED",
    [`EXPLICIT`]: "EXPLICIT",
  },
  "ViewportPositioningMethod",
);
export const ViewportScalingMethodSchema = enu(
  {
    [`EXPLICIT`]: "EXPLICIT",
    [`FIT`]: "FIT",
  },
  "ViewportScalingMethod",
);
export const ViewportTitleDrawingTemplateSchema = interf(
  {
    drawingType: lit("VIEWPORT_TITLE"),
    templateType: lit("DRAWING"),
    id: pk("CONTENT_TEMPLATE"),
    labels: fkTable("LABEL", bool),
    entityType: lit("CONTENT_TEMPLATE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    viewportName: opt(str),
    viewportNumber: opt(str),
    viewportDescription: opt(str),
    viewportScale: opt(str),
  },
  "ViewportTitleDrawingTemplate",
);
export const ViewportVerticalAlignmentSchema = enu(
  {
    [`TOP`]: "TOP",
    [`CENTER`]: "CENTER",
    [`BOTTOM`]: "BOTTOM",
  },
  "ViewportVerticalAlignment",
);
export const ViewportViewTypeSchema = union(
  [lit("ELEVATION_VIEW"), lit("SECTION_VIEW"), lit("VIEW_3D"), lit("PLAN_VIEW"), lit("DRAWING")],
  "ViewportViewType",
);
export const ViewSelectorSchema = union([id("DocTableViewSelector"), id("BuiltInViewSelector")], "ViewSelector");
export const ViewSelectorHandleSchema = interf(
  {
    type: lit("VIEW_SELECTOR"),
    id: str,
  },
  "ViewSelectorHandle",
);
export const ViewStyleSchema = enu(
  {
    [`LINEWORK`]: "LINEWORK",
    [`REALISTIC`]: "REALISTIC",
  },
  "ViewStyle",
);
export const ViewTemplateSchema = union(
  [
    id("PlanViewTemplate"),
    id("SectionViewTemplate"),
    id("ElevationViewTemplate"),
    id("PerspectiveViewTemplate"),
    id("DrawingViewTemplate"),
  ],
  "ViewTemplate",
);
export const ViewTemplateHandleSchema = interf(
  {
    type: lit("VIEW_TEMPLATE"),
    id: str,
  },
  "ViewTemplateHandle",
);
export const ViewTemplateOverrideSchema = interf(
  {
    id: pk("VIEW_TEMPLATE_OVERRIDE"),
    selectionMethod: id("SelectionMethod"),
    labels: fkTable("LABEL", bool),
    entityType: lit("VIEW_TEMPLATE_OVERRIDE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
  },
  "ViewTemplateOverride",
);
export const ViewTemplateOverrideHandleSchema = interf(
  {
    type: lit("VIEW_TEMPLATE_OVERRIDE"),
    id: str,
  },
  "ViewTemplateOverrideHandle",
);
export const ViewTemplateParameterSchema = interf(
  {
    viewType: union([lit("ELEVATION_VIEW"), lit("SECTION_VIEW"), lit("PLAN_VIEW"), lit("VIEW_3D")]),
    defaultValue: opt(fk("VIEW_TEMPLATE")),
    type: lit("VIEW_TEMPLATE"),
  },
  "ViewTemplateParameter",
);
export const ViewTemplateValueSchema = interf(
  {
    type: lit("VIEW_TEMPLATE"),
    value: fk("VIEW_TEMPLATE"),
  },
  "ViewTemplateValue",
);
export const VirtualRoofBlockSchema = interf(
  {
    type: lit("VIRTUAL_ROOF_BLOCK"),
    name: str,
    perimeter: any,
    edgeIds: arr(str),
    levelUsage: id("RoofSystemLevelUsage"),
  },
  "VirtualRoofBlock",
);
export const VisibilityEffectSchema = interf(
  {
    type: lit("VISIBILITY"),
    invert: id("OptionalBoolean"),
    id: pk("EFFECT"),
    categories: arr(id("SheetGeometryCategory")),
    parentId: opt(union([fk("VIEW_TEMPLATE_OVERRIDE", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
    entityType: lit("EFFECT"),
    name: str,
    sortIndex: num,
  },
  "VisibilityEffect",
);
export const WainscotingCapTypeSchema = enu(
  {
    [`NONE`]: "NONE",
    [`CAP`]: "CAP",
  },
  "WainscotingCapType",
);
export const WainscotingSettingsSchema = interf(
  {
    type: lit("WAINSCOTING_SETTINGS"),
    height: num,
    thickness: num,
    wainscotingMode: id("StreetOrientationMode"),
    waincotingDatum: id("LevelDatumAnchor"),
    closeDist: num,
    removeWainscotingSegmentsUnderLength: num,
    capType: id("WainscotingCapType"),
    capHeight: num,
    capThickness: num,
    dimensionOnElevations: id("OptionalBoolean"),
    showWainscotingOnPlans: id("OptionalBoolean"),
    showBrickLedgeOnPlans: id("OptionalBoolean"),
    porchWainscotingMode: id("StreetOrientationMode"),
    porchWainscotingDatum: id("FoundationDatumVerticalAnchor"),
    porchCapType: opt(id("WainscotingCapType")),
    material: opt(id("ExteriorMaterial")),
    trimMaterial: opt(id("ExteriorMaterial")),
    leftThreshold: opt(num),
    rightThreshold: opt(num),
    lateralThreshold: opt(num),
    viewNotes: opt(
      mapobj(
        enu(
          {
            [`WAINSCOTING`]: "WAINSCOTING",
            [`CAP`]: "CAP",
          },
          "WainscotingViewNoteType",
        ),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "WainscotingViewNoteTable",
      ),
    ),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "WainscotingSettings",
);
export const WalkSiteShapeSchema = interf(
  {
    type: lit("WALK"),
    isConformal: id("OptionalBoolean"),
    material: opt(id("ExteriorMaterial")),
    id: pk("SITE_SHAPE"),
    parentId: union([fk("SITE", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    geom: any,
    entityType: lit("SITE_SHAPE"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    zHeight: num,
    height: opt(num),
  },
  "WalkSiteShape",
);
export const WallAssemblyAirGapLayerSchema = interf(
  {
    airGapThickness: num,
    type: lit("AIRGAP"),
    roomId: opt(fk("ROOM")),
    parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
    layerSource: union([
      undef,
      id("RoomHandle"),
      id("EdgeBehaviorHandle"),
      id("WallPlaneRuleHandle"),
      id("FacadeSpanStratumHandle"),
    ]),
    lowerDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_VERTICAL"),
        }),
      ],
      "DatumUsage",
    ),
    upperDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_VERTICAL"),
        }),
      ],
      "DatumUsage",
    ),
    startDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_HORIZONTAL"),
        }),
      ],
      "DatumUsage",
    ),
    endDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_HORIZONTAL"),
        }),
      ],
      "DatumUsage",
    ),
  },
  "WallAssemblyAirGapLayer",
);
export const WallAssemblyEdgeBehaviorSchema = interf(
  {
    edgeBehaviorType: lit("WALL_ASSEMBLY"),
    wallAssemblyOperator: id("WallAssemblyOperator"),
    outside: id("OptionalBoolean"),
    id: pk("EDGE_BEHAVIOR"),
    parentId: union(
      [fk("ROOM", { hierarchy: ["PARENT"] }), fk("STAIR_BLOCK", { hierarchy: ["PARENT"] })],
      "DocEntityParentId",
    ),
    edgeId: str,
    entityType: lit("EDGE_BEHAVIOR"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "WallAssemblyEdgeBehavior",
);
export const WallAssemblyExteriorFinishLayerSchema = interf(
  {
    finishMaterial: id("ExteriorMaterial"),
    materialThickness: opt(num),
    materialTransformation: opt(id("UVTransformation")),
    elevationNoteEnabled: id("OptionalBoolean"),
    elevationNote: opt(str),
    type: lit("EXTERIOR_FINISH"),
    roomId: opt(fk("ROOM")),
    parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
    layerSource: union([
      undef,
      id("RoomHandle"),
      id("EdgeBehaviorHandle"),
      id("WallPlaneRuleHandle"),
      id("FacadeSpanStratumHandle"),
    ]),
    lowerDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_VERTICAL"),
        }),
      ],
      "DatumUsage",
    ),
    upperDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_VERTICAL"),
        }),
      ],
      "DatumUsage",
    ),
    startDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_HORIZONTAL"),
        }),
      ],
      "DatumUsage",
    ),
    endDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_HORIZONTAL"),
        }),
      ],
      "DatumUsage",
    ),
  },
  "WallAssemblyExteriorFinishLayer",
);
export const WallAssemblyFinishLayerSchema = union(
  [id("WallAssemblyInteriorFinishLayer"), id("WallAssemblyExteriorFinishLayer")],
  "WallAssemblyFinishLayer",
);
export const WallAssemblyFoundationCatalogLayerSchema = interf(
  {
    foundationComponentId: fk("FOUNDATION_COMPONENT"),
    type: lit("FOUNDATION"),
    roomId: opt(fk("ROOM")),
    parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
    layerSource: union([
      undef,
      id("RoomHandle"),
      id("EdgeBehaviorHandle"),
      id("WallPlaneRuleHandle"),
      id("FacadeSpanStratumHandle"),
    ]),
    lowerDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_VERTICAL"),
        }),
      ],
      "DatumUsage",
    ),
    upperDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_VERTICAL"),
        }),
      ],
      "DatumUsage",
    ),
    startDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_HORIZONTAL"),
        }),
      ],
      "DatumUsage",
    ),
    endDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_HORIZONTAL"),
        }),
      ],
      "DatumUsage",
    ),
  },
  "WallAssemblyFoundationCatalogLayer",
);
export const WallAssemblyInteriorFinishLayerSchema = interf(
  {
    finishMaterial: union([
      lit("glass0"),
      lit("glass1"),
      lit("glass2"),
      lit("propDefault0"),
      lit("propDefault1"),
      lit("propDefault2"),
      lit("floorInterior0"),
      lit("floorInterior1"),
      lit("floorInterior2"),
      lit("floorInterior3"),
      lit("floorInterior4"),
      lit("floorInterior5"),
      lit("wallInterior0"),
      lit("wallInterior1"),
      lit("wallInterior2"),
      lit("trimInterior0"),
      lit("trimInterior1"),
      lit("trimInterior2"),
      lit("ceiling0"),
      lit("ceiling1"),
      lit("ceiling2"),
      lit("doorInterior0"),
      lit("doorInterior1"),
      lit("doorInterior2"),
      lit("doorFixture0"),
      lit("doorFixture1"),
      lit("doorFixture2"),
    ]),
    type: lit("INTERIOR_FINISH"),
    roomId: opt(fk("ROOM")),
    parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
    layerSource: union([
      undef,
      id("RoomHandle"),
      id("EdgeBehaviorHandle"),
      id("WallPlaneRuleHandle"),
      id("FacadeSpanStratumHandle"),
    ]),
    lowerDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_VERTICAL"),
        }),
      ],
      "DatumUsage",
    ),
    upperDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_VERTICAL"),
        }),
      ],
      "DatumUsage",
    ),
    startDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_HORIZONTAL"),
        }),
      ],
      "DatumUsage",
    ),
    endDatumUsage: inters(
      [
        id("DatumUsageBase"),
        interf({
          __usage: lit("WALL_HORIZONTAL"),
        }),
      ],
      "DatumUsage",
    ),
  },
  "WallAssemblyInteriorFinishLayer",
);
export const WallAssemblyLayerSchema = union(
  [
    id("WallAssemblyFoundationCatalogLayer"),
    ref(
      interf(
        {
          wallMaterialId: str,
          type: typeParam("T"),
          roomId: opt(fk("ROOM")),
          parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
          layerSource: union([
            undef,
            id("RoomHandle"),
            id("EdgeBehaviorHandle"),
            id("WallPlaneRuleHandle"),
            id("FacadeSpanStratumHandle"),
          ]),
          lowerDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          upperDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          startDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
          endDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
        },
        "WallAssemblyMaterialCatalogLayerBase",
        ["T"],
      ),
      { T: lit("STRUCTURE") },
    ),
    ref(
      interf(
        {
          wallMaterialId: str,
          type: typeParam("T"),
          roomId: opt(fk("ROOM")),
          parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
          layerSource: union([
            undef,
            id("RoomHandle"),
            id("EdgeBehaviorHandle"),
            id("WallPlaneRuleHandle"),
            id("FacadeSpanStratumHandle"),
          ]),
          lowerDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          upperDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          startDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
          endDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
        },
        "WallAssemblyMaterialCatalogLayerBase",
        ["T"],
      ),
      { T: lit("SUBSTRATE") },
    ),
    id("WallAssemblyAirGapLayer"),
    ref(
      interf(
        {
          wallMaterialId: str,
          type: typeParam("T"),
          roomId: opt(fk("ROOM")),
          parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
          layerSource: union([
            undef,
            id("RoomHandle"),
            id("EdgeBehaviorHandle"),
            id("WallPlaneRuleHandle"),
            id("FacadeSpanStratumHandle"),
          ]),
          lowerDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          upperDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          startDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
          endDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
        },
        "WallAssemblyMaterialCatalogLayerBase",
        ["T"],
      ),
      { T: lit("MEMBRANE") },
    ),
    ref(
      interf(
        {
          wallMaterialId: str,
          type: typeParam("T"),
          roomId: opt(fk("ROOM")),
          parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
          layerSource: union([
            undef,
            id("RoomHandle"),
            id("EdgeBehaviorHandle"),
            id("WallPlaneRuleHandle"),
            id("FacadeSpanStratumHandle"),
          ]),
          lowerDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          upperDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          startDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
          endDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
        },
        "WallAssemblyMaterialCatalogLayerBase",
        ["T"],
      ),
      { T: lit("THERMAL") },
    ),
    id("WallAssemblyInteriorFinishLayer"),
    id("WallAssemblyExteriorFinishLayer"),
  ],
  "WallAssemblyLayer",
);
export const WallAssemblyLayerConstructorParamsSchema = union(
  [
    inters([
      pick(id("WallAssemblyMaterialCatalogLayer"), union([lit("type"), lit("wallMaterialId")])),
      partial(
        ref(
          interf(
            {
              wallMaterialId: str,
              type: typeParam("T"),
              roomId: opt(fk("ROOM")),
              parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
              layerSource: union([
                undef,
                id("RoomHandle"),
                id("EdgeBehaviorHandle"),
                id("WallPlaneRuleHandle"),
                id("FacadeSpanStratumHandle"),
              ]),
              lowerDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_VERTICAL"),
                  }),
                ],
                "DatumUsage",
              ),
              upperDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_VERTICAL"),
                  }),
                ],
                "DatumUsage",
              ),
              startDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_HORIZONTAL"),
                  }),
                ],
                "DatumUsage",
              ),
              endDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_HORIZONTAL"),
                  }),
                ],
                "DatumUsage",
              ),
            },
            "WallAssemblyMaterialCatalogLayerBase",
            ["T"],
          ),
          { T: lit("STRUCTURE") },
        ),
      ),
    ]),
    inters([
      pick(id("WallAssemblyMaterialCatalogLayer"), union([lit("type"), lit("wallMaterialId")])),
      partial(
        ref(
          interf(
            {
              wallMaterialId: str,
              type: typeParam("T"),
              roomId: opt(fk("ROOM")),
              parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
              layerSource: union([
                undef,
                id("RoomHandle"),
                id("EdgeBehaviorHandle"),
                id("WallPlaneRuleHandle"),
                id("FacadeSpanStratumHandle"),
              ]),
              lowerDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_VERTICAL"),
                  }),
                ],
                "DatumUsage",
              ),
              upperDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_VERTICAL"),
                  }),
                ],
                "DatumUsage",
              ),
              startDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_HORIZONTAL"),
                  }),
                ],
                "DatumUsage",
              ),
              endDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_HORIZONTAL"),
                  }),
                ],
                "DatumUsage",
              ),
            },
            "WallAssemblyMaterialCatalogLayerBase",
            ["T"],
          ),
          { T: lit("SUBSTRATE") },
        ),
      ),
    ]),
    inters([
      pick(id("WallAssemblyMaterialCatalogLayer"), union([lit("type"), lit("wallMaterialId")])),
      partial(
        ref(
          interf(
            {
              wallMaterialId: str,
              type: typeParam("T"),
              roomId: opt(fk("ROOM")),
              parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
              layerSource: union([
                undef,
                id("RoomHandle"),
                id("EdgeBehaviorHandle"),
                id("WallPlaneRuleHandle"),
                id("FacadeSpanStratumHandle"),
              ]),
              lowerDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_VERTICAL"),
                  }),
                ],
                "DatumUsage",
              ),
              upperDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_VERTICAL"),
                  }),
                ],
                "DatumUsage",
              ),
              startDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_HORIZONTAL"),
                  }),
                ],
                "DatumUsage",
              ),
              endDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_HORIZONTAL"),
                  }),
                ],
                "DatumUsage",
              ),
            },
            "WallAssemblyMaterialCatalogLayerBase",
            ["T"],
          ),
          { T: lit("MEMBRANE") },
        ),
      ),
    ]),
    inters([
      pick(id("WallAssemblyMaterialCatalogLayer"), union([lit("type"), lit("wallMaterialId")])),
      partial(
        ref(
          interf(
            {
              wallMaterialId: str,
              type: typeParam("T"),
              roomId: opt(fk("ROOM")),
              parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
              layerSource: union([
                undef,
                id("RoomHandle"),
                id("EdgeBehaviorHandle"),
                id("WallPlaneRuleHandle"),
                id("FacadeSpanStratumHandle"),
              ]),
              lowerDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_VERTICAL"),
                  }),
                ],
                "DatumUsage",
              ),
              upperDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_VERTICAL"),
                  }),
                ],
                "DatumUsage",
              ),
              startDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_HORIZONTAL"),
                  }),
                ],
                "DatumUsage",
              ),
              endDatumUsage: inters(
                [
                  id("DatumUsageBase"),
                  interf({
                    __usage: lit("WALL_HORIZONTAL"),
                  }),
                ],
                "DatumUsage",
              ),
            },
            "WallAssemblyMaterialCatalogLayerBase",
            ["T"],
          ),
          { T: lit("THERMAL") },
        ),
      ),
    ]),
    inters([
      pick(id("WallAssemblyFinishLayer"), union([lit("type"), lit("finishMaterial")])),
      partial(id("WallAssemblyInteriorFinishLayer")),
    ]),
    inters([
      pick(id("WallAssemblyFinishLayer"), union([lit("type"), lit("finishMaterial")])),
      partial(id("WallAssemblyExteriorFinishLayer")),
    ]),
    inters([
      pick(id("WallAssemblyFoundationCatalogLayer"), union([lit("type"), lit("foundationComponentId")])),
      partial(id("WallAssemblyFoundationCatalogLayer")),
    ]),
  ],
  "WallAssemblyLayerConstructorParams",
);
export const WallAssemblyLayerOperatorAddSchema = interf(
  {
    layer: id("WallAssemblyLayerConstructorParams"),
    operationType: lit("ADD"),
  },
  "WallAssemblyLayerOperatorAdd",
);
export const WallAssemblyLayerOperatorOverrideSchema = interf(
  {
    layerIndex: num,
    layer: union([
      inters([partial(id("WallAssemblyFoundationCatalogLayer")), pick(id("WallAssemblyLayer"), lit("type"))]),
      inters([
        partial(
          ref(
            interf(
              {
                wallMaterialId: str,
                type: typeParam("T"),
                roomId: opt(fk("ROOM")),
                parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
                layerSource: union([
                  undef,
                  id("RoomHandle"),
                  id("EdgeBehaviorHandle"),
                  id("WallPlaneRuleHandle"),
                  id("FacadeSpanStratumHandle"),
                ]),
                lowerDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_VERTICAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
                upperDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_VERTICAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
                startDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_HORIZONTAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
                endDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_HORIZONTAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
              },
              "WallAssemblyMaterialCatalogLayerBase",
              ["T"],
            ),
            { T: lit("STRUCTURE") },
          ),
        ),
        pick(id("WallAssemblyLayer"), lit("type")),
      ]),
      inters([
        partial(
          ref(
            interf(
              {
                wallMaterialId: str,
                type: typeParam("T"),
                roomId: opt(fk("ROOM")),
                parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
                layerSource: union([
                  undef,
                  id("RoomHandle"),
                  id("EdgeBehaviorHandle"),
                  id("WallPlaneRuleHandle"),
                  id("FacadeSpanStratumHandle"),
                ]),
                lowerDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_VERTICAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
                upperDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_VERTICAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
                startDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_HORIZONTAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
                endDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_HORIZONTAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
              },
              "WallAssemblyMaterialCatalogLayerBase",
              ["T"],
            ),
            { T: lit("SUBSTRATE") },
          ),
        ),
        pick(id("WallAssemblyLayer"), lit("type")),
      ]),
      inters([partial(id("WallAssemblyAirGapLayer")), pick(id("WallAssemblyLayer"), lit("type"))]),
      inters([
        partial(
          ref(
            interf(
              {
                wallMaterialId: str,
                type: typeParam("T"),
                roomId: opt(fk("ROOM")),
                parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
                layerSource: union([
                  undef,
                  id("RoomHandle"),
                  id("EdgeBehaviorHandle"),
                  id("WallPlaneRuleHandle"),
                  id("FacadeSpanStratumHandle"),
                ]),
                lowerDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_VERTICAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
                upperDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_VERTICAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
                startDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_HORIZONTAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
                endDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_HORIZONTAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
              },
              "WallAssemblyMaterialCatalogLayerBase",
              ["T"],
            ),
            { T: lit("MEMBRANE") },
          ),
        ),
        pick(id("WallAssemblyLayer"), lit("type")),
      ]),
      inters([
        partial(
          ref(
            interf(
              {
                wallMaterialId: str,
                type: typeParam("T"),
                roomId: opt(fk("ROOM")),
                parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
                layerSource: union([
                  undef,
                  id("RoomHandle"),
                  id("EdgeBehaviorHandle"),
                  id("WallPlaneRuleHandle"),
                  id("FacadeSpanStratumHandle"),
                ]),
                lowerDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_VERTICAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
                upperDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_VERTICAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
                startDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_HORIZONTAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
                endDatumUsage: inters(
                  [
                    id("DatumUsageBase"),
                    interf({
                      __usage: lit("WALL_HORIZONTAL"),
                    }),
                  ],
                  "DatumUsage",
                ),
              },
              "WallAssemblyMaterialCatalogLayerBase",
              ["T"],
            ),
            { T: lit("THERMAL") },
          ),
        ),
        pick(id("WallAssemblyLayer"), lit("type")),
      ]),
      inters([partial(id("WallAssemblyInteriorFinishLayer")), pick(id("WallAssemblyLayer"), lit("type"))]),
      inters([partial(id("WallAssemblyExteriorFinishLayer")), pick(id("WallAssemblyLayer"), lit("type"))]),
    ]),
    operationType: lit("OVERRIDE"),
  },
  "WallAssemblyLayerOperatorOverride",
);
export const WallAssemblyLayerOperatorRemoveSchema = interf(
  {
    layerIndex: num,
    layer: pick(id("WallAssemblyLayer"), lit("type")),
    operationType: lit("REMOVE"),
  },
  "WallAssemblyLayerOperatorRemove",
);
export const WallAssemblyLayerParentHandleSchema = union(
  [
    id("RoomHandle"),
    inters(
      [
        id("GeneratedEntityHandle"),
        interf({
          entity: ref(
            interf(
              {
                entityType: typeParam("T"),
                id: str,
              },
              "BuildingEntityHandleBase",
              ["T"],
            ),
            { T: lit("WALL_PLANE") },
          ),
        }),
      ],
      "GeneratedEntityHandleTyped",
    ),
    inters(
      [
        id("GeneratedEntityHandle"),
        interf({
          entity: id("BuildingGraphPlanarTopologyHandle"),
        }),
      ],
      "GeneratedEntityHandleTyped",
    ),
  ],
  "WallAssemblyLayerParentHandle",
);
export const WallAssemblyMaterialCatalogLayerSchema = union(
  [
    ref(
      interf(
        {
          wallMaterialId: str,
          type: typeParam("T"),
          roomId: opt(fk("ROOM")),
          parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
          layerSource: union([
            undef,
            id("RoomHandle"),
            id("EdgeBehaviorHandle"),
            id("WallPlaneRuleHandle"),
            id("FacadeSpanStratumHandle"),
          ]),
          lowerDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          upperDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          startDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
          endDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
        },
        "WallAssemblyMaterialCatalogLayerBase",
        ["T"],
      ),
      { T: lit("STRUCTURE") },
    ),
    ref(
      interf(
        {
          wallMaterialId: str,
          type: typeParam("T"),
          roomId: opt(fk("ROOM")),
          parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
          layerSource: union([
            undef,
            id("RoomHandle"),
            id("EdgeBehaviorHandle"),
            id("WallPlaneRuleHandle"),
            id("FacadeSpanStratumHandle"),
          ]),
          lowerDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          upperDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          startDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
          endDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
        },
        "WallAssemblyMaterialCatalogLayerBase",
        ["T"],
      ),
      { T: lit("SUBSTRATE") },
    ),
    ref(
      interf(
        {
          wallMaterialId: str,
          type: typeParam("T"),
          roomId: opt(fk("ROOM")),
          parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
          layerSource: union([
            undef,
            id("RoomHandle"),
            id("EdgeBehaviorHandle"),
            id("WallPlaneRuleHandle"),
            id("FacadeSpanStratumHandle"),
          ]),
          lowerDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          upperDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          startDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
          endDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
        },
        "WallAssemblyMaterialCatalogLayerBase",
        ["T"],
      ),
      { T: lit("MEMBRANE") },
    ),
    ref(
      interf(
        {
          wallMaterialId: str,
          type: typeParam("T"),
          roomId: opt(fk("ROOM")),
          parentChain: opt(arr(id("WallAssemblyLayerParentHandle"))),
          layerSource: union([
            undef,
            id("RoomHandle"),
            id("EdgeBehaviorHandle"),
            id("WallPlaneRuleHandle"),
            id("FacadeSpanStratumHandle"),
          ]),
          lowerDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          upperDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_VERTICAL"),
              }),
            ],
            "DatumUsage",
          ),
          startDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
          endDatumUsage: inters(
            [
              id("DatumUsageBase"),
              interf({
                __usage: lit("WALL_HORIZONTAL"),
              }),
            ],
            "DatumUsage",
          ),
        },
        "WallAssemblyMaterialCatalogLayerBase",
        ["T"],
      ),
      { T: lit("THERMAL") },
    ),
  ],
  "WallAssemblyMaterialCatalogLayer",
);
export const WallAssemblyOffsetOperatorSchema = interf(
  {
    offset: num,
    operationType: lit("OFFSET"),
  },
  "WallAssemblyOffsetOperator",
);
export const WallAssemblyOperatorSchema = union(
  [
    id("WallAssemblyLayerOperatorAdd"),
    id("WallAssemblyLayerOperatorRemove"),
    id("WallAssemblyLayerOperatorOverride"),
    id("WallAssemblyOffsetOperator"),
    id("WallOperatorSetTopDatum"),
    id("WallFoundationInteractionOperator"),
  ],
  "WallAssemblyOperator",
);
export const WallCaseworkSchema = union(
  [id("WallCaseworkFixed"), id("WallCaseworkFixedDeprecated"), id("WallCaseworkDynamicDeprecated")],
  "WallCasework",
);
export const WallCaseworkDynamicDeprecatedSchema = interf(
  {
    type: lit("DYNAMIC"),
    edgeIds: arr(str),
    paramAnchor: id("LineAnchor"),
    placementStart: id("HorizontalEdgeParamNoExpr"),
    placementEnd: id("HorizontalEdgeParamNoExpr"),
    heightFromCeiling: bool,
    material: id("PaletteMaterialSlot"),
    id: pk("CASEWORK"),
    handleOverride: opt(id("RoomLayoutInstanceHandle")),
    caseworkType: union([
      undef,
      lit("BASE_CABINET"),
      lit("UPPER_CABINET"),
      lit("TALL_CABINET"),
      lit("FILLER_PANEL"),
      lit("CLOSET_SHELF"),
    ]),
    shape: opt(id("CabinetShape")),
    cabinetDoorsOnLeft: id("OptionalBoolean"),
    cabinetDoorsOnRight: id("OptionalBoolean"),
    closetShelfRod: id("OptionalBoolean"),
    notes: arr(id("WallCaseworkPlanNote")),
    paletteType: id("PaletteType"),
    floorMaterialOverride: opt(id("InteriorFloorMaterialOverride")),
    lineStyle: opt(id("CaseworkLineStyle")),
    blindPanelSide: opt(id("BlindPanelSide")),
    blindPanelExtension: opt(num),
    adjacentCabinetFiller: id("OptionalBoolean"),
    adjacentCabinetFillerWidth: opt(num),
    tag: opt(str),
    tagOffset: opt(num),
    parentId: opt(
      union([fk("ROOM", { hierarchy: ["PARENT"] }), fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    ),
    entityType: lit("CASEWORK"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    entityInstanceType: opt(id("EntityInstanceType")),
    depth: union([num, id("Formula")]),
    height: union([num, id("Formula")]),
    verticalOffset: union([num, id("Formula")]),
    lateralOffset: union([num, id("Formula")]),
  },
  "WallCaseworkDynamicDeprecated",
);
export const WallCaseworkFixedSchema = interf(
  {
    type: lit("FIXED_V2"),
    width: num,
    catalogDescriptorId: opt(fk("CASEWORK_DESCRIPTOR")),
    horizontalAlignment: id("CaseworkHorizontalAlignment"),
    verticalAlignment: id("CaseworkVerticalAlignment"),
    lateralAlignment: id("CaseworkLateralAlignment"),
    verticalDatum: id("CaseworkVerticalDatumAnchor"),
    useWallStripMaxOffset: id("OptionalBoolean"),
    depth: opt(num),
    height: opt(num),
    verticalOffset: opt(num),
    material: opt(id("PaletteMaterialSlot")),
    lateralOffset: num,
    rotationDegrees: opt(num),
    edgeId: str,
    paramAnchor: id("LineAnchor"),
    horizontalDatum: opt(id("WallHorizontalDatum")),
    param: num,
    paramNormalized: bool,
    lateralOffsetNormalized: bool,
    lateralDatum: id("WallLateralDatumAnchorAll"),
    id: pk("CASEWORK"),
    handleOverride: opt(id("RoomLayoutInstanceHandle")),
    caseworkType: union([
      undef,
      lit("BASE_CABINET"),
      lit("UPPER_CABINET"),
      lit("TALL_CABINET"),
      lit("FILLER_PANEL"),
      lit("CLOSET_SHELF"),
    ]),
    shape: opt(id("CabinetShape")),
    cabinetDoorsOnLeft: id("OptionalBoolean"),
    cabinetDoorsOnRight: id("OptionalBoolean"),
    closetShelfRod: id("OptionalBoolean"),
    notes: arr(id("WallCaseworkPlanNote")),
    paletteType: id("PaletteType"),
    floorMaterialOverride: opt(id("InteriorFloorMaterialOverride")),
    lineStyle: opt(id("CaseworkLineStyle")),
    blindPanelSide: opt(id("BlindPanelSide")),
    blindPanelExtension: opt(num),
    adjacentCabinetFiller: id("OptionalBoolean"),
    adjacentCabinetFillerWidth: opt(num),
    tag: opt(str),
    tagOffset: opt(num),
    parentId: opt(
      union([fk("ROOM", { hierarchy: ["PARENT"] }), fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    ),
    entityType: lit("CASEWORK"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    entityInstanceType: opt(id("EntityInstanceType")),
  },
  "WallCaseworkFixed",
);
export const WallCaseworkFixedDeprecatedSchema = interf(
  {
    type: lit("FIXED"),
    edgeId: str,
    width: num,
    catalogDescriptorId: opt(fk("CASEWORK_DESCRIPTOR")),
    paramAnchor: id("LineAnchor"),
    heightFromCeiling: bool,
    material: id("PaletteMaterialSlot"),
    param: num,
    paramNormalized: bool,
    id: pk("CASEWORK"),
    handleOverride: opt(id("RoomLayoutInstanceHandle")),
    caseworkType: union([
      undef,
      lit("BASE_CABINET"),
      lit("UPPER_CABINET"),
      lit("TALL_CABINET"),
      lit("FILLER_PANEL"),
      lit("CLOSET_SHELF"),
    ]),
    shape: opt(id("CabinetShape")),
    cabinetDoorsOnLeft: id("OptionalBoolean"),
    cabinetDoorsOnRight: id("OptionalBoolean"),
    closetShelfRod: id("OptionalBoolean"),
    notes: arr(id("WallCaseworkPlanNote")),
    paletteType: id("PaletteType"),
    floorMaterialOverride: opt(id("InteriorFloorMaterialOverride")),
    lineStyle: opt(id("CaseworkLineStyle")),
    blindPanelSide: opt(id("BlindPanelSide")),
    blindPanelExtension: opt(num),
    adjacentCabinetFiller: id("OptionalBoolean"),
    adjacentCabinetFillerWidth: opt(num),
    tag: opt(str),
    tagOffset: opt(num),
    parentId: opt(
      union([fk("ROOM", { hierarchy: ["PARENT"] }), fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] })], "DocEntityParentId"),
    ),
    entityType: lit("CASEWORK"),
    name: str,
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    entityInstanceType: opt(id("EntityInstanceType")),
    depth: union([num, id("Formula")]),
    height: union([num, id("Formula")]),
    verticalOffset: union([num, id("Formula")]),
    lateralOffset: union([num, id("Formula")]),
  },
  "WallCaseworkFixedDeprecated",
);
export const WallCaseworkPlanNoteSchema = interf(
  {
    type: lit("PLAN"),
    note: str,
    position: arr(num),
    orientation: id("PlanNoteOrientation"),
  },
  "WallCaseworkPlanNote",
);
export const WallCatalogSettingsSchema = interf(
  {
    type: lit("WALL_CATALOG_SETTINGS"),
    wallTypes: pkTable("WALL_TYPE", id("WallType")),
    wallMaterials: pkTable("STRUCTURAL_MATERIAL", id("StructuralMaterial")),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "WallCatalogSettings",
);
export const WallConditionDataSchema = interf(
  {
    wallTypeId: fk("WALL_TYPE"),
  },
  "WallConditionData",
);
export const WallFaceRuleEntitySchema = interf(
  {
    ruleKind: lit("WALL_FACE"),
    filterId: opt(fk("WALL_PLANE_FILTER")),
    instanceFilterGraphId: str,
    instanceFilterGraphs: obj(id("DocBuildingGraphFilterGraph"), "Record"),
    subFilter: opt(id("DocFaceNodeSubFilter")),
    direction: id("DocFaceDirection"),
    roofId: opt(fk("ROOF")),
    id: pk("WALL_PLANE_RULE"),
    operation: opt(id("WallPlaneOperation")),
    operationBoundary: opt(id("WallPlaneOperationBoundary")),
    entityType: lit("WALL_PLANE_RULE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "WallFaceRuleEntity",
);
export const WallFoundationInteractionOperatorSchema = interf(
  {
    foundationIds: arr(fk("FOUNDATION")),
    operationType: lit("FOUNDATION_INTERACTION"),
  },
  "WallFoundationInteractionOperator",
);
export const WallFramingOpeningSettingsSchema = interf(
  {
    hasCrippleStudEnds: bool,
    hasCrippleStudsBelowOpening: bool,
    hasCrippleStudsAboveOpening: bool,
    hasTopHeaderSillPlate: bool,
    numberOfKingStuds: num,
    hasHeaderAssembly: id("OptionalBoolean"),
    headerAssemblyId: opt(fk("HEADER_ASSEMBLY")),
    numberOfJackStuds: opt(num),
    roughOpeningBorder: num,
  },
  "WallFramingOpeningSettings",
);
export const WallFramingSettingsSchema = interf(
  {
    type: lit("WALL_FRAMING_SETTINGS"),
    hasDoubleTopPlate: bool,
    hasBlocking: bool,
    studDistance: num,
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "WallFramingSettings",
);
export const WallHorizontalDatumSchema = enu(
  {
    [`ROOM_EDGE`]: "ROOM_EDGE",
    [`STRUCTURE`]: "STRUCTURE",
    [`SUBSTRATE`]: "SUBSTRATE",
    [`OUTSIDE_OF_SURFACE`]: "OUTSIDE_OF_SURFACE",
  },
  "WallHorizontalDatum",
);
export const WallHostedAnnotationSideSchema = enu(
  {
    [`OUTSIDE`]: "OUTSIDE",
    [`INSIDE`]: "INSIDE",
  },
  "WallHostedAnnotationSide",
);
export const WallIntersectionTypeSchema = enu(
  {
    [`NONE`]: "NONE",
    [`TEE`]: "TEE",
    [`CORNER`]: "CORNER",
    [`CORNER_REVERSE`]: "CORNER_REVERSE",
    [`LINE`]: "LINE",
  },
  "WallIntersectionType",
);
export const WallLateralDatumAnchorSchema = enu(
  {
    [`OUTSIDE_FACE_OF_FRAMING`]: "OUTSIDE_FACE_OF_FRAMING",
    [`OUTSIDE_FACE_OF_SUBSTRATE`]: "OUTSIDE_FACE_OF_SUBSTRATE",
  },
  "WallLateralDatumAnchor",
);
export const WallLateralDatumAnchorAllSchema = union(
  [
    lit("OUTSIDE_FACE_OF_FRAMING"),
    lit("OUTSIDE_FACE_OF_SUBSTRATE"),
    lit("OUTSIDE_FACE_OF_FINISH"),
    lit("INSIDE_FACE_OF_FRAMING"),
    lit("INSIDE_FACE_OF_SUBSTRATE"),
    lit("INSIDE_FACE_OF_FINISH"),
    lit("ROOM_EDGE"),
    lit("WALL_OFFSET"),
  ],
  "WallLateralDatumAnchorAll",
);
export const WallOpeningWrappingSettingsSchema = interf(
  {
    wrappingMode: id("OpeningWrappingMode"),
  },
  "WallOpeningWrappingSettings",
);
export const WallOperatorSetTopDatumSchema = interf(
  {
    offset: num,
    operationType: lit("WALL_SET_TOP_DATUM"),
  },
  "WallOperatorSetTopDatum",
);
export const WallPlaneAnchoredRuleEntitySchema = interf(
  {
    ruleKind: lit("WALL_PLANE"),
    planeHash: str,
    direction: id("DocFaceDirection"),
    id: pk("WALL_PLANE_RULE"),
    operation: opt(id("WallPlaneOperation")),
    operationBoundary: opt(id("WallPlaneOperationBoundary")),
    entityType: lit("WALL_PLANE_RULE"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "WallPlaneAnchoredRuleEntity",
);
export const WallPlaneAssemblyEntitySchema = interf(
  {
    id: pk("WALL_PLANE_ASSEMBLY"),
    name: str,
    layers: obj(id("WallPlaneAssemblyLayer"), "Table"),
    entityType: lit("WALL_PLANE_ASSEMBLY"),
    parentId: opt(str),
    sortIndex: num,
    labels: fkTable("LABEL", bool),
  },
  "WallPlaneAssemblyEntity",
);
export const WallPlaneAssemblyHandleSchema = interf(
  {
    type: lit("WALL_PLANE_ASSEMBLY"),
    id: str,
  },
  "WallPlaneAssemblyHandle",
);
export const WallPlaneAssemblyLayerSchema = union(
  [
    id("WallPlaneFramingLayer"),
    id("WallPlaneMasonryLayer"),
    id("WallPlaneCastInPlaceLayer"),
    id("WallPlaneSheathingLayer"),
  ],
  "WallPlaneAssemblyLayer",
);
export const WallPlaneAssemblyOperationSchema = interf(
  {
    operationType: lit("SET_WALL_ASSEMBLY"),
    wallCladdingNegativeOperator: opt(
      interf({
        operationType: lit("SET_WALL_FINISH"),
        assemblySide: lit("NEGATIVE_NORMAL"),
        assemblyId: union([fk("WALL_PLANE_ASSEMBLY"), nul]),
      }),
    ),
    wallCoreOperator: opt(
      interf({
        operationType: lit("SET_WALL_CORE"),
        assemblyId: union([fk("WALL_PLANE_ASSEMBLY"), nul]),
      }),
    ),
    wallCladdingPositiveOperator: opt(
      interf({
        operationType: lit("SET_WALL_FINISH"),
        assemblySide: lit("POSITIVE_NORMAL"),
        assemblyId: union([fk("WALL_PLANE_ASSEMBLY"), nul]),
      }),
    ),
    wallOffsetOperator: opt(
      interf({
        operationType: lit("SET_WALL_OFFSET"),
        offset: num,
      }),
    ),
    name: str,
  },
  "WallPlaneAssemblyOperation",
);
export const WallPlaneCastInPlaceLayerSchema = interf(
  {
    layerType: lit("CAST_IN_PLACE"),
    cipComponentId: fk("CIP_COMPONENT"),
    finish: opt(id("WallPlaneMaterialFinish")),
    id: str,
    sortIndex: num,
    name: opt(str),
  },
  "WallPlaneCastInPlaceLayer",
);
export const WallPlaneCutOperationSchema = interf(
  {
    operationType: lit("SET_WALL_CUT"),
    wallCutOperator: interf({
      operationType: lit("SET_WALL_CUT"),
    }),
    name: str,
  },
  "WallPlaneCutOperation",
);
export const WallPlaneFilterHandleSchema = interf(
  {
    type: lit("WALL_PLANE_FILTER"),
    id: str,
  },
  "WallPlaneFilterHandle",
);
export const WallPlaneFramingLayerSchema = interf(
  {
    layerType: lit("FRAMING"),
    framingComponentId: fk("FRAMING_COMPONENT"),
    studSpacing: num,
    topPlateCount: num,
    bottomPlateCount: num,
    id: str,
    sortIndex: num,
    name: opt(str),
  },
  "WallPlaneFramingLayer",
);
export const WallPlaneMasonryLayerSchema = interf(
  {
    layerType: lit("MASONRY"),
    masonryComponentId: fk("MASONRY_COMPONENT"),
    finish: opt(id("WallPlaneMaterialFinish")),
    id: str,
    sortIndex: num,
    name: opt(str),
  },
  "WallPlaneMasonryLayer",
);
export const WallPlaneMaterialFinishSchema = union(
  [
    interf({
      finishType: lit("EXTERIOR"),
      finishPalette: id("ExteriorMaterial"),
    }),
    interf({
      finishType: lit("INTERIOR"),
      finishPalette: union([
        lit("glass0"),
        lit("glass1"),
        lit("glass2"),
        lit("propDefault0"),
        lit("propDefault1"),
        lit("propDefault2"),
        lit("floorInterior0"),
        lit("floorInterior1"),
        lit("floorInterior2"),
        lit("floorInterior3"),
        lit("floorInterior4"),
        lit("floorInterior5"),
        lit("wallInterior0"),
        lit("wallInterior1"),
        lit("wallInterior2"),
        lit("trimInterior0"),
        lit("trimInterior1"),
        lit("trimInterior2"),
        lit("ceiling0"),
        lit("ceiling1"),
        lit("ceiling2"),
        lit("doorInterior0"),
        lit("doorInterior1"),
        lit("doorInterior2"),
        lit("doorFixture0"),
        lit("doorFixture1"),
        lit("doorFixture2"),
      ]),
    }),
  ],
  "WallPlaneMaterialFinish",
);
export const WallPlaneOperationSchema = union(
  [id("WallPlaneCutOperation"), id("WallPlaneAssemblyOperation")],
  "WallPlaneOperation",
);
export const WallPlaneOperationBoundarySchema = union(
  [
    interf({
      boundaryType: lit("AABB"),
      aabb: interf({
        start: opt(
          union(
            [
              interf({
                mode: lit("RELATIVE"),
                value: num,
              }),
              interf({
                mode: lit("HORIZONTAL_DATUM"),
                horizontalDatumId: fk("DATUM"),
              }),
            ],
            "WallPlaneOperationAABBHorizontalSideValue",
          ),
        ),
        end: opt(
          union(
            [
              interf({
                mode: lit("RELATIVE"),
                value: num,
              }),
              interf({
                mode: lit("HORIZONTAL_DATUM"),
                horizontalDatumId: fk("DATUM"),
              }),
            ],
            "WallPlaneOperationAABBHorizontalSideValue",
          ),
        ),
        bottom: opt(
          union(
            [
              interf({
                mode: lit("RELATIVE"),
                value: num,
              }),
              interf({
                mode: lit("DATUM"),
                datumId: fk("DATUM"),
              }),
            ],
            "WallPlaneOperationAABBVerticalSideValue",
          ),
        ),
        top: opt(
          union(
            [
              interf({
                mode: lit("RELATIVE"),
                value: num,
              }),
              interf({
                mode: lit("DATUM"),
                datumId: fk("DATUM"),
              }),
            ],
            "WallPlaneOperationAABBVerticalSideValue",
          ),
        ),
      }),
    }),
    interf({
      boundaryType: lit("ROOF_CLIPPING"),
      roofSelection: union(
        [
          interf({
            mode: lit("ALL"),
          }),
          interf({
            mode: lit("NONE"),
          }),
          interf({
            mode: lit("SELECTED"),
            roofIds: arr(fk("ROOF")),
          }),
        ],
        "WallPlaneRoofSelection",
      ),
      splitDirection: enu(
        {
          [`BELOW_ANY`]: "BELOW_ANY",
          [`BELOW_ALL`]: "BELOW_ALL",
          [`ABOVE_ANY`]: "ABOVE_ANY",
          [`ABOVE_ALL`]: "ABOVE_ALL",
        },
        "WallPlaneRoofClippingSplitDirection",
      ),
    }),
    interf({
      boundaryType: lit("STAIR_CLIPPING"),
    }),
  ],
  "WallPlaneOperationBoundary",
);
export const WallPlaneRuleEntitySchema = union(
  [id("WallFaceRuleEntity"), id("WallPlaneAnchoredRuleEntity")],
  "WallPlaneRuleEntity",
);
export const WallPlaneRuleHandleSchema = interf(
  {
    type: lit("WALL_PLANE_RULE"),
    id: str,
  },
  "WallPlaneRuleHandle",
);
export const WallPlaneSheathingLayerSchema = interf(
  {
    layerType: lit("SHEATHING"),
    sheathingComponentId: fk("SHEATHING_COMPONENT"),
    finish: opt(id("WallPlaneMaterialFinish")),
    id: str,
    sortIndex: num,
    name: opt(str),
  },
  "WallPlaneSheathingLayer",
);
export const WallPlaneTrimEntitySchema = interf(
  {
    id: pk("WALL_PLANE_TRIM"),
    finish: opt(id("WallPlaneMaterialFinish")),
    entityType: lit("WALL_PLANE_TRIM"),
    name: str,
    parentId: opt(str),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    ruleId: fk("WALL_PLANE_RULE"),
    path: any,
    profileId: id("ProfileId"),
    materialTransformation: opt(partial(id("UVTransformation"))),
  },
  "WallPlaneTrimEntity",
);
export const WallPlaneTrimHandleSchema = interf(
  {
    type: lit("WALL_PLANE_TRIM"),
    id: str,
  },
  "WallPlaneTrimHandle",
);
export const WallPlaneViewHandleSchema = interf(
  {
    type: lit("WALL_PLANE_VIEW"),
    planeHash: str,
    direction: id("DocFaceDirection"),
  },
  "WallPlaneViewHandle",
);
export const WallRoofBaseBoardFilterSchema = enu(
  {
    [`ALL_EDGES`]: "ALL_EDGES",
    [`HORIZONTAL_EDGES`]: "HORIZONTAL_EDGES",
    [`SLOPED_EDGES`]: "SLOPED_EDGES",
  },
  "WallRoofBaseBoardFilter",
);
export const WallRoofBaseBoardModeSchema = enu(
  {
    [`NONE`]: "NONE",
    [`ROOF_TOP_PLUMB_CUT`]: "ROOF_TOP_PLUMB_CUT",
    [`ROOF_TOP_SQUARED_CUT`]: "ROOF_TOP_SQUARED_CUT",
    [`FULL`]: "FULL",
  },
  "WallRoofBaseBoardMode",
);
export const WallSettingsSchema = interf(
  {
    type: lit("WALL_SETTINGS"),
    exteriorWallBaseThickness: num,
    exteriorWallSubstrateThickness: num,
    exteriorWallOffset: num,
    interiorWallOffset: num,
    exteriorWallMaterial: id("ExteriorMaterial"),
    exteriorWallOffsetMode: id("ExteriorWallOffsetMode"),
    exteriorWallOffsetDatum: id("WallLateralDatumAnchor"),
    wallConditions: obj(id("WallConditionData"), "WallConditionTable"),
    insideCornerWallOffsetForInteriorWallThickening: num,
    insideCornerWallOffsetForInteriorRoofWallThickening: num,
    outsideCornerWallOffsetForInteriorWallThickening: num,
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "WallSettings",
);
export const WallTypeSchema = interf(
  {
    name: str,
    structuralMaterialId: str,
    foundationMaterialId: opt(str),
    exteriorSubstrateMaterialId: opt(str),
    membraneMaterialId: opt(str),
    thermalMaterialId: opt(str),
    catalogItemType: lit("WALL_TYPE"),
  },
  "WallType",
);
export const WallVerticalDatumAnchorSchema = enu(
  {
    [`BASE_WALL`]: "BASE_WALL",
    [`GABLE_END`]: "GABLE_END",
  },
  "WallVerticalDatumAnchor",
);
export const WindowCatalogSettingsSchema = interf(
  {
    type: lit("WINDOW_CATALOG_SETTINGS"),
    displayBuiltInCatalog: id("OptionalBoolean"),
    windowTypes: pkTable("WINDOW_DESCRIPTOR", id("WindowDescriptorCustom")),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "WindowCatalogSettings",
);
export const WindowDescriptorCustomSchema = interf(
  {
    id: pk("WINDOW_DESCRIPTOR"),
    name: opt(str),
    shape: id("WindowShapeTypes"),
    arched: id("OptionalBoolean"),
    archRadius: opt(num),
    archBoolean: opt(id("ArchTopBoolean")),
    verticalDivisions: id("WindowVertDivisions"),
    verticalDivisionSpacing: opt(num),
    open: id("OptionalBoolean"),
    optionSets: opt(obj(id("DocOptionSet"), "Table")),
    angleVerticalOffset: opt(num),
    polygonWindowMode: opt(id("PolygonWindowMode")),
    removeWallFill: id("OptionalBoolean"),
    width: nom("LevelInches"),
    height: nom("LevelInches"),
    catalogItemType: lit("WINDOW_DESCRIPTOR"),
  },
  "WindowDescriptorCustom",
);
export const WindowGridLayoutSchema = interf(
  {
    positions: arr(id("WindowGridPosition")),
    start: num,
    startNormalized: bool,
    end: num,
    endNormalized: bool,
  },
  "WindowGridLayout",
);
export const WindowGridPositionSchema = interf(
  {
    value: num,
    valueNormalized: bool,
  },
  "WindowGridPosition",
);
export const WindowLateralAlignmentSchema = enu(
  {
    [`OUTSIDE_FACE`]: "OUTSIDE_FACE",
    [`INSIDE_FACE`]: "INSIDE_FACE",
    [`CENTERLINE`]: "CENTERLINE",
  },
  "WindowLateralAlignment",
);
export const WindowMaterialSettingsSchema = interf(
  {
    type: lit("WINDOW_MATERIAL_SETTINGS"),
    panelType: id("WindowPanelType"),
    glazingType: id("GlazingType"),
    glazingColor: id("GlazingColor"),
    frameMaterial: id("ExteriorMaterial"),
    integralMullionMaterial: id("ExteriorMaterial"),
    ventMaterial: id("ExteriorMaterial"),
    sashMaterial: id("ExteriorMaterial"),
    gridMaterial: id("ExteriorMaterial"),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "WindowMaterialSettings",
);
export const WindowMullionSettingsSchema = union(
  [id("GridWindowMullionSettings"), id("DisabledWindowMullionSettings")],
  "WindowMullionSettings",
);
export const WindowMullionTypeSchema = enu(
  {
    [`ORTHOGONAL`]: "ORTHOGONAL",
    [`ORTHOGONAL_CUSTOM`]: "ORTHOGONAL_CUSTOM",
    [`RADIAL_CUSTOM`]: "RADIAL_CUSTOM",
    [`DISABLED`]: "DISABLED",
  },
  "WindowMullionType",
);
export const WindowOperationTypeSchema = enu(
  {
    [`FIXED`]: "FIXED",
    [`AWNING`]: "AWNING",
    [`SLIDING`]: "SLIDING",
    [`CASEMENT`]: "CASEMENT",
    [`SINGLE_HUNG`]: "SINGLE_HUNG",
    [`DOUBLE_HUNG`]: "DOUBLE_HUNG",
  },
  "WindowOperationType",
);
export const WindowPanelTypeSchema = enu(
  {
    [`GLAZING`]: "GLAZING",
    [`FAUX_SHUTTER`]: "FAUX_SHUTTER",
    [`VENT`]: "VENT",
    [`SCREEN`]: "SCREEN",
  },
  "WindowPanelType",
);
export const WindowPlacementDeprecatedSchema = interf(
  {
    type: lit("WINDOW"),
    windowType: union([fk("WINDOW_DESCRIPTOR")]),
    reportedName: opt(str),
    awning: opt(id("Awning")),
    framing: opt(partial(id("WindowWallFramingSettings"))),
    wrapping: opt(partial(id("WindowWallWrappingSettings"))),
    lateralDatum: id("WallLateralDatumAnchor"),
    lateralAlignment: id("WindowLateralAlignment"),
    lateralOffset: opt(num),
    lateralOffsetNormalized: id("OptionalBoolean"),
    verticalOffset: opt(num),
    verticalDatum: id("WindowVerticalDatum"),
    verticalAlignment: id("WindowVerticalAlignment"),
    roughOpeningSettings: opt(partial(id("WindowRoughOpeningSettings"))),
    operationType: opt(id("WindowOperationType")),
    paneSplitParam: opt(num),
    paneSplitParamNormalized: id("OptionalBoolean"),
    verticalDivisionSpacing: opt(num),
    materials: opt(partial(id("WindowMaterialSettings"))),
    mullions: opt(
      union([partial(id("GridWindowMullionSettings")), partial(id("DisabledWindowMullionSettings"))], "Partial"),
    ),
    shutters: opt(
      union(
        [
          partial(id("DisabledShutterSettings")),
          partial(id("VentedShutterSettings")),
          partial(id("SimpleSlatShutterSettings")),
          partial(id("PanelShutterSettings")),
          partial(id("ZShutterSettings")),
          partial(id("GenericShutterSettings")),
        ],
        "Partial",
      ),
    ),
    exteriorCasing: opt(
      union(
        [
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingNone"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingTrim"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingSlices"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingStone"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingJackArch"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingFullArch"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingArchedSlices"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingEyebrowTrim"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
        ],
        "Partial",
      ),
    ),
    interiorCasing: opt(partial(id("InteriorWindowCasingSettings"))),
    awningSettings: opt(union([partial(id("ShedAwningSettings")), partial(id("DisabledAwningSettings"))], "Partial")),
    bugScreen: id("OptionalBoolean"),
    viewNotes: opt(
      mapobj(
        lit("WINDOW"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "WindowViewNoteTable",
      ),
    ),
    disableAutoDimensions: id("OptionalBoolean"),
    windowHeadHeight: opt(num),
    tagOffset: opt(num),
    tagDetails: opt(str),
    param: num,
    paramNormalized: bool,
    paramAnchor: id("LineAnchor"),
    wallStripDomain: bool,
    id: pk("OPENING"),
    name: str,
    parentId: union(
      [fk("ROOM", { hierarchy: ["PARENT"] }), fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] })],
      "DocEntityParentId",
    ),
    edgeId: str,
    handle: union([undef, id("RoomLayoutInstanceHandle"), id("OpeningHandle")]),
    handleAuxiliary: opt(id("OpeningHandle")),
    entityInstanceType: opt(id("EntityInstanceType")),
    entityType: lit("OPENING"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
  },
  "WindowPlacementDeprecated",
);
export const WindowPlacementMatchExprSchema = interf(
  {
    type: lit("WINDOW_V2"),
    verticalDatum: id("WindowVerticalDatum"),
    verticalAlignment: id("WindowVerticalAlignment"),
    lateralAlignment: id("WindowLateralAlignment"),
    lateralOffsetNormalized: id("OptionalBoolean"),
    lateralDatum: id("WallLateralDatumAnchor"),
    lateralOffset: opt(num),
    reportedName: opt(str),
    awning: opt(id("Awning")),
    framing: opt(partial(id("WindowWallFramingSettings"))),
    wrapping: opt(partial(id("WindowWallWrappingSettings"))),
    roughOpeningSettings: opt(partial(id("WindowRoughOpeningSettings"))),
    windowType: union([fk("WINDOW_DESCRIPTOR")]),
    operationType: opt(id("WindowOperationType")),
    paneSplitParam: opt(num),
    paneSplitParamNormalized: id("OptionalBoolean"),
    verticalDivisionSpacing: opt(num),
    materials: opt(partial(id("WindowMaterialSettings"))),
    mullions: opt(
      union([partial(id("GridWindowMullionSettings")), partial(id("DisabledWindowMullionSettings"))], "Partial"),
    ),
    shutters: opt(
      union(
        [
          partial(id("DisabledShutterSettings")),
          partial(id("VentedShutterSettings")),
          partial(id("SimpleSlatShutterSettings")),
          partial(id("PanelShutterSettings")),
          partial(id("ZShutterSettings")),
          partial(id("GenericShutterSettings")),
        ],
        "Partial",
      ),
    ),
    exteriorCasing: opt(
      union(
        [
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingNone"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingTrim"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingSlices"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingStone"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingJackArch"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingFullArch"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingArchedSlices"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
          partial(
            inters([
              interf({
                type: lit("EXTERIOR_WINDOW_CASING_SETTINGS"),
                factoryMulled: id("OptionalBoolean"),
              }),
              id("BaseSettings"),
              id("CasingOrientationSettings"),
              id("CasingHorizontalPlacementSettings"),
              id("CasingLateralPlacementSettings"),
              id("ApronCasingSettings"),
              id("SideCasingSettings"),
              id("StoolCasingSettings"),
              id("HeadCasingEyebrowTrim"),
              id("ExteriorWindowCasingViewNotesSettings"),
              id("CasingFinishSettings"),
            ]),
          ),
        ],
        "Partial",
      ),
    ),
    interiorCasing: opt(partial(id("InteriorWindowCasingSettings"))),
    awningSettings: opt(union([partial(id("ShedAwningSettings")), partial(id("DisabledAwningSettings"))], "Partial")),
    bugScreen: id("OptionalBoolean"),
    viewNotes: opt(
      mapobj(
        lit("WINDOW"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "WindowViewNoteTable",
      ),
    ),
    disableAutoDimensions: id("OptionalBoolean"),
    windowHeadHeight: opt(num),
    tagOffset: opt(num),
    tagDetails: opt(str),
    horizontalAlignment: id("OpeningHorizontalAlignment"),
    id: pk("OPENING"),
    name: str,
    parentId: union(
      [fk("ROOM", { hierarchy: ["PARENT"] }), fk("ROOM_LAYOUT", { hierarchy: ["PARENT"] })],
      "DocEntityParentId",
    ),
    edgeId: str,
    handle: union([undef, id("RoomLayoutInstanceHandle"), id("OpeningHandle")]),
    handleAuxiliary: opt(id("OpeningHandle")),
    entityInstanceType: opt(id("EntityInstanceType")),
    entityType: lit("OPENING"),
    sortIndex: num,
    disabled: id("FormulaDisabledField"),
    paramAnchor: id("LineAnchor"),
    horizontalDatum: opt(id("WallHorizontalDatum")),
    param: union([
      num,
      ref(
        interf(
          {
            type: lit("MATCH_EXPR"),
            cases: arr(
              ref(
                interf(
                  {
                    condition: id("Formula"),
                    value: typeParam("T"),
                  },
                  "MatchCase",
                  ["T"],
                ),
                { T: typeParam("T") },
              ),
            ),
            defaultValue: typeParam("T"),
          },
          "MatchExpression",
          ["T"],
        ),
        { T: num },
      ),
    ]),
    paramNormalized: union([
      lit(false),
      lit(true),
      ref(
        interf(
          {
            type: lit("MATCH_EXPR"),
            cases: arr(
              ref(
                interf(
                  {
                    condition: id("Formula"),
                    value: typeParam("T"),
                  },
                  "MatchCase",
                  ["T"],
                ),
                { T: typeParam("T") },
              ),
            ),
            defaultValue: typeParam("T"),
          },
          "MatchExpression",
          ["T"],
        ),
        { T: bool },
      ),
    ]),
    verticalOffset: union([
      num,
      ref(
        interf(
          {
            type: lit("MATCH_EXPR"),
            cases: arr(
              ref(
                interf(
                  {
                    condition: id("Formula"),
                    value: typeParam("T"),
                  },
                  "MatchCase",
                  ["T"],
                ),
                { T: typeParam("T") },
              ),
            ),
            defaultValue: typeParam("T"),
          },
          "MatchExpression",
          ["T"],
        ),
        { T: num },
      ),
    ]),
  },
  "WindowPlacementMatchExpr",
);
export const WindowRoughOpeningSettingsSchema = inters(
  [id("RoughOpeningJambSettings"), id("RoughOpeningHeadSettings"), id("RoughOpeningSillSettings")],
  "WindowRoughOpeningSettings",
);
export const WindowSettingsSchema = interf(
  {
    type: lit("WINDOW_SETTINGS"),
    windowHeadHeight: num,
    verticalDivisionSpacing: num,
    parentId: opt(
      union(
        [fk("LEVEL", { hierarchy: ["PARENT"] }), fk("SETTINGS_SET", { hierarchy: ["PARENT"] })],
        "DocEntityParentId",
      ),
    ),
    framingRoughOpeningJambDelta: opt(num),
    foundationRoughOpeningJambDelta: opt(num),
    framingRoughOpeningHeadDelta: opt(num),
    foundationRoughOpeningHeadDelta: opt(num),
    framingRoughOpeningSillDelta: opt(num),
    foundationRoughOpeningSillDelta: opt(num),
    name: opt(str),
    id: opt(pk("SETTINGS")),
  },
  "WindowSettings",
);
export const WindowShapeTypesSchema = enu(
  {
    [`RECTANGLE`]: "RECTANGLE",
    [`RECTANGLE_ARCHED_TOP`]: "RECTANGLE_ARCHED_TOP",
    [`CIRCLE`]: "CIRCLE",
    [`HALF_ROUND`]: "HALF_ROUND",
    [`ELLIPSE`]: "ELLIPSE",
    [`POLYGONAL`]: "POLYGONAL",
  },
  "WindowShapeTypes",
);
export const WindowShutterSettingsSchema = union(
  [
    id("DisabledShutterSettings"),
    id("VentedShutterSettings"),
    id("SimpleSlatShutterSettings"),
    id("PanelShutterSettings"),
    id("ZShutterSettings"),
    id("GenericShutterSettings"),
  ],
  "WindowShutterSettings",
);
export const WindowVertDivisionsSchema = enu(
  {
    [`SINGLE`]: "SINGLE",
    [`TWIN`]: "TWIN",
    [`TRIPLE`]: "TRIPLE",
  },
  "WindowVertDivisions",
);
export const WindowVerticalAlignmentSchema = enu(
  {
    [`TOP`]: "TOP",
    [`BOTTOM`]: "BOTTOM",
    [`CENTER`]: "CENTER",
  },
  "WindowVerticalAlignment",
);
export const WindowVerticalDatumSchema = enu(
  {
    [`TO_WALL_PLATE`]: "TO_WALL_PLATE",
    [`TO_FLOOR`]: "TO_FLOOR",
    [`WINDOW_HEAD_HEIGHT`]: "WINDOW_HEAD_HEIGHT",
  },
  "WindowVerticalDatum",
);
export const WindowWallFramingSettingsSchema = inters(
  [
    interf({
      type: lit("WINDOW_FRAMING_SETTINGS"),
    }),
    id("WallFramingOpeningSettings"),
  ],
  "WindowWallFramingSettings",
);
export const WindowWallWrappingSettingsSchema = inters(
  [
    interf({
      type: lit("WINDOW_WRAPPING_SETTINGS"),
    }),
    id("WallOpeningWrappingSettings"),
  ],
  "WindowWallWrappingSettings",
);
export const WoodSlabSchema = interf(
  {
    id: pk("SLAB_COMPONENT"),
    name: str,
    slabType: lit("WOOD"),
    thickness: num,
    entityType: lit("SLAB_COMPONENT"),
    parentId: opt(str),
    sortIndex: num,
  },
  "WoodSlab",
);
export const WorldFeetSchema = nom("WorldFeet");
export const WorldInchesSchema = nom("WorldInches");
export const WrapFriezeBoardModeSchema = enu(
  {
    [`NONE`]: "NONE",
    [`FULL`]: "FULL",
    [`SIDES`]: "SIDES",
    [`BOTTOM`]: "BOTTOM",
  },
  "WrapFriezeBoardMode",
);
export const YardsCubedSchema = nom("YardsCubed");
export const ZShutterSettingsSchema = interf(
  {
    shutterType: lit("Z_SLATS"),
    type: lit("WINDOW_SHUTTER_SETTINGS"),
    forceShutters: id("OptionalBoolean"),
    shutterShapeOverride: opt(id("ShutterShapeType")),
    shutterWidthOverride: opt(num),
    shutterHeightOverride: opt(num),
    shutterArchRadiusOverride: opt(num),
    verticalAlignment: opt(id("ShutterVerticalAlignment")),
    verticalOffset: opt(num),
    horizontalOffset: opt(num),
    lateralDatum: opt(id("WallLateralDatumAnchor")),
    lateralOffset: opt(num),
    shutterConfiguration: opt(id("ShutterConfigurationType")),
    orientation: opt(id("ShutterStreetOrientationPreference")),
    shutterMaterial: opt(id("ExteriorMaterial")),
    viewNotes: opt(
      mapobj(
        lit("SHUTTER"),
        interf(
          {
            enable: bool,
            tagOnlyOne: bool,
            text: str,
          },
          "ViewNote",
        ),
        false,
        "ShutterViewNoteTable",
      ),
    ),
    isLegacyWidthOverride: id("OptionalBoolean"),
    name: opt(str),
    id: opt(pk("SETTINGS")),
    parentId: opt(union([fk("SETTINGS_SET", { hierarchy: ["PARENT"] })], "DocEntityParentId")),
  },
  "ZShutterSettings",
);
export const DocSchemaLibrary = {
  AABB2: AABB2Schema,
  AABB3: AABB3Schema,
  AbsoluteVerticalDatumEntity: AbsoluteVerticalDatumEntitySchema,
  AggregationMethod: AggregationMethodSchema,
  AlignmentEnum: AlignmentEnumSchema,
  Annotation: AnnotationSchema,
  AnnotationDrawingTemplate: AnnotationDrawingTemplateSchema,
  AnnotationFillType: AnnotationFillTypeSchema,
  AnnotationHandle: AnnotationHandleSchema,
  AnnotationHostWall: AnnotationHostWallSchema,
  AnnotationLineType: AnnotationLineTypeSchema,
  AnyAtom: AnyAtomSchema,
  ApronCasingSettings: ApronCasingSettingsSchema,
  ApronCasingType: ApronCasingTypeSchema,
  ArchitecturalColumnDescriptor: ArchitecturalColumnDescriptorSchema,
  ArchTopBoolean: ArchTopBooleanSchema,
  AreaReportSetting: AreaReportSettingSchema,
  AreaReportSettings: AreaReportSettingsSchema,
  ArrayColumnPlacementV1: ArrayColumnPlacementV1Schema,
  ArrayColumnPlacementV2: ArrayColumnPlacementV2Schema,
  ArrayPostPlacement: ArrayPostPlacementSchema,
  AssembledStair: AssembledStairSchema,
  Asset: AssetSchema,
  AssetCatalogReference: AssetCatalogReferenceSchema,
  AssetHandle: AssetHandleSchema,
  AssetReferenceUnderlay: AssetReferenceUnderlaySchema,
  AtBackOfProp: AtBackOfPropSchema,
  AtDoorByType: AtDoorByTypeSchema,
  AutoDimensionFloorPlanExteriorByOrientationHandle: AutoDimensionFloorPlanExteriorByOrientationHandleSchema,
  AutoDimensionFloorPlanExteriorByOrientationProvenance: AutoDimensionFloorPlanExteriorByOrientationProvenanceSchema,
  AutoDimensionFloorPlanExteriorByRoomMultipleHandle: AutoDimensionFloorPlanExteriorByRoomMultipleHandleSchema,
  AutoDimensionFloorPlanExteriorByRoomMultipleProvenance: AutoDimensionFloorPlanExteriorByRoomMultipleProvenanceSchema,
  AutoDimensionFloorPlanExteriorByRoomSingleHandle: AutoDimensionFloorPlanExteriorByRoomSingleHandleSchema,
  AutoDimensionFloorPlanExteriorByRoomSingleProvenance: AutoDimensionFloorPlanExteriorByRoomSingleProvenanceSchema,
  AutoDimensionFloorPlanInteriorByOrthogonalRoomEdge: AutoDimensionFloorPlanInteriorByOrthogonalRoomEdgeSchema,
  AutoDimensionFloorPlanInteriorByOrthogonalRoomEdgeHandle:
    AutoDimensionFloorPlanInteriorByOrthogonalRoomEdgeHandleSchema,
  AutoDimensionFloorPlanInteriorByRoomEdgePair: AutoDimensionFloorPlanInteriorByRoomEdgePairSchema,
  AutoDimensionFloorPlanInteriorByRoomEdgePairHandle: AutoDimensionFloorPlanInteriorByRoomEdgePairHandleSchema,
  AutoDimensionFoundationExteriorByOrientationHandle: AutoDimensionFoundationExteriorByOrientationHandleSchema,
  AutoDimensionFoundationExteriorByOrientationProvenance: AutoDimensionFoundationExteriorByOrientationProvenanceSchema,
  AutoDimensionFoundationExteriorByRoomMultipleHandle: AutoDimensionFoundationExteriorByRoomMultipleHandleSchema,
  AutoDimensionFoundationExteriorByRoomMultipleProvenance:
    AutoDimensionFoundationExteriorByRoomMultipleProvenanceSchema,
  AutoDimensionFoundationExteriorByRoomSingleHandle: AutoDimensionFoundationExteriorByRoomSingleHandleSchema,
  AutoDimensionFoundationExteriorByRoomSingleProvenance: AutoDimensionFoundationExteriorByRoomSingleProvenanceSchema,
  AutoDimensionFoundationInteriorByOrientationHandle: AutoDimensionFoundationInteriorByOrientationHandleSchema,
  AutoDimensionFoundationInteriorByOrientationProvenance: AutoDimensionFoundationInteriorByOrientationProvenanceSchema,
  AutoDimensionFoundationInteriorByRoomMultipleHandle: AutoDimensionFoundationInteriorByRoomMultipleHandleSchema,
  AutoDimensionFoundationInteriorByRoomMultipleProvenance:
    AutoDimensionFoundationInteriorByRoomMultipleProvenanceSchema,
  AutoDimensionFoundationInteriorByRoomSingleHandle: AutoDimensionFoundationInteriorByRoomSingleHandleSchema,
  AutoDimensionFoundationInteriorByRoomSingleProvenance: AutoDimensionFoundationInteriorByRoomSingleProvenanceSchema,
  AutoDimensionPersistedHandle: AutoDimensionPersistedHandleSchema,
  AutoDimensionSelector: AutoDimensionSelectorSchema,
  Awning: AwningSchema,
  AwningSettings: AwningSettingsSchema,
  BackgroundPlanSheet: BackgroundPlanSheetSchema,
  BackgroundType: BackgroundTypeSchema,
  BackgroundVisibility: BackgroundVisibilitySchema,
  BalusterDefault: BalusterDefaultSchema,
  BaseCabinetDescriptor: BaseCabinetDescriptorSchema,
  BaseRangeFilter: BaseRangeFilterSchema,
  BaseRoomTypeSpaceTypeFilter: BaseRoomTypeSpaceTypeFilterSchema,
  BaseSettings: BaseSettingsSchema,
  BayFramingEdgeOverride: BayFramingEdgeOverrideSchema,
  BlindPanelSide: BlindPanelSideSchema,
  Block: BlockSchema,
  BlockHandle: BlockHandleSchema,
  BoardDescriptor: BoardDescriptorSchema,
  BoardProfileEntity: BoardProfileEntitySchema,
  BooleanAtom: BooleanAtomSchema,
  BooleanParameter: BooleanParameterSchema,
  BrickLedgeBehavior: BrickLedgeBehaviorSchema,
  BrickLedgeType: BrickLedgeTypeSchema,
  BuildingGraphPlanarTopologyHandle: BuildingGraphPlanarTopologyHandleSchema,
  BuildingSide: BuildingSideSchema,
  BuildingWallPlaneSubdomainHandle: BuildingWallPlaneSubdomainHandleSchema,
  BuiltInExteriorPropId: BuiltInExteriorPropIdSchema,
  BuiltinPlanViewType: BuiltinPlanViewTypeSchema,
  BuiltInSiteType: BuiltInSiteTypeSchema,
  BuiltInViewSelector: BuiltInViewSelectorSchema,
  BuiltinWindowId: BuiltinWindowIdSchema,
  CabinetShape: CabinetShapeSchema,
  CabinetShapeAngled: CabinetShapeAngledSchema,
  CabinetShapeLShaped: CabinetShapeLShapedSchema,
  CabinetShapeNone: CabinetShapeNoneSchema,
  CameraPosition: CameraPositionSchema,
  CandidateTypeConstraints: CandidateTypeConstraintsSchema,
  CaseworkCatalogSettings: CaseworkCatalogSettingsSchema,
  CaseworkDescriptor: CaseworkDescriptorSchema,
  CaseworkDoorStyle: CaseworkDoorStyleSchema,
  CaseworkHandle: CaseworkHandleSchema,
  CaseworkHorizontalAlignment: CaseworkHorizontalAlignmentSchema,
  CaseworkLateralAlignment: CaseworkLateralAlignmentSchema,
  CaseworkLineStyle: CaseworkLineStyleSchema,
  CaseworkSettings: CaseworkSettingsSchema,
  CaseworkVerticalAlignment: CaseworkVerticalAlignmentSchema,
  CaseworkVerticalDatumAnchor: CaseworkVerticalDatumAnchorSchema,
  CasingFinishSettings: CasingFinishSettingsSchema,
  CasingHorizontalPlacementSettings: CasingHorizontalPlacementSettingsSchema,
  CasingLateralPlacementSettings: CasingLateralPlacementSettingsSchema,
  CasingOrientationSettings: CasingOrientationSettingsSchema,
  CatalogItemHandle: CatalogItemHandleSchema,
  Ceiling: CeilingSchema,
  CeilingBoundaryType: CeilingBoundaryTypeSchema,
  CeilingHandle: CeilingHandleSchema,
  CeilingRidgeOrientation: CeilingRidgeOrientationSchema,
  CipComponentHandle: CipComponentHandleSchema,
  CipConcrete: CipConcreteSchema,
  CIPStemWallEntity: CIPStemWallEntitySchema,
  CircularCIPPierEntity: CircularCIPPierEntitySchema,
  CircularCMUPierEntity: CircularCMUPierEntitySchema,
  CircularIsolatedFootingEntity: CircularIsolatedFootingEntitySchema,
  ClosetShelfDescriptor: ClosetShelfDescriptorSchema,
  CMUBrickLedgeType: CMUBrickLedgeTypeSchema,
  CMUProfile: CMUProfileSchema,
  CMUStemWallEntity: CMUStemWallEntitySchema,
  CodeFormatting: CodeFormattingSchema,
  ColonnadeTerminationRule: ColonnadeTerminationRuleSchema,
  ColonnadeTerminationType: ColonnadeTerminationTypeSchema,
  Column: ColumnSchema,
  ColumnCatalogSettings: ColumnCatalogSettingsSchema,
  ColumnDescriptor: ColumnDescriptorSchema,
  ColumnDimensionType: ColumnDimensionTypeSchema,
  ColumnHandle: ColumnHandleSchema,
  ColumnHorizontalAlignment: ColumnHorizontalAlignmentSchema,
  ColumnLateralAlignment: ColumnLateralAlignmentSchema,
  ColumnPlacementV1: ColumnPlacementV1Schema,
  ColumnPlacementV2: ColumnPlacementV2Schema,
  ColumnPosition: ColumnPositionSchema,
  ColumnSection: ColumnSectionSchema,
  ColumnV1: ColumnV1Schema,
  ColumnV2: ColumnV2Schema,
  Component: ComponentSchema,
  ComponentHandle: ComponentHandleSchema,
  ComponentInstance: ComponentInstanceSchema,
  ComponentInstanceHandle: ComponentInstanceHandleSchema,
  ComponentOptionSetAssociation: ComponentOptionSetAssociationSchema,
  ComponentVerticalPlacement: ComponentVerticalPlacementSchema,
  ComponentVerticalPlacementRemapping: ComponentVerticalPlacementRemappingSchema,
  ComponentVerticalPlacementReplication: ComponentVerticalPlacementReplicationSchema,
  CompositeLevel: CompositeLevelSchema,
  CompositeLevelHandle: CompositeLevelHandleSchema,
  CompositeLevelMember: CompositeLevelMemberSchema,
  CompositeLevelPlanView: CompositeLevelPlanViewSchema,
  CompositeLumberComponent: CompositeLumberComponentSchema,
  Concrete: ConcreteSchema,
  ConcreteSlab: ConcreteSlabSchema,
  Condition: ConditionSchema,
  ConditionedAreaCalculationType: ConditionedAreaCalculationTypeSchema,
  ConditionOperator: ConditionOperatorSchema,
  ConditionTypeDefId: ConditionTypeDefIdSchema,
  ConnectiveOperator: ConnectiveOperatorSchema,
  ContentReplicator: ContentReplicatorSchema,
  ContentReplicatorHandle: ContentReplicatorHandleSchema,
  ContentTemplate: ContentTemplateSchema,
  ContentTemplateHandle: ContentTemplateHandleSchema,
  ContentTemplateInstance: ContentTemplateInstanceSchema,
  ContentTemplateInstanceHandle: ContentTemplateInstanceHandleSchema,
  ContentTemplateInstanceViewHandle: ContentTemplateInstanceViewHandleSchema,
  ContentTemplateValue: ContentTemplateValueSchema,
  ContentTemplateViewHandle: ContentTemplateViewHandleSchema,
  ContextHomeProp: ContextHomePropSchema,
  ContourSiteShape: ContourSiteShapeSchema,
  ControllerPosition: ControllerPositionSchema,
  ControllerSelectionConfig: ControllerSelectionConfigSchema,
  ControllerSwitchType: ControllerSwitchTypeSchema,
  ControllerType: ControllerTypeSchema,
  ControllerTypeSlot: ControllerTypeSlotSchema,
  ControllerTypeSlots: ControllerTypeSlotsSchema,
  CornerBoardTrimAlignment: CornerBoardTrimAlignmentSchema,
  CornerBoardTrimHorizontalDatum: CornerBoardTrimHorizontalDatumSchema,
  CSByControllerTag: CSByControllerTagSchema,
  CSDoorByRoomIds: CSDoorByRoomIdsSchema,
  CSDoorByRoomType: CSDoorByRoomTypeSchema,
  CSDoorByRoomTypeOutside: CSDoorByRoomTypeOutsideSchema,
  CSExplicitPoint: CSExplicitPointSchema,
  CSNearestCandidate: CSNearestCandidateSchema,
  CSNearestCandidateOutside: CSNearestCandidateOutsideSchema,
  CSNearestDoorOutside: CSNearestDoorOutsideSchema,
  CSNearestExplicitWall: CSNearestExplicitWallSchema,
  CSNone: CSNoneSchema,
  CSPrimaryEntrance: CSPrimaryEntranceSchema,
  CSPrimaryEntranceOutside: CSPrimaryEntranceOutsideSchema,
  CustomDataSequence: CustomDataSequenceSchema,
  CustomDescriptor: CustomDescriptorSchema,
  CustomFramingComponent: CustomFramingComponentSchema,
  CustomPierEntity: CustomPierEntitySchema,
  CustomProfileEntity: CustomProfileEntitySchema,
  DataSequence: DataSequenceSchema,
  DataSequenceHandle: DataSequenceHandleSchema,
  DataSequenceParameter: DataSequenceParameterSchema,
  DataSequenceValue: DataSequenceValueSchema,
  DataSequenceViewHandle: DataSequenceViewHandleSchema,
  DataTable: DataTableSchema,
  DataTableColumnConfig: DataTableColumnConfigSchema,
  DataTableFindAndReplaceRow: DataTableFindAndReplaceRowSchema,
  DataTableHandle: DataTableHandleSchema,
  DatumEntity: DatumEntitySchema,
  DatumHandle: DatumHandleSchema,
  DatumLevelPlacement: DatumLevelPlacementSchema,
  DatumScope: DatumScopeSchema,
  DatumUsageBase: DatumUsageBaseSchema,
  DeprecatedPlanDim: DeprecatedPlanDimSchema,
  DimensionalLumberComponent: DimensionalLumberComponentSchema,
  DimensionEdgeBehavior: DimensionEdgeBehaviorSchema,
  DimensionPrecision: DimensionPrecisionSchema,
  DimensionRowLevel: DimensionRowLevelSchema,
  DisabledAwningSettings: DisabledAwningSettingsSchema,
  DisabledShutterSettings: DisabledShutterSettingsSchema,
  DisabledWindowMullionSettings: DisabledWindowMullionSettingsSchema,
  DivisionColumnPlacementV1: DivisionColumnPlacementV1Schema,
  DivisionColumnPlacementV2: DivisionColumnPlacementV2Schema,
  DivisionPostPlacement: DivisionPostPlacementSchema,
  Doc: DocSchema,
  DocBuildingGraphAndFilterNode: DocBuildingGraphAndFilterNodeSchema,
  DocBuildingGraphFilterGraph: DocBuildingGraphFilterGraphSchema,
  DocBuildingGraphFilterNode: DocBuildingGraphFilterNodeSchema,
  DocBuildingGraphNotFilterNode: DocBuildingGraphNotFilterNodeSchema,
  DocBuildingGraphOrFilterNode: DocBuildingGraphOrFilterNodeSchema,
  DocBuildingGraphPredicateFilterNode: DocBuildingGraphPredicateFilterNodeSchema,
  DocBuildingGraphPredicateLiteral: DocBuildingGraphPredicateLiteralSchema,
  DocBuildingGraphSubfilterValueSource: DocBuildingGraphSubfilterValueSourceSchema,
  DocDatumSpanAssociation: DocDatumSpanAssociationSchema,
  DocEntityHandle: DocEntityHandleSchema,
  DocFacadeSpanStratumAssociation: DocFacadeSpanStratumAssociationSchema,
  DocFacadeSweepStratumAssociation: DocFacadeSweepStratumAssociationSchema,
  DocFaceDirection: DocFaceDirectionSchema,
  DocFaceNodeSubFilter: DocFaceNodeSubFilterSchema,
  DocOption: DocOptionSchema,
  DocOptionEffect: DocOptionEffectSchema,
  DocOptionLock: DocOptionLockSchema,
  DocOptionRule: DocOptionRuleSchema,
  DocOptionSet: DocOptionSetSchema,
  DocOptionSetOverrides: DocOptionSetOverridesSchema,
  DocOptionTemplate: DocOptionTemplateSchema,
  DocRef: DocRefSchema,
  DocRefHandle: DocRefHandleSchema,
  DocTableViewSelector: DocTableViewSelectorSchema,
  DocWallPlaneFilter: DocWallPlaneFilterSchema,
  DoorCandidateTypeConstraints: DoorCandidateTypeConstraintsSchema,
  DoorCatalogSettings: DoorCatalogSettingsSchema,
  DoorDescriptorCustom: DoorDescriptorCustomSchema,
  DoorOperationType: DoorOperationTypeSchema,
  DoorPathColumnSpreadMode: DoorPathColumnSpreadModeSchema,
  DoorPlacementDeprecated: DoorPlacementDeprecatedSchema,
  DoorPlacementMatchExpr: DoorPlacementMatchExprSchema,
  DoorPropIdPrefix: DoorPropIdPrefixSchema,
  DoorRoughOpeningSettings: DoorRoughOpeningSettingsSchema,
  DoorSettings: DoorSettingsSchema,
  DoorWallFramingSettings: DoorWallFramingSettingsSchema,
  DoorWallWrappingSettings: DoorWallWrappingSettingsSchema,
  DormerElevationPlanSettings: DormerElevationPlanSettingsSchema,
  DormerHandle: DormerHandleSchema,
  DormerPlanSettings: DormerPlanSettingsSchema,
  DormerRoofType: DormerRoofTypeSchema,
  DormerSettings: DormerSettingsSchema,
  DormerWallBaseBoardMode: DormerWallBaseBoardModeSchema,
  DotsPerInch: DotsPerInchSchema,
  Drawing: DrawingSchema,
  DrawingCatalogSettings: DrawingCatalogSettingsSchema,
  DrawingRef: DrawingRefSchema,
  DrawingRefHandle: DrawingRefHandleSchema,
  DrawingScale: DrawingScaleSchema,
  DrawingScaleMode: DrawingScaleModeSchema,
  DrawingScaleParameter: DrawingScaleParameterSchema,
  DrawingsPlanSheet: DrawingsPlanSheetSchema,
  DrawingTemplateInstance: DrawingTemplateInstanceSchema,
  DrawingTemplateParameter: DrawingTemplateParameterSchema,
  DrawingType: DrawingTypeSchema,
  DrawingViewport: DrawingViewportSchema,
  DrawingViewTemplate: DrawingViewTemplateSchema,
  DrivewaySiteShape: DrivewaySiteShapeSchema,
  Drywall: DrywallSchema,
  DxfAsset: DxfAssetSchema,
  DXFUnit: DXFUnitSchema,
  EaveBracketPlacement: EaveBracketPlacementSchema,
  EaveBracketSide: EaveBracketSideSchema,
  EaveCutType: EaveCutTypeSchema,
  EaveFasciaHeightDatum: EaveFasciaHeightDatumSchema,
  EaveFriezeBoardMode: EaveFriezeBoardModeSchema,
  EaveType: EaveTypeSchema,
  EdgeBehavior: EdgeBehaviorSchema,
  EdgeBehaviorHandle: EdgeBehaviorHandleSchema,
  EdgeHandle: EdgeHandleSchema,
  EdgeModifier: EdgeModifierSchema,
  EdgeModifierHandle: EdgeModifierHandleSchema,
  EdgeOrientation: EdgeOrientationSchema,
  EditModeHandle: EditModeHandleSchema,
  EditorViewState: EditorViewStateSchema,
  Effect: EffectSchema,
  EffectHandle: EffectHandleSchema,
  ElectricalBoxType: ElectricalBoxTypeSchema,
  ElectricalControllerNonSwitch: ElectricalControllerNonSwitchSchema,
  ElectricalControllerSwitch: ElectricalControllerSwitchSchema,
  ElectricalDevice: ElectricalDeviceSchema,
  ElectricalDeviceHandle: ElectricalDeviceHandleSchema,
  ElectricalItemCatalogSettings: ElectricalItemCatalogSettingsSchema,
  ElectricalLayout: ElectricalLayoutSchema,
  ElectricalLayoutHandle: ElectricalLayoutHandleSchema,
  ElectricalLoad: ElectricalLoadSchema,
  ElectricalRule: ElectricalRuleSchema,
  ElectricalRuleHandle: ElectricalRuleHandleSchema,
  ElectricalSettings: ElectricalSettingsSchema,
  ElectricalSlots: ElectricalSlotsSchema,
  Elevation: ElevationSchema,
  ElevationHandle: ElevationHandleSchema,
  ElevationImages: ElevationImagesSchema,
  ElevationNoteEdgeBehavior: ElevationNoteEdgeBehaviorSchema,
  ElevationNotePlacementType: ElevationNotePlacementTypeSchema,
  ElevationOptionSet: ElevationOptionSetSchema,
  ElevationReferenceFrame: ElevationReferenceFrameSchema,
  ElevationView: ElevationViewSchema,
  ElevationViewHandle: ElevationViewHandleSchema,
  ElevationViewParameter: ElevationViewParameterSchema,
  ElevationViewport: ElevationViewportSchema,
  ElevationViewTemplate: ElevationViewTemplateSchema,
  ElevationViewValue: ElevationViewValueSchema,
  EnableOptionEffect: EnableOptionEffectSchema,
  EntityHostedAnnotationPoint: EntityHostedAnnotationPointSchema,
  EntityInstanceType: EntityInstanceTypeSchema,
  EntityRef: EntityRefSchema,
  EntitySettings: EntitySettingsSchema,
  EntitySettingsHandle: EntitySettingsHandleSchema,
  EntityTypesEligibleForEntitySettings: EntityTypesEligibleForEntitySettingsSchema,
  ExplicitIndexLoadConnection: ExplicitIndexLoadConnectionSchema,
  ExteriorDimensionType: ExteriorDimensionTypeSchema,
  ExteriorDoorCasingSettings: ExteriorDoorCasingSettingsSchema,
  ExteriorDoorCasingViewNotesSettings: ExteriorDoorCasingViewNotesSettingsSchema,
  ExteriorFloorMaterialOverride: ExteriorFloorMaterialOverrideSchema,
  ExteriorMaterial: ExteriorMaterialSchema,
  ExteriorMaterialSettings: ExteriorMaterialSettingsSchema,
  ExteriorPalette: ExteriorPaletteSchema,
  ExteriorPropSettings: ExteriorPropSettingsSchema,
  ExteriorTrimSettings: ExteriorTrimSettingsSchema,
  ExteriorWallOffsetMode: ExteriorWallOffsetModeSchema,
  ExteriorWindowCasingSettings: ExteriorWindowCasingSettingsSchema,
  ExteriorWindowCasingViewNotesSettings: ExteriorWindowCasingViewNotesSettingsSchema,
  Facade: FacadeSchema,
  FacadeHandle: FacadeHandleSchema,
  FacadeSpanStratum: FacadeSpanStratumSchema,
  FacadeSpanStratumHandle: FacadeSpanStratumHandleSchema,
  FacadeSweepStratum: FacadeSweepStratumSchema,
  FacadeSweepStratumHandle: FacadeSweepStratumHandleSchema,
  FacadeWallSweep: FacadeWallSweepSchema,
  FbxAsset: FbxAssetSchema,
  FeetCubed: FeetCubedSchema,
  FeetSquared: FeetSquaredSchema,
  FillerPanelDescriptor: FillerPanelDescriptorSchema,
  FilterEntitySourceId: FilterEntitySourceIdSchema,
  FinishClipping: FinishClippingSchema,
  FixedWidthCurbEntity: FixedWidthCurbEntitySchema,
  Flat: FlatSchema,
  FloorAssemblyDynamicFinishLayerOperator: FloorAssemblyDynamicFinishLayerOperatorSchema,
  FloorAssemblyExteriorFinishLayerOperator: FloorAssemblyExteriorFinishLayerOperatorSchema,
  FloorAssemblyFinishLayerOverride: FloorAssemblyFinishLayerOverrideSchema,
  FloorAssemblyInteriorFinishLayerOperator: FloorAssemblyInteriorFinishLayerOperatorSchema,
  FloorAssemblyOperationType: FloorAssemblyOperationTypeSchema,
  FloorAssemblyOverride: FloorAssemblyOverrideSchema,
  FloorAssemblyOverrideBase: FloorAssemblyOverrideBaseSchema,
  FloorBay: FloorBaySchema,
  FloorBayEdgeHandle: FloorBayEdgeHandleSchema,
  FloorBayHandle: FloorBayHandleSchema,
  FloorEdgeOverride: FloorEdgeOverrideSchema,
  FloorFinishHandle: FloorFinishHandleSchema,
  FloorHandle: FloorHandleSchema,
  FloorPerimeterOpeningHandle: FloorPerimeterOpeningHandleSchema,
  FloorSettings: FloorSettingsSchema,
  FloorSplitData: FloorSplitDataSchema,
  FloorSplitLineEdgeHandle: FloorSplitLineEdgeHandleSchema,
  FloorSplitLineHandle: FloorSplitLineHandleSchema,
  FloorSystemExternal: FloorSystemExternalSchema,
  FloorSystemHandle: FloorSystemHandleSchema,
  FloorSystemOpeningFramingConfig: FloorSystemOpeningFramingConfigSchema,
  FontId: FontIdSchema,
  FootInchParameter: FootInchParameterSchema,
  ForeignKeyPathOf: ForeignKeyPathOfSchema,
  Formula: FormulaSchema,
  FormulaDisabled: FormulaDisabledSchema,
  FormulaDisabledField: FormulaDisabledFieldSchema,
  Foundation: FoundationSchema,
  FoundationAssemblyEdgeBehavior: FoundationAssemblyEdgeBehaviorSchema,
  FoundationAssemblyEntity: FoundationAssemblyEntitySchema,
  FoundationAssemblyEntityDatums: FoundationAssemblyEntityDatumsSchema,
  FoundationAssemblyHandle: FoundationAssemblyHandleSchema,
  FoundationAssemblySelection: FoundationAssemblySelectionSchema,
  FoundationComponentEntity: FoundationComponentEntitySchema,
  FoundationComponentEntityHandle: FoundationComponentEntityHandleSchema,
  FoundationDatumVerticalAnchor: FoundationDatumVerticalAnchorSchema,
  FoundationHandle: FoundationHandleSchema,
  FoundationOverride: FoundationOverrideSchema,
  FoundationPattern: FoundationPatternSchema,
  FoundationPatternEdgeBehavior: FoundationPatternEdgeBehaviorSchema,
  FoundationSettings: FoundationSettingsSchema,
  FoundationSubSystemType: FoundationSubSystemTypeSchema,
  FoundationSystem: FoundationSystemSchema,
  FoundationSystemHandle: FoundationSystemHandleSchema,
  FourLightsWithOptionalFan: FourLightsWithOptionalFanSchema,
  FrameFloorAssemblyEntity: FrameFloorAssemblyEntitySchema,
  FrameFloorAssemblyHandle: FrameFloorAssemblyHandleSchema,
  FramingComponentEntity: FramingComponentEntitySchema,
  FramingComponentHandle: FramingComponentHandleSchema,
  FramingConfig: FramingConfigSchema,
  FreeformWallEdgeHandle: FreeformWallEdgeHandleSchema,
  FreeformWallEntity: FreeformWallEntitySchema,
  FreeformWallHandle: FreeformWallHandleSchema,
  FriezeBoard: FriezeBoardSchema,
  FullMaterialSlot: FullMaterialSlotSchema,
  GableLabel: GableLabelSchema,
  GableRoofType: GableRoofTypeSchema,
  GarageHandingDirection: GarageHandingDirectionSchema,
  GarageLights: GarageLightsSchema,
  GarageSettings: GarageSettingsSchema,
  GeneratedEntityHandle: GeneratedEntityHandleSchema,
  GeneratedPageViewHandle: GeneratedPageViewHandleSchema,
  GenerateSettings: GenerateSettingsSchema,
  GenericDrawingTemplate: GenericDrawingTemplateSchema,
  GenericShutterSettings: GenericShutterSettingsSchema,
  GenericStair: GenericStairSchema,
  GlazingColor: GlazingColorSchema,
  GlazingType: GlazingTypeSchema,
  GlobalParameter: GlobalParameterSchema,
  GlobalParameterHandle: GlobalParameterHandleSchema,
  GradeLineSource: GradeLineSourceSchema,
  GridWindowMullionSettings: GridWindowMullionSettingsSchema,
  Group: GroupSchema,
  GroupHandle: GroupHandleSchema,
  HatchDesignMaterial: HatchDesignMaterialSchema,
  HatchMaterial: HatchMaterialSchema,
  HatchMaterialId: HatchMaterialIdSchema,
  HatchPatternLine: HatchPatternLineSchema,
  HatchPatternMaterial: HatchPatternMaterialSchema,
  HatchProceduralMaterial: HatchProceduralMaterialSchema,
  HeadCasingArchedSlice: HeadCasingArchedSliceSchema,
  HeadCasingArchedSlices: HeadCasingArchedSlicesSchema,
  HeadCasingEyebrowTrim: HeadCasingEyebrowTrimSchema,
  HeadCasingFullArch: HeadCasingFullArchSchema,
  HeadCasingJackArch: HeadCasingJackArchSchema,
  HeadCasingNone: HeadCasingNoneSchema,
  HeadCasingSlice: HeadCasingSliceSchema,
  HeadCasingSlices: HeadCasingSlicesSchema,
  HeadCasingStone: HeadCasingStoneSchema,
  HeadCasingTrim: HeadCasingTrimSchema,
  HeaderAssemblyEntity: HeaderAssemblyEntitySchema,
  HeaderAssemblyHandle: HeaderAssemblyHandleSchema,
  HeaderFramingRule: HeaderFramingRuleSchema,
  HeaderFramingSettings: HeaderFramingSettingsSchema,
  HeightType: HeightTypeSchema,
  HidableEntityHandle: HidableEntityHandleSchema,
  HipFramingMethod: HipFramingMethodSchema,
  HomeAttributes: HomeAttributesSchema,
  HorizontalAlignment: HorizontalAlignmentSchema,
  HorizontalEdgeParamNoExpr: HorizontalEdgeParamNoExprSchema,
  HorizontalFloorAssemblyFreeForm: HorizontalFloorAssemblyFreeFormSchema,
  HorizontalFloorAssemblyLegacy: HorizontalFloorAssemblyLegacySchema,
  HorizontalFloorAssemblyRoomDerived: HorizontalFloorAssemblyRoomDerivedSchema,
  HorizontalFloorAssemblyType: HorizontalFloorAssemblyTypeSchema,
  HorizontalJustification: HorizontalJustificationSchema,
  IJoistComponent: IJoistComponentSchema,
  IJoistProfileType: IJoistProfileTypeSchema,
  ImageAsset: ImageAssetSchema,
  ImageAssetLegacy: ImageAssetLegacySchema,
  ImportArrangement: ImportArrangementSchema,
  ImportHalfEdge: ImportHalfEdgeSchema,
  ImportVertex: ImportVertexSchema,
  InchesCubed: InchesCubedSchema,
  InchesSquared: InchesSquaredSchema,
  IndeterminateHandle: IndeterminateHandleSchema,
  InlineImageAsset: InlineImageAssetSchema,
  InlineImageUnderlay: InlineImageUnderlaySchema,
  InPlaceElectricalLayout: InPlaceElectricalLayoutSchema,
  InstanceOptionSet: InstanceOptionSetSchema,
  InstanceOptionSetHandle: InstanceOptionSetHandleSchema,
  InteriorBaseBoardTrimSettings: InteriorBaseBoardTrimSettingsSchema,
  InteriorCrownMoldingTrimSettings: InteriorCrownMoldingTrimSettingsSchema,
  InteriorDimensionType: InteriorDimensionTypeSchema,
  InteriorDoorCasingSettings: InteriorDoorCasingSettingsSchema,
  InteriorDoorHeadTrimSettings: InteriorDoorHeadTrimSettingsSchema,
  InteriorDoorSideTrimSettings: InteriorDoorSideTrimSettingsSchema,
  InteriorFloorMaterialOverride: InteriorFloorMaterialOverrideSchema,
  InteriorMaterialSettings: InteriorMaterialSettingsSchema,
  InteriorPalette: InteriorPaletteSchema,
  InteriorPropSettings: InteriorPropSettingsSchema,
  InteriorTrimSettings: InteriorTrimSettingsSchema,
  InteriorWindowCasingSettings: InteriorWindowCasingSettingsSchema,
  InteriorWindowGeneralCasingSettings: InteriorWindowGeneralCasingSettingsSchema,
  IntersectingOptionSet: IntersectingOptionSetSchema,
  IntersectionConditions: IntersectionConditionsSchema,
  IntersectionEffect: IntersectionEffectSchema,
  IntersectionScope: IntersectionScopeSchema,
  KeyMeasuresSettings: KeyMeasuresSettingsSchema,
  Label: LabelSchema,
  LabelEdgeBehavior: LabelEdgeBehaviorSchema,
  LabelHandle: LabelHandleSchema,
  LandscapeSiteShape: LandscapeSiteShapeSchema,
  LandscapeType: LandscapeTypeSchema,
  LateralAlignment: LateralAlignmentSchema,
  LateralDatumJustification: LateralDatumJustificationSchema,
  LegacyFoundationLateralDatumEntity: LegacyFoundationLateralDatumEntitySchema,
  LegacyFoundationVerticalDatumEntity: LegacyFoundationVerticalDatumEntitySchema,
  LegacyLevelDatumEntity: LegacyLevelDatumEntitySchema,
  LegacyOffsetFromPropBack: LegacyOffsetFromPropBackSchema,
  LegacyWallHorizontalDatumEntity: LegacyWallHorizontalDatumEntitySchema,
  LegacyWallPlaneHorizontalDatumEntity: LegacyWallPlaneHorizontalDatumEntitySchema,
  LegacyWallVerticalDatumEntity: LegacyWallVerticalDatumEntitySchema,
  LevelDatumAnchor: LevelDatumAnchorSchema,
  LevelDef: LevelDefSchema,
  LevelHandle: LevelHandleSchema,
  LevelInches: LevelInchesSchema,
  LevelParameter: LevelParameterSchema,
  LevelPlacement: LevelPlacementSchema,
  LevelPlanView: LevelPlanViewSchema,
  LevelRoomEdge: LevelRoomEdgeSchema,
  LevelValue: LevelValueSchema,
  LineAnchor: LineAnchorSchema,
  LinearArray: LinearArraySchema,
  LinearDimension: LinearDimensionSchema,
  LineStyle: LineStyleSchema,
  Linework: LineworkSchema,
  LoadConnection: LoadConnectionSchema,
  LoadDescriptor: LoadDescriptorSchema,
  LoadSymbol: LoadSymbolSchema,
  LoadType: LoadTypeSchema,
  LoadTypeSlot: LoadTypeSlotSchema,
  LoadTypeSlots: LoadTypeSlotsSchema,
  LocalParameter: LocalParameterSchema,
  LocalParameterHandle: LocalParameterHandleSchema,
  LockableEntityHandle: LockableEntityHandleSchema,
  LockOptionEffect: LockOptionEffectSchema,
  LumberProfileType: LumberProfileTypeSchema,
  ManualCodeFormatting: ManualCodeFormattingSchema,
  MasonryComponentEntity: MasonryComponentEntitySchema,
  MasonryComponentHandle: MasonryComponentHandleSchema,
  MasterPlanSettings: MasterPlanSettingsSchema,
  Mat3: Mat3Schema,
  MaterialSrc: MaterialSrcSchema,
  MaxDistanceColumnPlacementV1: MaxDistanceColumnPlacementV1Schema,
  MaxDistanceColumnPlacementV2: MaxDistanceColumnPlacementV2Schema,
  MaxDistancePostPlacement: MaxDistancePostPlacementSchema,
  MeasurementHandle: MeasurementHandleSchema,
  Modifier: ModifierSchema,
  ModifierHandle: ModifierHandleSchema,
  ModifySettings: ModifySettingsSchema,
  MonolithicStair: MonolithicStairSchema,
  NearestArrayTerminusLoadConnection: NearestArrayTerminusLoadConnectionSchema,
  NearestLoadConnection: NearestLoadConnectionSchema,
  NominalNumber: NominalNumberSchema,
  None: NoneSchema,
  Note: NoteSchema,
  NullAtom: NullAtomSchema,
  NumberAtom: NumberAtomSchema,
  NumberParameter: NumberParameterSchema,
  OneHundredthMillimeters: OneHundredthMillimetersSchema,
  Opening: OpeningSchema,
  OpeningHandle: OpeningHandleSchema,
  OpeningHorizontalAlignment: OpeningHorizontalAlignmentSchema,
  OpeningWrappingMode: OpeningWrappingModeSchema,
  OptionalBoolean: OptionalBooleanSchema,
  OptionChoiceParameter: OptionChoiceParameterSchema,
  OptionChoices: OptionChoicesSchema,
  OptionCodeFormatting: OptionCodeFormattingSchema,
  OptionEffectHandle: OptionEffectHandleSchema,
  OptionHandle: OptionHandleSchema,
  OptionLockHandle: OptionLockHandleSchema,
  OptionPresetBase: OptionPresetBaseSchema,
  OptionPresetParameter: OptionPresetParameterSchema,
  OptionPresetValue: OptionPresetValueSchema,
  OptionRuleHandle: OptionRuleHandleSchema,
  OptionSetForeignKeyString: OptionSetForeignKeyStringSchema,
  OptionSetHandle: OptionSetHandleSchema,
  OptionSetMasterPlanSetBehavior: OptionSetMasterPlanSetBehaviorSchema,
  OptionSetOverridesHandle: OptionSetOverridesHandleSchema,
  OptionTemplateHandle: OptionTemplateHandleSchema,
  OptionValue: OptionValueSchema,
  Osb: OsbSchema,
  OSBProfile: OSBProfileSchema,
  Other: OtherSchema,
  OtherMasonryComponent: OtherMasonryComponentSchema,
  Palette: PaletteSchema,
  PaletteHandle: PaletteHandleSchema,
  PaletteMaterialSlot: PaletteMaterialSlotSchema,
  PaletteType: PaletteTypeSchema,
  PanelShutterSettings: PanelShutterSettingsSchema,
  PaperSize: PaperSizeSchema,
  ParamColumnPlacementV1: ParamColumnPlacementV1Schema,
  ParamColumnPlacementV2: ParamColumnPlacementV2Schema,
  ParameterForeignKeyString: ParameterForeignKeyStringSchema,
  ParameterFormula: ParameterFormulaSchema,
  ParameterFormulaDisabledField: ParameterFormulaDisabledFieldSchema,
  ParameterRef: ParameterRefSchema,
  ParameterRefNumberField: ParameterRefNumberFieldSchema,
  ParameterRefStringField: ParameterRefStringFieldSchema,
  ParameterValue: ParameterValueSchema,
  ParameterValueHandle: ParameterValueHandleSchema,
  ParamPostPlacement: ParamPostPlacementSchema,
  PathEndStyle: PathEndStyleSchema,
  Percent: PercentSchema,
  PerspectiveViewport: PerspectiveViewportSchema,
  PerspectiveViewTemplate: PerspectiveViewTemplateSchema,
  PierPosition: PierPositionSchema,
  PixelsPerInch: PixelsPerInchSchema,
  PlacementPoint: PlacementPointSchema,
  PlacementStyleVersion: PlacementStyleVersionSchema,
  PlacementXAnchor: PlacementXAnchorSchema,
  PlacementYAnchor: PlacementYAnchorSchema,
  PlanAreaMeasurement: PlanAreaMeasurementSchema,
  PlanAreaMeasurementShape: PlanAreaMeasurementShapeSchema,
  PlanLineStyle: PlanLineStyleSchema,
  PlanNoteOrientation: PlanNoteOrientationSchema,
  PlanOrientation: PlanOrientationSchema,
  PlanSeries: PlanSeriesSchema,
  PlanSetTemplate: PlanSetTemplateSchema,
  PlanSetTemplateConfig: PlanSetTemplateConfigSchema,
  PlanSetTemplateConfigHandle: PlanSetTemplateConfigHandleSchema,
  PlanSetTemplateHandle: PlanSetTemplateHandleSchema,
  PlanSettings: PlanSettingsSchema,
  PlanView: PlanViewSchema,
  PlanViewCompositeLevelMember: PlanViewCompositeLevelMemberSchema,
  PlanViewHandle: PlanViewHandleSchema,
  PlanViewLevelMember: PlanViewLevelMemberSchema,
  PlanViewport: PlanViewportSchema,
  PlanViewTemplate: PlanViewTemplateSchema,
  Plywood: PlywoodSchema,
  PlywoodProfile: PlywoodProfileSchema,
  PolygonWindowMode: PolygonWindowModeSchema,
  PorchColumnEdgeBehavior: PorchColumnEdgeBehaviorSchema,
  PorchColumnPattern: PorchColumnPatternSchema,
  PorchHeaderTrimAlignment: PorchHeaderTrimAlignmentSchema,
  PorchPlanSettings: PorchPlanSettingsSchema,
  PorchSettings: PorchSettingsSchema,
  PositioningMethod: PositioningMethodSchema,
  PostDefault: PostDefaultSchema,
  PostPlacement: PostPlacementSchema,
  PredicateOp: PredicateOpSchema,
  Preset: PresetSchema,
  PresetHandle: PresetHandleSchema,
  PresetType: PresetTypeSchema,
  PrimitiveValue: PrimitiveValueSchema,
  ProfileCatalogSettings: ProfileCatalogSettingsSchema,
  ProfileEntity: ProfileEntitySchema,
  ProfileExtrusionDescriptor: ProfileExtrusionDescriptorSchema,
  ProfileHandle: ProfileHandleSchema,
  ProfileId: ProfileIdSchema,
  PropAttributes: PropAttributesSchema,
  PropAttributesCustom: PropAttributesCustomSchema,
  PropAttributesHandle: PropAttributesHandleSchema,
  PropBoundOrientation: PropBoundOrientationSchema,
  PropCatalogType: PropCatalogTypeSchema,
  PropCategory: PropCategorySchema,
  PropInstance: PropInstanceSchema,
  PropInstanceHandle: PropInstanceHandleSchema,
  PropInstanceHorizontalAlignment: PropInstanceHorizontalAlignmentSchema,
  PropInstanceLateralAlignment: PropInstanceLateralAlignmentSchema,
  PropInstanceV1: PropInstanceV1Schema,
  PropInstanceV2: PropInstanceV2Schema,
  PropInstanceVerticalAlignment: PropInstanceVerticalAlignmentSchema,
  PropInstanceVerticalDatumAnchor: PropInstanceVerticalDatumAnchorSchema,
  PropThumbnails: PropThumbnailsSchema,
  QRCode: QRCodeSchema,
  QueryPoint: QueryPointSchema,
  QueryPointUnion: QueryPointUnionSchema,
  RailDefault: RailDefaultSchema,
  Railing: RailingSchema,
  RailingCatalogSettings: RailingCatalogSettingsSchema,
  RailingDefaultSetting: RailingDefaultSettingSchema,
  RailingHandle: RailingHandleSchema,
  RailingInfillStyle: RailingInfillStyleSchema,
  RailingPostHandle: RailingPostHandleSchema,
  RailingSettingHandle: RailingSettingHandleSchema,
  RakeFriezeBoardMode: RakeFriezeBoardModeSchema,
  RangeFilter: RangeFilterSchema,
  RearPorchSettings: RearPorchSettingsSchema,
  RectangularArray: RectangularArraySchema,
  RectangularCIPPierEntity: RectangularCIPPierEntitySchema,
  RectangularCMUPierEntity: RectangularCMUPierEntitySchema,
  RectangularIsolatedFootingEntity: RectangularIsolatedFootingEntitySchema,
  ReferenceGeom: ReferenceGeomSchema,
  ReferenceGeomHandle: ReferenceGeomHandleSchema,
  RelaxationObstacleEffect: RelaxationObstacleEffectSchema,
  ReportableUnitDesignation: ReportableUnitDesignationSchema,
  ReportableUnitDesignationHandle: ReportableUnitDesignationHandleSchema,
  RetainingWallSiteShape: RetainingWallSiteShapeSchema,
  RoadSiteShape: RoadSiteShapeSchema,
  Roof: RoofSchema,
  RoofBlockInstanceRef: RoofBlockInstanceRefSchema,
  RoofBlocks: RoofBlocksSchema,
  RoofBoundaryType: RoofBoundaryTypeSchema,
  RoofDormerPlacement: RoofDormerPlacementSchema,
  RoofElevationPlanSettings: RoofElevationPlanSettingsSchema,
  RoofFaces: RoofFacesSchema,
  RoofFramingSettings: RoofFramingSettingsSchema,
  RoofFramingSpacingMethod: RoofFramingSpacingMethodSchema,
  RoofFramingType: RoofFramingTypeSchema,
  RoofHandle: RoofHandleSchema,
  RoofOpeningHandle: RoofOpeningHandleSchema,
  RoofOpeningJustification: RoofOpeningJustificationSchema,
  RoofOpeningPlacement: RoofOpeningPlacementSchema,
  RoofPeakDirection: RoofPeakDirectionSchema,
  RoofPlanSettings: RoofPlanSettingsSchema,
  RoofSettings: RoofSettingsSchema,
  RoofSide: RoofSideSchema,
  RoofSideHandle: RoofSideHandleSchema,
  RoofSlopeOptions: RoofSlopeOptionsSchema,
  RoofStructureType: RoofStructureTypeSchema,
  RoofSystem: RoofSystemSchema,
  RoofSystemHandle: RoofSystemHandleSchema,
  RoofSystemLevelUsage: RoofSystemLevelUsageSchema,
  RoofTruncationType: RoofTruncationTypeSchema,
  RoofTrussType: RoofTrussTypeSchema,
  RoofVolume: RoofVolumeSchema,
  RoofVolumeHandle: RoofVolumeHandleSchema,
  RoofWallFramingType: RoofWallFramingTypeSchema,
  RoofWallMode: RoofWallModeSchema,
  RoofWeldMode: RoofWeldModeSchema,
  RoomBoundaryType: RoomBoundaryTypeSchema,
  RoomCaseworkPosition: RoomCaseworkPositionSchema,
  RoomClass: RoomClassSchema,
  RoomEdge: RoomEdgeSchema,
  RoomEdgeHandle: RoomEdgeHandleSchema,
  RoomEnclosure: RoomEnclosureSchema,
  RoomHandle: RoomHandleSchema,
  RoomIsolatedFoundationPattern: RoomIsolatedFoundationPatternSchema,
  RoomLabelDimensionType: RoomLabelDimensionTypeSchema,
  RoomLabelRounding: RoomLabelRoundingSchema,
  RoomLabelUnits: RoomLabelUnitsSchema,
  RoomLayout: RoomLayoutSchema,
  RoomLayoutHandle: RoomLayoutHandleSchema,
  RoomLayoutInstance: RoomLayoutInstanceSchema,
  RoomLayoutInstanceHandle: RoomLayoutInstanceHandleSchema,
  RoomMaterials: RoomMaterialsSchema,
  RoomPosition: RoomPositionSchema,
  RoomPropPosition: RoomPropPositionSchema,
  RoomRefGeomPosition: RoomRefGeomPositionSchema,
  RoomSetMaterials: RoomSetMaterialsSchema,
  RoomTagCapitalization: RoomTagCapitalizationSchema,
  RoomTagDimensionControl: RoomTagDimensionControlSchema,
  RoomType: RoomTypeSchema,
  RoomTypeFilter: RoomTypeFilterSchema,
  RoomTypeSet: RoomTypeSetSchema,
  RoomTypeSpaceTypeFilter: RoomTypeSpaceTypeFilterSchema,
  RoomWallPosition: RoomWallPositionSchema,
  RoughOpeningHeadSettings: RoughOpeningHeadSettingsSchema,
  RoughOpeningJambSettings: RoughOpeningJambSettingsSchema,
  RoughOpeningSillSettings: RoughOpeningSillSettingsSchema,
  RuleBasedSelector: RuleBasedSelectorSchema,
  RuleBasedSelectorHandle: RuleBasedSelectorHandleSchema,
  RuleBasedSelectorInstance: RuleBasedSelectorInstanceSchema,
  RuleBasedSelectorInstanceHandle: RuleBasedSelectorInstanceHandleSchema,
  SalesImage: SalesImageSchema,
  ScalingEffect: ScalingEffectSchema,
  ScheduleSettings: ScheduleSettingsSchema,
  SectionView: SectionViewSchema,
  SectionViewHandle: SectionViewHandleSchema,
  SectionViewParameter: SectionViewParameterSchema,
  SectionViewport: SectionViewportSchema,
  SectionViewTemplate: SectionViewTemplateSchema,
  SectionViewValue: SectionViewValueSchema,
  SelectionMethod: SelectionMethodSchema,
  SelectorHandle: SelectorHandleSchema,
  SetPriceOptionEffect: SetPriceOptionEffectSchema,
  SettingsCriterion: SettingsCriterionSchema,
  SettingsFragment: SettingsFragmentSchema,
  SettingsHandle: SettingsHandleSchema,
  SettingsSet: SettingsSetSchema,
  SettingsSetBehaviorType: SettingsSetBehaviorTypeSchema,
  SettingsSetHandle: SettingsSetHandleSchema,
  SettingsType: SettingsTypeSchema,
  ShapeBasedEntityHandle: ShapeBasedEntityHandleSchema,
  ShapeHandle: ShapeHandleSchema,
  SheathingComponentEntity: SheathingComponentEntitySchema,
  SheathingComponentHandle: SheathingComponentHandleSchema,
  ShedAwningSettings: ShedAwningSettingsSchema,
  Sheet: SheetSchema,
  SheetCustomScales: SheetCustomScalesSchema,
  SheetGeometryCategory: SheetGeometryCategorySchema,
  SheetHandle: SheetHandleSchema,
  SheetInches: SheetInchesSchema,
  SheetPixels: SheetPixelsSchema,
  SheetPoints: SheetPointsSchema,
  SheetTemplate: SheetTemplateSchema,
  SheetTemplateInstance: SheetTemplateInstanceSchema,
  ShutterConfigurationType: ShutterConfigurationTypeSchema,
  ShutterShapeType: ShutterShapeTypeSchema,
  ShutterStreetOrientationPreference: ShutterStreetOrientationPreferenceSchema,
  ShutterVerticalAlignment: ShutterVerticalAlignmentSchema,
  SideCasingSettings: SideCasingSettingsSchema,
  SideCasingType: SideCasingTypeSchema,
  SidewalkSiteShape: SidewalkSiteShapeSchema,
  Sign: SignSchema,
  SimpleSlatShutterSettings: SimpleSlatShutterSettingsSchema,
  SingleLight: SingleLightSchema,
  Site: SiteSchema,
  SiteFillSiteShape: SiteFillSiteShapeSchema,
  SiteFittingMode: SiteFittingModeSchema,
  SiteHandle: SiteHandleSchema,
  SiteOverrideSiteShape: SiteOverrideSiteShapeSchema,
  SiteResolutionLevel: SiteResolutionLevelSchema,
  SiteShape: SiteShapeSchema,
  SiteShapeHandle: SiteShapeHandleSchema,
  SiteSubtractSiteShape: SiteSubtractSiteShapeSchema,
  SkylightHandle: SkylightHandleSchema,
  SkylightPlacement: SkylightPlacementSchema,
  SlabComponentEntity: SlabComponentEntitySchema,
  SlabComponentHandle: SlabComponentHandleSchema,
  SlabFloorAssemblyEntity: SlabFloorAssemblyEntitySchema,
  SlabFloorAssemblyHandle: SlabFloorAssemblyHandleSchema,
  Slope: SlopeSchema,
  SnapEntity: SnapEntitySchema,
  SnapKind: SnapKindSchema,
  SolidFramingFloorAssembly: SolidFramingFloorAssemblySchema,
  SolidOpeningPlacement: SolidOpeningPlacementSchema,
  SolidSlabFloorAssembly: SolidSlabFloorAssemblySchema,
  SpaceType: SpaceTypeSchema,
  SpaceTypeFilter: SpaceTypeFilterSchema,
  SpacingType: SpacingTypeSchema,
  SpanDirection: SpanDirectionSchema,
  SpanRating: SpanRatingSchema,
  SplitLine: SplitLineSchema,
  StackedLevelDatumEntity: StackedLevelDatumEntitySchema,
  StackedLevelPlacement: StackedLevelPlacementSchema,
  StairBlock: StairBlockSchema,
  StairBlockDatumHosting: StairBlockDatumHostingSchema,
  StairBlockEdgeHosting: StairBlockEdgeHostingSchema,
  StairBlockHandle: StairBlockHandleSchema,
  StairBlockHosting: StairBlockHostingSchema,
  StairBlockLanding: StairBlockLandingSchema,
  StairBlockRun: StairBlockRunSchema,
  StairBlockType: StairBlockTypeSchema,
  StairBottomShape: StairBottomShapeSchema,
  StairCatalogSettings: StairCatalogSettingsSchema,
  StairConfig: StairConfigSchema,
  StairConstruction: StairConstructionSchema,
  StairIsolatedFoundationPattern: StairIsolatedFoundationPatternSchema,
  StairSetting: StairSettingSchema,
  StairSettingHandle: StairSettingHandleSchema,
  StairSystem: StairSystemSchema,
  StairSystemHandle: StairSystemHandleSchema,
  StairVerticalAlignment: StairVerticalAlignmentSchema,
  StandardOutlet: StandardOutletSchema,
  StaticRoom: StaticRoomSchema,
  StaticRoomAttributes: StaticRoomAttributesSchema,
  StoolCasingSettings: StoolCasingSettingsSchema,
  StoolCasingType: StoolCasingTypeSchema,
  StreetOrientationMode: StreetOrientationModeSchema,
  StringAtom: StringAtomSchema,
  Stringer: StringerSchema,
  StringerLayout: StringerLayoutSchema,
  StringerPositioning: StringerPositioningSchema,
  StripFootingEntity: StripFootingEntitySchema,
  StructuralFloorType: StructuralFloorTypeSchema,
  StructuralMaterial: StructuralMaterialSchema,
  StructuralWoodPostDescriptor: StructuralWoodPostDescriptorSchema,
  StructureSettings: StructureSettingsSchema,
  StylingEffect: StylingEffectSchema,
  SwingSide: SwingSideSchema,
  SystemDataSequence: SystemDataSequenceSchema,
  SystemOptionSet: SystemOptionSetSchema,
  SystemParameter: SystemParameterSchema,
  SystemParameterHandle: SystemParameterHandleSchema,
  TagTemplate: TagTemplateSchema,
  TallCabinetDescriptor: TallCabinetDescriptorSchema,
  TextAlignment: TextAlignmentSchema,
  TextBackground: TextBackgroundSchema,
  TextParameter: TextParameterSchema,
  TextStyle: TextStyleSchema,
  TextVerticalAlignment: TextVerticalAlignmentSchema,
  TrayFreeform: TrayFreeformSchema,
  TraySimpleOffset: TraySimpleOffsetSchema,
  TreadJustification: TreadJustificationSchema,
  TrimEdgeBehavior: TrimEdgeBehaviorSchema,
  TrimJustification: TrimJustificationSchema,
  TruncationSlopeType: TruncationSlopeTypeSchema,
  TrussComponent: TrussComponentSchema,
  TurndownBrickLedgeType: TurndownBrickLedgeTypeSchema,
  TurndownFootingEntity: TurndownFootingEntitySchema,
  UndefinedAtom: UndefinedAtomSchema,
  Underlay: UnderlaySchema,
  UnderlayHandle: UnderlayHandleSchema,
  UnitParameter: UnitParameterSchema,
  UnitValue: UnitValueSchema,
  UnsignedNumber: UnsignedNumberSchema,
  UntypedNumber: UntypedNumberSchema,
  UpperCabinetDescriptor: UpperCabinetDescriptorSchema,
  UpperCabinetSubType: UpperCabinetSubTypeSchema,
  UrlParameter: UrlParameterSchema,
  UserOptionSet: UserOptionSetSchema,
  UtilityDimensionType: UtilityDimensionTypeSchema,
  UVTransformation: UVTransformationSchema,
  Vaulted: VaultedSchema,
  Vec3: Vec3Schema,
  VentedShutterSettings: VentedShutterSettingsSchema,
  VertexHandle: VertexHandleSchema,
  VerticalAlignment: VerticalAlignmentSchema,
  VerticalDatumData: VerticalDatumDataSchema,
  VerticalJustification: VerticalJustificationSchema,
  View3D: View3DSchema,
  View3DHandle: View3DHandleSchema,
  View3DParameter: View3DParameterSchema,
  ViewFilter: ViewFilterSchema,
  ViewNoteSettings: ViewNoteSettingsSchema,
  ViewOverride: ViewOverrideSchema,
  ViewOverrideHandle: ViewOverrideHandleSchema,
  Viewport: ViewportSchema,
  ViewportBase: ViewportBaseSchema,
  ViewportHandle: ViewportHandleSchema,
  ViewportHorizontalAlignment: ViewportHorizontalAlignmentSchema,
  ViewportPositioningMethod: ViewportPositioningMethodSchema,
  ViewportScalingMethod: ViewportScalingMethodSchema,
  ViewportTitleDrawingTemplate: ViewportTitleDrawingTemplateSchema,
  ViewportVerticalAlignment: ViewportVerticalAlignmentSchema,
  ViewportViewType: ViewportViewTypeSchema,
  ViewSelector: ViewSelectorSchema,
  ViewSelectorHandle: ViewSelectorHandleSchema,
  ViewStyle: ViewStyleSchema,
  ViewTemplate: ViewTemplateSchema,
  ViewTemplateHandle: ViewTemplateHandleSchema,
  ViewTemplateOverride: ViewTemplateOverrideSchema,
  ViewTemplateOverrideHandle: ViewTemplateOverrideHandleSchema,
  ViewTemplateParameter: ViewTemplateParameterSchema,
  ViewTemplateValue: ViewTemplateValueSchema,
  VirtualRoofBlock: VirtualRoofBlockSchema,
  VisibilityEffect: VisibilityEffectSchema,
  WainscotingCapType: WainscotingCapTypeSchema,
  WainscotingSettings: WainscotingSettingsSchema,
  WalkSiteShape: WalkSiteShapeSchema,
  WallAssemblyAirGapLayer: WallAssemblyAirGapLayerSchema,
  WallAssemblyEdgeBehavior: WallAssemblyEdgeBehaviorSchema,
  WallAssemblyExteriorFinishLayer: WallAssemblyExteriorFinishLayerSchema,
  WallAssemblyFinishLayer: WallAssemblyFinishLayerSchema,
  WallAssemblyFoundationCatalogLayer: WallAssemblyFoundationCatalogLayerSchema,
  WallAssemblyInteriorFinishLayer: WallAssemblyInteriorFinishLayerSchema,
  WallAssemblyLayer: WallAssemblyLayerSchema,
  WallAssemblyLayerConstructorParams: WallAssemblyLayerConstructorParamsSchema,
  WallAssemblyLayerOperatorAdd: WallAssemblyLayerOperatorAddSchema,
  WallAssemblyLayerOperatorOverride: WallAssemblyLayerOperatorOverrideSchema,
  WallAssemblyLayerOperatorRemove: WallAssemblyLayerOperatorRemoveSchema,
  WallAssemblyLayerParentHandle: WallAssemblyLayerParentHandleSchema,
  WallAssemblyMaterialCatalogLayer: WallAssemblyMaterialCatalogLayerSchema,
  WallAssemblyOffsetOperator: WallAssemblyOffsetOperatorSchema,
  WallAssemblyOperator: WallAssemblyOperatorSchema,
  WallCasework: WallCaseworkSchema,
  WallCaseworkDynamicDeprecated: WallCaseworkDynamicDeprecatedSchema,
  WallCaseworkFixed: WallCaseworkFixedSchema,
  WallCaseworkFixedDeprecated: WallCaseworkFixedDeprecatedSchema,
  WallCaseworkPlanNote: WallCaseworkPlanNoteSchema,
  WallCatalogSettings: WallCatalogSettingsSchema,
  WallConditionData: WallConditionDataSchema,
  WallFaceRuleEntity: WallFaceRuleEntitySchema,
  WallFoundationInteractionOperator: WallFoundationInteractionOperatorSchema,
  WallFramingOpeningSettings: WallFramingOpeningSettingsSchema,
  WallFramingSettings: WallFramingSettingsSchema,
  WallHorizontalDatum: WallHorizontalDatumSchema,
  WallHostedAnnotationSide: WallHostedAnnotationSideSchema,
  WallIntersectionType: WallIntersectionTypeSchema,
  WallLateralDatumAnchor: WallLateralDatumAnchorSchema,
  WallLateralDatumAnchorAll: WallLateralDatumAnchorAllSchema,
  WallOpeningWrappingSettings: WallOpeningWrappingSettingsSchema,
  WallOperatorSetTopDatum: WallOperatorSetTopDatumSchema,
  WallPlaneAnchoredRuleEntity: WallPlaneAnchoredRuleEntitySchema,
  WallPlaneAssemblyEntity: WallPlaneAssemblyEntitySchema,
  WallPlaneAssemblyHandle: WallPlaneAssemblyHandleSchema,
  WallPlaneAssemblyLayer: WallPlaneAssemblyLayerSchema,
  WallPlaneAssemblyOperation: WallPlaneAssemblyOperationSchema,
  WallPlaneCastInPlaceLayer: WallPlaneCastInPlaceLayerSchema,
  WallPlaneCutOperation: WallPlaneCutOperationSchema,
  WallPlaneFilterHandle: WallPlaneFilterHandleSchema,
  WallPlaneFramingLayer: WallPlaneFramingLayerSchema,
  WallPlaneMasonryLayer: WallPlaneMasonryLayerSchema,
  WallPlaneMaterialFinish: WallPlaneMaterialFinishSchema,
  WallPlaneOperation: WallPlaneOperationSchema,
  WallPlaneOperationBoundary: WallPlaneOperationBoundarySchema,
  WallPlaneRuleEntity: WallPlaneRuleEntitySchema,
  WallPlaneRuleHandle: WallPlaneRuleHandleSchema,
  WallPlaneSheathingLayer: WallPlaneSheathingLayerSchema,
  WallPlaneTrimEntity: WallPlaneTrimEntitySchema,
  WallPlaneTrimHandle: WallPlaneTrimHandleSchema,
  WallPlaneViewHandle: WallPlaneViewHandleSchema,
  WallRoofBaseBoardFilter: WallRoofBaseBoardFilterSchema,
  WallRoofBaseBoardMode: WallRoofBaseBoardModeSchema,
  WallSettings: WallSettingsSchema,
  WallType: WallTypeSchema,
  WallVerticalDatumAnchor: WallVerticalDatumAnchorSchema,
  WindowCatalogSettings: WindowCatalogSettingsSchema,
  WindowDescriptorCustom: WindowDescriptorCustomSchema,
  WindowGridLayout: WindowGridLayoutSchema,
  WindowGridPosition: WindowGridPositionSchema,
  WindowLateralAlignment: WindowLateralAlignmentSchema,
  WindowMaterialSettings: WindowMaterialSettingsSchema,
  WindowMullionSettings: WindowMullionSettingsSchema,
  WindowMullionType: WindowMullionTypeSchema,
  WindowOperationType: WindowOperationTypeSchema,
  WindowPanelType: WindowPanelTypeSchema,
  WindowPlacementDeprecated: WindowPlacementDeprecatedSchema,
  WindowPlacementMatchExpr: WindowPlacementMatchExprSchema,
  WindowRoughOpeningSettings: WindowRoughOpeningSettingsSchema,
  WindowSettings: WindowSettingsSchema,
  WindowShapeTypes: WindowShapeTypesSchema,
  WindowShutterSettings: WindowShutterSettingsSchema,
  WindowVertDivisions: WindowVertDivisionsSchema,
  WindowVerticalAlignment: WindowVerticalAlignmentSchema,
  WindowVerticalDatum: WindowVerticalDatumSchema,
  WindowWallFramingSettings: WindowWallFramingSettingsSchema,
  WindowWallWrappingSettings: WindowWallWrappingSettingsSchema,
  WoodSlab: WoodSlabSchema,
  WorldFeet: WorldFeetSchema,
  WorldInches: WorldInchesSchema,
  WrapFriezeBoardMode: WrapFriezeBoardModeSchema,
  YardsCubed: YardsCubedSchema,
  ZShutterSettings: ZShutterSettingsSchema,
} as const;

export interface DocSchemaNameToType {
  AABB2: AABB2;
  AABB3: AABB3;
  AbsoluteVerticalDatumEntity: AbsoluteVerticalDatumEntity;
  AggregationMethod: AggregationMethod;
  AlignmentEnum: AlignmentEnum;
  Annotation: Annotation;
  AnnotationDrawingTemplate: AnnotationDrawingTemplate;
  AnnotationFillType: AnnotationFillType;
  AnnotationHandle: AnnotationHandle;
  AnnotationHostWall: AnnotationHostWall;
  AnnotationLineType: AnnotationLineType;
  ApronCasingSettings: ApronCasingSettings;
  ApronCasingType: ApronCasingType;
  ArchitecturalColumnDescriptor: ArchitecturalColumnDescriptor;
  ArchTopBoolean: ArchTopBoolean;
  AreaReportSetting: AreaReportSetting;
  AreaReportSettings: AreaReportSettings;
  ArrayColumnPlacementV1: ArrayColumnPlacementV1;
  ArrayColumnPlacementV2: ArrayColumnPlacementV2;
  ArrayPostPlacement: ArrayPostPlacement;
  AssembledStair: AssembledStair;
  Asset: Asset;
  AssetCatalogReference: AssetCatalogReference;
  AssetHandle: AssetHandle;
  AssetReferenceUnderlay: AssetReferenceUnderlay;
  AtBackOfProp: AtBackOfProp;
  AtDoorByType: AtDoorByType;
  AutoDimensionFloorPlanExteriorByOrientationHandle: AutoDimensionFloorPlanExteriorByOrientationHandle;
  AutoDimensionFloorPlanExteriorByOrientationProvenance: AutoDimensionFloorPlanExteriorByOrientationProvenance;
  AutoDimensionFloorPlanExteriorByRoomMultipleHandle: AutoDimensionFloorPlanExteriorByRoomMultipleHandle;
  AutoDimensionFloorPlanExteriorByRoomMultipleProvenance: AutoDimensionFloorPlanExteriorByRoomMultipleProvenance;
  AutoDimensionFloorPlanExteriorByRoomSingleHandle: AutoDimensionFloorPlanExteriorByRoomSingleHandle;
  AutoDimensionFloorPlanExteriorByRoomSingleProvenance: AutoDimensionFloorPlanExteriorByRoomSingleProvenance;
  AutoDimensionFloorPlanInteriorByOrthogonalRoomEdge: AutoDimensionFloorPlanInteriorByOrthogonalRoomEdge;
  AutoDimensionFloorPlanInteriorByOrthogonalRoomEdgeHandle: AutoDimensionFloorPlanInteriorByOrthogonalRoomEdgeHandle;
  AutoDimensionFloorPlanInteriorByRoomEdgePair: AutoDimensionFloorPlanInteriorByRoomEdgePair;
  AutoDimensionFloorPlanInteriorByRoomEdgePairHandle: AutoDimensionFloorPlanInteriorByRoomEdgePairHandle;
  AutoDimensionFoundationExteriorByOrientationHandle: AutoDimensionFoundationExteriorByOrientationHandle;
  AutoDimensionFoundationExteriorByOrientationProvenance: AutoDimensionFoundationExteriorByOrientationProvenance;
  AutoDimensionFoundationExteriorByRoomMultipleHandle: AutoDimensionFoundationExteriorByRoomMultipleHandle;
  AutoDimensionFoundationExteriorByRoomMultipleProvenance: AutoDimensionFoundationExteriorByRoomMultipleProvenance;
  AutoDimensionFoundationExteriorByRoomSingleHandle: AutoDimensionFoundationExteriorByRoomSingleHandle;
  AutoDimensionFoundationExteriorByRoomSingleProvenance: AutoDimensionFoundationExteriorByRoomSingleProvenance;
  AutoDimensionFoundationInteriorByOrientationHandle: AutoDimensionFoundationInteriorByOrientationHandle;
  AutoDimensionFoundationInteriorByOrientationProvenance: AutoDimensionFoundationInteriorByOrientationProvenance;
  AutoDimensionFoundationInteriorByRoomMultipleHandle: AutoDimensionFoundationInteriorByRoomMultipleHandle;
  AutoDimensionFoundationInteriorByRoomMultipleProvenance: AutoDimensionFoundationInteriorByRoomMultipleProvenance;
  AutoDimensionFoundationInteriorByRoomSingleHandle: AutoDimensionFoundationInteriorByRoomSingleHandle;
  AutoDimensionFoundationInteriorByRoomSingleProvenance: AutoDimensionFoundationInteriorByRoomSingleProvenance;
  AutoDimensionPersistedHandle: AutoDimensionPersistedHandle;
  AutoDimensionSelector: AutoDimensionSelector;
  Awning: Awning;
  AwningSettings: AwningSettings;
  BackgroundPlanSheet: BackgroundPlanSheet;
  BackgroundType: BackgroundType;
  BackgroundVisibility: BackgroundVisibility;
  BalusterDefault: BalusterDefault;
  BaseCabinetDescriptor: BaseCabinetDescriptor;
  BaseRangeFilter: BaseRangeFilter;
  BaseRoomTypeSpaceTypeFilter: BaseRoomTypeSpaceTypeFilter;
  BaseSettings: BaseSettings;
  BayFramingEdgeOverride: BayFramingEdgeOverride;
  BlindPanelSide: BlindPanelSide;
  Block: Block;
  BlockHandle: BlockHandle;
  BoardDescriptor: BoardDescriptor;
  BoardProfileEntity: BoardProfileEntity;
  BooleanParameter: BooleanParameter;
  BrickLedgeBehavior: BrickLedgeBehavior;
  BrickLedgeType: BrickLedgeType;
  BuildingGraphPlanarTopologyHandle: BuildingGraphPlanarTopologyHandle;
  BuildingSide: BuildingSide;
  BuildingWallPlaneSubdomainHandle: BuildingWallPlaneSubdomainHandle;
  BuiltInExteriorPropId: BuiltInExteriorPropId;
  BuiltinPlanViewType: BuiltinPlanViewType;
  BuiltInSiteType: BuiltInSiteType;
  BuiltInViewSelector: BuiltInViewSelector;
  BuiltinWindowId: BuiltinWindowId;
  CabinetShape: CabinetShape;
  CabinetShapeAngled: CabinetShapeAngled;
  CabinetShapeLShaped: CabinetShapeLShaped;
  CabinetShapeNone: CabinetShapeNone;
  CameraPosition: CameraPosition;
  CandidateTypeConstraints: CandidateTypeConstraints;
  CaseworkCatalogSettings: CaseworkCatalogSettings;
  CaseworkDescriptor: CaseworkDescriptor;
  CaseworkDoorStyle: CaseworkDoorStyle;
  CaseworkHandle: CaseworkHandle;
  CaseworkHorizontalAlignment: CaseworkHorizontalAlignment;
  CaseworkLateralAlignment: CaseworkLateralAlignment;
  CaseworkLineStyle: CaseworkLineStyle;
  CaseworkSettings: CaseworkSettings;
  CaseworkVerticalAlignment: CaseworkVerticalAlignment;
  CaseworkVerticalDatumAnchor: CaseworkVerticalDatumAnchor;
  CasingFinishSettings: CasingFinishSettings;
  CasingHorizontalPlacementSettings: CasingHorizontalPlacementSettings;
  CasingLateralPlacementSettings: CasingLateralPlacementSettings;
  CasingOrientationSettings: CasingOrientationSettings;
  CatalogItemHandle: CatalogItemHandle;
  Ceiling: Ceiling;
  CeilingBoundaryType: CeilingBoundaryType;
  CeilingHandle: CeilingHandle;
  CeilingRidgeOrientation: CeilingRidgeOrientation;
  CipComponentHandle: CipComponentHandle;
  CipConcrete: CipConcrete;
  CIPStemWallEntity: CIPStemWallEntity;
  CircularCIPPierEntity: CircularCIPPierEntity;
  CircularCMUPierEntity: CircularCMUPierEntity;
  CircularIsolatedFootingEntity: CircularIsolatedFootingEntity;
  ClosetShelfDescriptor: ClosetShelfDescriptor;
  CMUBrickLedgeType: CMUBrickLedgeType;
  CMUProfile: CMUProfile;
  CMUStemWallEntity: CMUStemWallEntity;
  CodeFormatting: CodeFormatting;
  ColonnadeTerminationRule: ColonnadeTerminationRule;
  ColonnadeTerminationType: ColonnadeTerminationType;
  Column: Column;
  ColumnCatalogSettings: ColumnCatalogSettings;
  ColumnDescriptor: ColumnDescriptor;
  ColumnDimensionType: ColumnDimensionType;
  ColumnHandle: ColumnHandle;
  ColumnHorizontalAlignment: ColumnHorizontalAlignment;
  ColumnLateralAlignment: ColumnLateralAlignment;
  ColumnPlacementV1: ColumnPlacementV1;
  ColumnPlacementV2: ColumnPlacementV2;
  ColumnPosition: ColumnPosition;
  ColumnSection: ColumnSection;
  ColumnV1: ColumnV1;
  ColumnV2: ColumnV2;
  Component: Component;
  ComponentHandle: ComponentHandle;
  ComponentInstance: ComponentInstance;
  ComponentInstanceHandle: ComponentInstanceHandle;
  ComponentOptionSetAssociation: ComponentOptionSetAssociation;
  ComponentVerticalPlacement: ComponentVerticalPlacement;
  ComponentVerticalPlacementRemapping: ComponentVerticalPlacementRemapping;
  ComponentVerticalPlacementReplication: ComponentVerticalPlacementReplication;
  CompositeLevel: CompositeLevel;
  CompositeLevelHandle: CompositeLevelHandle;
  CompositeLevelMember: CompositeLevelMember;
  CompositeLevelPlanView: CompositeLevelPlanView;
  CompositeLumberComponent: CompositeLumberComponent;
  Concrete: Concrete;
  ConcreteSlab: ConcreteSlab;
  Condition: Condition;
  ConditionedAreaCalculationType: ConditionedAreaCalculationType;
  ConditionOperator: ConditionOperator;
  ConditionTypeDefId: ConditionTypeDefId;
  ConnectiveOperator: ConnectiveOperator;
  ContentReplicator: ContentReplicator;
  ContentReplicatorHandle: ContentReplicatorHandle;
  ContentTemplate: ContentTemplate;
  ContentTemplateHandle: ContentTemplateHandle;
  ContentTemplateInstance: ContentTemplateInstance;
  ContentTemplateInstanceHandle: ContentTemplateInstanceHandle;
  ContentTemplateInstanceViewHandle: ContentTemplateInstanceViewHandle;
  ContentTemplateValue: ContentTemplateValue;
  ContentTemplateViewHandle: ContentTemplateViewHandle;
  ContextHomeProp: ContextHomeProp;
  ContourSiteShape: ContourSiteShape;
  ControllerPosition: ControllerPosition;
  ControllerSelectionConfig: ControllerSelectionConfig;
  ControllerSwitchType: ControllerSwitchType;
  ControllerType: ControllerType;
  ControllerTypeSlot: ControllerTypeSlot;
  ControllerTypeSlots: ControllerTypeSlots;
  CornerBoardTrimAlignment: CornerBoardTrimAlignment;
  CornerBoardTrimHorizontalDatum: CornerBoardTrimHorizontalDatum;
  CSByControllerTag: CSByControllerTag;
  CSDoorByRoomIds: CSDoorByRoomIds;
  CSDoorByRoomType: CSDoorByRoomType;
  CSDoorByRoomTypeOutside: CSDoorByRoomTypeOutside;
  CSExplicitPoint: CSExplicitPoint;
  CSNearestCandidate: CSNearestCandidate;
  CSNearestCandidateOutside: CSNearestCandidateOutside;
  CSNearestDoorOutside: CSNearestDoorOutside;
  CSNearestExplicitWall: CSNearestExplicitWall;
  CSNone: CSNone;
  CSPrimaryEntrance: CSPrimaryEntrance;
  CSPrimaryEntranceOutside: CSPrimaryEntranceOutside;
  CustomDataSequence: CustomDataSequence;
  CustomDescriptor: CustomDescriptor;
  CustomFramingComponent: CustomFramingComponent;
  CustomPierEntity: CustomPierEntity;
  CustomProfileEntity: CustomProfileEntity;
  DataSequence: DataSequence;
  DataSequenceHandle: DataSequenceHandle;
  DataSequenceParameter: DataSequenceParameter;
  DataSequenceValue: DataSequenceValue;
  DataSequenceViewHandle: DataSequenceViewHandle;
  DataTable: DataTable;
  DataTableColumnConfig: DataTableColumnConfig;
  DataTableFindAndReplaceRow: DataTableFindAndReplaceRow;
  DataTableHandle: DataTableHandle;
  DatumEntity: DatumEntity;
  DatumHandle: DatumHandle;
  DatumLevelPlacement: DatumLevelPlacement;
  DatumScope: DatumScope;
  DatumUsageBase: DatumUsageBase;
  DeprecatedPlanDim: DeprecatedPlanDim;
  DimensionalLumberComponent: DimensionalLumberComponent;
  DimensionEdgeBehavior: DimensionEdgeBehavior;
  DimensionPrecision: DimensionPrecision;
  DimensionRowLevel: DimensionRowLevel;
  DisabledAwningSettings: DisabledAwningSettings;
  DisabledShutterSettings: DisabledShutterSettings;
  DisabledWindowMullionSettings: DisabledWindowMullionSettings;
  DivisionColumnPlacementV1: DivisionColumnPlacementV1;
  DivisionColumnPlacementV2: DivisionColumnPlacementV2;
  DivisionPostPlacement: DivisionPostPlacement;
  Doc: Doc;
  DocBuildingGraphAndFilterNode: DocBuildingGraphAndFilterNode;
  DocBuildingGraphFilterGraph: DocBuildingGraphFilterGraph;
  DocBuildingGraphFilterNode: DocBuildingGraphFilterNode;
  DocBuildingGraphNotFilterNode: DocBuildingGraphNotFilterNode;
  DocBuildingGraphOrFilterNode: DocBuildingGraphOrFilterNode;
  DocBuildingGraphPredicateFilterNode: DocBuildingGraphPredicateFilterNode;
  DocBuildingGraphPredicateLiteral: DocBuildingGraphPredicateLiteral;
  DocBuildingGraphSubfilterValueSource: DocBuildingGraphSubfilterValueSource;
  DocDatumSpanAssociation: DocDatumSpanAssociation;
  DocEntityHandle: DocEntityHandle;
  DocFacadeSpanStratumAssociation: DocFacadeSpanStratumAssociation;
  DocFacadeSweepStratumAssociation: DocFacadeSweepStratumAssociation;
  DocFaceDirection: DocFaceDirection;
  DocFaceNodeSubFilter: DocFaceNodeSubFilter;
  DocOption: DocOption;
  DocOptionEffect: DocOptionEffect;
  DocOptionLock: DocOptionLock;
  DocOptionRule: DocOptionRule;
  DocOptionSet: DocOptionSet;
  DocOptionSetOverrides: DocOptionSetOverrides;
  DocOptionTemplate: DocOptionTemplate;
  DocRef: DocRef;
  DocRefHandle: DocRefHandle;
  DocTableViewSelector: DocTableViewSelector;
  DocWallPlaneFilter: DocWallPlaneFilter;
  DoorCandidateTypeConstraints: DoorCandidateTypeConstraints;
  DoorCatalogSettings: DoorCatalogSettings;
  DoorDescriptorCustom: DoorDescriptorCustom;
  DoorOperationType: DoorOperationType;
  DoorPathColumnSpreadMode: DoorPathColumnSpreadMode;
  DoorPlacementDeprecated: DoorPlacementDeprecated;
  DoorPlacementMatchExpr: DoorPlacementMatchExpr;
  DoorPropIdPrefix: DoorPropIdPrefix;
  DoorRoughOpeningSettings: DoorRoughOpeningSettings;
  DoorSettings: DoorSettings;
  DoorWallFramingSettings: DoorWallFramingSettings;
  DoorWallWrappingSettings: DoorWallWrappingSettings;
  DormerElevationPlanSettings: DormerElevationPlanSettings;
  DormerHandle: DormerHandle;
  DormerPlanSettings: DormerPlanSettings;
  DormerRoofType: DormerRoofType;
  DormerSettings: DormerSettings;
  DormerWallBaseBoardMode: DormerWallBaseBoardMode;
  DotsPerInch: DotsPerInch;
  Drawing: Drawing;
  DrawingCatalogSettings: DrawingCatalogSettings;
  DrawingRef: DrawingRef;
  DrawingRefHandle: DrawingRefHandle;
  DrawingScale: DrawingScale;
  DrawingScaleMode: DrawingScaleMode;
  DrawingScaleParameter: DrawingScaleParameter;
  DrawingsPlanSheet: DrawingsPlanSheet;
  DrawingTemplateInstance: DrawingTemplateInstance;
  DrawingTemplateParameter: DrawingTemplateParameter;
  DrawingType: DrawingType;
  DrawingViewport: DrawingViewport;
  DrawingViewTemplate: DrawingViewTemplate;
  DrivewaySiteShape: DrivewaySiteShape;
  Drywall: Drywall;
  DxfAsset: DxfAsset;
  DXFUnit: DXFUnit;
  EaveBracketPlacement: EaveBracketPlacement;
  EaveBracketSide: EaveBracketSide;
  EaveCutType: EaveCutType;
  EaveFasciaHeightDatum: EaveFasciaHeightDatum;
  EaveFriezeBoardMode: EaveFriezeBoardMode;
  EaveType: EaveType;
  EdgeBehavior: EdgeBehavior;
  EdgeBehaviorHandle: EdgeBehaviorHandle;
  EdgeHandle: EdgeHandle;
  EdgeModifier: EdgeModifier;
  EdgeModifierHandle: EdgeModifierHandle;
  EdgeOrientation: EdgeOrientation;
  EditModeHandle: EditModeHandle;
  EditorViewState: EditorViewState;
  Effect: Effect;
  EffectHandle: EffectHandle;
  ElectricalBoxType: ElectricalBoxType;
  ElectricalControllerNonSwitch: ElectricalControllerNonSwitch;
  ElectricalControllerSwitch: ElectricalControllerSwitch;
  ElectricalDevice: ElectricalDevice;
  ElectricalDeviceHandle: ElectricalDeviceHandle;
  ElectricalItemCatalogSettings: ElectricalItemCatalogSettings;
  ElectricalLayout: ElectricalLayout;
  ElectricalLayoutHandle: ElectricalLayoutHandle;
  ElectricalLoad: ElectricalLoad;
  ElectricalRule: ElectricalRule;
  ElectricalRuleHandle: ElectricalRuleHandle;
  ElectricalSettings: ElectricalSettings;
  ElectricalSlots: ElectricalSlots;
  Elevation: Elevation;
  ElevationHandle: ElevationHandle;
  ElevationImages: ElevationImages;
  ElevationNoteEdgeBehavior: ElevationNoteEdgeBehavior;
  ElevationNotePlacementType: ElevationNotePlacementType;
  ElevationOptionSet: ElevationOptionSet;
  ElevationReferenceFrame: ElevationReferenceFrame;
  ElevationView: ElevationView;
  ElevationViewHandle: ElevationViewHandle;
  ElevationViewParameter: ElevationViewParameter;
  ElevationViewport: ElevationViewport;
  ElevationViewTemplate: ElevationViewTemplate;
  ElevationViewValue: ElevationViewValue;
  EnableOptionEffect: EnableOptionEffect;
  EntityHostedAnnotationPoint: EntityHostedAnnotationPoint;
  EntityInstanceType: EntityInstanceType;
  EntityRef: EntityRef;
  EntitySettings: EntitySettings;
  EntitySettingsHandle: EntitySettingsHandle;
  EntityTypesEligibleForEntitySettings: EntityTypesEligibleForEntitySettings;
  ExplicitIndexLoadConnection: ExplicitIndexLoadConnection;
  ExteriorDimensionType: ExteriorDimensionType;
  ExteriorDoorCasingSettings: ExteriorDoorCasingSettings;
  ExteriorDoorCasingViewNotesSettings: ExteriorDoorCasingViewNotesSettings;
  ExteriorFloorMaterialOverride: ExteriorFloorMaterialOverride;
  ExteriorMaterial: ExteriorMaterial;
  ExteriorMaterialSettings: ExteriorMaterialSettings;
  ExteriorPalette: ExteriorPalette;
  ExteriorPropSettings: ExteriorPropSettings;
  ExteriorTrimSettings: ExteriorTrimSettings;
  ExteriorWallOffsetMode: ExteriorWallOffsetMode;
  ExteriorWindowCasingSettings: ExteriorWindowCasingSettings;
  ExteriorWindowCasingViewNotesSettings: ExteriorWindowCasingViewNotesSettings;
  Facade: Facade;
  FacadeHandle: FacadeHandle;
  FacadeSpanStratum: FacadeSpanStratum;
  FacadeSpanStratumHandle: FacadeSpanStratumHandle;
  FacadeSweepStratum: FacadeSweepStratum;
  FacadeSweepStratumHandle: FacadeSweepStratumHandle;
  FacadeWallSweep: FacadeWallSweep;
  FbxAsset: FbxAsset;
  FeetCubed: FeetCubed;
  FeetSquared: FeetSquared;
  FillerPanelDescriptor: FillerPanelDescriptor;
  FilterEntitySourceId: FilterEntitySourceId;
  FinishClipping: FinishClipping;
  FixedWidthCurbEntity: FixedWidthCurbEntity;
  Flat: Flat;
  FloorAssemblyDynamicFinishLayerOperator: FloorAssemblyDynamicFinishLayerOperator;
  FloorAssemblyExteriorFinishLayerOperator: FloorAssemblyExteriorFinishLayerOperator;
  FloorAssemblyFinishLayerOverride: FloorAssemblyFinishLayerOverride;
  FloorAssemblyInteriorFinishLayerOperator: FloorAssemblyInteriorFinishLayerOperator;
  FloorAssemblyOperationType: FloorAssemblyOperationType;
  FloorAssemblyOverride: FloorAssemblyOverride;
  FloorAssemblyOverrideBase: FloorAssemblyOverrideBase;
  FloorBay: FloorBay;
  FloorBayEdgeHandle: FloorBayEdgeHandle;
  FloorBayHandle: FloorBayHandle;
  FloorEdgeOverride: FloorEdgeOverride;
  FloorFinishHandle: FloorFinishHandle;
  FloorHandle: FloorHandle;
  FloorPerimeterOpeningHandle: FloorPerimeterOpeningHandle;
  FloorSettings: FloorSettings;
  FloorSplitData: FloorSplitData;
  FloorSplitLineEdgeHandle: FloorSplitLineEdgeHandle;
  FloorSplitLineHandle: FloorSplitLineHandle;
  FloorSystemExternal: FloorSystemExternal;
  FloorSystemHandle: FloorSystemHandle;
  FloorSystemOpeningFramingConfig: FloorSystemOpeningFramingConfig;
  FontId: FontId;
  FootInchParameter: FootInchParameter;
  ForeignKeyPathOf: ForeignKeyPathOf;
  Formula: Formula;
  FormulaDisabled: FormulaDisabled;
  Foundation: Foundation;
  FoundationAssemblyEdgeBehavior: FoundationAssemblyEdgeBehavior;
  FoundationAssemblyEntity: FoundationAssemblyEntity;
  FoundationAssemblyEntityDatums: FoundationAssemblyEntityDatums;
  FoundationAssemblyHandle: FoundationAssemblyHandle;
  FoundationAssemblySelection: FoundationAssemblySelection;
  FoundationComponentEntity: FoundationComponentEntity;
  FoundationComponentEntityHandle: FoundationComponentEntityHandle;
  FoundationDatumVerticalAnchor: FoundationDatumVerticalAnchor;
  FoundationHandle: FoundationHandle;
  FoundationOverride: FoundationOverride;
  FoundationPattern: FoundationPattern;
  FoundationPatternEdgeBehavior: FoundationPatternEdgeBehavior;
  FoundationSettings: FoundationSettings;
  FoundationSubSystemType: FoundationSubSystemType;
  FoundationSystem: FoundationSystem;
  FoundationSystemHandle: FoundationSystemHandle;
  FourLightsWithOptionalFan: FourLightsWithOptionalFan;
  FrameFloorAssemblyEntity: FrameFloorAssemblyEntity;
  FrameFloorAssemblyHandle: FrameFloorAssemblyHandle;
  FramingComponentEntity: FramingComponentEntity;
  FramingComponentHandle: FramingComponentHandle;
  FramingConfig: FramingConfig;
  FreeformWallEdgeHandle: FreeformWallEdgeHandle;
  FreeformWallEntity: FreeformWallEntity;
  FreeformWallHandle: FreeformWallHandle;
  FriezeBoard: FriezeBoard;
  FullMaterialSlot: FullMaterialSlot;
  GableLabel: GableLabel;
  GableRoofType: GableRoofType;
  GarageHandingDirection: GarageHandingDirection;
  GarageLights: GarageLights;
  GarageSettings: GarageSettings;
  GeneratedEntityHandle: GeneratedEntityHandle;
  GeneratedPageViewHandle: GeneratedPageViewHandle;
  GenerateSettings: GenerateSettings;
  GenericDrawingTemplate: GenericDrawingTemplate;
  GenericShutterSettings: GenericShutterSettings;
  GenericStair: GenericStair;
  GlazingColor: GlazingColor;
  GlazingType: GlazingType;
  GlobalParameter: GlobalParameter;
  GlobalParameterHandle: GlobalParameterHandle;
  GradeLineSource: GradeLineSource;
  GridWindowMullionSettings: GridWindowMullionSettings;
  Group: Group;
  GroupHandle: GroupHandle;
  HatchDesignMaterial: HatchDesignMaterial;
  HatchMaterial: HatchMaterial;
  HatchMaterialId: HatchMaterialId;
  HatchPatternLine: HatchPatternLine;
  HatchPatternMaterial: HatchPatternMaterial;
  HatchProceduralMaterial: HatchProceduralMaterial;
  HeadCasingArchedSlice: HeadCasingArchedSlice;
  HeadCasingArchedSlices: HeadCasingArchedSlices;
  HeadCasingEyebrowTrim: HeadCasingEyebrowTrim;
  HeadCasingFullArch: HeadCasingFullArch;
  HeadCasingJackArch: HeadCasingJackArch;
  HeadCasingNone: HeadCasingNone;
  HeadCasingSlice: HeadCasingSlice;
  HeadCasingSlices: HeadCasingSlices;
  HeadCasingStone: HeadCasingStone;
  HeadCasingTrim: HeadCasingTrim;
  HeaderAssemblyEntity: HeaderAssemblyEntity;
  HeaderAssemblyHandle: HeaderAssemblyHandle;
  HeaderFramingRule: HeaderFramingRule;
  HeaderFramingSettings: HeaderFramingSettings;
  HeightType: HeightType;
  HidableEntityHandle: HidableEntityHandle;
  HipFramingMethod: HipFramingMethod;
  HomeAttributes: HomeAttributes;
  HorizontalAlignment: HorizontalAlignment;
  HorizontalEdgeParamNoExpr: HorizontalEdgeParamNoExpr;
  HorizontalFloorAssemblyFreeForm: HorizontalFloorAssemblyFreeForm;
  HorizontalFloorAssemblyLegacy: HorizontalFloorAssemblyLegacy;
  HorizontalFloorAssemblyRoomDerived: HorizontalFloorAssemblyRoomDerived;
  HorizontalFloorAssemblyType: HorizontalFloorAssemblyType;
  HorizontalJustification: HorizontalJustification;
  IJoistComponent: IJoistComponent;
  IJoistProfileType: IJoistProfileType;
  ImageAsset: ImageAsset;
  ImageAssetLegacy: ImageAssetLegacy;
  ImportArrangement: ImportArrangement;
  ImportHalfEdge: ImportHalfEdge;
  ImportVertex: ImportVertex;
  InchesCubed: InchesCubed;
  InchesSquared: InchesSquared;
  IndeterminateHandle: IndeterminateHandle;
  InlineImageAsset: InlineImageAsset;
  InlineImageUnderlay: InlineImageUnderlay;
  InPlaceElectricalLayout: InPlaceElectricalLayout;
  InstanceOptionSet: InstanceOptionSet;
  InstanceOptionSetHandle: InstanceOptionSetHandle;
  InteriorBaseBoardTrimSettings: InteriorBaseBoardTrimSettings;
  InteriorCrownMoldingTrimSettings: InteriorCrownMoldingTrimSettings;
  InteriorDimensionType: InteriorDimensionType;
  InteriorDoorCasingSettings: InteriorDoorCasingSettings;
  InteriorDoorHeadTrimSettings: InteriorDoorHeadTrimSettings;
  InteriorDoorSideTrimSettings: InteriorDoorSideTrimSettings;
  InteriorFloorMaterialOverride: InteriorFloorMaterialOverride;
  InteriorMaterialSettings: InteriorMaterialSettings;
  InteriorPalette: InteriorPalette;
  InteriorPropSettings: InteriorPropSettings;
  InteriorTrimSettings: InteriorTrimSettings;
  InteriorWindowCasingSettings: InteriorWindowCasingSettings;
  InteriorWindowGeneralCasingSettings: InteriorWindowGeneralCasingSettings;
  IntersectingOptionSet: IntersectingOptionSet;
  IntersectionConditions: IntersectionConditions;
  IntersectionEffect: IntersectionEffect;
  IntersectionScope: IntersectionScope;
  KeyMeasuresSettings: KeyMeasuresSettings;
  Label: Label;
  LabelEdgeBehavior: LabelEdgeBehavior;
  LabelHandle: LabelHandle;
  LandscapeSiteShape: LandscapeSiteShape;
  LandscapeType: LandscapeType;
  LateralAlignment: LateralAlignment;
  LateralDatumJustification: LateralDatumJustification;
  LegacyFoundationLateralDatumEntity: LegacyFoundationLateralDatumEntity;
  LegacyFoundationVerticalDatumEntity: LegacyFoundationVerticalDatumEntity;
  LegacyLevelDatumEntity: LegacyLevelDatumEntity;
  LegacyOffsetFromPropBack: LegacyOffsetFromPropBack;
  LegacyWallHorizontalDatumEntity: LegacyWallHorizontalDatumEntity;
  LegacyWallPlaneHorizontalDatumEntity: LegacyWallPlaneHorizontalDatumEntity;
  LegacyWallVerticalDatumEntity: LegacyWallVerticalDatumEntity;
  LevelDatumAnchor: LevelDatumAnchor;
  LevelDef: LevelDef;
  LevelHandle: LevelHandle;
  LevelInches: LevelInches;
  LevelParameter: LevelParameter;
  LevelPlacement: LevelPlacement;
  LevelPlanView: LevelPlanView;
  LevelRoomEdge: LevelRoomEdge;
  LevelValue: LevelValue;
  LineAnchor: LineAnchor;
  LinearArray: LinearArray;
  LinearDimension: LinearDimension;
  LineStyle: LineStyle;
  Linework: Linework;
  LoadConnection: LoadConnection;
  LoadDescriptor: LoadDescriptor;
  LoadSymbol: LoadSymbol;
  LoadType: LoadType;
  LoadTypeSlot: LoadTypeSlot;
  LoadTypeSlots: LoadTypeSlots;
  LocalParameter: LocalParameter;
  LocalParameterHandle: LocalParameterHandle;
  LockableEntityHandle: LockableEntityHandle;
  LockOptionEffect: LockOptionEffect;
  LumberProfileType: LumberProfileType;
  ManualCodeFormatting: ManualCodeFormatting;
  MasonryComponentEntity: MasonryComponentEntity;
  MasonryComponentHandle: MasonryComponentHandle;
  MasterPlanSettings: MasterPlanSettings;
  Mat3: Mat3;
  MaterialSrc: MaterialSrc;
  MaxDistanceColumnPlacementV1: MaxDistanceColumnPlacementV1;
  MaxDistanceColumnPlacementV2: MaxDistanceColumnPlacementV2;
  MaxDistancePostPlacement: MaxDistancePostPlacement;
  MeasurementHandle: MeasurementHandle;
  Modifier: Modifier;
  ModifierHandle: ModifierHandle;
  ModifySettings: ModifySettings;
  MonolithicStair: MonolithicStair;
  NearestArrayTerminusLoadConnection: NearestArrayTerminusLoadConnection;
  NearestLoadConnection: NearestLoadConnection;
  NominalNumber: NominalNumber;
  None: None;
  Note: Note;
  NumberParameter: NumberParameter;
  OneHundredthMillimeters: OneHundredthMillimeters;
  Opening: Opening;
  OpeningHandle: OpeningHandle;
  OpeningHorizontalAlignment: OpeningHorizontalAlignment;
  OpeningWrappingMode: OpeningWrappingMode;
  OptionChoiceParameter: OptionChoiceParameter;
  OptionChoices: OptionChoices;
  OptionCodeFormatting: OptionCodeFormatting;
  OptionEffectHandle: OptionEffectHandle;
  OptionHandle: OptionHandle;
  OptionLockHandle: OptionLockHandle;
  OptionPresetBase: OptionPresetBase;
  OptionPresetParameter: OptionPresetParameter;
  OptionPresetValue: OptionPresetValue;
  OptionRuleHandle: OptionRuleHandle;
  OptionSetForeignKeyString: OptionSetForeignKeyString;
  OptionSetHandle: OptionSetHandle;
  OptionSetMasterPlanSetBehavior: OptionSetMasterPlanSetBehavior;
  OptionSetOverridesHandle: OptionSetOverridesHandle;
  OptionTemplateHandle: OptionTemplateHandle;
  OptionValue: OptionValue;
  Osb: Osb;
  OSBProfile: OSBProfile;
  Other: Other;
  OtherMasonryComponent: OtherMasonryComponent;
  Palette: Palette;
  PaletteHandle: PaletteHandle;
  PaletteMaterialSlot: PaletteMaterialSlot;
  PaletteType: PaletteType;
  PanelShutterSettings: PanelShutterSettings;
  PaperSize: PaperSize;
  ParamColumnPlacementV1: ParamColumnPlacementV1;
  ParamColumnPlacementV2: ParamColumnPlacementV2;
  ParameterForeignKeyString: ParameterForeignKeyString;
  ParameterFormula: ParameterFormula;
  ParameterRef: ParameterRef;
  ParameterRefNumberField: ParameterRefNumberField;
  ParameterRefStringField: ParameterRefStringField;
  ParameterValue: ParameterValue;
  ParameterValueHandle: ParameterValueHandle;
  ParamPostPlacement: ParamPostPlacement;
  PathEndStyle: PathEndStyle;
  Percent: Percent;
  PerspectiveViewport: PerspectiveViewport;
  PerspectiveViewTemplate: PerspectiveViewTemplate;
  PierPosition: PierPosition;
  PixelsPerInch: PixelsPerInch;
  PlacementPoint: PlacementPoint;
  PlacementStyleVersion: PlacementStyleVersion;
  PlacementXAnchor: PlacementXAnchor;
  PlacementYAnchor: PlacementYAnchor;
  PlanAreaMeasurement: PlanAreaMeasurement;
  PlanAreaMeasurementShape: PlanAreaMeasurementShape;
  PlanLineStyle: PlanLineStyle;
  PlanNoteOrientation: PlanNoteOrientation;
  PlanOrientation: PlanOrientation;
  PlanSeries: PlanSeries;
  PlanSetTemplate: PlanSetTemplate;
  PlanSetTemplateConfig: PlanSetTemplateConfig;
  PlanSetTemplateConfigHandle: PlanSetTemplateConfigHandle;
  PlanSetTemplateHandle: PlanSetTemplateHandle;
  PlanSettings: PlanSettings;
  PlanView: PlanView;
  PlanViewCompositeLevelMember: PlanViewCompositeLevelMember;
  PlanViewHandle: PlanViewHandle;
  PlanViewLevelMember: PlanViewLevelMember;
  PlanViewport: PlanViewport;
  PlanViewTemplate: PlanViewTemplate;
  Plywood: Plywood;
  PlywoodProfile: PlywoodProfile;
  PolygonWindowMode: PolygonWindowMode;
  PorchColumnEdgeBehavior: PorchColumnEdgeBehavior;
  PorchColumnPattern: PorchColumnPattern;
  PorchHeaderTrimAlignment: PorchHeaderTrimAlignment;
  PorchPlanSettings: PorchPlanSettings;
  PorchSettings: PorchSettings;
  PositioningMethod: PositioningMethod;
  PostDefault: PostDefault;
  PostPlacement: PostPlacement;
  PredicateOp: PredicateOp;
  Preset: Preset;
  PresetHandle: PresetHandle;
  PresetType: PresetType;
  PrimitiveValue: PrimitiveValue;
  ProfileCatalogSettings: ProfileCatalogSettings;
  ProfileEntity: ProfileEntity;
  ProfileExtrusionDescriptor: ProfileExtrusionDescriptor;
  ProfileHandle: ProfileHandle;
  ProfileId: ProfileId;
  PropAttributes: PropAttributes;
  PropAttributesCustom: PropAttributesCustom;
  PropAttributesHandle: PropAttributesHandle;
  PropBoundOrientation: PropBoundOrientation;
  PropCatalogType: PropCatalogType;
  PropCategory: PropCategory;
  PropInstance: PropInstance;
  PropInstanceHandle: PropInstanceHandle;
  PropInstanceHorizontalAlignment: PropInstanceHorizontalAlignment;
  PropInstanceLateralAlignment: PropInstanceLateralAlignment;
  PropInstanceV1: PropInstanceV1;
  PropInstanceV2: PropInstanceV2;
  PropInstanceVerticalAlignment: PropInstanceVerticalAlignment;
  PropInstanceVerticalDatumAnchor: PropInstanceVerticalDatumAnchor;
  PropThumbnails: PropThumbnails;
  QRCode: QRCode;
  QueryPoint: QueryPoint;
  QueryPointUnion: QueryPointUnion;
  RailDefault: RailDefault;
  Railing: Railing;
  RailingCatalogSettings: RailingCatalogSettings;
  RailingDefaultSetting: RailingDefaultSetting;
  RailingHandle: RailingHandle;
  RailingInfillStyle: RailingInfillStyle;
  RailingPostHandle: RailingPostHandle;
  RailingSettingHandle: RailingSettingHandle;
  RakeFriezeBoardMode: RakeFriezeBoardMode;
  RangeFilter: RangeFilter;
  RearPorchSettings: RearPorchSettings;
  RectangularArray: RectangularArray;
  RectangularCIPPierEntity: RectangularCIPPierEntity;
  RectangularCMUPierEntity: RectangularCMUPierEntity;
  RectangularIsolatedFootingEntity: RectangularIsolatedFootingEntity;
  ReferenceGeom: ReferenceGeom;
  ReferenceGeomHandle: ReferenceGeomHandle;
  RelaxationObstacleEffect: RelaxationObstacleEffect;
  ReportableUnitDesignation: ReportableUnitDesignation;
  ReportableUnitDesignationHandle: ReportableUnitDesignationHandle;
  RetainingWallSiteShape: RetainingWallSiteShape;
  RoadSiteShape: RoadSiteShape;
  Roof: Roof;
  RoofBlockInstanceRef: RoofBlockInstanceRef;
  RoofBlocks: RoofBlocks;
  RoofBoundaryType: RoofBoundaryType;
  RoofDormerPlacement: RoofDormerPlacement;
  RoofElevationPlanSettings: RoofElevationPlanSettings;
  RoofFaces: RoofFaces;
  RoofFramingSettings: RoofFramingSettings;
  RoofFramingSpacingMethod: RoofFramingSpacingMethod;
  RoofFramingType: RoofFramingType;
  RoofHandle: RoofHandle;
  RoofOpeningHandle: RoofOpeningHandle;
  RoofOpeningJustification: RoofOpeningJustification;
  RoofOpeningPlacement: RoofOpeningPlacement;
  RoofPeakDirection: RoofPeakDirection;
  RoofPlanSettings: RoofPlanSettings;
  RoofSettings: RoofSettings;
  RoofSide: RoofSide;
  RoofSideHandle: RoofSideHandle;
  RoofSlopeOptions: RoofSlopeOptions;
  RoofStructureType: RoofStructureType;
  RoofSystem: RoofSystem;
  RoofSystemHandle: RoofSystemHandle;
  RoofSystemLevelUsage: RoofSystemLevelUsage;
  RoofTruncationType: RoofTruncationType;
  RoofTrussType: RoofTrussType;
  RoofVolume: RoofVolume;
  RoofVolumeHandle: RoofVolumeHandle;
  RoofWallFramingType: RoofWallFramingType;
  RoofWallMode: RoofWallMode;
  RoofWeldMode: RoofWeldMode;
  RoomBoundaryType: RoomBoundaryType;
  RoomCaseworkPosition: RoomCaseworkPosition;
  RoomClass: RoomClass;
  RoomEdge: RoomEdge;
  RoomEdgeHandle: RoomEdgeHandle;
  RoomEnclosure: RoomEnclosure;
  RoomHandle: RoomHandle;
  RoomIsolatedFoundationPattern: RoomIsolatedFoundationPattern;
  RoomLabelDimensionType: RoomLabelDimensionType;
  RoomLabelRounding: RoomLabelRounding;
  RoomLabelUnits: RoomLabelUnits;
  RoomLayout: RoomLayout;
  RoomLayoutHandle: RoomLayoutHandle;
  RoomLayoutInstance: RoomLayoutInstance;
  RoomLayoutInstanceHandle: RoomLayoutInstanceHandle;
  RoomMaterials: RoomMaterials;
  RoomPosition: RoomPosition;
  RoomPropPosition: RoomPropPosition;
  RoomRefGeomPosition: RoomRefGeomPosition;
  RoomSetMaterials: RoomSetMaterials;
  RoomTagCapitalization: RoomTagCapitalization;
  RoomTagDimensionControl: RoomTagDimensionControl;
  RoomType: RoomType;
  RoomTypeFilter: RoomTypeFilter;
  RoomTypeSet: RoomTypeSet;
  RoomTypeSpaceTypeFilter: RoomTypeSpaceTypeFilter;
  RoomWallPosition: RoomWallPosition;
  RoughOpeningHeadSettings: RoughOpeningHeadSettings;
  RoughOpeningJambSettings: RoughOpeningJambSettings;
  RoughOpeningSillSettings: RoughOpeningSillSettings;
  RuleBasedSelector: RuleBasedSelector;
  RuleBasedSelectorHandle: RuleBasedSelectorHandle;
  RuleBasedSelectorInstance: RuleBasedSelectorInstance;
  RuleBasedSelectorInstanceHandle: RuleBasedSelectorInstanceHandle;
  SalesImage: SalesImage;
  ScalingEffect: ScalingEffect;
  ScheduleSettings: ScheduleSettings;
  SectionView: SectionView;
  SectionViewHandle: SectionViewHandle;
  SectionViewParameter: SectionViewParameter;
  SectionViewport: SectionViewport;
  SectionViewTemplate: SectionViewTemplate;
  SectionViewValue: SectionViewValue;
  SelectionMethod: SelectionMethod;
  SelectorHandle: SelectorHandle;
  SetPriceOptionEffect: SetPriceOptionEffect;
  SettingsCriterion: SettingsCriterion;
  SettingsFragment: SettingsFragment;
  SettingsHandle: SettingsHandle;
  SettingsSet: SettingsSet;
  SettingsSetBehaviorType: SettingsSetBehaviorType;
  SettingsSetHandle: SettingsSetHandle;
  SettingsType: SettingsType;
  ShapeBasedEntityHandle: ShapeBasedEntityHandle;
  ShapeHandle: ShapeHandle;
  SheathingComponentEntity: SheathingComponentEntity;
  SheathingComponentHandle: SheathingComponentHandle;
  ShedAwningSettings: ShedAwningSettings;
  Sheet: Sheet;
  SheetCustomScales: SheetCustomScales;
  SheetGeometryCategory: SheetGeometryCategory;
  SheetHandle: SheetHandle;
  SheetInches: SheetInches;
  SheetPixels: SheetPixels;
  SheetPoints: SheetPoints;
  SheetTemplate: SheetTemplate;
  SheetTemplateInstance: SheetTemplateInstance;
  ShutterConfigurationType: ShutterConfigurationType;
  ShutterShapeType: ShutterShapeType;
  ShutterStreetOrientationPreference: ShutterStreetOrientationPreference;
  ShutterVerticalAlignment: ShutterVerticalAlignment;
  SideCasingSettings: SideCasingSettings;
  SideCasingType: SideCasingType;
  SidewalkSiteShape: SidewalkSiteShape;
  Sign: Sign;
  SimpleSlatShutterSettings: SimpleSlatShutterSettings;
  SingleLight: SingleLight;
  Site: Site;
  SiteFillSiteShape: SiteFillSiteShape;
  SiteFittingMode: SiteFittingMode;
  SiteHandle: SiteHandle;
  SiteOverrideSiteShape: SiteOverrideSiteShape;
  SiteResolutionLevel: SiteResolutionLevel;
  SiteShape: SiteShape;
  SiteShapeHandle: SiteShapeHandle;
  SiteSubtractSiteShape: SiteSubtractSiteShape;
  SkylightHandle: SkylightHandle;
  SkylightPlacement: SkylightPlacement;
  SlabComponentEntity: SlabComponentEntity;
  SlabComponentHandle: SlabComponentHandle;
  SlabFloorAssemblyEntity: SlabFloorAssemblyEntity;
  SlabFloorAssemblyHandle: SlabFloorAssemblyHandle;
  Slope: Slope;
  SnapEntity: SnapEntity;
  SnapKind: SnapKind;
  SolidFramingFloorAssembly: SolidFramingFloorAssembly;
  SolidOpeningPlacement: SolidOpeningPlacement;
  SolidSlabFloorAssembly: SolidSlabFloorAssembly;
  SpaceType: SpaceType;
  SpaceTypeFilter: SpaceTypeFilter;
  SpacingType: SpacingType;
  SpanDirection: SpanDirection;
  SpanRating: SpanRating;
  SplitLine: SplitLine;
  StackedLevelDatumEntity: StackedLevelDatumEntity;
  StackedLevelPlacement: StackedLevelPlacement;
  StairBlock: StairBlock;
  StairBlockDatumHosting: StairBlockDatumHosting;
  StairBlockEdgeHosting: StairBlockEdgeHosting;
  StairBlockHandle: StairBlockHandle;
  StairBlockHosting: StairBlockHosting;
  StairBlockLanding: StairBlockLanding;
  StairBlockRun: StairBlockRun;
  StairBlockType: StairBlockType;
  StairBottomShape: StairBottomShape;
  StairCatalogSettings: StairCatalogSettings;
  StairConfig: StairConfig;
  StairConstruction: StairConstruction;
  StairIsolatedFoundationPattern: StairIsolatedFoundationPattern;
  StairSetting: StairSetting;
  StairSettingHandle: StairSettingHandle;
  StairSystem: StairSystem;
  StairSystemHandle: StairSystemHandle;
  StairVerticalAlignment: StairVerticalAlignment;
  StandardOutlet: StandardOutlet;
  StaticRoom: StaticRoom;
  StaticRoomAttributes: StaticRoomAttributes;
  StoolCasingSettings: StoolCasingSettings;
  StoolCasingType: StoolCasingType;
  StreetOrientationMode: StreetOrientationMode;
  Stringer: Stringer;
  StringerLayout: StringerLayout;
  StringerPositioning: StringerPositioning;
  StripFootingEntity: StripFootingEntity;
  StructuralFloorType: StructuralFloorType;
  StructuralMaterial: StructuralMaterial;
  StructuralWoodPostDescriptor: StructuralWoodPostDescriptor;
  StructureSettings: StructureSettings;
  StylingEffect: StylingEffect;
  SwingSide: SwingSide;
  SystemDataSequence: SystemDataSequence;
  SystemOptionSet: SystemOptionSet;
  SystemParameter: SystemParameter;
  SystemParameterHandle: SystemParameterHandle;
  TagTemplate: TagTemplate;
  TallCabinetDescriptor: TallCabinetDescriptor;
  TextAlignment: TextAlignment;
  TextBackground: TextBackground;
  TextParameter: TextParameter;
  TextStyle: TextStyle;
  TextVerticalAlignment: TextVerticalAlignment;
  TrayFreeform: TrayFreeform;
  TraySimpleOffset: TraySimpleOffset;
  TreadJustification: TreadJustification;
  TrimEdgeBehavior: TrimEdgeBehavior;
  TrimJustification: TrimJustification;
  TruncationSlopeType: TruncationSlopeType;
  TrussComponent: TrussComponent;
  TurndownBrickLedgeType: TurndownBrickLedgeType;
  TurndownFootingEntity: TurndownFootingEntity;
  Underlay: Underlay;
  UnderlayHandle: UnderlayHandle;
  UnitParameter: UnitParameter;
  UnitValue: UnitValue;
  UnsignedNumber: UnsignedNumber;
  UntypedNumber: UntypedNumber;
  UpperCabinetDescriptor: UpperCabinetDescriptor;
  UpperCabinetSubType: UpperCabinetSubType;
  UrlParameter: UrlParameter;
  UserOptionSet: UserOptionSet;
  UtilityDimensionType: UtilityDimensionType;
  UVTransformation: UVTransformation;
  Vaulted: Vaulted;
  Vec3: Vec3;
  VentedShutterSettings: VentedShutterSettings;
  VertexHandle: VertexHandle;
  VerticalAlignment: VerticalAlignment;
  VerticalDatumData: VerticalDatumData;
  VerticalJustification: VerticalJustification;
  View3D: View3D;
  View3DHandle: View3DHandle;
  View3DParameter: View3DParameter;
  ViewFilter: ViewFilter;
  ViewNoteSettings: ViewNoteSettings;
  ViewOverride: ViewOverride;
  ViewOverrideHandle: ViewOverrideHandle;
  Viewport: Viewport;
  ViewportBase: ViewportBase;
  ViewportHandle: ViewportHandle;
  ViewportHorizontalAlignment: ViewportHorizontalAlignment;
  ViewportPositioningMethod: ViewportPositioningMethod;
  ViewportScalingMethod: ViewportScalingMethod;
  ViewportTitleDrawingTemplate: ViewportTitleDrawingTemplate;
  ViewportVerticalAlignment: ViewportVerticalAlignment;
  ViewportViewType: ViewportViewType;
  ViewSelector: ViewSelector;
  ViewSelectorHandle: ViewSelectorHandle;
  ViewStyle: ViewStyle;
  ViewTemplate: ViewTemplate;
  ViewTemplateHandle: ViewTemplateHandle;
  ViewTemplateOverride: ViewTemplateOverride;
  ViewTemplateOverrideHandle: ViewTemplateOverrideHandle;
  ViewTemplateParameter: ViewTemplateParameter;
  ViewTemplateValue: ViewTemplateValue;
  VirtualRoofBlock: VirtualRoofBlock;
  VisibilityEffect: VisibilityEffect;
  WainscotingCapType: WainscotingCapType;
  WainscotingSettings: WainscotingSettings;
  WalkSiteShape: WalkSiteShape;
  WallAssemblyAirGapLayer: WallAssemblyAirGapLayer;
  WallAssemblyEdgeBehavior: WallAssemblyEdgeBehavior;
  WallAssemblyExteriorFinishLayer: WallAssemblyExteriorFinishLayer;
  WallAssemblyFinishLayer: WallAssemblyFinishLayer;
  WallAssemblyFoundationCatalogLayer: WallAssemblyFoundationCatalogLayer;
  WallAssemblyInteriorFinishLayer: WallAssemblyInteriorFinishLayer;
  WallAssemblyLayer: WallAssemblyLayer;
  WallAssemblyLayerConstructorParams: WallAssemblyLayerConstructorParams;
  WallAssemblyLayerOperatorAdd: WallAssemblyLayerOperatorAdd;
  WallAssemblyLayerOperatorOverride: WallAssemblyLayerOperatorOverride;
  WallAssemblyLayerOperatorRemove: WallAssemblyLayerOperatorRemove;
  WallAssemblyLayerParentHandle: WallAssemblyLayerParentHandle;
  WallAssemblyMaterialCatalogLayer: WallAssemblyMaterialCatalogLayer;
  WallAssemblyOffsetOperator: WallAssemblyOffsetOperator;
  WallAssemblyOperator: WallAssemblyOperator;
  WallCasework: WallCasework;
  WallCaseworkDynamicDeprecated: WallCaseworkDynamicDeprecated;
  WallCaseworkFixed: WallCaseworkFixed;
  WallCaseworkFixedDeprecated: WallCaseworkFixedDeprecated;
  WallCaseworkPlanNote: WallCaseworkPlanNote;
  WallCatalogSettings: WallCatalogSettings;
  WallConditionData: WallConditionData;
  WallFaceRuleEntity: WallFaceRuleEntity;
  WallFoundationInteractionOperator: WallFoundationInteractionOperator;
  WallFramingOpeningSettings: WallFramingOpeningSettings;
  WallFramingSettings: WallFramingSettings;
  WallHorizontalDatum: WallHorizontalDatum;
  WallHostedAnnotationSide: WallHostedAnnotationSide;
  WallIntersectionType: WallIntersectionType;
  WallLateralDatumAnchor: WallLateralDatumAnchor;
  WallLateralDatumAnchorAll: WallLateralDatumAnchorAll;
  WallOpeningWrappingSettings: WallOpeningWrappingSettings;
  WallOperatorSetTopDatum: WallOperatorSetTopDatum;
  WallPlaneAnchoredRuleEntity: WallPlaneAnchoredRuleEntity;
  WallPlaneAssemblyEntity: WallPlaneAssemblyEntity;
  WallPlaneAssemblyHandle: WallPlaneAssemblyHandle;
  WallPlaneAssemblyLayer: WallPlaneAssemblyLayer;
  WallPlaneAssemblyOperation: WallPlaneAssemblyOperation;
  WallPlaneCastInPlaceLayer: WallPlaneCastInPlaceLayer;
  WallPlaneCutOperation: WallPlaneCutOperation;
  WallPlaneFilterHandle: WallPlaneFilterHandle;
  WallPlaneFramingLayer: WallPlaneFramingLayer;
  WallPlaneMasonryLayer: WallPlaneMasonryLayer;
  WallPlaneMaterialFinish: WallPlaneMaterialFinish;
  WallPlaneOperation: WallPlaneOperation;
  WallPlaneOperationBoundary: WallPlaneOperationBoundary;
  WallPlaneRuleEntity: WallPlaneRuleEntity;
  WallPlaneRuleHandle: WallPlaneRuleHandle;
  WallPlaneSheathingLayer: WallPlaneSheathingLayer;
  WallPlaneTrimEntity: WallPlaneTrimEntity;
  WallPlaneTrimHandle: WallPlaneTrimHandle;
  WallPlaneViewHandle: WallPlaneViewHandle;
  WallRoofBaseBoardFilter: WallRoofBaseBoardFilter;
  WallRoofBaseBoardMode: WallRoofBaseBoardMode;
  WallSettings: WallSettings;
  WallType: WallType;
  WallVerticalDatumAnchor: WallVerticalDatumAnchor;
  WindowCatalogSettings: WindowCatalogSettings;
  WindowDescriptorCustom: WindowDescriptorCustom;
  WindowGridLayout: WindowGridLayout;
  WindowGridPosition: WindowGridPosition;
  WindowLateralAlignment: WindowLateralAlignment;
  WindowMaterialSettings: WindowMaterialSettings;
  WindowMullionSettings: WindowMullionSettings;
  WindowMullionType: WindowMullionType;
  WindowOperationType: WindowOperationType;
  WindowPanelType: WindowPanelType;
  WindowPlacementDeprecated: WindowPlacementDeprecated;
  WindowPlacementMatchExpr: WindowPlacementMatchExpr;
  WindowRoughOpeningSettings: WindowRoughOpeningSettings;
  WindowSettings: WindowSettings;
  WindowShapeTypes: WindowShapeTypes;
  WindowShutterSettings: WindowShutterSettings;
  WindowVertDivisions: WindowVertDivisions;
  WindowVerticalAlignment: WindowVerticalAlignment;
  WindowVerticalDatum: WindowVerticalDatum;
  WindowWallFramingSettings: WindowWallFramingSettings;
  WindowWallWrappingSettings: WindowWallWrappingSettings;
  WoodSlab: WoodSlab;
  WorldFeet: WorldFeet;
  WorldInches: WorldInches;
  WrapFriezeBoardMode: WrapFriezeBoardMode;
  YardsCubed: YardsCubed;
  ZShutterSettings: ZShutterSettings;
}

// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn higharc gen doc-schema directly.
